import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/accordion';
import 'jquery-ui/ui/widgets/dialog';
import * as helpers from './helpers';
import { SeadevShedBuilder } from './ssb_builder';
import {
	colorLabels,
	constants,
	convertSides,
	ePackageType,
	interiors,
	layoutTypes,
	NOTICES,
	revertSides,
	typeHasColor,
	zSide,
} from './ssb_constants';
import { Seadev2DFloorPlan } from './ssb_floorplan';
import QRCode = require('../public/js/easy.qrcode.min.js');
import Pickr = require('../public/js/pickr.es5.min.js');

export class SeadevShedBuilderScripts {
	_seadevShedBuilder: SeadevShedBuilder;
	_shareLinkData;
	_shareLinkId;
	_builderWrapper;
	_configuratorWrapper;
	_configuratorGroup;
	_configuratorAccordionWrapper;
	_configuratorMobileWrapper;
	_openingDialog;
	_isChangeLayout;
	_isAddNewComponent;
	_currentSide;
	_sideSelected;
	_editingComponent;
	_isShowPrice;
	_isEnabledRailing: boolean = true;
	_prices: object;
	_isEnabledExternalPorch: boolean = false;

	_zipCodeCookieKey = 'zip-code';
	_locationCokieKey = 'location';
	_zipCodeContinue = '';

	_markupFee = 0;
	_fixedAmountFee = 0;
	_discount = 0;
	_logisticsFee = 0;
	_truckloadFee = 0;
	_wideFreightFee = 0;
	_multiModuleBuildsFee = 0;

	_isEnabledZonePrice: boolean = false;
	_sizesZone: any = [];
	_isShowUpgradeChargeInfo: boolean = false;
	_includeComponentRemove: any = [];
	_creditItemElectrical: any = [];
	_includeAddOnsRemove: any = [];
	_listVentsReplace: any = [];
	_isShowCredit: boolean = false;
	_isShowPositionComponent: boolean = false;
	_isManufactureEditOrder: boolean = false;
	_canCustomLineItems: boolean = false;
	_isCreateAlertChangeSize: boolean = true;
	_isMaterialUpdateBasePrice: boolean = true;

	_zoneID = '';
	_lotID = '';
	_enableTax = 'no';
	_idRestrictionSize = '';
	_isStructurePorch = false;
	_totalBuildingOptionsPrice = 0;
	_wainscotCondition = '';
	_isUseLocation = false;
	_cookiedValidate = '';
	_elementValidate;
	_sizeInShareLink = '';
	_base64Data = null;
	_includeItemsComponent = [];
    _electricalPackageInclude = [];
    _includeComponents = [];
    _deductionComponents = [];
    _includeAddOns = [];
    _isAllowChangeIncludeWindowVent = false;
	_currentLayoutID = '';

	constructor() {
		this._builderWrapper = $('#ssb-builder');
		const canvasId = this._builderWrapper.find('canvas').attr('id');
		if (undefined === canvasId || canvasId.length <= 0) {
			return;
		}

		const canvas = document.getElementById(canvasId) as unknown as HTMLCanvasElement;
		const webgl = canvas.getContext('webgl');
		if (null === webgl) {
			this.showNotification(NOTICES.webGLNotSupport);
			return;
		}

		this._seadevShedBuilder = new SeadevShedBuilder(canvasId, canvas);
		this._isShowPrice = !(
			$('body.ssb-request-a-quote-mode').length > 0 && $('body.show-price').length === 0
		);
		this._configuratorGroup = $('.ssb-configurator-options');
		this._configuratorWrapper = $('.ssb-configurator-wrapper');
		this._configuratorMobileWrapper = $('#ssb-configurator-mobile');
		this._configuratorAccordionWrapper = $('#ssb-configurator-accordion');
		this._isShowUpgradeChargeInfo =
			this._seadevShedBuilder._canvas.getAttribute('data-show-upgrade-charge-info') ===
			'true';
		this._isShowCredit =
			this._seadevShedBuilder._canvas.getAttribute('data-show-credit-info') === 'true';
		this._isShowPositionComponent = $('body.show-position-components').length ? true : false;
		this._isEnabledZonePrice = $('body.enable-zone-price').length ? true : false;
		this._isManufactureEditOrder =
			this._seadevShedBuilder._canvas.getAttribute('data-is-manufacture-edit-order') ===
			'true';
		this._lotID = (<any>window).ssb.lotID;
		this._enableTax = (<any>window).ssb.enable_tax;
		this._canCustomLineItems = (<any>window).ssb.user_can_custom_line_items;
		this._isMaterialUpdateBasePrice = '1' === (<any>window).shedpro.material_update_base_price;
		this._isStructurePorch =
			(this._seadevShedBuilder.isExternalPorch() && this._isEnabledExternalPorch) ||
			this._seadevShedBuilder.isExternalPorch() ||
			this._seadevShedBuilder.isDeluxeCornerLeftPorch() ||
			this._seadevShedBuilder.isCornerPorchLeft() ||
			this._seadevShedBuilder.isMiddlePorch() ||
			this._seadevShedBuilder.isFrontPorch() ||
			this._seadevShedBuilder.isSidePorch() ||
			'structure_ranch_cabin' === this._seadevShedBuilder._shedType ||
			this._seadevShedBuilder.isSidePorchCabin() ||
			this._seadevShedBuilder.isDoubleGable() ||
			this._seadevShedBuilder.isAframeSingleGable();
		this._isUseLocation = $('#js-select-location').length > 0;
		this._cookiedValidate = this._isUseLocation
			? this._locationCokieKey
			: this._zipCodeCookieKey;
		this._elementValidate = this._isUseLocation ? $('#js-select-location') : $('#js-zip-code');
		const url = new URL(window.location.href);
		const dataBase64 = url.searchParams.get('data');
		const shareableLinkId = url.searchParams.get('share');
		this._includeItemsComponent = this._seadevShedBuilder.getSettingData( 'include_component_items' );
        this._isAllowChangeIncludeWindowVent = 1 == this._seadevShedBuilder.getSettingData( 'allow_vent_swap_window' );
		if (dataBase64) {
			this._seadevShedBuilder._isShareLink = true;
			this._shareLinkData = dataBase64;
		}

		if (shareableLinkId) {
			this._seadevShedBuilder._isShareLink = true;
			this._shareLinkId = shareableLinkId;
		}

		if (this._seadevShedBuilder._isShareLink) {
			$('.ssb-configurator-options.other input').prop('checked', false);
		}

		this._seadevShedBuilder._dataSettingsTackroom =
			this._seadevShedBuilder.getSettingData('data_tackroom');
		this._seadevShedBuilder._dataSettingsTackroom['colorInfo'] =
			helpers.getDefaultComponentColor(
				this._seadevShedBuilder._dataSettingsTackroom['default_tackroom_door'],
			);

		const tackDoorName = this._seadevShedBuilder.getTackDoor();
		const tackDoorColor = helpers.getDefaultComponentColor(tackDoorName);
		this._seadevShedBuilder.setGlobalData(constants.tackDoorInfo, {
			name: tackDoorName,
			colorInfo: tackDoorColor,
		});

		this.renderCustomLineItem();
		this.handleZipCode();
		this.zipCodeEvent();
		this.customSelectOption();
		this.eventCloseAllSelect();
		this.renderModelCanvas();
		this.initConfiguratorAccordion();
		this.hideConfiguratorGroup();
		this.hideSizeOptionsConfigurator();
		this.handleSizeChange();
		this.handleUpgradePackageUpdate();
		this.popupAddComponent();
		this.openEditComponent();
		this.changeComponent();
		this.removeComponent();
		this.cancelEditComponent();
		this.handleShareButton();
		this.generateFlyer();
		this.viewShedInARDesktop();
		this.viewShedInARMobile();
		this.handlePopupLogin();
		this.shedTypesToggle();
		this.handleInterior();
		this.resetModel();
		this.customRoofOverhang();
		this.handleLoftList();
		this.handleLoftChange();
		this.handleUpgradeChange();
		this.handleAddToCart();
		this.handlePorchList();
		this.handleChangePorch();
		this.handleChangeRoofPitch();
		this.handleChangeLegs();
		this.handleChangeFrameSpacing();
		this.handleChangeRailing();
		this.handleSendFromParent();
		this.handleFoundation();
		this.handleChangeTackDoor();
		this.handleChangeComponentSize();
		this.hideDoorAndWindowsOption();
		this.handleCaptureImageAT();
		this.handleElectricalPackageChange();
		this.handleChangeSidesEnds();
		this.handleChangeSideOnPopup();
		this.handle2DFloorPlan();
		this.handleZipcodeForSimplifyCheckout();
		this.customizeLineItems();
		this.handleDisplayAddonSection();
		this.handleChangeWainscoting();
		this.handleChangeExteriorSidingUpgrades();
		this.handleDormerOption();
		this.handleChangeLeanTo();
		this.handleColorPicker();
		this.handleListFrame();
		this.handleChangeWallFinish();
		this.handleChangeSideGable();
		this.handleChangeComponentColor();

		window.addEventListener('callback-after-login', async (event) => {
			let zipCode = this.getCookie(this._cookiedValidate);
			if (
				(zipCode && this._zipCodeContinue != zipCode) ||
				(event['detail']['res']['can_see_est_price'] && !this.isEnableZonePrice())
			) {
				this._isShowPrice = event['detail']['res']['can_see_est_price'];
				this.shedDetailUpdatePriceMaterialColor();
				this.shedDetailRenderSidingAndTrim();
				this.shedDetailRenderRoof();
				this.shedDetailStructureRenderColor();
				this.shedDetailRenderPorchData();
				this.shedDetailRenderExterior();
				this.shedDetailRenderInterior();
				this.handleShowSeeMonthlyPayment();
				this.updatePrice();
			}

			const action = event['detail']['action'];

			if (false === action) {
				return;
			}

			const element = event['detail']['element'];
			if (false === element) {
				return;
			}
			if ('save' === action) {
				this.saveModels(element);
			} else if ('share' === action) {
				$('.ssb-share-model').click();
			}
		});

		window.addEventListener('close-edit-component', (event) => {
			$(this._openingDialog).dialog('option', 'position', {
				my: 'center',
				at: 'center',
				of: window,
			});
		});

		window.addEventListener('update-shed-info', (event) => {
			this.shedDetailRenderExterior();
			this.shedDetailRenderInterior();
			this.updatePrice();
		});

		window.addEventListener('add-component', (event) => {
			let { name, key, type, side, parent, uuid } = event['detail'];

			if ('flower_box' === type || 'shutters' === type || 'transom' === type) {
				name = this._seadevShedBuilder._walls[side]['items'][parent]['name'];
				key = this._seadevShedBuilder._walls[side]['items'][parent]['key'];
				uuid = this._seadevShedBuilder._walls[side]['items'][parent]['uuid'];
			}

			if (this.isLoftRestrictionByComponent()) {
				const isLoftRestriction = this.isLoftRestriction(
					$('input.ssb_loft:checked'),
					event['detail']['name'],
					side,
				);
				if (isLoftRestriction) {
					$('input.ssb_loft:checked').prop('checked', false);
					this.loftChange({}, false);
					this._seadevShedBuilder.createAlert(NOTICES.loftNotCompatible);
				}

				this.handleLoftList();
			}

			const rampInfo = 'ramp' === type ? event['detail'] : false;
			let isTackDoor = event['detail']['isTackDoor'] ? 'tackdoor' : '';
			const isDisable = this._seadevShedBuilder.isItemBlock(key);
			this.addComponentDOM(
				uuid,
				side,
				type,
				name,
				key,
				rampInfo,
				event['detail']['componentSize'],
				isDisable,
				isTackDoor,
			);

			this.shedDetailRenderExterior();
			this.shedDetailRenderInterior();
			this.checkShowTypeColor(type);
			this.updatePrice();
		});

		window.addEventListener('after-drag', (event) => {
			this.shedDetailRenderExterior();
			this.shedDetailRenderInterior();
		});

		window.addEventListener('after-rotate-component', (event) => {
			this.shedDetailRenderInterior();
		});

		window.addEventListener('place-component', (event) => {
			this.shedDetailRenderExterior();
			this.shedDetailRenderInterior();
		});

		window.addEventListener('change-size', (event) => {
			this.handleUpdateFrame();
			this.handleShowHideTackRoomGroup();
			this.shedDetailRenderExterior();
			this.shedDetailRenderInterior();
			this.shedDetailRenderLayout();
		});

		window.addEventListener('remove-component', (event) => {
			const side = event['detail']['side'];
			const type = event['detail']['type'];
			const key = event['detail']['key'];

			this.removeComponentV2(side, type, key);
		});

		window.addEventListener('remove-component-callback', (event) => {
			if (this.isLoftRestrictionByComponent()) {
				this.handleLoftList();
			}
		});

		window.addEventListener('add-component-v2', async (event) => {
			this._seadevShedBuilder.addLoadingAndStopRenderClasses('add-component-v2');
			const side = event['detail']['side'];
			const type = event['detail']['type'];
			const name = event['detail']['name'];
			const uuid = event['detail']['uuid'];
			const position = event['detail']['position'];
			const lockData = helpers.getDefaultLock(type, name);
			const colorInfo = helpers.getDefaultComponentColor(uuid);
			const result = await this._seadevShedBuilder.addNewComponent({
				side,
				componentType: type,
				componentName: name,
				position,
				isChangeComponent: true,
				lockData,
				colorInfo,
				uuid,
			});

			this.addFirstAddon(type, uuid, side, result);

			this._seadevShedBuilder.removeLoadingAndStopRenderClasses('add-component-v2');
		});

		window.addEventListener('update-accordion-status', (event) => {
			this._configuratorAccordionWrapper.accordion('option', 'active', 10000);
		});

		window.addEventListener('calculate_monthly_payment', (event) => {
			this.calculate_monthly_payment();
		});

		window.addEventListener('update-price-outside-ts', (event) => {
			this.updatePrice();
		});
	}

	/**
	 * Preload all the siding textures in the background
	 *
	 * This function will loop through all the siding options and try to fetch the diffuse, bump and specular textures
	 * in the background. This is done to speed up the rendering of the siding when the user selects a different
	 * type of siding.
	 */
	loadSidingForCache = (): void => {
		const _this = this;
		// Loop through all the siding options
		try {
			$('.ssb-configurator-siding-type li').each((index, item) => {
				const { sidingType, defaultDiffuse, defaultBump, defaultSpecular, specularPower } =
					_this._seadevShedBuilder.getSidingMaterialData($(item));

				const { diffuseTexture, bumpTexture, specularTexture } =
					this._seadevShedBuilder.getTextureFile(
						sidingType,
						defaultDiffuse,
						defaultBump,
						defaultSpecular,
						specularPower,
					);

				// Try to fetch the textures in the background
				if (diffuseTexture) helpers.tryCatchAndFetchUrl(diffuseTexture);
				if (bumpTexture) helpers.tryCatchAndFetchUrl(bumpTexture);
				if (specularTexture) helpers.tryCatchAndFetchUrl(specularTexture);
			});
		} catch (error) {
			console.error('Load cache siding error: ', error);
		}
	};

	showNotification = (message) => {
		let template = document.createElement('template');
		template.innerHTML = `<div class="wrap-notice">
            <div class="content"><div>${message}</div></div>
        </div>`;

		document.body.appendChild(template.content.firstChild);
	};

	shedDetailRenderLayout(label: any = false) {
		if (false === label) {
			label = $('#js-shed-data input[name="ssb-option-layout"]').val();
		}
		const price = this.getLayoutCharge();
		const content = `<div class="details-price-charge">
                <div class="item">
                        <p class="left">Layout: ${label}</p>
                        ${this._isShowPrice && this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(price, this._isShowPrice)}` : ''}
                </div>
            </div>`;

		$('#js-layout-content').html(content);
	}

	isCalculatePostRailsColor() {
		if (
			(this._seadevShedBuilder.isExternalPorch() && this._isEnabledExternalPorch) ||
			this._seadevShedBuilder.isDeluxeCornerLeftPorch() ||
			this._seadevShedBuilder.isCornerPorchLeft() ||
			this._seadevShedBuilder.isFrontPorch() ||
			this._seadevShedBuilder.isSidePorch() ||
			'structure_ranch_cabin' === this._seadevShedBuilder._shedType ||
			this._seadevShedBuilder.isSidePorchCabin() ||
			this._seadevShedBuilder.isDoubleGable() ||
			this._seadevShedBuilder.isAframeSingleGable()
		) {
			return true;
		}

		if (this._seadevShedBuilder.isMiddlePorch() && this._isEnabledRailing) {
			return true;
		}

		return false;
	}

	shedDetailRenderSize() {
		const basePrice = this.getBasePrice(true);
		const sizeLabel = helpers.getSizeLabel();
		const content = `<div class="details-price-charge">
                            <div class="item">
                                    <p class="left">Size: ${sizeLabel['label']}</p>
                                    ${this._isShowPrice && this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(basePrice, this._isShowPrice)}` : ''}
                            </div>
                        </div>`;
		$('#js-size-content').html(content);
	}

	shedDetailUpdatePriceMaterialColor() {
		const _this = this;
		const listColors = [
			'siding',
			'trim',
			'roof',
			'door',
			'shutter',
			'vent',
			'windows',
			'rails',
			'wall',
			'ceiling',
		];
		listColors.forEach((item) => {
			const colorActive = $(`.ssb-configurator-color.${item} li.active`);
			const priceColor = this.getPriceOptions(colorActive);
			$(`#js-shed-data input[name="ssb-option-${item}-color-price"]`).val(priceColor);
		});

		const elMateial = $('#siding-material-option li.active');
		let priceMaterial = 0;
		if (_this.isManualPrice()) {
			const height = helpers.getBaseHeight();
			const dataSizes = $(`#ssb-configurator-size-area`)
				.children('option:selected')
				.attr('data-sizes');
			const basePrice = _this.getPriceByHeight(
				height,
				dataSizes,
				elMateial.data('siding-type'),
			);
			const defaultMaterial = $('.ssb-configurator-siding-type .default-material');
			const defaultBasePriceMaterial = _this.getPriceByHeight(
				height,
				dataSizes,
				defaultMaterial.data('siding-type'),
			);
			priceMaterial = basePrice - defaultBasePriceMaterial;
		} else {
			priceMaterial = !_this._isMaterialUpdateBasePrice
				? _this.getPriceOptions(elMateial, 'material')
				: 0;
		}
		$('#js-shed-data input[name="ssb-option-siding-type-price"]').val(priceMaterial);
	}

	shedDetailRenderSidingAndTrim() {
		const _this = this;
		const sidingType = $('#js-shed-data input[name="ssb-option-siding-type"]').val();
		const sidingKey = $('#js-shed-data input[name="ssb-option-siding-type"]').attr('data-key');
		const sidingTypePrice = _this._isShowPrice
			? $('#js-shed-data input[name="ssb-option-siding-type-price"]').val()
			: 0;
		const sidingColor = $('#js-shed-data input[name="ssb-option-siding-color"]').val();
		const sidingColorPrice = _this._isShowPrice
			? $('#js-shed-data input[name="ssb-option-siding-color-price"]').val()
			: 0;
		const trimColor = $('#js-shed-data input[name="ssb-option-trim-color"]').val();
		const trimColorPrice = _this._isShowPrice
			? $('#js-shed-data input[name="ssb-option-trim-color-price"]').val()
			: 0;
		const dataSideEnd = _this.getCarportSidingData();
		const wainscoting = _this.getWainscotingData();
		const eSidingUpgrades = _this.getExteriorSidingUpgradesData();

		let data = {
			sidingKey,
			sidingType,
			trimColor,
			sidingColor,
		};

		let element = `<ul class="details-price-charge">`;
		if (this.carportShowWallInfo()) {
			if ('' !== sidingType) {
				element += `<li>
                                <div class="item">
                                    <p class="left">Material: ${sidingType}</p>
                                    ${_this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(sidingTypePrice, this._isShowPrice)}` : ''}
                                </div>
                            </li>`;
			}

			if ('' !== sidingColor) {
				element += `<li>
                                <div class="item">
                                    <p class="left">Siding Color: ${sidingColor}</p>
                                    ${_this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(sidingColorPrice, this._isShowPrice)}` : ''}
                                </div>
                            </li>`;
			}
		} else {
			data = {
				sidingKey: null,
				sidingType: null,
				trimColor: null,
				sidingColor: null,
			};
		}

		if (
			'pergola' === this._seadevShedBuilder._shedType ||
			'pavilion' === this._seadevShedBuilder._shedType
		) {
			$('#js-siding-trim-content').closest('li').find('span.label').text('Siding: ');
		} else {
			if (trimColor !== undefined && trimColor !== '') {
				element += `<li>
                    <div class="item">
                        <p class="left">Trim Color: ${trimColor}</p>
                        ${_this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(trimColorPrice, this._isShowPrice)}` : ''}
                    </div>
                </li>`;
			}

			if (Object.keys(dataSideEnd).length) {
				Object.keys(dataSideEnd).forEach(function (key) {
					const data = dataSideEnd[key];

					element += `<li>
                        <div class="item">
                            <p class="left">${helpers.capitalize(key)} Side: ${data.details}</p>
                            ${_this._isShowPrice && _this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(data.price, _this._isShowPrice)}` : ''}
                        </div>
                    </li>`;
				});
			}
		}

		if (wainscoting && 1 !== this._seadevShedBuilder._wainscotingType) {
			const wainscotData = JSON.parse(window.atob(wainscoting));
			this.getElectricalPackageData;
			const { display } = wainscotData;

			display.forEach((data) => {
				element += `
                    <li>
                        <div class="item">
                            <p class="left">${data.key}: ${data.value}</p>
                            ${_this._isShowPrice && _this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(data.price, this._isShowPrice)}` : ''}
                        </div>
                    </li>              
                `;
			});
		}

		if (eSidingUpgrades) {
			const { display } = JSON.parse(window.atob(eSidingUpgrades));

			display.forEach((data) => {
				element += `
                    <li>
                        <div class="item">
                            <p class="left">${data.key}: ${data.value}</p>
                            ${_this._isShowPrice && _this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(data.price, this._isShowPrice)}` : ''}
                        </div>
                    </li>              
                `;
			});
		}

		element += `</ul>`;

		$('#js-siding-trim-content').html(element);
		return data;
	}

	shedDetailRenderPorchData() {
		if (!this._isStructurePorch || $('.ssb-configurator-color.rails').length == 0) {
			$('#js-porch-details').hide();
			return '';
		}

		let isShow = false;
		const deckColor = $('#js-deck-data').data('color');
		const deckColorPrice = 0;
		let element = `<ul class="details-price-charge">`;
		let railsColor;
		let railsColorPrice;
		if ($('.group-rails-color').length) {
			railsColor = $('#js-shed-data input[name="ssb-option-rails-color"]').val();
			railsColorPrice = this._isShowPrice
				? $('#js-shed-data input[name="ssb-option-rails-color-price"]').val()
				: 0;
		} else {
			railsColor = $('#js-post-railing-data').data('color');
			railsColorPrice = 0;
		}

		if (this.isCalculatePostRailsColor() && undefined !== railsColor && '' !== railsColor) {
			element += `<li>
                <div class="item">
                    <p class="left">Post/Railing Color: ${railsColor}</p>
                    ${this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(railsColorPrice, this._isShowPrice)}` : ''}
                </div>
            </li>`;
			isShow = true;
		}
		if (undefined !== deckColor && '' !== deckColor) {
			element += `<li>
                <div class="item">
                    <p class="left">Deck Color: ${deckColor}</p>
                    ${this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(deckColorPrice, this._isShowPrice)}` : ''}
                </div>
            </li>`;
			element += `</ul>`;
			isShow = true;
		}

		if (!isShow) {
			$('#js-porch-details').hide();
			return '';
		}
		$('#js-porch-content').html(element);
		$('#js-porch-details').show();
	}

	getTackRoomData() {
		if (
			!this._seadevShedBuilder._isEnableTackRoom ||
			0 === $(`[name="ssb-configurator-upgrade-tackroom"]:checked`).length
		) {
			return {};
		}
		const elementTackRoom = $(`[name="ssb-configurator-upgrade-tackroom"]:checked`);
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = this.getBasePrice();
		const priceType = elementTackRoom.data('price-type');
		const priceItem = elementTackRoom.data('price');
		const price = this.calculatePriceByType(
			priceType,
			priceItem,
			basePrice,
			baseWidth,
			baseDepth,
			false,
		);
		const includeTackDoor = this._seadevShedBuilder._dataSettingsTackroom[
			'include_tackroom_door'
		]
			? true
			: false;
		const tackDoorName = this._seadevShedBuilder._tackDoor
			? this._seadevShedBuilder._tackDoor.name
			: '';
		let name;
		let original_name;
		if (this._seadevShedBuilder._tackDoor) {
			const niceNameTackDoor = $(`.ssb-configurator-options.ssb-configurator-upgrade.door`)
				.find(`input[data-upgrade-component-name="${tackDoorName}"]`)
				.attr('data-option-value');
			const originalNameTackDoor = $(
				`.ssb-configurator-options.ssb-configurator-upgrade.door`,
			)
				.find(`input[data-upgrade-component-name="${tackDoorName}"]`)
				.attr('data-option-original-value');
			name = `${elementTackRoom.val()} with ${niceNameTackDoor} door ${includeTackDoor ? '(door included in Tackroom cost)' : '(door not included in Tackroom cost)'}`;
			original_name = `${elementTackRoom.val()} with ${originalNameTackDoor} door ${includeTackDoor ? '(door included in Tackroom cost)' : '(door not included in Tackroom cost)'}`;
		} else {
			name = `${elementTackRoom.val()}`;
			original_name = `${elementTackRoom.val()}`;
		}
		if (this.isEnableManufacturer()) {
			return {
				name,
				price,
				quantity: 1,
				group: 'Tackroom',
				original_group: 'Tackroom',
				original_name,
			};
		} else {
			return {
				name,
				price,
				quantity: 1,
				group: 'Tackroom',
			};
		}
	}

	getPorchDataColor() {
		if (!this._isStructurePorch || $('.ssb-configurator-color.rails').length == 0) {
			return '';
		}
		let data: any = { post: null, deck: null };
		const deckColor = $('#js-deck-data').data('color');
		const deckColorPrice = 0;
		let railsColor;
		let railsColorPrice;
		if ($('.group-rails-color').length) {
			railsColor = $('#js-shed-data input[name="ssb-option-rails-color"]').val();
			railsColorPrice = $('#js-shed-data input[name="ssb-option-rails-color-price"]').val();
		} else {
			railsColor = $('#js-post-railing-data').data('color');
			railsColorPrice = 0;
		}
		if (this.isCalculatePostRailsColor() && undefined !== railsColor && '' !== railsColor) {
			data.post = { color: railsColor, price: railsColorPrice };
		}
		if (undefined !== deckColor && '' !== deckColor) {
			data.deck = { color: deckColor, price: deckColorPrice };
		}
		return data;
	}

	/**
	 * Constructs a shed detail item HTML element based on the provided parameters.
	 *
	 * @param {string} element - The HTML element string to append the shed detail item.
	 * @param {string} roofType - The type of roof.
	 * @param {string} price - The price of the roof.
	 * @param {string} label - The label for the roof type.
	 * @returns {string} The updated HTML element with the shed detail item.
	 */
	getShedDetailItem = (element, roofType, price, label) => {
		if (roofType) {
			element += `<li>
                <div class="item">
                    <p class="left">${label}: ${roofType}</p>
                    ${helpers.getPriceElement(price, this._isShowPrice, this._isShowUpgradeChargeInfo)}
                </div>
            </li>`;
		}

		return element;
	};

	shedDetailRenderRoof() {
		if (
			'pergola' === this._seadevShedBuilder._shedType ||
			'greenhouse' === this._seadevShedBuilder._shedType
		) {
			$('#js-roof-content').closest('li').remove();
			return;
		}

		const roofType = $('#js-shed-data input[name="ssb-option-roof-type"]').val();
		const roofColor = $('#js-shed-data input[name="ssb-option-roof-color"]').val();
		const roofPrice = $('#js-shed-data input[name="ssb-option-roof-color-price"]').val();
		const roofMaterialPrice = this.getRoofMaterialPrice();
		const roofPitch = $(
			'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
		).attr('data-option-value');
		let element = `<ul class="details-price-charge">`;
		element = this.getShedDetailItem(element, roofType, roofMaterialPrice, 'Material');
		element = this.getShedDetailItem(element, roofColor, roofPrice, 'Color');
		let roofPitchPrice = 0;
		if (roofPitch) {
			const priceCondition = $(
				'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
			).attr('data-price-condition');
			let { price, priceType } = this.getRoofPitchUnitDataPrice(priceCondition);
			roofPitchPrice = this.calculatePriceByType(
				priceType,
				price,
				this.getBasePrice(),
				helpers.getBaseWidth(),
				helpers.getBaseDepth(),
				false,
			);
			element = this.getShedDetailItem(element, roofPitch, roofPitchPrice, 'Roof Pitch');
		}
		element += `</ul>`;

		$('#js-roof-content').html(`${element}`);

		return { roofType, roofColor, roofPitch, roofPitchPrice };
	}

	shedDetailStructureRenderColor() {
		const types = ['door', 'vent', 'shutter', 'windows'];
		types.forEach((item) => {
			this.shedDetailRenderColor(item);
		});
	}

	checkShowVentColor() {
		const _this = this;
		const ventColor = $(`#js-shed-data input[name="ssb-option-vent-color"]`).val();
		if (ventColor !== undefined && ventColor !== '') {
			const components = _this._seadevShedBuilder.getAllComponents();
			for (let k in components) {
				const { type } = components[k];
				if (type === 'vent') {
					$('#js-vent-details').show();
					$('.woocommerce.single input[name="ssb-option-has-vent"]').val('true');
					return;
				}
			}
		}

		$('#js-vent-details').hide();
		$('.woocommerce.single input[name="ssb-option-has-vent"]').val('false');
	}

	checkShowDoorColor() {
		const _this = this;
		const doorColor = $(`#js-shed-data input[name="ssb-option-door-color"]`).val();
		if (doorColor !== undefined && doorColor !== '') {
			const components = _this._seadevShedBuilder.getAllComponents();
			for (let k in components) {
				const { type } = components[k];
				if (type === 'door') {
					$('#js-door-details').show();
					return;
				}
			}
		}
		$('#js-door-details').hide();
	}

	checkShowTypeColor = (typeColor) => {
		const _this = this;
		const colorVal = $(`#js-shed-data input[name="ssb-option-${typeColor}-color"]`).val();
		typeColor = 'shutters' === typeColor ? 'shutter' : typeColor;
		if (colorVal !== undefined && colorVal !== '') {
			if ('rails' === typeColor && _this.isRailingEnable()) {
				$(`#js-${typeColor}-details`).show();
				$(`.woocommerce.single input[name="ssb-option-has-${typeColor}"]`).val('true');
				return;
			}
			const components = _this._seadevShedBuilder.getAllComponents();
			const shuttersInObjects = _this._seadevShedBuilder.getShuttersInObject();
			const allComponents = { ...components, ...shuttersInObjects };
			for (let k in allComponents) {
				const { type, name, meshes } = allComponents[k];
				if (type === typeColor || (typeColor === 'shutter' && type === 'shutters')) {
					$(`.woocommerce.single input[name="ssb-option-has-${typeColor}"]`).val('true');
					$(`#js-${typeColor}-details`).show();
					return;
				}
			}
		}

		$(`#js-${typeColor}-details`).hide();
		$(`.woocommerce.single input[name="ssb-option-has-${typeColor}"]`).val('false');
	};

	shedDetailRenderColor(type) {
		const color = $(`#js-shed-data input[name="ssb-option-${type}-color"]`).val();
		const colorPrice = this._isShowPrice
			? $(`#js-shed-data input[name="ssb-option-${type}-color-price"]`).val()
			: 0;

		if (color !== undefined && color !== '') {
			let element = `<ul class="details-price-charge">
                                <li>
                                    <div class="item">
                                        <p class="left">Color: ${color}</p>
                                        ${this._isShowUpgradeChargeInfo ? `${helpers.getPriceElement(colorPrice, this._isShowPrice)}` : ''}
                                    </div>
                                </li>
                            </ul>`;
			$(`#js-${type}-details`).show();
			$(`#js-${type}-content`).html(`${element}`);
			this.checkShowTypeColor(type);
		} else {
			$(`#js-${type}-details`).hide();
		}
	}

	pushElement(title, element) {
		return `
                <div class="content">
                    <p class="description">${title}:</p>
                    <ul>
                        ${element}
                    </ul>
                </div>
            `;
	}

	getChildElementText(elements, original = false) {
		if (elements.length <= 0) {
			return '';
		}

		const result = original
			? elements.map((e) => e.originalNiceName)
			: elements.map((e) => e.niceName);

		return ` with ${result.join(', ')}`;
	}

	getShedDetailText = (components, face = '') => {
		const _this = this;
		const elements = {};

		let includeComponents = [ ..._this._includeComponents ];
        let includeAddOns = [ ..._this._includeAddOns ];
		let includeComponentRemove = [..._this._includeComponentRemove];
		let includeAddOnsRemove = [..._this._includeAddOnsRemove];
		const componentPackage = this._seadevShedBuilder.getComponentPackageInfo();
		const selectedLayout = jQuery(
			`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
		);
		const packageLayout = selectedLayout.data('layout-packages');
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = _this.getBasePrice();
		let listVentsReplace = [..._this._listVentsReplace];

		const tmpComponents = JSON.parse(JSON.stringify(components));
		for (const type in tmpComponents) {
			const items = tmpComponents[type];
			items.sort((a, b) => {
				const sizeA =
					undefined !== a.componentSize && 0 != a.componentSize
						? Number(a.componentSize)
						: 1;
				const sizeB =
					undefined !== b.componentSize && 0 != b.componentSize
						? Number(b.componentSize)
						: 1;
				const priceA = Number(a.price) * sizeA;
				const priceB = Number(b.price) * sizeB;
				const discountA =
					undefined !== a.priceDiscount ? Number(a.priceDiscount) * sizeA : 0;
				const discountB =
					undefined !== b.priceDiscount ? Number(b.priceDiscount) * sizeB : 0;

				return priceA - priceB || discountA - discountB;
			});

			let customItems = [];
			items.forEach((item, i) => {
				customItems.push(item);

				if ('door' === type) {
					const isAllow = jQuery(`[data-upgrade-component-name='${item.name}'][data-uuid='${item.uuid}']`).data(
						'allow-change-position',
					);
					if (isAllow) {
						const tmpComponent = _this._seadevShedBuilder.getComponentBySideAndKey(
							item.side,
							item.key,
						);
						if (tmpComponent['customLock'] && tmpComponent['defaultLock']) {
							const lockPrice =
								tmpComponent['customLock'] !== tmpComponent['defaultLock']
									? tmpComponent['lockPrice']
									: 0;
							const lockText = _this._seadevShedBuilder.getLockPositionText(
								tmpComponent['name'],
								tmpComponent['customLock'],
							);
							customItems.push({
								key: `${tmpComponent['name']}-lock`,
								name: 'lock',
								side: item.side,
								type: 'lock',
								face: 'exterior',
								price: lockPrice,
								options: [],
								niceName: lockText,
								priceType: 'fixed',
								parentName: item.name,
							});
						}
					}

					if (item.childs.length > 0) {
						customItems = customItems.concat(item.childs);
					}
				}

				if ('windows' === type) {
					if (item.childs.length > 0) {
						customItems = customItems.concat(item.childs);
					}
				}
			});

			customItems.forEach((item) => {
				const component = this._seadevShedBuilder.getComponentBySideAndKey(
					item.side,
					item.key,
				);
				const niceName =
					'' !== item.niceName
						? item.niceName
						: item.name
								.split('_')
								.map((n) => n.charAt(0).toUpperCase() + n.slice(1))
								.join(' ');
				const originalNiceName =
					'' !== item.originalNiceName && item.originalNiceName
						? item.originalNiceName
						: niceName;
				let nameElement = niceName;
				let originalNameElement = originalNiceName;
				let position = [];
				let positionLeft = 0;
				let positionRight = 0;
				let priceElement: any = '';
				let price = jQuery(`[data-upgrade-component-name="${item.name}"][data-uuid="${item.uuid}"]`).data('price');
				let priceDiscount = jQuery(`[data-upgrade-component-name="${item.name}"][data-uuid="${item.uuid}"]`).data(
					'price-discount',
				);
				const priceType = jQuery(`[data-upgrade-component-name="${item.name}"][data-uuid="${item.uuid}"]`).data(
					'price-type',
				);

				if (priceType === 'n_a') {
					priceElement = '(n/a)';
				} else if (priceType === 'call_for_pricing') {
					priceElement = '(call for pricing)';
				}

				if (
					'transom' !== item.type &&
					'ramp' !== item.type &&
					'shutters' !== item.type &&
					'flower_box' !== item.type &&
					'lock' !== item.type
				) {
					const index = includeComponents.indexOf(component['uuid']);
					if (-1 !== index && true !== component['isTackDoor']) {
						includeComponents.splice(index, 1);
						priceElement = '(included)';
					} else {
						let componentPrice = price;
						if (includeComponentRemove.length) {
							const indexItemRemove = helpers.findIndexObject(
								includeComponentRemove,
								'type',
								item.type,
							);
							if (-1 !== indexItemRemove) {
								if (undefined !== priceDiscount && '' !== priceDiscount) {
									componentPrice = priceDiscount;
								}
								includeComponentRemove.splice(indexItemRemove, 1);
							} else if (listVentsReplace.length && 'vent' === item.type) {
								const indexVent = listVentsReplace.indexOf(component.name);
								if (-1 !== indexVent) {
									if (undefined !== priceDiscount && '' !== priceDiscount) {
										componentPrice = priceDiscount;
									}
									listVentsReplace.splice(indexVent, 1);
								}
							}
						}
						if (componentPrice) {
							const tmpWidth =
								'linear_foot' === priceType
									? Number(
											$(`[data-component-key="${item.key}"]`).attr(
												'data-component-size',
											),
										)
									: baseWidth;
							priceElement = this.calculatePriceByType(
								priceType,
								componentPrice,
								basePrice,
								tmpWidth,
								baseDepth,
								false,
							);
						}
					}

					const wallWidth = this._seadevShedBuilder.getWallWidthBySide(item.side);
					const wallHeight = this._seadevShedBuilder.getHeightForTextBySide(item.side);
					/* Backup
					 * This is correct case
					 * const wallHeight        = this._seadevShedBuilder.getWallHeightBySide( item.side );
					 */
					let distanceBottom = this._seadevShedBuilder.getDistanceBottom(component);
					let tmpDistanceBottom = helpers.convertUnit(distanceBottom);
					let distanceTop = wallHeight - (distanceBottom + component.componentHeight);
					let tmpDistanceTop = helpers.convertUnit(distanceTop);
					const child = this.getChildElementText(item.childs);
					const originChild = this.getChildElementText(item.childs, true);
					const halfWidth = component.width / 2;
					const distance = this._seadevShedBuilder.getDistanceHorizontal(
						item.side,
						component,
					);

					let tmpDistanceLeft: any = 0;
					let tmpDistanceRight: any = 0;
					let distanceLeft = 0;
					let distanceRight = 0;

					if (
						'front' === item.side ||
						'top_front' === item.side ||
						'lean_to_front' === item.side ||
						'left' === item.side ||
						'lean_to_left' === item.side ||
						'top_left' === item.side ||
						'porch' === item.side ||
						'dormer' === item.side ||
						'roof_left' === item.side ||
						'inner_front' === item.side ||
						'inner_left' === item.side ||
						'left_front' === item.side ||
						'left_back' === item.side ||
						'front_inner_porch' === item.side ||
						'right_inner_porch' === item.side
					) {
						distanceRight = wallWidth - distance - halfWidth;
						distanceLeft = distance - halfWidth;

						tmpDistanceLeft = helpers.convertUnit(distanceLeft);
						tmpDistanceRight = helpers.convertUnit(distanceRight);
					} else if (
						'back' === item.side ||
						'inner_back' === item.side ||
						'top_back' === item.side ||
						'lean_to_back' === item.side ||
						'right' === item.side ||
						'top_right' === item.side ||
						'roof' === item.side ||
						'roof_right' === item.side ||
						'left_inner_porch' === item.side ||
						'inner_right' === item.side ||
						'lean_to_right' === item.side
					) {
						distanceLeft = wallWidth - distance - halfWidth;
						distanceRight = distance - halfWidth;

						tmpDistanceRight = helpers.convertUnit(distanceRight);
						tmpDistanceLeft = helpers.convertUnit(distanceLeft);
					}

					if (
						this._seadevShedBuilder.isBetaFeature(
							'refactor_component_position_dimension',
						)
					) {
						let linePoints;
						if (this._seadevShedBuilder.isMoveAlongFloor(component.uuid)) {
							linePoints =
								this._seadevShedBuilder.calculateFloorLinePoints(component);
						} else {
							linePoints = this._seadevShedBuilder.calculateWallLinePoints(component);
						}

						let horizontalLeft = this._seadevShedBuilder.calculateDistanceSpace(
							linePoints?.horizontalLeft?.start,
							linePoints?.horizontalLeft?.end,
						);
						let horizontalRight = this._seadevShedBuilder.calculateDistanceSpace(
							linePoints?.horizontalRight?.start,
							linePoints?.horizontalRight?.end,
						);
						let verticalTop = this._seadevShedBuilder.calculateDistanceSpace(
							linePoints?.verticalTop?.start,
							linePoints?.verticalTop?.end,
						);
						let verticalBottom = this._seadevShedBuilder.calculateDistanceSpace(
							linePoints?.verticalBottom?.start,
							linePoints?.verticalBottom?.end,
						);

						distanceLeft = horizontalLeft?.original;
						distanceRight = horizontalRight?.original;

						tmpDistanceLeft = horizontalLeft?.converted || '0';
						tmpDistanceRight = horizontalRight?.converted || '0';
						tmpDistanceTop = verticalTop?.converted || '0';
						tmpDistanceBottom = verticalBottom?.converted || '0';
					}

					positionLeft = distanceLeft;
					positionRight = distanceRight;
					position = [
						tmpDistanceTop,
						tmpDistanceBottom,
						tmpDistanceLeft,
						tmpDistanceRight,
					];

					let lockText = '';
					if ('door' === item.type) {
						const tmpComponent = _this._seadevShedBuilder.getComponentBySideAndKey(
							item.side,
							item.key,
						);
						if (tmpComponent['customLock'] && tmpComponent['defaultLock']) {
							lockText = ` ${_this._seadevShedBuilder.getLockPositionText(tmpComponent['name'], tmpComponent['customLock'])}`;
						}
					}

					const behavior = this._seadevShedBuilder.getBehavior(item.name, item.type);
					let positionLabel = ` (Top: ${tmpDistanceTop}, Bottom: ${tmpDistanceBottom}, Left: ${tmpDistanceLeft}, Right: ${tmpDistanceRight})`;
					if (
						!this._isShowPositionComponent ||
						'diagonal_right' === item.side ||
						'structure_monitorbarns_helmuth' === _this._seadevShedBuilder._shedType ||
						(('top_front' === item.side || 'top_back' === item.side) &&
							!this._seadevShedBuilder.is2StoryLeanTo())
					) {
						positionLabel = '';
					} else if (
						'door' === item.type ||
						'roof' === item.side ||
						'dormer' === item.side ||
						'roof_left' === item.side ||
						'roof_right' === item.side ||
						this._seadevShedBuilder.isInteriorComponent(behavior)
					) {
						positionLabel = ` (Left: ${tmpDistanceLeft}, Right: ${tmpDistanceRight})`;
					}

					if (
						this._seadevShedBuilder.isMoveAlongFloor(item.uuid) &&
						'floor' === item.side
					) {
						positionLabel = ` (Top: ${tmpDistanceTop}, Bottom: ${tmpDistanceBottom}, Left: ${tmpDistanceLeft}, Right: ${tmpDistanceRight})`;
					}

					nameElement = `${niceName}${lockText}${child}${positionLabel}`;
					originalNameElement = `${originalNiceName}${lockText}${originChild}${positionLabel}`;
				}

				if (
					'door' === item.type ||
					'flower_box' === item.type ||
					'shutters' === item.type
				) {
					item.options = item.childs;
				}

				if (
					'transom' === item.type ||
					'flower_box' === item.type ||
					'ramp' === item.type ||
					'shutters' === item.type
				) {
					const index = includeAddOns.indexOf(item.name);
					if (-1 !== index) {
						includeAddOns.splice(index, 1);
						priceElement = '(included)';
					} else {
						let addOnPrice = price;
						if (includeAddOnsRemove.length) {
							const i = helpers.findIndexObject(
								includeAddOnsRemove,
								'type',
								item.type,
							);
							if (i !== -1) {
								if (undefined !== priceDiscount && '' !== priceDiscount) {
									addOnPrice = priceDiscount;
								}
								includeAddOnsRemove.splice(i, 1);
							}
						}

						if (addOnPrice) {
							priceElement = this.calculatePriceByType(
								priceType,
								addOnPrice,
								basePrice,
								baseWidth,
								baseDepth,
								false,
							);
						}
					}
				}

				if ('lock' === item.type) {
					priceElement = this.calculatePriceByType(
						item.priceType,
						item.price,
						basePrice,
						baseWidth,
						baseDepth,
						price,
					);
				}

				if ('linear_foot' === priceType) {
					const componentSize = $(`[data-component-key="${item.key}"]`).attr(
						'data-component-size',
					);
					nameElement += ' (' + componentSize + ' linear feet)';
					originalNameElement += ' (' + componentSize + ' linear feet)';
				}

				if (
					componentPackage.hasPackage &&
					helpers.hasKeyInArray(componentPackage.componentInPackage, item.key)
				) {
					priceElement = '';
				}

				let _width = '';
				if (component.width) {
					_width = component.width;
				}

				let text = 'lock' === item.type ? nameElement : `One ${nameElement}`;
				let originalText =
					'lock' === item.type ? originalNameElement : `One ${originalNameElement}`;
				if (item.isTackDoor) {
					text = nameElement;
					originalText = originalNameElement;
				}

				if (!_this._seadevShedBuilder._isEnableTackRoom && item.isTackDoor) {
					priceElement = item.price;
				} else if (
					item.isTackDoor &&
					_this._seadevShedBuilder._dataSettingsTackroom['include_tackroom_door']
				) {
					priceElement = 0;
				}

				const componentName = jQuery(`[data-upgrade-component-name="${item.name}"][data-uuid="${item.uuid}"]`).data(
					'option-value',
				);
				const electricalText = '(Electrical package) ';
				for (const key of componentPackage.componentInPackage) {
					if (key !== item.key) continue;

					text = electricalText + text;
					originalText = electricalText + originalText;
					$(`[data-component-key="${key}"] .added-component-label`).text(
						electricalText + componentName,
					);
				}

				for (const key of componentPackage.componentOutPackage) {
					if (key !== item.key) continue;

					$(`[data-component-key="${key}"] .added-component-label`).text(componentName);
				}

				let colors = [];
				if (item.colors && item.colors.length > 0) {
					for (let i = 0; i < item.colors.length; i++) {
						const {
							type,
							type_display,
							display,
							color_price,
							color_price_type,
							texture_type,
							texture,
							description,
							upcharge,
						} = item.colors[i];
						const endPrice = this.calculatePriceByType(
							color_price_type,
							color_price,
							basePrice,
							baseWidth,
							baseDepth,
							false,
						);
						colors.push({
							type,
							type_display,
							display,
							color_price: endPrice,
							color_price_type,
							texture_type,
							texture,
							description,
						});

						if (upcharge && !helpers.isEmptyObject(upcharge)) {
							colors.push({
								display: upcharge.display,
								type_display: upcharge.type_display,
								color_price: upcharge.price,
								color_price_type: upcharge.priceType,
							});
						}
					}
				}

				const face = component.face ? component.face : item.face;
				const element: any = {
					key: item.name,
					ckey: item.key,
					text,
					price: priceElement,
					name: niceName,
					type: item.type,
					side: item.side,
					sideName: this.getSideLabel(item.side),
					width: _width,
					left: positionLeft,
					right: positionRight,
					position: position,
					options: item.options,
					face,
					colors,
				};

				if (_this.isEnableManufacturer()) {
					element.original_text = originalText;
					element.original_name = originalNiceName;
				}

				elements[item.side] = helpers.checkAndPushKeyToArray(elements[item.side], element);
			});
		}

		if (
			_this._seadevShedBuilder._isAllowEnableTackRoom &&
			!_this._seadevShedBuilder._dataSettingsTackroom['include_tackroom_door'] &&
			_this._seadevShedBuilder._tackDoor &&
			includeComponents.length > 0
		) {
			const { name, side, key } = _this._seadevShedBuilder._tackDoor;
			if (-1 !== includeComponents.indexOf(name) && elements[side]) {
				let indexTackDoor = helpers.findIndexObject(elements[side], 'ckey', key);
				if (-1 !== indexTackDoor) {
					elements[side][indexTackDoor].price = '(included)';
				}
			}
		}

		return elements;
	};

	getCreditItem = () => {
		let creditItem = [];
		if (this._includeComponentRemove.length) {
			this._includeComponentRemove.forEach((value, index) => {
				const element = jQuery(`[data-upgrade-component-type="${value.type}"][data-uuid='${value.key}']`);
				let componentName = element.attr(
					'data-option-value',
				);
				const originalNameCreditComponent = element.attr('data-option-original-value');
				if (Number(value.deduction) > 0 && componentName) {
					let element: any = {
						name: componentName,
						text: componentName,
						price: Number(value.deduction) * -1,
					};

					if (this.isEnableManufacturer()) {
						element.original_name = originalNameCreditComponent;
						element.original_text = originalNameCreditComponent;
					}

					creditItem.push(element);
				}
			});
		}

		return [...creditItem, ...this._creditItemElectrical];
	};

	shedDetailRenderCreditItem = () => {
		const _this = this;
		const creditItem = _this.getCreditItem();
		let fullHtml = '';
		creditItem.forEach((item) => {
			fullHtml += _this.buildShedDetailElement(item);
		});
		if ('' !== fullHtml && _this._isShowCredit) {
			const html = `
                <div class="wrap-content">
                    <h5 class="ssb-configurator-group-name">Credit</h5>
                    <div class="content">
                        <ul>${fullHtml}</ul>
                    </div>
                </div>
            `;
			$('#js-credit-content').html(html);
		} else {
			$('#js-credit-content').html('');
		}
	};

	shedDetailRenderExterior() {
		const _this = this;
		const components = _this.getListComponents('exterior');
		const elements = _this.pushOpeningToRightElements(
			_this.getShedDetailText(components, 'exterior'),
		);
		let fullElement = '';
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = _this.getBasePrice();

		$(`[name="ssb-configurator-upgrade-porch"]:checked`).each((i, v) => {
			let label = $(v).data('option-value');
			const price = $(v).data('price');
			const priceType = $(v).data('price-type');
			const oPosition = _this._seadevShedBuilder.isCornerPorchLeft()
				? ''
				: _this._seadevShedBuilder.getOpeningPosition();
			const railingPrice = _this.calculateRailingPrice();
			let endPrice = Number(
				_this.calculatePriceByType(
					priceType,
					price,
					basePrice,
					baseWidth,
					baseDepth,
					false,
				),
			);
			endPrice = isNaN(endPrice) ? 0 : endPrice;
			endPrice += railingPrice;

			if (_this._isEnabledRailing) {
				label +=
					' - ' +
					oPosition.charAt(0).toUpperCase() +
					oPosition.slice(1) +
					` (With Railing)`;
			} else {
				label += ` (No Railing)`;
			}

			if (!this._seadevShedBuilder.isHidePorchInfo()) {
				elements['porch'] = helpers.checkAndPushKeyToArray(elements['porch'], {
					text: label,
					price: endPrice,
					type: 'porch',
				});
			}
		});

		if (_this._seadevShedBuilder.isExternalPorch() && _this._isEnabledExternalPorch) {
			const label = this.getExternalPorchLabel();
			const porchElement = $('[name="ssb-configurator-upgrade-external-porch"]');
			const price = porchElement.attr('data-price');
			const priceType = porchElement.attr('data-price-type');
			let endPrice = Number(
				_this.calculatePriceByType(
					priceType,
					price,
					basePrice,
					baseWidth,
					baseDepth,
					false,
				),
			);
			endPrice = isNaN(endPrice) ? 0 : endPrice;
			endPrice += _this.calculateRailingPrice();

			elements['porch'] = helpers.checkAndPushKeyToArray(elements['porch'], {
				text: label,
				price: endPrice,
				type: 'porch',
			});
		}

		for (const key of Object.keys(elements)) {
			if (!_this._isShowCredit && 'credit' === key) continue;
			const sideData = elements[key];
			const sideName = this.getSideLabel(key);
			let sideElements = '';
			sideData.forEach((item) => {
				sideElements += _this.buildShedDetailElement(item);
			});

			fullElement += this.pushElement(sideName, sideElements);
		}

		if ('' !== fullElement) {
			const html = `
                <div class="wrap-content">
                    <h5 class="ssb-configurator-group-name">Exteriors</h5>
                    ${fullElement}
                </div>`;
			$('#js-exterior-content').html(html);
		} else {
			$('#js-exterior-content').html('');
		}

		this.shedDetailRenderCreditItem();
	}

	/**
	 * Update the Interior info to Shed Detail tab
	 */
	shedDetailRenderInterior() {
		let _this = this;
		const components = _this.getListComponents('interior');
		const elements = _this.getShedDetailText(components);
		let upgrades = [];
		const componentPackage = _this._seadevShedBuilder.getComponentPackageInfo();
		const includePrice = _this._seadevShedBuilder.includePrice();
		const selectedLayout = jQuery(
			`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
		);
		const packageLayout = selectedLayout.data('layout-packages');
		let packageDefaultID = '';
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = _this.getBasePrice();
		if (packageLayout.length > 0) {
			packageDefaultID = packageLayout[0].id;
		}

		const sizeElement = $('#ssb-configurator-size-area option:selected');
		$(`[name="ssb-configurator-upgrade-package"]:checked`).each((i, v) => {
			const quantity = $(v).closest('div').find('.upgrade-quantity').val() || 1;
			const excludeDealer: any = $(v).attr('data-exclude')
				? $(v).attr('data-exclude').split(',')
				: [];
			const excludePrice =
				excludeDealer.length && _this._lotID && excludeDealer.includes(_this._lotID);
			upgrades.push({
				label: 'Package Upgrade: ' + $(v).data('option-value'),
				price: excludePrice ? '' : $(v).data('price'),
				type: $(v).data('price-type'),
				quantity,
			});
		});

		$('#foundation-options input:checked').each((i, v) => {
			const label = $(v).attr('label');
			if ($(v).attr('visible') == '1') {
				upgrades.push({
					label: label + ': ' + $(v).data('title'),
					price: Number(sizeElement.attr(`${$(v).val()}`)),
					type: 'fixed',
					quantity: 1,
				});
			}
		});

		$(`[data-option-key="ssb-option-upgrade-other"]:checked`).each((i, v) => {
			const quantity = $(v).closest('div').find('.upgrade-quantity').val() || 1;
			const typeLabel = $(v)
				.closest('.group-upgrade-other')
				.find('.ssb-configurator-group-name')
				.text();
			const excludeDealer: any = $(v).attr('data-exclude')
				? $(v).attr('data-exclude').split(',')
				: [];
			const excludePrice =
				excludeDealer.length && _this._lotID && excludeDealer.includes(_this._lotID);
			const minPrice = $(v).data('min-price');
			const maxPrice = $(v).data('max-price');
			upgrades.push({
				label: typeLabel + ': ' + $(v).data('option-value'),
				price: excludePrice ? '' : $(v).data('price'),
				type: $(v).data('price-type'),
				quantity,
				minPrice,
				maxPrice,
			});
		});

		$(`[name="ssb-configurator-upgrade-loft"]:checked`).each((i, v) => {
			upgrades.push({
				label: 'Loft Upgrade: ' + $(v).data('option-value'),
				price: $(v).data('price'),
				type: $(v).data('price-type'),
			});
			$(`[name="ssb-option-loft"]`).attr(
				'final-price',
				this.calculatePriceByType(
					$(v).data('price-type'),
					$(v).data('price'),
					_this.getBasePrice(),
					helpers.getBaseWidth(),
					helpers.getBaseDepth(),
					false,
				),
			);
		});

		const sideGableData = _this.getSideGableData();
		if (!helpers.isEmptyObject(sideGableData)) {
			const fullLabel = `${sideGableData['group']}: ${sideGableData['name']}`;
			upgrades.push({
				label: fullLabel,
				price: sideGableData['price'],
				type: 'fixed',
				quantity: sideGableData['quantity'],
			});
		}

		$(`[name="ssb-configurator-upgrade-roof_overhang"]:checked`).each((i, v) => {
			const excludeDealer: any = $(v).attr('data-exclude')
				? $(v).attr('data-exclude').split(',')
				: [];
			const excludePrice =
				excludeDealer.length && _this._lotID && excludeDealer.includes(_this._lotID);
			upgrades.push({
				label: 'Roof Overhang: ' + $(v).data('option-value'),
				price: excludePrice ? '' : $(v).data('price'),
				type: $(v).data('price-type'),
			});
		});

		$(`[name="ssb-configurator-upgrade-legs_setting"]:checked`).each((i, v) => {
			upgrades.push({
				label: 'Legs: ' + $(v).data('option-value'),
				price: $(v).data('price'),
				type: $(v).data('price-type'),
			});
		});

		$(`[name="ssb-configurator-upgrade-frame_spacing"]:checked`).each((i, v) => {
			upgrades.push({
				label: 'Frame Spacing: ' + $(v).data('option-value'),
				price: $(v).data('price'),
				type: $(v).data('price-type'),
			});
		});
		if (this._seadevShedBuilder._isEnableTackRoom) {
			const tackRoomData = this.getTackRoomData();
			$(`[name="ssb-configurator-upgrade-tackroom"]:checked`).each((i, v) => {
				upgrades.push({
					label: `Tackroom option:  ${tackRoomData.name}`,
					price: $(v).data('price'),
					type: $(v).data('price-type'),
				});
			});
		}

		$(`[name="ssb-configurator-upgrade-frame"]:checked`).each((i, v) => {
			upgrades.push({
				label: `Studs:  ${$(v).data('option-value')}`,
				price: $(v).data('price'),
				type: $(v).data('price-type'),
			});
		});

		if (this._seadevShedBuilder.isEnableLeanTo()) {
			const data = this._seadevShedBuilder.getLeanToData();

			if (data) {
				upgrades.push({
					label: 'Leanto: ' + data.custom_name,
					price: data.price,
					type: data.price_type,
				});
			} else {
				upgrades.push({
					label: $('[name=ssb-configurator-upgrade-lean-to]:checked').attr(
						'origin-group-name',
					),
					price: $('[name=ssb-configurator-upgrade-lean-to]:checked').data('price'),
					type: $('[name=ssb-configurator-upgrade-lean-to]:checked').data('price-type'),
				});
			}
		}

		if ($('#floor-material-option li.active').length > 0) {
			const elem = $('#floor-material-option li.active');
			upgrades.push({
				label: 'Floor Material: ' + elem.data('label'),
				price: elem.data('price'),
				type: elem.data('price-type'),
			});
		}

		let interiorFinishingData = [];
		let insulationData = [];
		const wallColor = $('#js-shed-data input[name="ssb-option-wall-color"]').val();
		const wallColorPrice = _this._isShowPrice
			? $('#js-shed-data input[name="ssb-option-wall-color-price"]').val()
			: 0;
		const ceilingColor = $('#js-shed-data input[name="ssb-option-ceiling-color"]').val();
		const ceilingColorPrice = _this._isShowPrice
			? $('#js-shed-data input[name="ssb-option-ceiling-color-price"]').val()
			: 0;

		const arrInteriorFinishing = {
			interior_wall: 'Wall Finishing',
			interior_ceiling: 'Ceiling Finishing',
		};
		const arrInteriorInsulation = {
			insulation_wall: 'Wall Insulation',
			insulation_roof: 'Roof Insulation',
		};
		Object.entries(arrInteriorFinishing).forEach(([key, value]) => {
			const elementMaterial = $(`#${key}-material-option li.active`);
			const materialType = elementMaterial.data('material-type');
			let materialPrice: any = this.calculatePriceByType(
				elementMaterial.data('price-type'),
				elementMaterial.data('price'),
				basePrice,
				baseWidth,
				baseDepth,
				false,
				0,
			);
			materialPrice =
				'(n/a)' === materialPrice || '(call for pricing)' === materialPrice
					? materialPrice
					: isNaN(materialPrice)
						? 0
						: materialPrice;

			if (elementMaterial.length && 'none' !== materialType) {
				const dataGroup = {
					name: value,
					options: [
						{
							label: `Material: ${elementMaterial.data('label')}`,
							price: materialPrice,
						},
					],
				};
				if ('interior_wall' === key && '' !== wallColor) {
					dataGroup.options.push({
						label: `Color: ${wallColor}`,
						price: wallColorPrice,
					});
				} else if ('interior_ceiling' === key && '' !== ceilingColor) {
					dataGroup.options.push({
						label: `Color: ${ceilingColor}`,
						price: ceilingColorPrice,
					});
				}
				interiorFinishingData.push(dataGroup);
			}
		});

		Object.entries(arrInteriorInsulation).forEach(([key, value]) => {
			const elementMaterial = $(`#${key}-material-option li.active`);
			const materialType = elementMaterial.data('material-type');
			let materialPrice: any = this.calculatePriceByType(
				elementMaterial.data('price-type'),
				elementMaterial.data('price'),
				basePrice,
				baseWidth,
				baseDepth,
				false,
				0,
			);
			materialPrice =
				'(n/a)' === materialPrice || '(call for pricing)' === materialPrice
					? materialPrice
					: isNaN(materialPrice)
						? 0
						: materialPrice;
			if (elementMaterial.length && 'none' !== materialType) {
				const dataGroup = {
					name: value,
					options: [
						{
							label: `Material: ${elementMaterial.data('label')}`,
							price: _this._isShowPrice ? materialPrice : 0,
						},
					],
				};
				insulationData.push(dataGroup);
			}
		});

		const indexElectricalPackageInclude = _this.getIndexElectricalPackageInclude( _this._seadevShedBuilder._electricalPackageID );
		if (
			componentPackage.hasPackage &&
			_this._seadevShedBuilder._electricalPackageID !== 'none'
		) {
			const elementElectricalPackages = $(
				'[name="ssb-configurator-electrical-packages"]:checked',
			);
			let priceElectricalPackage = elementElectricalPackages.attr('data-price');
			if ( _this._electricalPackageInclude.length > 0 ) {
				if( -1 !== indexElectricalPackageInclude ) {
					priceElectricalPackage = '(included)';
				} else {
					priceElectricalPackage =
						'' !== elementElectricalPackages.attr('data-discount')
							? elementElectricalPackages.attr('data-discount')
							: priceElectricalPackage;
				}
			}

			upgrades.push({
				label: _this._isManufactureEditOrder
					? elementElectricalPackages.attr('data-option-original-value')
					: elementElectricalPackages.val(),
				price: priceElectricalPackage,
				type: elementElectricalPackages.attr('data-price-type'),
			});
		}

		let fullElement = '';

		if (interiorFinishingData.length) {
			fullElement += this.pushElement(
				'Interior Finishing',
				this.buildShedDetailGroupElement(interiorFinishingData),
			);
		}

		const customUpcharge = this.getCustomUpcharge();
		if (customUpcharge.length) {
			for (let i = 0; i < customUpcharge.length; i++) {
				upgrades.push({
					label: customUpcharge[i].description
						? `${customUpcharge[i].name} <i class="fas fa-info-circle" ssb-toggle="tooltip" title="${customUpcharge[i].description}"></i>`
						: customUpcharge[i].name,
					price: customUpcharge[i].price,
					type: customUpcharge[i].priceType,
				});
			}
		}

		if (upgrades.length || insulationData.length > 0) {
			let sideElements = '';

			upgrades.forEach((p) => {
				let tQuantity = '';
				let priceElement = '';
				if (_this._isShowPrice) {
					if (
						'(included)' === p.price ||
						'(n/a)' === p.price ||
						'(call for pricing)' === p.price
					) {
						priceElement = `${helpers.getPriceElement(p.price, _this._isShowPrice)}`;
					} else {
						let endPrice = Number(
							this.calculatePriceByType(
								p.type,
								p.price,
								basePrice,
								baseWidth,
								baseDepth,
								false,
								0,
								p.minPrice,
								p.maxPrice,
							),
						);
						endPrice = isNaN(endPrice) ? 0 : endPrice;
						if (p.quantity > 1) {
							endPrice *= p.quantity;
						}
						priceElement = `${helpers.getPriceElement(endPrice, _this._isShowPrice)}`;
					}

					if (p.type === 'n_a') {
						priceElement = `${helpers.getPriceElement('(n/a)', _this._isShowPrice)}`;
					} else if (p.type === 'call_for_pricing') {
						priceElement = `${helpers.getPriceElement('(call for pricing)', _this._isShowPrice)}`;
					}
				}

				if (p.quantity > 1) {
					tQuantity = `x ${p.quantity}`;
				}

				sideElements += `
                    <li>
                        <div class="item">
                            <p class="left">${p.label} ${tQuantity}</p>
                            ${priceElement}
                        </div>
                    </li>
                `;
			});

			if (insulationData.length > 0) {
				sideElements += this.buildShedDetailGroupElement(insulationData);
			}

			fullElement += this.pushElement('Upgrades', sideElements);
		}

		for (const key of Object.keys(elements)) {
			let sideData = elements[key];
			let sideName = '';
			let sideElements = '';

			sideData.forEach((item) => {
				sideName = item.sideName;
				sideElements += _this.buildShedDetailElement(item);
			});

			fullElement += this.pushElement(sideName, sideElements);
		}

		if ('' !== fullElement) {
			const html = `
                <div class="wrap-content">
                    <h5 class="ssb-configurator-group-name">Upgrades, Flooring & Interior</h5>
                    ${fullElement}
                </div>
            `;
			$('#js-interior-content').html(html);
		} else {
			$('#js-interior-content').html('');
		}

		this.shedDetailRenderCreditItem();
	}

	buildShedDetailElement(element) {
		let colorText = '';
		const componentName =
			this._isManufactureEditOrder && element.original_text
				? element.original_text
				: element.text;

		if (helpers.hasKeyInArray(typeHasColor, element.type)) {
			colorText = `<ul class="color">`;
			if (element.colors && element.colors.length > 0) {
				element.colors.forEach((color) => {
					if (color.display) {
						colorText += `<li>
                                <div class="item">
                                    <p class="left">${color.type_display}: ${color.display}</p>
                                    ${helpers.getPriceElement(color.color_price, this._isShowPrice, this._isShowUpgradeChargeInfo)}
                                </div>
                            </li>`;
					}
				});
			}
			colorText += `</ul>`;
		}

		return `<li>
            <div class="item">
                <p class="left type-${element.type}">${componentName}</p>
                ${helpers.getPriceElement(element.price, this._isShowPrice)} 
                ${colorText}
            </div>
        </li>`;
	}

	buildShedDetailGroupElement(group) {
		let html = '';
		if (0 === group.length) return '';
		group.forEach((item) => {
			let htmlOption = '';
			if (item.options.length) {
				htmlOption += '<ul>';
				item.options.forEach((optionItem) => {
					htmlOption += `<li>
                        <div class="item">
                            <p class="left">${optionItem.label}</p>
                            ${helpers.getPriceElement(optionItem.price, this._isShowPrice)} 
                        </div>
                    </li>`;
				});
				htmlOption += '</ul>';
			}

			html += `<li>
                <div class="item">
                    <p class="left">${item.name}</p>
                </div>
                ${htmlOption}
            </li>`;
		});

		return html;
	}

	hideConfiguratorGroup() {
		$('#ssb-configurator-accordion .ssb-configurator-panel.display-thumbnail').each(
			function (index, panel) {
				let isPanelShow = 0;
				$(panel)
					.find('.ssb-configurator-group')
					.each(function (index, group) {
						let options = $(group).find('.ssb-option.display-thumbnail').length;
						if (options < 2) {
							$(group).hide();
						} else {
							isPanelShow += 1;
						}
					});

				if (isPanelShow < 1) {
					$(panel).hide();
				} else {
					$(panel).show();
				}
			},
		);

		$('.ssb-configurator-options.ssb-configurator-upgrade').hide();
	}

	/**
	 * Hide size option configurator if less than 2 options
	 */
	hideSizeOptionsConfigurator() {
		$('.group-upgrade-lean-to-size-option, .group-upgrade-porch-size-option').each(
			function (index, group) {
				let options = $(group).find('.ssb-configurator-options input').length;
				if (options < 2) {
					$(group).hide();
				}
			},
		);
	}

	getAddOn(key, elements, isShareLink = false) {
		let addOns = [];
		for (let k in elements) {
			if (elements[k].parent === key) {
				const dataChild: any = {
					key: elements[k].key,
					price: $('[data-upgrade-component-name="' + elements[k].name + '"]').attr(
						'data-price',
					),
					name: elements[k].name,
					niceName: $(`[for="${elements[k].name}"] input`).data('option-value'),
					side: elements[k].side,
					type: elements[k].type,
					colors: elements[k].colors,
					uuid: elements[k].uuid,
				};

				if (!isShareLink) {
					dataChild.originalNiceName = $(`[for="${elements[k].name}"] input`).data(
						'option-original-value',
					);
				}

				addOns.push(dataChild);
			}
		}

		return addOns;
	}

	getShareLinkData = (element) => {
		let results = [];

		$(`${element}`).each((i, v) => {
			const groupKey = window.atob($(v).data('group-key'));
			const customKey = window.atob($(v).data('custom-key'));
			const name = '' !== customKey ? customKey : $(v).data('option-value');
			const group =
				'' !== groupKey
					? groupKey
					: ($(v).attr('customize-group-name') ??
						$(v)
							.closest('.ssb-configurator-group')
							.find('.ssb-configurator-group-name')
							.text());
			const quantity = Number($(v).closest('div').find('.upgrade-quantity').val()) || 1;

			results.push({ name, quantity, group });
		});

		return window.btoa(JSON.stringify(results));
	};

	async generateShedUrl() {
		const layoutId = $(
			'#ssb-configurator-layout-option input[name="ssb-configurator-layout"]:checked',
		).data('layout-id');
		const size = $('#js-shed-data input[name="ssb-option-size"]').val();
		const height = $('#js-shed-data input[name="ssb-option-size-height"]').attr('data-key');
		const sidingType = $('#js-shed-data input[name="ssb-option-siding-type"]').attr('data-key');
		const roofType = $('#js-shed-data input[name="ssb-option-roof-type"]').attr('data-key');
		const sidingColor = $('#js-shed-data input[name="ssb-option-siding-color"]').attr(
			'data-key',
		);
		const trimColor = $('#js-shed-data input[name="ssb-option-trim-color"]').attr('data-key');
		const ventColor = $('#js-shed-data input[name="ssb-option-vent-color"]').attr('data-key');
		const windowColor = $('#js-shed-data input[name="ssb-option-windows-color"]').attr(
			'data-key',
		);
		const railsColor = $('#js-shed-data input[name="ssb-option-rails-color"]').attr('data-key');
		const roofColor = $('#js-shed-data input[name="ssb-option-roof-color"]').attr('data-key');
		const shutterColor = $('#js-shed-data input[name="ssb-option-shutter-color"]').attr(
			'data-key',
		);
		const doorColor = $('#js-shed-data input[name="ssb-option-door-color"]').attr('data-key');
		const roofOverhang = this.getRoofOverhangShareableLink();
		const loftConfig = $('input[name="ssb-configurator-upgrade-loft"]:checked').attr(
			'data-key',
		);
		const oPosition = $('input[name="ssb-configurator-upgrade-opening-position"]:checked').attr(
			'data-key',
		);
		const porch = $('input[name="ssb-configurator-upgrade-porch"]:checked').attr(
			'data-option-value',
		);
		const roofPitch = $(
			'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
		).val();
		const legs = $('#js-shed-data input[name="ssb-option-legs"]').val();
		const frameSpacing = $('#js-shed-data input[name="ssb-option-frame-spacing"]').val();
		const packages = this.getShareLinkData('[name="ssb-configurator-upgrade-package"]:checked');
		const others = this.getShareLinkData(
			'[data-option-key="ssb-option-upgrade-other"]:checked',
		);
		const levelingFee = this.getPackagesOption('#foundation-options input:checked');
		const tackDoor = $('#js-enable-tack-door').is(':checked') || undefined;
		const components = this.getListComponents('exterior', true);
		const iComponents = this.getListComponents('interior', true);
		const ePackagesId = $('[name="ssb-configurator-electrical-packages"]:checked').attr(
			'data-package-id',
		);
		const railing = this.isRailingEnable() || undefined;
		const externalPorch = this._seadevShedBuilder.isExternalPorch()
			? this._isEnabledExternalPorch
			: undefined;
		const leanTo = this._seadevShedBuilder.isEnableLeanTo() ? true : undefined;
		const jTrim = $('[name="j_trim"]:checked').val();
		const tackRoom = this._seadevShedBuilder._isEnableTackRoom
			? {
					position: $('input[name="ssb-configurator-upgrade-tackroom"]:checked').attr(
						'data-key',
					),
					side: this._seadevShedBuilder._sideWallTackRoom,
				}
			: undefined;
		const sidingColorCode = this.getColorPickerCode('siding');
		const roofColorCode = this.getColorPickerCode('roof');
		const trimColorCode = this.getColorPickerCode('trim');
		const shutterColorCode = this.getColorPickerCode('shutter');
		const doorColorCode = this.getColorPickerCode('door');
		const ventColorCode = this.getColorPickerCode('vent');
		const windowsColorCode = this.getColorPickerCode('windows');
		const railsColorCode = this.getColorPickerCode('rails');
		const floorMaterial = $('#floor-material-option li.active').data('key');
		const carportSidingData = this.getCarportSidingData(true);
		const customItems = $(
			'#js-shed-data input[name="ssb-option-custom-line-items-source"]',
		).val();
		const wainsCot = this.getWainscotingData('shareable');
		const eSidingUpgrades = this.getExteriorSidingUpgradesData('shareable');
		const t = Date.now().toString().substring(0, 6); // add Timestamp to shareable link
		const frame = $('[name="ssb-configurator-upgrade-frame"]:checked').data(
			'option-value-base64',
		);
		const dormer = $('[name="ssb-configurator-upgrade-dormer-option"]:checked').data('key');
		const leantoOption = $(
			'[name="ssb-configurator-upgrade-lean-to-size-option"]:checked',
		).data('key');
		const porchOption = $('[name="ssb-configurator-upgrade-porch-size-option"]:checked').data(
			'key',
		);

		const wallColor = $('#js-shed-data input[name="ssb-option-wall-color"]').attr('data-key');
		const ceilingColor = $('#js-shed-data input[name="ssb-option-ceiling-color"]').attr(
			'data-key',
		);
		const countertopsColor = $('#js-shed-data input[name="ssb-option-countertops-color"]').attr(
			'data-key',
		);
		const applianceColor = $('#js-shed-data input[name="ssb-option-appliance-color"]').attr(
			'data-key',
		);
		const wallColorCode = this.getColorPickerCode('wall');
		const ceilingColorCode = this.getColorPickerCode('ceiling');
		const countertopsColorCode = this.getColorPickerCode('countertops');
		const applianceColorCode = this.getColorPickerCode('appliance');
		const isSwapSideGable = helpers.isSwapSide();
		const interiorWallType = $(
			'#js-shed-data input[name="ssb-option-interior-wall-material-type"]',
		).attr('data-key');
		const interiorCeilingType = $(
			'#js-shed-data input[name="ssb-option-interior-ceiling-material-type"]',
		).attr('data-key');
		const insulationWallType = $(
			'#js-shed-data input[name="ssb-option-insulation-wall-material-type"]',
		).attr('data-key');
		const insulationRoofType = $(
			'#js-shed-data input[name="ssb-option-insulation-roof-material-type"]',
		).attr('data-key');
		const geoData = this.getCookie(this._cookiedValidate);

		const data = {
			size,
			height,
			sidingType,
			wainsCot,
			eSidingUpgrades,
			roofType,
			sidingColor,
			sidingColorCode,
			trimColor,
			roofColor,
			roofColorCode,
			shutterColor,
			components,
			iComponents,
			roofOverhang,
			porch,
			railing,
			packages,
			others,
			externalPorch,
			levelingFee,
			loftConfig,
			layoutId,
			doorColor,
			oPosition,
			tackDoor,
			ventColor,
			roofPitch,
			legs,
			frameSpacing,
			ePackagesId,
			carportSidingData,
			jTrim,
			windowColor,
			t,
			frame,
			dormer,
			leanTo,
			railsColor,
			trimColorCode,
			shutterColorCode,
			doorColorCode,
			ventColorCode,
			windowsColorCode,
			railsColorCode,
			leantoOption,
			porchOption,
			tackRoom,
			floorMaterial,
			wallColor,
			wallColorCode,
			ceilingColor,
			ceilingColorCode,
			countertopsColor,
			countertopsColorCode,
			applianceColor,
			applianceColorCode,
			isSwapSideGable,
			interiorWallType,
			interiorCeilingType,
			insulationRoofType,
			insulationWallType,
			geoData,
		};
		const jsonData = JSON.stringify(this.handleShareableLinkData(data));
		const dataBase64 = window.btoa(jsonData);

		const linkId = await this.storeShareableLinkData(dataBase64) as string;

		const ssb_settings = <any>window;
		/**Save custom line items to database */
		if ($('.ssb-share-model').hasClass('is_login') && customItems !== 'W10=') {
			$.ajax({
				type: 'post',
				url: ssb_settings.ssb.ajax_url,
				data: {
					action: 'ssb_save_custom_line_items',
					key: linkId,
					custom_items: customItems,
				},
			});
		}
		return {
			linkId,
			dataBase64,
		};
	}

	handleShareableLinkData = (data) => {
		if (data.levelingFee) {
			const args = JSON.parse(window.atob(data.levelingFee));

			const levelingFeeData = args.map((data) => {
				const { price, quantity, group, ...LFData } = data;
				return LFData;
			});

			data.levelingFee = window.btoa(JSON.stringify(levelingFeeData));
		}

		return helpers.objectFilter(
			data,
			(d) => undefined === d || '' === d || 'undefined||undefined' === d,
		);
	};

	getRoofOverhangShareableLink = () => {
		const overHangValue = $(
			`input[name="ssb-configurator-upgrade-roof_overhang"]:checked`,
		).val();
		const overHangKey = $(`input[name="ssb-configurator-upgrade-roof_overhang"]:checked`).attr(
			'data-value-base64',
		);

		return `${overHangValue}||${overHangKey}`;
	};

	getPriceTackDoor = (componentName, isOnlyTackDoor = false) => {
		const _this = this;
		let priceTackRoom = $('#js-enable-tack-door').data('price');
		let includePrice = $('#js-enable-tack-door').data('include-price');
		let priceTypeTackRoom = $('#js-enable-tack-door').data('price-type');
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = _this.getBasePrice();
		if (_this._seadevShedBuilder._isEnableTackRoom) {
			priceTackRoom = _this._seadevShedBuilder._dataTackroom.price;
			priceTypeTackRoom = _this._seadevShedBuilder._dataTackroom.priceType;
			includePrice = _this._seadevShedBuilder._dataSettingsTackroom['include_tackroom_door']
				? 1
				: 0;
			priceTackRoom = Number(
				_this.calculatePriceByType(
					priceTypeTackRoom,
					priceTackRoom,
					basePrice,
					baseWidth,
					baseDepth,
					false,
				),
			);
		}
		const priceDoor = $(`[data-upgrade-component-name="${componentName}"]`).data('price');
		const priceTypeDoor = $(`[data-upgrade-component-name="${componentName}"]`).data(
			'price-type',
		);
		let price = 0;
		if (
			'' !== priceDoor &&
			'' !== priceTypeDoor &&
			undefined !== priceDoor &&
			undefined !== priceTypeDoor
		) {
			price = Number(
				_this.calculatePriceByType(
					priceTypeDoor,
					priceDoor,
					basePrice,
					baseWidth,
					baseDepth,
					false,
				),
			);
		}

		priceTackRoom = isOnlyTackDoor || isNaN(priceTackRoom) ? 0 : priceTackRoom;

		if (1 === includePrice) {
			price = priceTackRoom;
		} else {
			price = isNaN(price) ? 0 : price;
			price = price + priceTackRoom;
		}

		return price;
	};

	getListComponents(face = 'exterior', isShareLink = false) {
		let walls = this._seadevShedBuilder._walls;
		let components = {};
		for (let k1 in walls) {
			for (let k2 in walls[k1]) {
				if (Object.keys(walls[k1][k2]).length > 0) {
					for (let k3 in walls[k1][k2]) {
						const unsetKey = [
							'niceName',
							'details',
							'price',
							'priceDiscount',
							'key',
							'face',
						];
						if (!this._seadevShedBuilder._isEnableTackRoom) {
							unsetKey.push('isTackDoor');
						}
						const comp = walls[k1][k2][k3];

						if (comp.isHidden || comp.face !== face) {
							continue;
						}

						if (null === comp.parent) {
							const shutters =
								'windows' === comp.type
									? this._seadevShedBuilder.getShuttersInObjectBySide(k1)
									: {};
							const allComponents = { ...walls[k1][k2], ...shutters };
							const childs = this.getAddOn(comp.key, allComponents, isShareLink);
							let niceName = $(
								`.ssb-configurator-options.ssb-configurator-upgrade.${comp.type}`,
							)
								.find(`input[data-uuid="${comp.uuid}"]`)
								.attr('data-option-value');
							let originalNiceName =
								$(`.ssb-configurator-options.ssb-configurator-upgrade.${comp.type}`)
									.find(`input[data-uuid="${comp.uuid}"]`)
									.attr('data-option-original-value') ?? niceName;
							if (undefined === niceName) {
								niceName = comp.name
									.split('_')
									.map((n) => n.charAt(0).toUpperCase() + n.slice(1))
									.join(' ');
							}

							niceName = niceName.trim();
							let price: any = jQuery(`.ssb-configurator-options.ssb-configurator-upgrade.${comp.type}`)
									.find(`[data-uuid="${comp.uuid}"]`).attr('data-price');
							let isTackDoor = false;
							if (
								('structure_lofted_horserunin' ===
									this._seadevShedBuilder._shedType ||
									'structure_aframe_horserunin' ===
										this._seadevShedBuilder._shedType ||
									'structure_horse_shelter' ===
										this._seadevShedBuilder._shedType) &&
								'left' === comp.side &&
								this._seadevShedBuilder.getTackDoor() === comp.name
							) {
								const labelTackRoom = $('#js-enable-tack-door').data('label');
								niceName = `${labelTackRoom} - ${niceName}`;
								price = this.getPriceTackDoor(comp.name);
								isTackDoor = true;
							}

							if (
								this._seadevShedBuilder._isEnableTackRoom &&
								this._seadevShedBuilder._sideWallTackRoom === comp.side &&
								comp.isTackDoor
							) {
								niceName = `Tackroom door - ${niceName}`;
								isTackDoor = true;
							}

							if (isShareLink && !this._seadevShedBuilder._isEnableTackRoom) {
								if (isTackDoor) continue;

								childs.forEach((v, c) => {
									unsetKey.forEach((k) => delete childs[c][k]);
								});
							}

							const compArgs = {
								key: comp.key,
								name: comp.name,
								uuid: comp.uuid,
								niceName,
								originalNiceName,
								isTackDoor,
								details: $(`[data-component-key="${comp.key}"]`).text().trim(),
								side: comp.side,
								type: comp.type,
								price,
								priceDiscount: $(
									'[data-uuid="' + comp.uuid + '"]',
								).attr('data-price-discount'),
								childs,
								face: comp.face,
								componentSize: comp.componentSize,
								position: {
									x: Number(comp.meshes[0]._position.x.toString()),
									y: Number(comp.meshes[0]._position.y.toString()),
									z: Number(comp.meshes[0]._position.z.toString()),
								},
								colors: comp.colors,
								isBlock: comp.isBlock,
								blockOptions: comp.blockOptions,
								horizontal: comp.horizontal,
								vertical: comp.vertical,
								rotation: {
									x: Number(comp.meshes[0]._rotation.x.toString()),
									y: Number(comp.meshes[0]._rotation.y.toString()),
									z: Number(comp.meshes[0]._rotation.z.toString()),
								},
							};

							if ('door' === comp.type && comp['defaultLock'] && comp['customLock']) {
								compArgs['lockData'] = {
									defaultLock: comp['defaultLock'],
									customLock: comp['customLock'],
									enableHinge: comp['enableHinge'],
									lockPrice: comp['lockPrice'],
								};
							}

							if (isShareLink) {
								if (undefined === comp.componentSize)
									unsetKey.push('componentSize');
								if (0 === childs.length) unsetKey.push('childs');
								unsetKey.push('originalNiceName');
								unsetKey.forEach((k) => delete compArgs[k]);
							}

							if (components.hasOwnProperty(comp.type)) {
								components[comp.type].push(compArgs);
							} else {
								components[comp.type] = [compArgs];
							}
						}
					}
				}
			}
		}

		if (isShareLink && 0 === Object.keys(components).length) return undefined;
		return components;
	}

	/**
	 * Calculate price and return data of the package to add to cart
	 *
	 * @param   {htmlElement} element HTML Element of package option
	 * @returns {string}
	 */
	getPackagesOption = (element, customize: any = false) => {
		const _this = this;
		let results = [];
		let price: any = '';
		let isPorch = false;

		$(`${element}`).each((i, v) => {
			let name = $(v).data('option-value');
			let group =
				$(v).attr('customize-group-name') ??
				$(v).closest('.ssb-configurator-group').find('.ssb-configurator-group-name').text();
			let excludeDealer: any = $(v).attr('data-exclude')
				? $(v).attr('data-exclude').split(',')
				: [];

			const quantity =
				Number($(v).closest('div').find('.upgrade-quantity').val()) || Number(1);

			if (-1 !== element.indexOf('ssb-configurator-upgrade-external-porch')) {
				name = this.getExternalPorchLabel();
			}

			if (-1 !== element.indexOf('ssb-configurator-upgrade-porch')) {
				let railingText = $('input.ssb_porch-railing:checked').val();

				if ('With Railing' === railingText) {
					let oPosition = _this._seadevShedBuilder.getOpeningPosition();
					name = name + ' - ' + oPosition.charAt(0).toUpperCase() + oPosition.slice(1);
				}

				if (!railingText) {
					railingText = 'No Railing';
				}
				name += ' (' + railingText + ')';
			}

			const type = $(v).data('price-type');
			const excludePrice =
				excludeDealer.length && _this._lotID && excludeDealer.includes(_this._lotID);
			const minPrice = $(v).data('min-price');
			const maxPrice = $(v).data('max-price');

			price = excludePrice ? '' : $(v).data('price');

			if (type === 'n_a') {
				price = '(n/a)';
			} else if (type === 'call_for_pricing') {
				price = '(call for pricing)';
			}

			if ('' !== price) {
				const baseWidth = helpers.getBaseWidth();
				const baseDepth = helpers.getBaseDepth();
				const basePrice = this.getBasePrice();
				price = this.calculatePriceByType(
					type,
					price,
					basePrice,
					baseWidth,
					baseDepth,
					false,
					0,
					minPrice,
					maxPrice,
				);
			}
			if (
				-1 !== element.indexOf('ssb-configurator-upgrade-porch') ||
				-1 !== element.indexOf('ssb-configurator-upgrade-external-porch')
			) {
				price += _this.calculateRailingPrice();
				isPorch = true;
			}
			let itemResult: any = {};
			if (_this.isEnableManufacturer() && customize) {
				let original_group = $(v).attr('origin-group-name') ?? group;
				let original_name = $(v).attr('origin-value') ?? name;
				itemResult = { name, price, quantity, group, original_group, original_name };
			} else {
				itemResult = { name, price, quantity, group };
			}
			if (isPorch && $('[name="ssb-configurator-upgrade-opening-position"]').length) {
				const porchOpenPosition = $(
					'[name="ssb-configurator-upgrade-opening-position"]',
				).val();
				itemResult.position = porchOpenPosition;
			}
			results.push(itemResult);
		});

		if (
			-1 !== element.indexOf('ssb-option-upgrade-other') &&
			this._seadevShedBuilder.isEnableLeanTo()
		) {
			const baseWidth = helpers.getBaseWidth();
			const baseDepth = helpers.getBaseDepth();
			const basePrice = this.getBasePrice();
			const priceType = $('[name=ssb-configurator-upgrade-lean-to]:checked').data(
				'price-type',
			);
			const priceItem = $('[name=ssb-configurator-upgrade-lean-to]:checked').data('price');
			const price = this.calculatePriceByType(
				priceType,
				priceItem,
				basePrice,
				baseWidth,
				baseDepth,
				false,
			);

			results.push({
				name: $('[name=ssb-configurator-upgrade-lean-to]:checked').attr('origin-value'),
				price,
				quantity: 1,
				group: $('[name=ssb-configurator-upgrade-lean-to]:checked').attr(
					'origin-group-name',
				),
			});
		}

		if (
			-1 !== element.indexOf('ssb-option-upgrade-other') &&
			this._seadevShedBuilder._isEnableTackRoom
		) {
			const tackroomData = this.getTackRoomData();
			if (!helpers.isEmptyObject(tackroomData)) {
				results.push(tackroomData);
			}
		}

		if (-1 !== element.indexOf('ssb-option-upgrade-other')) {
			const sideGableData = _this.getSideGableData();
			if (!helpers.isEmptyObject(sideGableData)) {
				results.push(sideGableData);
			}
		}

		if (results.length <= 0) {
			return '';
		}

		const jsonData = JSON.stringify(results);
		return window.btoa(jsonData);
	};

	getPorchData = () => {
		const _this = this;
		let element: any = '';
		const basePrice = _this.getBasePrice();
		let porchType = 'internal';
		if (_this._isEnabledExternalPorch) {
			porchType = 'external';
			element = $('[name="ssb-configurator-upgrade-external-porch"]:checked');
		} else {
			if (this._seadevShedBuilder.isHidePorchInfo()) return '';
			element = $('[name="ssb-configurator-upgrade-porch"]:checked');
		}
		if (0 === element.length) return '';
		const railing = $('input.ssb_porch-railing:checked').val();
		const railingPrice = _this.getRailingPrice();
		const price = element.attr('data-price');
		const priceType = element.attr('data-price-type');
		const porchName = element.attr('data-option-value');
		const porchSize = element.attr('data-porch-size');
		const porchPrice = _this.calculatePriceByType(
			priceType,
			price,
			basePrice,
			helpers.getBaseWidth(),
			helpers.getBaseDepth(),
			false,
		);

		return window.btoa(
			JSON.stringify({ porchType, porchName, porchSize, porchPrice, railing, railingPrice }),
		);
	};

	// TODO  @group [data][shareablelink][order][wainscoting]
	// Reason: return mulitple purpose and can be duplicate with other getWainscotingData
	getWainscotingData = (type: string = '') => {
		const wainscotingData = this._seadevShedBuilder.getWainscotingData();
		if (helpers.isEmptyObject(wainscotingData)) {
			return '';
		}

		const wType = this._seadevShedBuilder._wainscotingType;
		const wainsSide = this._seadevShedBuilder._wainscotingSide;
		if ('shareable' !== type && (1 === wType || (3 === wType && 0 === wainsSide.length))) {
			return '';
		}

		const basePrice = this.getBasePrice();
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const colorName = $('#js-shed-data input[name="ssb-option-wainscoting-color"]').val();
		const colorCode = $('#js-shed-data input[name="ssb-option-wainscoting-color"]').attr(
			'data-color',
		);
		const colorKey = $('#js-shed-data input[name="ssb-option-wainscoting-color"]').attr(
			'data-key',
		);
		const wainscotPrice = this.calculatePriceByType(
			wainscotingData.priceType,
			wainscotingData.price,
			basePrice,
			baseWidth,
			baseDepth,
			false,
		);
		const materialKey = $('#wainscoting-material-option li.active').attr('data-key');
		const material = $('#wainscoting-material-option li.active .ssb-option-name').text();
		const sideName =
			2 === wType ? ['All sides'] : wainsSide.map((key) => this.getSideLabel(key));
		const sides = sideName.join(', ');
		let display = [];

		const colorPrice = $('.group-wainscoting-color .active').attr('data-price');
		const colorPriceType = $('.group-wainscoting-color .active').attr('data-price-type');
		const colorPriceItem = $('.group-wainscoting-color .active').attr('data-price');
		const endClorPrice = this.calculatePriceByType(
			colorPriceType,
			colorPrice,
			basePrice,
			baseWidth,
			baseDepth,
			false,
		);
		if (2 === wType || (3 == wType && sides.length > 0)) {
			display = [
				{
					key: 'Wainscot',
					slug: 'wainscot',
					value:
						wainscotingData.materials.length > 1
							? `${wainscotingData.name} - ${material}`
							: wainscotingData.name,
					price: wainscotPrice,
					priceType: wainscotingData.priceType,
					priceItem: wainscotingData.price,
				},
				{
					key: 'Wainscot Color',
					slug: 'wainscot-color',
					value: colorName,
					price: endClorPrice,
					priceType: colorPriceType,
					priceItem: colorPriceItem,
				},
				{
					key: 'Wainscot Side(s)',
					value: sides,
					price: 0,
					priceType: 'fixed',
					priceItem: 0,
				},
			];
		}

		let data: object = {
			display,
			material,
			sideName,
			colorCode,
			colorName,
			colorPrice: endClorPrice,
			type: wType,
			price: wainscotPrice,
			name: wainscotingData.name,
			side: wainsSide,
		};

		if ('shareable' === type) {
			const colorCode = this.getColorPickerCode('wainscoting');
			const wainsKey = $('.ssb_wainscoting:checked').attr('data-key');
			data = {};
			if (2 === wType) {
				data = { wainsKey, colorKey, material: materialKey, wainsType: wType, colorCode };
			}
			if (3 === wType) {
				data = {
					wainsKey,
					colorKey,
					material: materialKey,
					wainsSide,
					wainsType: wType,
					colorCode,
				};
			}
		}

		return window.btoa(JSON.stringify(data));
	};

	/**
	 * Retrieves and processes the selected Exterior Siding Upgrades data based on the provided type.
	 *
	 * @param {string} [type=''] - Specifies whether to return full data or a shareable version.
	 *                             Use 'shareable' for a shareable format.
	 * @return {string} Base64-encoded JSON string with the Exterior Siding Upgrades data.
	 */
	getExteriorSidingUpgradesData = (type: string = '') => {
		const data = this._seadevShedBuilder.getExteriorSidingUpgradesInfo();
		const key = $(
			'.ssb-configurator-options.exterior_siding_upgrades .ssb-option:checked',
		).attr('data-key');

		if ('shareable' === type && 'none' === key) {
			return window.btoa(JSON.stringify({ key }));
		}

		if (!key || 'none' === key || helpers.isEmptyObject(data)) {
			return '';
		}

		const material = $(
			'#exterior_siding_upgrades-material-option li.active .ssb-option-name',
		).text();
		const materialKey = $('#exterior_siding_upgrades-material-option li.active').attr(
			'data-key',
		);
		const colorName = $(
			'.group-exterior_siding_upgrades-color ul li.active .ssb-option-name',
		).text();
		const colorType = $('.group-exterior_siding_upgrades-color ul li.active').attr(
			'data-texture-type',
		);
		const colorCode =
			'color_picker' === colorType
				? $('.group-exterior_siding_upgrades-color ul li.active').attr('data-texture-color')
				: '';
		const colorKey = $('.group-exterior_siding_upgrades-color ul li.active').attr('data-key');
		const price = this.calculatePriceByType(
			data.priceType,
			data.price,
			this.getBasePrice(),
			helpers.getBaseWidth(),
			helpers.getBaseDepth(),
			false,
		);
		const sideName = data.side.map((key) => this.getSideLabel(key));
		const sides = sideName.join(', ');
		const colorPrice = 0;

		const display = [
			{
				key: 'Exterior Siding Upgrades',
				slug: 'exterior_siding_upgrades',
				value: `${data.name} - ${material}`,
				price: price,
				priceType: data.priceType,
				priceItem: data.price,
			},
			{
				key: 'Exterior Siding Upgrades Color',
				slug: 'exterior_siding_upgrades-color',
				value: colorName,
				price: 0,
			},
			{
				key: 'Exterior Siding Upgrades Side(s)',
				value: sides,
				price: 0,
				priceType: 'fixed',
				priceItem: 0,
			},
		];

		let res: object = {
			display,
			material,
			sideName,
			colorCode,
			colorName,
			colorPrice,
			price,
			name: data.name,
			side: sides,
		};

		if ('shareable' === type) {
			res = { key, materialKey, colorCode, colorKey };
		}

		return window.btoa(JSON.stringify(res));
	};

	getComponentForCart = (components, face = 'exterior') => {
		let elements: object = [];
		if ('interior' === face) {
			elements = this.getShedDetailText(components);
		} else {
			elements = this.pushOpeningToRightElements(this.getShedDetailText(components, face));
		}

		const jsonData = JSON.stringify(elements);

		return window.btoa(jsonData);
	};

	getShedColor = () => {
		const sidingColor = $('input[name=ssb-option-siding-color]').attr('data-color');
		const trimColor = $('input[name=ssb-option-trim-color]').attr('data-color');
		const roofColor = $('input[name=ssb-option-roof-color]').attr('data-color');
		const shutterColor = $('input[name=ssb-option-shutter-color]').attr('data-color');
		const doorColor = $('input[name=ssb-option-door-color]').attr('data-color');
		const ventColor = $('input[name=ssb-option-vent-color]').attr('data-color');
		const windowColor = $('input[name=ssb-option-windows-color]').attr('data-color');

		const wallColor = $('input[name=ssb-option-wall-color]').attr('data-color');
		const ceilingColor = $('input[name=ssb-option-ceiling-color]').attr('data-color');
		const countertopsColor = $('input[name=ssb-option-countertops-color]').attr('data-color');
		const applianceColor = $('input[name=ssb-option-appliance-color]').attr('data-color');

		return window.btoa(
			JSON.stringify({
				sidingColor,
				trimColor,
				roofColor,
				shutterColor,
				doorColor,
				ventColor,
				windowColor,
				wallColor,
				ceilingColor,
				countertopsColor,
				applianceColor,
			}),
		);
	};

	async handleDataInputHide(thumbnails = []) {
		let _this = this;
		const components = _this.getListComponents('exterior');
		const iComponents = _this.getListComponents('interior');

		const porches = this._seadevShedBuilder.isHidePorchInfo()
			? ''
			: _this.getPackagesOption('[name="ssb-configurator-upgrade-porch"]:checked');
		const porchSize = $('[name="ssb-configurator-upgrade-porch"]:checked').attr(
			'data-porch-size',
		);
		const externalPorch = _this.getPackagesOption(
			'[name="ssb-configurator-upgrade-external-porch"]:checked',
		);
		const packages = _this.getPackagesOption(
			'[name="ssb-configurator-upgrade-package"]:checked',
			true,
		);
		const others = helpers.mergeAndEncodeUpcharges(
			_this.getCustomUpcharge(),
			_this.getPackagesOption('[data-option-key="ssb-option-upgrade-other"]:checked', true),
		);
		const overhang = _this.getPackagesOption(
			'[name="ssb-configurator-upgrade-roof_overhang"]:checked',
			true,
		);
		const side = $('.ssb-configurator-layout .ssb-option:checked').attr(
			'data-layout-main-side',
		);
		const [imageMain, imageFront, imageBack, imageLeft, imageRight] =
			thumbnails.length > 0 ? thumbnails : await this.captureAllThumbnails(side);
		const door = _this.getUpgradeType(components, 'door');
		const shedColor = _this.getShedColor();
		const loft = _this.getPackagesOption(
			'[name="ssb-configurator-upgrade-loft"]:checked',
			true,
		);
		const roofPitch = _this.getRoofPitchData();
		const ePackage = _this.getElectricalPackageData();
		const carportSiding = window.btoa(JSON.stringify(_this.getCarportSidingData()));
		const legs = _this.getPackagesOption(
			'[name="ssb-configurator-upgrade-legs_setting"]:checked',
		);
		const frameSpacing = _this.getPackagesOption(
			'[name="ssb-configurator-upgrade-frame_spacing"]:checked',
		);
		const sidingKey = $('.woocommerce.single input[name="ssb-option-siding-type"]').attr(
			'data-key',
		);
		const heightDisplay = $('#ssb-configurator-height').css('display');
		const porchData = _this.getPorchData();
		const porchColorData = _this.getPorchDataColor()
			? window.btoa(JSON.stringify(_this.getPorchDataColor()))
			: '';
		const floorMaterial = _this.getFloorMaterialData();
		const credits = _this.getCreditItem();
		const finishingInterior = _this.getDataInteriorWall('finishing_interior');
		const insulationInterior = _this.getDataInteriorWall('insulation_interior');
		const generateShedUrl = await _this.generateShedUrl();
		this._base64Data = generateShedUrl?.dataBase64;

		// const temporaryData   = { image: {
		//     FreeCamera: await this._seadevShedBuilder.captureImage()
		// } };

		$('.woocommerce.single input[name="ssb-model-brand"]').val(
			_this._seadevShedBuilder._canvas.getAttribute('data-model-brand'),
		);
		$('.woocommerce.single input[name="ssb-shed-url"]').val(generateShedUrl?.linkId);
		$('.woocommerce.single input[name="ssb-option-upgrade-door"]').val(door);
		$('.woocommerce.single input[name="ssb-option-upgrade-windows"]').val(
			_this.getUpgradeType(components, 'windows'),
		);
		$('.woocommerce.single input[name="ssb-option-components"]').val(
			_this.getComponentForCart(components),
		);
		$('.woocommerce.single input[name="ssb-option-components-interior"]').val(
			_this.getComponentForCart(iComponents, 'interior'),
		);
		$('.woocommerce.single input[name="ssb-option-upgrade-porch"]').val(
			_this._isEnabledExternalPorch ? externalPorch : porches,
		);
		$('.woocommerce.single input[name="ssb-option-porch-size"]').val(porchSize);
		$('.woocommerce.single input[name="ssb-option-porch-data"]').val(porchData);
		$('.woocommerce.single input[name="ssb-option-upgrade-package"]').val(packages);
		$('.woocommerce.single input[name="ssb-option-upgrade-other"]').val(others);
		$('.woocommerce.single input[name="ssb-option-roof-overhang"]').val(overhang);
		$('.woocommerce.single input[name="ssb-option-thumbnail"], #r-thumbnail').val(imageMain);
		$('.woocommerce.single input[name="ssb-option-thumbnail-front"], #r-thumbnail-front').val(
			imageFront,
		);
		$('.woocommerce.single input[name="ssb-option-thumbnail-back"], #r-thumbnail-back').val(
			imageBack,
		);
		$('.woocommerce.single input[name="ssb-option-thumbnail-left"], #r-thumbnail-left').val(
			imageLeft,
		);
		$('.woocommerce.single input[name="ssb-option-thumbnail-right"], #r-thumbnail-right').val(
			imageRight,
		);
		$('.woocommerce.single input[name="ssb-option-shed-color"]').val(shedColor);
		$('.woocommerce.single input[name="ssb-option-roof-material-price"]').val(
			this.getRoofMaterialPrice(),
		);
		$('.woocommerce.single input[name="ssb-option-model-name"]').val(
			_this._seadevShedBuilder._shedType,
		);
		$('.woocommerce.single input[name="ssb-option-loft"]').val(loft);
		$('.woocommerce.single input[name="ssb-option-roof-pitch"]').val(roofPitch);
		$('.woocommerce.single input[name="ssb-option-electrical-package"]').val(ePackage);
		$('.woocommerce.single input[name="ssb-option-carport-siding-data"]').val(carportSiding);
		$('.woocommerce.single input[name="ssb-option-legs"]').val(legs);
		$('.woocommerce.single input[name="ssb-option-frame-spacing"]').val(frameSpacing);
		$('.woocommerce.single input[name="ssb-option-siding-type-key"]').val(sidingKey);
		$('.woocommerce.single input[name="ssb-option-base-price"]').val(_this.getBasePrice());
		$('.woocommerce.single input[name="ssb-option-default-base-price"]').val(
			_this.getBasePrice(true),
		);
		$('.woocommerce.single input[name="ssb-option-layout-charge-price"]').val(
			_this.getLayoutCharge(),
		);
		$('.woocommerce.single input[name="ssb-option-wainscoting"]').val(
			this.getWainscotingData(),
		);
		$('.woocommerce.single input[name="ssb-option-exterior-siding-upgrades"]').val(
			this.getExteriorSidingUpgradesData(),
		);
		// $( '.woocommerce.single input[name="temporary-data"]' ).val( window.btoa( JSON.stringify( temporaryData ) ) );
		$('.woocommerce.single input[name="ssb-option-frame"]').val(this.getFrameData());
		$('.woocommerce.single input[name="ssb-option-porch-data-color"]').val(porchColorData);
		$('.woocommerce.single input[name="ssb-option-quaker-width"]').val(
			this._seadevShedBuilder._quakerWidth,
		);
		$('.woocommerce.single input[name="ssb-option-mfr-fees"]').val(this.getManufacturerFees());
		$('.woocommerce.single input[name="ssb-option-floor-material"]').val(floorMaterial);

		if (finishingInterior.length > 0) {
			$('.woocommerce.single input[name="ssb-option-finishing-interior"]').val(
				window.btoa(JSON.stringify(finishingInterior)),
			);
		}

		if (insulationInterior.length > 0) {
			$('.woocommerce.single input[name="ssb-option-insulation-interior"]').val(
				window.btoa(JSON.stringify(insulationInterior)),
			);
		}

		if (credits.length > 0) {
			$('.woocommerce.single input[name="ssb-option-credit"]').val(
				window.btoa(JSON.stringify(credits)),
			);
		}

		if ('none' === heightDisplay) {
			const width = helpers.getBaseWidth();
			const length = helpers.getBaseDepth();
			$('.woocommerce.single input[name="ssb-option-size"]').val(`${width}x${length}`);
			$('.woocommerce.single input[name="ssb-option-size"]').attr(
				'data-key',
				`${width}x${length}`,
			);
		}

		const sizeLabel = helpers.getSizeLabel();
		$('.woocommerce.single input[name="ssb-sizes-display"]').val(
			window.btoa(JSON.stringify(sizeLabel['label'])),
		);
		$('.woocommerce.single input[name="ssb-option-custom-line-items"]').val(
			_this.getDataCustomLineItems(),
		);
		$('.woocommerce.single input[name="other-line-items"]').val(_this.getDataCustomFees(true));
	}

	getDataCustomLineItems = () => {
		var customData: any = [];
		var customDataInput: any = [];
		if ($('.custom-item-wrap').length) {
			$('.custom-item-wrap').each(function () {
				var encodeData: any = [];
				var tax = $(this).find('.item-col-tax input[type="checkbox"]');
				$(this)
					.find('.default-input')
					.each(function () {
						let itemData = $(this).val();
						encodeData.push(itemData);
					});
				encodeData.push(tax.is(':checked') ? `yes` : `no`);
				customData.push(encodeData);
			});
		}
		customDataInput = this.shedDetailRenderCustomLineItem(customData, true);
		if (0 == customDataInput.length) return '';

		return window.btoa(JSON.stringify(customDataInput));
	};

	getDataCustomFees = (isToString = false) => {
		if (0 == $('.custom-item-wrap').length) {
			return isToString ? '' : [];
		}
		let results = [];
		const _this = this;
		const basePrice = _this.getBasePrice();
		$('.custom-item-wrap').each(function () {
			const taxable = $(this).find('.item-col-tax input[type="checkbox"]').is(':checked')
				? 'yes'
				: 'no';
			const unitPrice = $(this).find('.item-col-price .default-input').val();
			const priceType = $(this).find('.item-col-price-type .default-input').val();
			const name = $(this).find('.item-col-name .default-input').val();
			const quantity = $(this).find('.item-col-qty .default-input').val();
			const price = _this.calculatePriceByType(priceType, unitPrice, basePrice, '', '', '');
			results.push({
				name,
				price,
				quantity,
				taxable,
				group: 'Other Upgrades',
			});
		});

		if (isToString) {
			return results.length > 0 ? window.btoa(JSON.stringify(results)) : '';
		}

		return results;
	};

	disableAddToCart = (element) => {
		element.addClass('disabled');
		element.css('pointer-events', 'none');
	};

	enableAddToCart = (element) => {
		element.removeClass('disabled');
		element.css('pointer-events', 'auto');
	};

	handleAddToCart() {
		let _this = this;
		$('.woocommerce.single .single_add_to_cart_button').on('click', async function (e) {
			if (_this.preventUpdatePriceCustomizeLineItem()) {
				e.preventDefault();
				_this.enableAddToCart($(this));
				_this.validateCustomizeLineItem();
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.cannotNull,
				);
			}
			const zipCode: any = _this.getCookie(_this._cookiedValidate);
			const ssb_settings = <any>window;
			_this.disableAddToCart($(this));
			if (
				(_this._isEnabledZonePrice || $('#js-zip-code-submit.zone-price').length) &&
				zipCode !== false &&
				ssb_settings.ssb.simplify_checkout !== 'yes'
			) {
				let is_valid_zipcode = true;
				const ajaxUrl = ssb_settings.ssb.ajax_url;
				const modelID = $('#js-shed-data [name="ssb-model-id"').val();
				const dealerName = _this.getCookie('dealer');
				$.ajax({
					url: ajaxUrl,
					dataType: 'JSON',
					async: false,
					method: 'POST',
					data: { action: 'valid_zipcode_zone_price', zipCode, modelID, dealerName },
				}).done(function (res) {
					if (!res.is_success) {
						is_valid_zipcode = false;
					}
				});

				if (!is_valid_zipcode) {
					e.preventDefault();
					_this._elementValidate.val(zipCode).change();
					$('#js-zip-code-notice').show();
					$('#js-wrap-zip-code-popup').show();
					_this.enableAddToCart($(this));
					return;
				}
			}
			const actionType = $(this).attr('action-type');
			if (!actionType) {
				e.preventDefault();
				await _this.handleDataInputHide();
				$(this).off('click').trigger('click');
			}

			_this.updatePrice();
			window.dispatchEvent(new CustomEvent('update-accordion-status'));
			const components = _this.getListComponents('exterior');
			const door = _this.getUpgradeType(components, 'door');
			const acceptAddToCart = [
				'pergola',
				'horse_run_in',
				'pavilion',
				'structure_lofted_horserunin',
				'structure_teahouse',
				'structure_aframe_horserunin',
				'structure_loafing_shed',
				'structure_horse_shelter',
			];
			if (
				(!_this.allowAddCarportToCart() ||
					(!_this._seadevShedBuilder.isCarport() &&
						-1 === acceptAddToCart.indexOf(_this._seadevShedBuilder._shedType))) &&
				!door
			) {
				e.preventDefault();
				_this.enableAddToCart($(this));
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.cannotAddToCart,
				);
			}

			if ($('[name="ssb-option-size-height"]').val() == 'NaN') {
				e.preventDefault();
				_this.enableAddToCart($(this));
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.missingInformation,
				);
			}
		});

		$(document).on('click', '.group-buttons a', async function (e) {
			await _this.handleDataInputHide();
			const action = $(this).attr('class');
			const addToCart = $('.woocommerce.single .single_add_to_cart_button');
			addToCart.attr('action-type', action).trigger('click');
		});

		var queryString = window.location.search;
		var urlParams = new URLSearchParams(queryString);
		var referer = urlParams.get('referer');
		var iframeDomain = new URL(document.baseURI);
		var websiteDomain =
			window.location != window.parent.location
				? new URL(document.referrer)
				: new URL(document.location.href);
		var embeddingDomain: any = referer !== null ? referer : websiteDomain.hostname;
		var parts = embeddingDomain.split('.');
		var embeddingDomain = parts.slice(-2).join('.');
		if (iframeDomain.hostname.indexOf(embeddingDomain) == -1) {
			$('.is-iframe.woocommerce.single .single_add_to_cart_button').on(
				'click',
				async function (e) {
					_this.enableAddToCart($(this));
					return false;
				},
			);
		}
	}

	/**
	 * get data interior Finishing/Insulation
	 */
	getDataInteriorWall = (type) => {
		const _this = this;
		let dataObjKey;
		if ('finishing_interior' === type) {
			dataObjKey = {
				interior_wall: 'Wall Finishing',
				interior_ceiling: 'Ceiling Finishing',
			};
		} else {
			dataObjKey = {
				insulation_wall: 'Wall Insulation',
				insulation_roof: 'Roof Insulation',
			};
		}
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = _this.getBasePrice();
		const result = [];
		Object.entries(dataObjKey).forEach(([key, value]) => {
			if ($(`#${key}-material-option`).length) {
				const elementMaterial = $(`#${key}-material-option li.active`);
				const materialType = elementMaterial.data('material-type');
				if ('none' !== materialType && elementMaterial.length) {
					let materialPrice = _this.calculatePriceByType(
						elementMaterial.data('price-type'),
						elementMaterial.data('price'),
						basePrice,
						baseWidth,
						baseDepth,
						false,
						0,
					);
					materialPrice =
						'(n/a)' === materialPrice || '(call for pricing)' === materialPrice
							? materialPrice
							: isNaN(materialPrice)
								? 0
								: materialPrice;
					let color: any = '';
					let colorPrice: any = '';
					if ('interior_wall' === key) {
						color = $('#js-shed-data input[name="ssb-option-wall-color"]').val();
						colorPrice = $(
							'#js-shed-data input[name="ssb-option-wall-color-price"]',
						).val();
					} else if ('interior_ceiling' === key) {
						color = $('#js-shed-data input[name="ssb-option-ceiling-color"]').val();
						colorPrice = $(
							'#js-shed-data input[name="ssb-option-ceiling-color-price"]',
						).val();
					}
					let temp = {
						type: type,
						name: value,
						material: elementMaterial.data('label'),
						color,
						price: materialPrice,
						side: ['All sides'],
						color_price: colorPrice,
					};
					result.push(temp);
				}
			}
		});

		return result;
	};

	/*
	 * Get encrypted data from activated floor material configurator
	 */
	getFloorMaterialData = () => {
		const elem = $('#floor-material-option li.active');

		const value = elem.data('original-name');
		const key = elem.data('key');
		const name = elem.data('label');
		if (value && key && name) {
			let price = 0;
			const priceType = elem.data('price-type');
			price = elem.data('price');
			price = this.calculatePriceByType(
				priceType,
				price,
				this.getBasePrice(),
				helpers.getBaseWidth(),
				helpers.getBaseDepth(),
				false,
			);

			return window.btoa(JSON.stringify({ key, value, name, price }));
		}

		return '';
	};

	getRoofPitchData = () => {
		const value = $(
			'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
		).val();
		const key = $(
			'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
		).attr('data-key');
		const name = $(
			'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
		).attr('data-option-value');
		const priceCondition = $(
			'.group-upgrade-roof_pitch input[name="ssb-configurator-upgrade-roof_pitch"]:checked',
		).attr('data-price-condition');
		if (value && key && name) {
			let { price, priceType } = this.getRoofPitchUnitDataPrice(priceCondition);
			price = this.calculatePriceByType(
				priceType,
				price,
				this.getBasePrice(),
				helpers.getBaseWidth(),
				helpers.getBaseDepth(),
				false,
			);
			return window.btoa(JSON.stringify({ key, value, name, price }));
		}

		return '';
	};

	getRoofPitchUnitDataPrice = (priceCondition) => {
		let price = 0;
		let priceType = 'fixed';
		if ('' == priceCondition) return { price, priceType };
		priceCondition = JSON.parse(priceCondition);
		const roofType = $('#roof-material-option li.active').attr('data-roof-type');
		const findIndex = priceCondition.findIndex((item) => item.materials.includes(roofType));
		if (-1 === findIndex) return { price, priceType };
		price = priceCondition[findIndex].price;
		priceType = priceCondition[findIndex].price_type;
		return { price, priceType };
	};

	getElectricalPackageData(isBase64 = true) {
		const ePackageOriginalVal = $('[name="ssb-configurator-electrical-packages"]:checked').attr(
			'data-option-original-value',
		);
		const ePackageVal = $('[name="ssb-configurator-electrical-packages"]:checked').val();
		const ePackageID = $('[name="ssb-configurator-electrical-packages"]:checked').attr(
			'data-package-id',
		);
		let ePackagePrice = $('[name="ssb-configurator-electrical-packages"]:checked').attr(
			'data-price',
		);
		const ePackagePriceDiscount = $(
			'[name="ssb-configurator-electrical-packages"]:checked',
		).attr('data-discount');
		const componentPackage = this._seadevShedBuilder.getComponentPackageInfo();
		let ePackage;
		if (!componentPackage.hasPackage) {
			return ePackage;
		}

		if (ePackageVal && 'none' !== ePackageVal) {
			const includePrice = this._seadevShedBuilder.includePrice();
			const selectedLayout = jQuery(
				`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
			);
			const packageLayout = selectedLayout.data('layout-packages');
			if (packageLayout.length > 0 && (includePrice || packageLayout[0].include_price)) {
				let packageDefaultID = packageLayout[0].id;
				if (ePackageID === packageDefaultID) {
					ePackagePrice = '(included)';
				} else {
					ePackagePrice =
						'' !== ePackagePriceDiscount ? ePackagePriceDiscount : ePackagePrice;
				}
			}

			ePackagePrice = !isBase64 && ePackagePrice === '' ? '0' : ePackagePrice;

			let data = {
				price: ePackagePrice,
				value: ePackageVal,
				originalValue: ePackageOriginalVal ? ePackageOriginalVal : ePackageVal,
			};

			ePackage = isBase64 ? window.btoa(JSON.stringify(data)) : data;
		}

		return ePackage;
	}

	getUpgradeType(components, type) {
		if (components.hasOwnProperty(type)) {
			const jsonData = JSON.stringify(components[type]);
			return window.btoa(jsonData);
		}

		return '';
	}

	async generateShareableLink() {
		let url: string = $('.cart').attr('action');
		const linkId = (await this.generateShedUrl())?.linkId;

		if (linkId) {
			url = url + '?share=' + linkId;
		}

		return url;
	}

	createNotice(message) {
		const $ = jQuery;
		if ($('#js-custom-alert-share').length === 0) {
			let template = document.createElement('template');
			template.innerHTML =
				'<div id="js-custom-alert-share" class="ssb-custom-alert alert-share"><div class="content"></div></div>';
			document.body.appendChild(template.content.firstChild);

			const messageElement = $(`
                    <div class="item item-0">
                        <div class="message"><span class="success"></span>${message}</div>
                    </div>`).hide();

			messageElement.appendTo($(`#js-custom-alert-share .content`)).slideDown(300);

			setTimeout(() => {
				$('#js-custom-alert-share .content').slideUp(300, () => {
					$('#js-custom-alert-share').remove();
				});
			}, 3000);
		}
	}

	createDialog = (
		message,
		actions = [
			{ key: 'close', label: 'Close' },
			{ key: 'replace', label: 'Replace' },
		],
		data = {},
	) => {
		let actionElement = '';

		if (actions) {
			actions.forEach((e) => {
				actionElement += `<span id="action-${e.key}" class="action-${e.key}" data=${window.btoa(JSON.stringify(data))}>${e.label}</span>`;
			});
		}

		const htmlElement = `
            <div id="shedpro-custom-dialog" class="shedpro-custom-dialog">
                <div class="shedpro-dialog-backdrop">
                    <div class="wrap-dialog">
                        <div class="content">${message}</div>
        
                        <div class="action">${actionElement}</div>
                    </div>
                </div>
            </div>
        `;

		$('body').append(htmlElement);
	};

	removeDialog() {
		$('#shedpro-custom-dialog').remove();
	}

	async copyShareableLink(ele) {
		let _this = this;
		ele.removeClass('added');
		ele.addClass('loading');
		let url = await _this.generateShareableLink();
		setTimeout(() => {
			_this.copyToClipboard(url);
			ele.removeClass('loading');
			ele.addClass('added');
		}, 1000);
	}

	handleColorPicker = () => {
		$('.custom-color-picker').each(function (i, obj) {
			const _parent = $(this).closest('.ssb-option');

			const colorPicker = Pickr.create({
				el: obj,
				theme: 'nano',
				lockOpacity: true,
				swatches: [],
				closeOnScroll: true,
				default: '#000000',
				components: {
					hue: true,
					interaction: {
						input: true,
					},
				},
			});

			colorPicker.on('change', (color, source, instance) => {
				_parent
					.find('.ssb-option-color-picker')
					.val(color.toHEXA().toString())
					.trigger('input');
			});

			colorPicker.on('show', (color, instance) => {
				const _default = _parent.find('.ssb-option-color-picker').val() || color;

				if (helpers.isValidHexColor(_default)) {
					colorPicker.setColor(_default);
				}
			});
		});
	};

	handleWainscotingUIStatus = () => {
		if (1 === this._seadevShedBuilder._wainscotingType) {
			$('.group-wainscoting-color').hide();
			$('.group-wainscoting-type').hide();
		} else {
			$('.group-wainscoting-color').show();
			$('.group-wainscoting-type').show();
		}
	};

	//TODO @Khiet
	handleListWainscoting = () => {
		const _this = this;
		const { height } = this.getSizes();
		$('.ssb-configurator-options.wainscot .wrap-item').removeClass('hide');
		$('.ssb-configurator-options.wainscot .wrap-item input.ssb_wainscoting').prop(
			'disabled',
			false,
		);
		$('.ssb-option.ssb_wainscoting').each((i, v) => {
			const element = $(v);
			const wainscot = _this.getDataWaincostingFromElement(element);
			let isValidMaterial = true;
			if ('' != wainscot.sidingMaterial) {
				const material = JSON.parse(window.atob(wainscot.sidingMaterial));
				isValidMaterial = this._seadevShedBuilder.isValidSidingMaterialCondition(material);
			}
			const isValidSize = helpers.isValidSize(
				wainscot.condition.operation,
				height,
				wainscot.condition.condition_height_min,
				wainscot.condition.condition_height_max,
			);
			if ('None' !== wainscot.name && (!isValidMaterial || !isValidSize)) {
				element.parent().addClass('hide');
				element.prop('disabled', true);
			}
		});

		if ($('.ssb-configurator-options.wainscot .wainscot-option:not(.hide)').length) {
			if ($('.ssb-option.ssb_wainscoting:checked').is(':disabled')) {
				$(
					'.ssb-configurator-options.wainscot .wainscot-option:not(.hide):eq(0) input.ssb_wainscoting',
				)
					.prop('checked', true)
					.trigger('change');
			}
		} else {
			$(
				'.ssb-configurator-options.wainscot .wrap-item:not(.wainscot-option) input.ssb_wainscoting',
			)
				.prop('checked', true)
				.trigger('change');
		}
	};

	handleListInsulationWall = () => {
		const wrapperInsulation = $('.group-insulation_wall-type');
		wrapperInsulation.show();
		wrapperInsulation.find('li.ssb-option').removeClass('active hide');
		wrapperInsulation.find('li.ssb-option').each((i, v) => {
			const element = $(v);
			const sidingMaterial = $(v).attr('siding-material');
			let isValidMaterial = true;
			if ('' != sidingMaterial) {
				const material = JSON.parse(window.atob(sidingMaterial));
				isValidMaterial = this._seadevShedBuilder.isValidSidingMaterialCondition(material);
			}
			if (!isValidMaterial) {
				element.addClass('hide');
			}
		});

		if ( wrapperInsulation.find('li.ssb-option:not(.hide)').length) {
			if (wrapperInsulation.find('li.ssb-option.active').hasClass('hide') || wrapperInsulation.find('li.ssb-option.active').length === 0) {
				wrapperInsulation.find('li.ssb-option:not(.hide):eq(0)').addClass('active').trigger('click');
			}
		} else {
			const { diffuseTexture, bumpTexture, specularTexture, uScale, vScale, specularPower } = this._seadevShedBuilder.getSidingInnerMaterialData(true);
			const data = {
				material: 'interior_wall',
				materialType: 'none',
				diffuseTexture,
				bumpTexture,
				specularTexture,
				specularPower,
				uScale,
				vScale,
			};
			this._seadevShedBuilder.animateMaterialInteriorChange(data);
			wrapperInsulation.hide();
			wrapperInsulation.find('li.ssb-option').removeClass('active');
		}
	};

	getOptionWainscottingMatchingCondition = (defaultMaterial) => {
		const _this = this;
		const { height } = this.getSizes();
		let result = $('.ssb-option.ssb_wainscoting[data-primary-key="1"]');
		$('.ssb-option.ssb_wainscoting').each((i, v) => {
			const element = $(v);
			const wainscot = _this.getDataWaincostingFromElement(element);
			let isValidMaterial = true;
			let isValidWainscotMaterial =
				wainscot.materials && wainscot.materials.length > 0
					? wainscot.materials.includes(defaultMaterial)
					: false;
			if ('' != wainscot.sidingMaterial) {
				const material = JSON.parse(window.atob(wainscot.sidingMaterial));
				isValidMaterial = this._seadevShedBuilder.isValidSidingMaterialCondition(material);
			}
			const isValidSize = helpers.isValidSize(
				wainscot.condition.operation,
				height,
				wainscot.condition.condition_height_min,
				wainscot.condition.condition_height_max,
			);
			if (
				'None' !== wainscot.name &&
				isValidMaterial &&
				isValidSize &&
				isValidWainscotMaterial
			) {
				result = element;
				return false;
			}
		});

		return result;
	};

	handleActiveDefaultWainscoting = () => {
		if (this._seadevShedBuilder._isShareLink) return;
		const isEnableWainscotDefault =
			'1' == this._seadevShedBuilder.getSettingData('wainscoting_default');
		if (!isEnableWainscotDefault) {
			$(
				'.ssb-configurator-options.wainscot .wrap-item:not(.wainscot-option) input.ssb_wainscoting',
			)
				.prop('checked', true)
				.trigger('change');
		} else {
			$(
				'.ssb-configurator-options.wainscot .wainscot-option:not(.hide):eq(0) input.ssb_wainscoting',
			)
				.prop('checked', true)
				.trigger('change');
		}
	};

	handleWainscotingChangeSidingMaterial = (originalEvent) => {
		const conditionName = this._wainscotCondition;
		const wainscotingData = this._seadevShedBuilder.getWainscotingData();
		this._wainscotCondition = wainscotingData.name;
		if (this._wainscotCondition != conditionName && originalEvent) {
			const wcDefault = this._seadevShedBuilder.getSettingData('wainscoting_default');
			this._seadevShedBuilder._wainscotingType = '1' == wcDefault ? 2 : 1;
			$('.side-wrap').remove();
			$(
				`.ssb-configurator-options.wainscot .ssb-option[data-primary-key=${this._seadevShedBuilder._wainscotingType}]`,
			).prop('checked', true);
			this._seadevShedBuilder.buildMesh();
		}
	};

	handleWainscotingListMaterial = () => {
		const { materials, defaultMaterial } = this._seadevShedBuilder.getWainscotingData();
		if (!materials) return;

		$('#wainscoting-material-option li').hide().addClass('unavailable');
		materials.forEach((key) => {
			$(`#wainscoting-material-option li[data-key="${key}"]`)
				.show()
				.removeClass('unavailable');
		});

		if (materials.length > 1) {
			$('.group-wainscoting-type').show();
		} else {
			$('.group-wainscoting-type').hide();
		}
	};

	handleChangeLeanTo = () => {
		const _this = this;

		$('.ssb-configurator-upgrade-new.lean-to .ssb-option').on('change', function (e) {
			_this._seadevShedBuilder.handleLeanToOptionMesh();
			_this.hideSizeOptionsConfigurator();
		});

		_this._seadevShedBuilder.handleLeanToSizeOption(true);
		$('.ssb-configurator-upgrade-new.lean-to-size-option .ssb-option').on(
			'change',
			function (e) {
				_this._seadevShedBuilder.handleLeanToSizeOption();
			},
		);

		_this._seadevShedBuilder.handlePorchSizeOption(true);
		$('.ssb-configurator-upgrade-new.porch-size-option .ssb-option').on('change', function (e) {
			_this._seadevShedBuilder.handlePorchSizeOption();
		});
	};

	handleDormerOption = () => {
		if ('structure_rancher_modular' !== this._seadevShedBuilder._shedTypeVersion) return;
		const _this = this;

		$('.ssb-configurator-upgrade-new.dormer-option .ssb-option').on('change', function (e) {
			_this._seadevShedBuilder.addStopRenderClasses('handleDormerOption');
			const dormerOption = $(this).data('key');
			_this._seadevShedBuilder._dormerOption = dormerOption;
			_this._seadevShedBuilder.handleDormerOptionMesh();
			_this._seadevShedBuilder.buildMesh();
			_this._seadevShedBuilder.removeStopRenderClasses('handleDormerOption');
		});
	};

	/**
	 * Handles the visibility and selection of Exterior Siding Upgrades materials in the UI.
	 *
	 * @return {void}
	 */
	handleExteriorSidingUpgradesListMaterial = () => {
		const data = this._seadevShedBuilder.getExteriorSidingUpgradesInfo();

		if (helpers.isEmptyObject(data)) {
			$('.group-exterior_siding_upgrades-type').hide();
		} else {
			const { material, defaultMaterial, defaultColor } = data;

			$('#exterior_siding_upgrades-material-option li')
				.hide()
				.addClass('unavailable')
				.removeClass('active');
			material.forEach((key) => {
				$(`#exterior_siding_upgrades-material-option li[data-key="${key}"]`)
					.show()
					.removeClass('unavailable');
			});

			$(`.group-exterior_siding_upgrades-color ul li`).removeClass('default');
			if (defaultColor) {
				$(
					`.group-exterior_siding_upgrades-color ul li[data-color-id=${defaultColor}]`,
				).addClass('default');
			}

			if (defaultMaterial) {
				$(`#exterior_siding_upgrades-material-option li[data-key="${defaultMaterial}"]`)
					.addClass('active')
					.trigger('click');
			} else {
				$(`#exterior_siding_upgrades-material-option li.ssb-option:not(.unavailable):eq(0)`)
					.addClass('active')
					.trigger('click');
			}

			if (material && !helpers.isEmptyObject(material)) {
				$('.group-exterior_siding_upgrades-type').show();
			} else {
				$('.group-exterior_siding_upgrades-type').hide();
			}
		}
	};

	handleChangeExteriorSidingUpgrades = () => {
		const _this = this;

		_this.handleExteriorSidingUpgradesListMaterial();

		$('.ssb-configurator-options.exterior_siding_upgrades .ssb-option').on(
			'change',
			async function (e) {
				_this._seadevShedBuilder.addStopRenderClasses('handleChangeExteriorSidingUpgrades');
				_this.handleExteriorSidingUpgradesListMaterial();
				_this._seadevShedBuilder.buildMesh();
				_this.shedDetailRenderSidingAndTrim();
				_this.updatePrice();
				_this._seadevShedBuilder.removeStopRenderClasses('handleChangeExteriorSidingUpgrades');
			},
		);
	};

	handleChangeWainscoting = () => {
		const _this = this;
		const wType = Number(
			$('.wainscot [name=ssb-configurator-upgrade-wainscot]:checked').attr(
				'data-primary-key',
			),
		);

		_this._seadevShedBuilder._wainscotingType = 2 == wType || 3 == wType ? wType : 1;

		$('.ssb-configurator-options.wainscot .ssb-option').on('change', function (e) {
			_this._seadevShedBuilder.addStopRenderClasses('handleChangeWainscoting_sub');
			const currentElement = $(this);
			const wainscotType = currentElement.data('primary-key');
			_this._seadevShedBuilder._wainscotingType = wainscotType;

			const dataWainscoting = _this.getDataWaincostingFromElement(currentElement);
			_this._seadevShedBuilder.setWainscotingData(dataWainscoting);
			$('.side-wrap').remove();
			let sideAllow = currentElement.attr('apply-sides');
			_this.animateUpdateWainscotingOption({
				type: wainscotType,
				sides: JSON.parse(sideAllow),
				defaultMaterial: dataWainscoting.defaultMaterial,
				defaultColor: dataWainscoting.defaultColor,
			});
			if (dataWainscoting.allowUserSelect) {
				_this.renderWainscotingSideSelect(this);
			}
			_this._seadevShedBuilder.removeStopRenderClasses('handleChangeWainscoting_sub');
		});

		$('.ssb-configurator-options.wainscot').on('change', '.wainscot-side', function (e) {
			_this._seadevShedBuilder.addStopRenderClasses('handleChangeWainscoting_main');
			const sideChecked = $('input[name="wainscot-side"]:checked');
			const sides = sideChecked
				.map(function () {
					return $(this).val().toString();
				})
				.get();
			_this.renderWainscotingSideText(sides);

			_this._seadevShedBuilder._wainscotingSide = sides;
			_this._seadevShedBuilder.buildMesh();
			_this.shedDetailRenderSidingAndTrim();
			_this.updatePrice();
			_this._seadevShedBuilder.removeStopRenderClasses('handleChangeWainscoting_main');
		});

		$('.ssb-configurator-options.wainscot').on('click', '.side-select-name', function (e) {
			$(this).closest('.side-wrap').toggleClass('active');
		});
	};

	animateUpdateWainscotingOption = (data) => {
		const { type, sides, defaultMaterial, defaultColor } = data;
		this._seadevShedBuilder._wainscotingType = type;
		this._seadevShedBuilder._wainscotingSide = sides;
		this.handleWainscotingUIStatus();
		this.handleWainscotingListMaterial();

		let elementWainscotMateriral = $(
			`#wainscoting-material-option li[data-key="${defaultMaterial}"]:not(.unavailable)`,
		);
		elementWainscotMateriral = elementWainscotMateriral.length
			? elementWainscotMateriral
			: $(`#wainscoting-material-option li:not(.unavailable):eq(0)`);
		elementWainscotMateriral.addClass('active').trigger('click');

		let elementWainscotColor = $(
			`.ssb-configurator-color.wainscoting li[data-color-id="${defaultColor}"]:not(.unavailable)`,
		);
		elementWainscotColor = elementWainscotColor.length
			? elementWainscotColor
			: $(`.ssb-configurator-color.wainscoting li:not(.unavailable):eq(0)`);
		elementWainscotColor.addClass('active').trigger('click');

		this._seadevShedBuilder.buildMesh();
		this.shedDetailRenderSidingAndTrim();
		this.updatePrice();
	};

	getDataWaincostingFromElement = (element) => {
		const name = element.val();
		const heightData = JSON.parse(element.attr('wainscot-height'));
		const heightType = heightData.wainscot_height_type;
		const height =
			'percentage' != heightType
				? Number(heightData.height_value)
				: Number(
						helpers.toFixed3(
							(heightData.height_value * this._seadevShedBuilder._wallHeight) / 100,
						),
					);
		const price = element.attr('data-price');
		const priceType = element.attr('data-price-type');
		const materials = element.attr('wainscot-material');
		const defaultMaterial = element.attr('default-material');
		const condition = JSON.parse(element.attr('condition'));
		const allowUserSelect = '1' == element.attr('allow-user-select');
		const applySides = element.attr('apply-sides');
		const defaultColor = element.attr('default-color');
		const sidingMaterial = element.attr('siding-material');

		return {
			height,
			name,
			price,
			priceType,
			materials: materials ? JSON.parse(materials) : [],
			defaultMaterial,
			defaultColor,
			condition,
			applySides: applySides ? JSON.parse(applySides) : [],
			allowUserSelect,
			sidingMaterial,
		};
	};

	renderWainscotingSideText = (sides) => {
		const sidesData = this._seadevShedBuilder.getSettingData('sides_data');
		let labelText = 'Select side';

		if (sides.length > 0) {
			const sideNames = sides.map((key) => sidesData[key]);
			labelText = sideNames.join(', ');
		}

		$('.ssb-configurator-options.wainscot .side-select-name').text(labelText);
	};

	renderWainscotingSideSelect = (element) => {
		const sides = [];
		const sidesData = this._seadevShedBuilder.getSettingData('sides_data');
		const cSides = this._seadevShedBuilder._wainscotingSide;
		let walls = this._seadevShedBuilder.getListWainscotingSide();
		let sideHtml = '';
		if (Array.isArray(cSides) && cSides.length > 0) {
			walls = walls.filter((side) => -1 !== cSides.indexOf(side));
		}
		if (walls.length > 0) {
			walls.forEach((wall) => {
				if (sidesData[wall]) {
					sides.push({ key: wall, label: sidesData[wall] });
				}
			});
		} else {
			cSides.forEach((item) => {
				if (sidesData[item]) {
					sides.push({ key: item, label: sidesData[item] });
				}
			});
		}

		const sidesDisplay = [];
		sides.forEach((side) => {
			const checked = -1 !== cSides.indexOf(side.key) ? 'checked' : '';
			sidesDisplay.push(side.label);
			sideHtml += `
                <div class="item">
                    <input value="${side.key}" id="side-${side.key}" type="checkbox" ${checked} class="wainscot-side" name="wainscot-side" />
                    <label for="side-${side.key}">${side.label}</label>
                </div>
            `;
		});

		const html = `
            <div class="side-wrap">
                <div class="side-select-name">${sidesDisplay.join(', ')}</div>
                <div class="side-popup">${sideHtml}</div>
            </div>
        `;

		$(element).closest('div').append(html);
	};

	handle2DFloorPlan() {
		const _this = this;
		$('.view-2d').on('click', function (e) {
			const floorPlan = new Seadev2DFloorPlan(_this._seadevShedBuilder);
			floorPlan.generate2D();
		});

		$('.woocommerce.single .single_add_to_cart_button, [name="ssb-option-2d-floor-plan"]').on(
			'click',
			function (e) {
				const floorPlan = new Seadev2DFloorPlan(_this._seadevShedBuilder);
				floorPlan.capture2D();
			},
		);
	}

	storeShareableLinkData = (base64Data) => {
		const ssbSettings = <any>window;
		const apiCreateShareableLink = ssbSettings.ssb.create_shareable_link;
		const maxRetries = 2;
		const delayMs = 500; // Delay in milliseconds between retries
		let beforeSendData: string;
		const ajaxFailPrefix = 'AJAX failed:';
		const attempt = function (retryCount) {
			const clientTime = new Date();
			return new Promise((resolve) => {
				$.ajax({
					url: apiCreateShareableLink,
					type: 'POST',
					dataType: 'text',
					timeout: 10000,
					data: {
						url: window.location.href,
						action: 'create_shareable_link',
						data: base64Data,
					},
					beforeSend: function (xhr) {
						beforeSendData = JSON.stringify(xhr);
					},
					success: function (rawResponse, textStatus, xhr) {
						const commonErrorMessage = `status: ${xhr.status}, client time: ${clientTime}, before send: ${beforeSendData}`;
						let response;
						try {
							response = JSON.parse(rawResponse);
						} catch (err) {
							// Invalid JSON or returned "0"
							const errorMessage = `${ajaxFailPrefix} Invalid JSON from server: ${rawResponse}, ${commonErrorMessage}`;
							console.error(errorMessage);
							helpers.writeLogForShareableLink(
								errorMessage,
								{ raw: rawResponse },
								base64Data,
							);
							resolve(undefined);
							return;
						}

						// If the server returns JSON but not an object
						if (
							typeof response !== 'object' ||
							response === null ||
							typeof response.success === 'undefined'
						) {
							const errorMessage = `${ajaxFailPrefix} Unexpected JSON format: ${rawResponse}, ${commonErrorMessage}`;
							console.error(errorMessage);
							helpers.writeLogForShareableLink(errorMessage, response, base64Data);
							resolve(undefined);
							return;
						}

						// Successful case
						if (response.success) {
							resolve(response.id);
						} else {
							resolve(undefined);
							const errorMessage = `${ajaxFailPrefix} ${response?.error}, ${commonErrorMessage}`;
							console.error(errorMessage);
							helpers.writeLogForShareableLink(
								`${errorMessage}, URL: ${apiCreateShareableLink}`,
								response,
								base64Data,
							);
						}
					},
					error: function (xhr) {
						const errorMessage = `${ajaxFailPrefix} status ${xhr.status}, status text: ${xhr.statusText}, client time: ${clientTime}, before send: ${beforeSendData}, retrying... (${retryCount})`;
						console.error(errorMessage);
						if (retryCount <= maxRetries) {
							helpers.writeLogForShareableLink(
								`${errorMessage}, URL: ${apiCreateShareableLink}`,
								xhr,
								base64Data,
							);
							setTimeout(() => {
								attempt(retryCount + 1).then(resolve);
							}, delayMs);
						} else {
							resolve(undefined);
						}
					},
				});
			});
		};

		return attempt(1);
	};

	/**
	 * Call ajax to get shareable link data by id
	 *
	 * @param {string} shareableLinkId - ID of stored data
	 * @return {Promise<data>} - Shareable link data
	 */
	getSharebleLinkDataById = async (shareableLinkId) => {
		const ssb_settings = <any>window;
		const ajaxUrl = ssb_settings.ssb.ajax_url;

		try {
			const response = await $.ajax({
				url: ajaxUrl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'get_shareable_link_data',
					data: shareableLinkId,
				},
			});

			if (response.success) {
				return response.data;
			} else {
				console.error('Error retrieving item:', response.data);
			}
		} catch (error) {
			console.error('AJAX request failed:', error);
		}
	};

	handleShareButton() {
		let _this = this;
		$(document).on('click', '.ssb-share-model', async function (e) {
			e.preventDefault();
			let element = $(this);
			element.removeClass('added');
			element.addClass('loading');

			const url = await _this.generateShareableLink();

			if (element.hasClass('not_login') && $('body').hasClass('save-customized-shed')) {
				$('#login-form .body-form-login h2').text('Sign in to share your design');
				$('#login-form').addClass('is_show');
				$('.form-login .btn.button').attr('action', 'share');
				$('.form-sign-up').attr('redirect', url);
				$('.form-login').attr('url-share', url);
				return;
			} else {
				_this._openingDialog = $('#content-wrap-share-shed');
				const title = _this._openingDialog.attr('title-dialog');
				$(_this._openingDialog).dialog({
					autoOpen: false,
					modal: true,
					title: title,
					closeText: '',
					dialogClass: 'ssb-component-dialog dialog-share-shed',
					resizable: false,
					close: function (event, ui) {
						_this.closeEditComponent();
					},
				});
				$('.list-share-social li').each(function (i, data) {
					$(data).attr('data-url', url);
					$(data).attr('data-model-url', $('form.cart').attr('action'));
					$(data).removeClass('shared');
				});
				$('body').addClass('dialog-opened');
				$(_this._openingDialog).dialog('open');
			}
			element.removeClass('loading');
		});

		$(document).on('click', '.list-share-social li.email', function (e) {
			e.preventDefault();
			const element = $(this);
			_this._openingDialog = $('#content-wrap-share-shed');

			$(_this._openingDialog).dialog('close');
			$('body').removeClass('dialog-opened');

			_this._openingDialog = $('#content-form-share-email');
			const title = _this._openingDialog.attr('title-dialog');

			$(_this._openingDialog).dialog({
				autoOpen: false,
				modal: true,
				title: title,
				closeText: '',
				dialogClass: 'ssb-component-dialog dialog-share-to-email',
				resizable: false,
				close: function (event, ui) {
					_this.closeEditComponent();
				},
			});

			$('#content-form-share-email .wpcf7-not-valid-tip').remove();
			$('#content-form-share-email .wpcf7-response-output').empty();
			$('#content-form-share-email .wpcf7-form').removeClass('sent');
			$('#content-form-share-email .wpcf7-form').removeClass('failed');
			$('#content-form-share-email .wpcf7-form').removeClass('invalid');
			$('#content-form-share-email .wpcf7-form').addClass('init');

			setTimeout(() => {
				const shareUrl = element.attr('data-url');
				const modelUrl = element.attr('data-model-url');
				$('#content-form-share-email').find('#share_url').val(shareUrl);
				$('#content-form-share-email').find('#model_url').val(modelUrl);
			}, 500);

			$('body').addClass('dialog-opened');
			$(_this._openingDialog).dialog('open');
		});

		if ($('.group-button-checkout-inner button.group-button').length) {
			$('.ssb-mobile-button-request-a-quote ').text(
				$('.group-button-checkout-inner button.group-button').text(),
			);
		} else {
			$('.ssb-mobile-button-request-a-quote ').text(
				$('.single_add_to_cart_button.button').text(),
			);
		}

		$(document).on('click', '.ssb-mobile-button-request-a-quote', async function (e) {
			if ($(this).hasClass('is_disable')) {
				e.preventDefault();
			}
			if ($('.woocommerce.single button.group-button').length) {
				$(
					'.ssb-shed-product-single .summary-wrapper.active .wrap-price-add-to-cart form',
				).addClass('active');
				$('.woocommerce.single button.group-button').trigger('click');
			} else {
				$(this).addClass('pending');
				await _this.handleDataInputHide();
				const action = $(this).attr('class');
				const addToCart = $('.woocommerce.single .single_add_to_cart_button');
				addToCart.attr('action-type', action).trigger('click');
			}
		});
	}

	copyToClipboard = (str) => {
		const el = document.createElement('textarea');
		el.value = str;
		el.setAttribute('readonly', '');
		el.style.position = 'absolute';
		el.style.left = '-9999px';
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

	generateShortenLink = async (link: string) => {
		var myHeaders = new Headers();
		var queryString = window.location.search;
		var urlParams = new URLSearchParams(queryString);
		var dealer = urlParams.get('dealer');
		link = dealer != null ? link + '&dealer=' + encodeURI(dealer) : link;
		myHeaders.append('Content-Type', 'application/json');
		var raw =
			'{\r\n  "dynamicLinkInfo": {\r\n    "domainUriPrefix": "https://shortlink.shedpro.co",\r\n    "link": "' +
			link +
			'",\r\n  },\r\n  "suffix": {\r\n     "option": "SHORT"\r\n   }\r\n}';
		var requestOptions: any = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		const shortenURL: any = await (
			await fetch(
				'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyDxaVH0sCus0OTQ3Lo6w5aLpvD6Nrv8-pw',
				requestOptions,
			)
		).json();
		if (shortenURL.shortLink == undefined) {
			return link;
		}
		return shortenURL.shortLink;
	};

	resetModel() {
		$('.ssb-reset-btn').click(function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			var iframe = urlParams.get('iframe');
			var referer = urlParams.get('referer');
			var url: any = window.location.href;
			if (iframe === 'true') {
				var websiteDomain =
					window.location != window.parent.location
						? new URL(document.referrer)
						: new URL(document.location.href);
				var embeddingDomain: any = referer !== null ? referer : websiteDomain.hostname;
				var parts = embeddingDomain.split('.');
				var embeddingDomain = parts.slice(-2).join('.');
				if (url.indexOf('?') > -1) {
					url += '&referer=' + embeddingDomain;
				} else {
					url += '&referer=' + embeddingDomain;
				}
			}
			// location.reload();
			window.location.href = url;
		});
	}

	generateFlyer() {
		let _this = this;

		$(document).on('click', '.ssb-flyer-code', async function (e) {
			let _that = $(this);
			let image = await _this._seadevShedBuilder.captureCartThumbnailV2('front_left');
			let newWindow = window.open(document.location.origin + '/flyer.html');
			let url = await _this.generateShareableLink();
			let title = _that.data('title');
			const data = { url, title, image };
			const jsonData = JSON.stringify(data);
			const dataBase64 = window.btoa(jsonData);
			_that.removeClass('added').addClass('loading');
			$.ajax({
				url: _that.data('ajax_url'),
				dataType: 'JSON',
				method: 'POST',
				data: { action: 'create_shortlink', data: dataBase64 },
			}).done(function (res) {
				_that.removeClass('loading').addClass('added');
				if (res.success) {
					newWindow.location = res.link;
				} else {
					alert(res.msg);
				}
			});
		});

		$(document).on('click', '.ssb-print-order', async function (e) {
			let element = $(this);
			const side = $('.ssb-configurator-layout .ssb-option:checked').attr(
				'data-layout-main-side',
			);
			const thumbnails = await _this.captureAllThumbnails(side);
			let newWindow = window.open(document.location.origin + '/print-order.html');
			var result = {};
			const floorPlan = new Seadev2DFloorPlan(_this._seadevShedBuilder);
			floorPlan.capture2D();
			await _this.handleDataInputHide(thumbnails);
			$.each($('form.cart').serializeArray(), function () {
				result[this.name.split('-').join('_')] = this.value;
			});
			const dataBase64 = window.btoa(JSON.stringify(result));
			element.removeClass('added').addClass('loading');
			$.ajax({
				url: element.data('ajax_url'),
				dataType: 'JSON',
				method: 'POST',
				data: { action: 'create_shortlink_print_order', data: dataBase64 },
			}).done(function (res) {
				element.removeClass('loading').addClass('added');
				if (res.success) {
					newWindow.location = res.link;
				} else {
					alert(res.msg);
				}
			});
		});
	}

	/**
	 * Show popup confirm view shed in AR mode
	 */
	viewShedInARMobile = () => {
		$('#ar-view-shed-mobile').on('click', (e) => {
			$('.wrap-ar-popup-mobile').slideDown();
		});

		$('#open-ar-mode').on('click', (e) => {
			$('.wrap-ar-popup-mobile').hide();
			$('.babylonVRicon').trigger('click');
		});

		$('#close-ar-popup-mobile').on('click', (e) => {
			$('.wrap-ar-popup-mobile').slideUp();
		});
	};

	/**
	 * Handle event view shed on AR mode
	 * Only handle for desktop
	 */
	viewShedInARDesktop = () => {
		const _this = this;
		let arLink;
		$('#ar-view-shed-desktop').on('click', async function (e) {
			let idViewShed = $(this);
			idViewShed.attr('disabled', 1).addClass('loading');
			let ShareableLink = await _this.generateShareableLink();
			await _this.showARPopup(ShareableLink);
			arLink = ShareableLink;
			// $.ajax({
			//     url: ajaxUrl,
			//     dataType: 'JSON',
			//     method: 'POST',
			//     data: {
			//         action: 'create_qr_code_for_ar',
			//         shareable_link: window.btoa( ShareableLink )
			//     }
			// }).done( async function( res ) {
			//     idViewShed.removeClass('loading').removeAttr('disabled');
			//     if( res.success ) {
			//         arLink = res.link;
			//         await _this.showARPopup( arLink );
			//     } else {
			//         alert( res.msg );
			//     }
			// });
		});

		_this.handleCloseARPopup();

		$('#send-ar-link').on('click', function (e) {
			e.preventDefault();
			let idSendLink = $(this);
			idSendLink.removeClass('added').addClass('loading').attr('disabled', 1);

			$('#ar-email').keypress(() => {
				$('#ar-notice').hide();
			});

			if (undefined === arLink) {
				return alert('Oops! Something went wrong!');
			}

			const email = $('#ar-email').val();
			const ssb_settings = <any>window;
			const ajaxUrl = ssb_settings.ssb.ajax_url;

			if (helpers.isValidateEmail(email)) {
				_this.sendARLink(email, arLink, ajaxUrl);
			} else {
				let errorMessage: any = $('#ar-invalid-email-message').val();
				$('#send-ar-link').removeClass('loading');
				$('#ar-notice').html(errorMessage).removeClass('success').addClass('error').show();
				idSendLink.removeAttr('disabled');
			}
		});
	};

	/**
	 * Create QR code and show to AR popup
	 *
	 * @param   {string} link link to attact to QR code
	 * @returns {Promise}
	 */
	showARPopup = (link) => {
		return new Promise((resolve) => {
			let options = {
				text: link,
				logoBackgroundTransparent: true,
				width: 171,
				height: 171,
			};

			$('#ar-qr-code').html('');
			new QRCode(document.getElementById('ar-qr-code'), options);
			$('.wrap-ar-popup').show();

			resolve(true);
		});
	};

	/**
	 * Handle event when closing the AR Popup
	 */
	handleCloseARPopup = () => {
		$('.close-ar-popup').on('click', function (e) {
			e.preventDefault();
			$('.wrap-ar-popup').hide();
			$('#ar-email').val('');
			$('#ar-notice').hide();
			$('#ar-view-shed-desktop').removeAttr('disabled').removeClass('loading');
		});
	};

	/**
	 * Send AR Link
	 *
	 * @param {string} email    Recived email
	 * @param {string} link     AR link
	 * @param {string} ajaxUrl  Ajax URL to call to server
	 */
	sendARLink = (email, link, ajaxUrl) => {
		const name = $('.product_title').text();
		$.ajax({
			url: ajaxUrl,
			dataType: 'JSON',
			method: 'POST',
			data: {
				action: 'send_link_for_ar',
				data: { link, email, name },
			},
		}).done(function (res) {
			$('#send-ar-link').removeAttr('disabled');
			if (res.success) {
				$('#send-ar-link').removeClass('loading').addClass('added');
				$('#ar-notice').html(res.msg).removeClass('error').addClass('success').show();
			} else {
				alert(res.msg);
			}
		});
	};

	handleInterior() {
		let _this = this;

		_this._configuratorAccordionWrapper.accordion({
			activate: function (event, ui) {
				if (ui.newHeader.hasClass('interior-header')) {
					_this._seadevShedBuilder.setStatusForInteriorView(true);
					$('[name="ssb-configurator-upgrade-loft"]:checked').trigger('change');
				} else {
					_this._seadevShedBuilder.setStatusForInteriorView(false);
				}
			},
		});
	}
	async saveModels(element) {
		let _this = this;
		let save_model_dom = $('input[name="ssb-option-save-model-id"]');
		let save_model_id = save_model_dom.val();
		let url = save_model_id
			? (await _this.generateShareableLink()) + '&save_model_id=' + save_model_id
			: await _this.generateShareableLink();
		let title = element.data('title');
		let price = $('input[name="ssb-shed-full-price"]').val();
		let pid = $('.woocommerce.single .single_add_to_cart_button').val();
		let image = await _this._seadevShedBuilder.captureCartThumbnailV2('front_left');
		const data = { url, title, image, price, pid };
		const jsonData = JSON.stringify(data);
		const dataBase64 = helpers.b64EncodeUnicode(jsonData);
		element.removeClass('added').addClass('loading');
		$.ajax({
			url: element.data('ajax_url'),
			dataType: 'JSON',
			method: 'POST',
			data: { action: 'saved_models', data: dataBase64, save_model_id: save_model_id },
		}).done(function (res) {
			element.removeClass('loading').addClass('added');
			if (res.success) {
				save_model_dom.val(res.save_model_id);

				const url = new URL(window.location.href);
				url.searchParams.set('save_model_id', res.save_model_id);
				window.history.pushState(null, null, url.toString());

				$('.wrap-notification').html(res.msg);
				$('.canvas-notification').show(400);
				setTimeout(function () {
					$('.canvas-notification').hide(400);
				}, 3000);
				$('.ssb-saved-models .icon-heart').attr('data-count', res.count);
				$('.nav-link.ssb-saved-models').addClass('has-saved-models');
			} else {
				alert(res.msg);
			}
		});
	}
	handlePopupLogin() {
		let _this = this;
		$(document).on('click', '.ssb-save-model', async function (e) {
			let element = $(this);
			if (element.hasClass('not_login')) {
				$('#login-form .body-form-login h2').text('Sign in to save your design');
				$('#login-form').addClass('is_show');
				$('.form-login .btn.button').attr('action', 'save');
				return;
			} else {
				await _this.saveModels(element);
			}
		});

		$(document).on('click', '.ssb-save-model, .ssb-login-popup', async function (e) {
			const shareLink = await _this.generateShareableLink();
			$('.form-sign-up').attr('redirect', shareLink);
			$('.form-login').attr('url-share', shareLink);
		});
	}

	handleCaptureImageAT() {
		let _this = this;
		$(document).on('click', '.btn-capture-image', async function () {
			const side = $('.ssb-configurator-layout .ssb-option:checked').attr(
				'data-layout-main-side',
			);
			const [imageMain, imageFront, imageBack, imageLeft, imageRight] =
				await _this.captureAllThumbnails(side);
			$('.woocommerce.single input[name="ssb-option-thumbnail"]').val(imageMain);
			$('.woocommerce.single input[name="ssb-option-thumbnail-front"]').val(imageFront);
			$('.woocommerce.single input[name="ssb-option-thumbnail-back"]').val(imageBack);
			$('.woocommerce.single input[name="ssb-option-thumbnail-left"]').val(imageLeft);
			$('.woocommerce.single input[name="ssb-option-thumbnail-right"]').val(imageRight);
		});
	}

	shedTypesToggle() {
		let _this = this;
		$('.dropdown-list .dropdown-shed').on('click', function () {
			let shedpro = (<any>window).shedpro_data;

			let id = $(this).data('id');
			let post_id = $(this).data('post_id');

			$('.shed-type-dropdown').addClass('disabled').removeClass('open');
			$('.shed-type-dropdown .current').text($(this).text());
			$('#ssb-configurator-accordion-style .ssb-configurator-panel-content').addClass(
				'loading',
			);
			$('.dropdown-list').slideUp('fast');

			_this._configuratorAccordionWrapper.accordion('option', 'active', 0);

			var data = {
				action: 'get_product_by_cat',
				cat_id: id,
				post_id: post_id,
			};

			jQuery.post(shedpro.ajax_url, data, function (response) {
				$('.shed-type-dropdown').removeClass('disabled');
				$('#ssb-configurator-accordion-style .ssb-configurator-panel-content')
					.removeClass('loading')
					.html(response);
			});
		});
	}

	private initConfiguratorAccordion() {
		this._configuratorAccordionWrapper.accordion({
			collapsible: true,
			header: '.ssb-configurator-panel-heading',
			heightStyle: 'content',
		});
	}

	renderComponent(components) {
		return new Promise(async (resolve) => {
			let componentNotFound = [];
			const keys = Object.keys(components);
			for (const key of keys) {
				await this.loopComponents(components[key], componentNotFound);
			}

			resolve(componentNotFound);
		});
	}

	loopComponents(components, componentNotFound) {
		const _this = this;
		return new Promise(async (resolve) => {
			for (const comp of components) {
				if (comp.isTackDoor && !_this._seadevShedBuilder._isAllowEnableTackRoom) {
					continue;
				}

				if (0 === $(`[data-upgrade-component-name=${comp.name}]`).length) {
					componentNotFound.push(`${comp.name} ${comp.side} side`);
					continue;
				}

				$(`[data-upgrade-component-name=${comp.name}]`).parent().removeClass('hidden');
				await this.addComponentToModel(comp, componentNotFound);
			}

			resolve(componentNotFound);
		});
	}

	addComponentToModel(comp, componentNotFound) {
		return new Promise(async (resolve) => {
			const _this = this;
			const {
				side,
				type,
				name,
				componentSize,
				isTackDoor,
				isBlock,
				rotation,
				blockOptions,
				vertical,
				horizontal,
				uuid,
			} = comp;

			if ('light' === type) {
				comp.position.y = _this._seadevShedBuilder.getPositionYForLight();
			}

			const pos = { x: comp.position.x, y: comp.position.y, z: comp.position.z };
			if (side && type && name) {
				if (-1 !== ePackageType.indexOf(type)) {
					jQuery(`.group-upgrade-${type}`).show();
				}
				let errorText = [];
				let compUUID = uuid || name;
				const args = {
					side,
					componentType: type,
					componentName: name,
					position: pos,
					vertical,
					horizontal,
					componentSize,
					lockData: comp['lockData'],
					isTackDoor,
					isBlock,
					rotation,
					blockOptions,
					uuid: compUUID,
					source: 'shareable_link'
				};

				if (comp['lockData']) {
					const customLock = comp['lockData']['customLock'];
					const lockPosition = jQuery(`input.ssb-option[data-uuid="${compUUID}"]`).data(
						'lock-position',
					);
					if (
						customLock !== lockPosition &&
						0 ===
							jQuery(`input.ssb-option[data-uuid="${compUUID}"]`)
								.siblings('.upgrade-item-options')
								.find(`.wrap-lock-setting .lock-setting[value="${customLock}"]`)
								.length
					) {
						errorText.push(`lock ${customLock}`);
					}
					const enableHinge = jQuery(`input.ssb-option[data-uuid="${compUUID}"]`).data(
						'enable-hinge',
					);
					if (comp['lockData']['enableHinge'] != enableHinge) {
						errorText.push(`enable hinge`);
					}
				}

				if (comp.colors) {
					const componentColor = comp.colors.filter((color) => color.type === type);
					if (componentColor.length > 0) {
						const { display } = componentColor[0];
						const colorKey = helpers.generateKey(display.toString());
						let colorInfo = {};
						const colorSelected = $(
							`.ssb-configurator-options.ssb-configurator-upgrade.${type}`,
						).find(
							`[data-key-base64=${helpers.removeSpecialCharacters(window.btoa(colorKey))}]`,
						);
						if (colorSelected.length > 0) {
							const textureType = $(colorSelected).data('texture-type');
							const textureImage = $(colorSelected).data('texture-image');
							const textureColor = $(colorSelected).data('texture-color');
							const priceType = $(colorSelected).data('price-type');
							const itemPrice = $(colorSelected).data('price');
							const colorName = $(colorSelected).data('name');
							const endPrice = this.calculatePriceByType(
								priceType,
								itemPrice,
								this.getBasePrice(),
								helpers.getBaseWidth(),
								helpers.getBaseDepth(),
								false,
							);
							colorInfo = {
								key: colorKey,
								name: colorName,
								price: itemPrice,
								priceType,
								endPrice,
								textureType,
								textureImage,
								textureColor,
								description: '',
							};
						}

						args['colorInfo'] = colorInfo;
					}
				}

				const parentResult = await _this._seadevShedBuilder.addNewComponent(args);
				if (isTackDoor) {
					_this._seadevShedBuilder._tackDoor = parentResult;
				}
				const parentKey = parentResult['key'];
				if (comp.childs) {
					for (const child of comp.childs) {
						const { side, type, name: childName } = child;
						if (side && type && childName) {
							if ($(`input[name="child_${type}"][value="${childName}"]`).length) {
								if ('shutters' === type) {
									const sidingType = this._seadevShedBuilder.getSidingType();
									if (
										!this._seadevShedBuilder.isValidShutters(
											sidingType,
											childName,
											compUUID,
										)
									) {
										errorText.push(childName);
										continue;
									}
								}

								$(`[data-upgrade-component-name=${childName}]`)
									.parent()
									.removeClass('hidden');
								this._seadevShedBuilder.addNewShutters(
									childName,
									parentResult['meshes'],
									side,
									parentKey,
									type,
								);
							} else {
								errorText.push(childName);
							}
						}
					}
				}

				// Handle for old Shutters in Shareable link
				if ('windows' === type && comp.options) {
					for (let i = 0; i < comp.options.length; i++) {
						const shuttersKey = comp.options[i];
						const shuttersName =
							'_shutter_wood_obj' === shuttersKey
								? 'in_object_wood'
								: '_shutter_vinyl_obj' === shuttersKey
									? 'in_object_vinyl'
									: false;
						if (shuttersName) {
							this._seadevShedBuilder.updateShuttersInObject(
								shuttersName,
								parentResult['meshes'],
								side,
								parentResult['key'],
							);
						}
					}
				}

				if (errorText.length) {
					componentNotFound.push(errorText.join(', '));
				}
			}
			resolve(componentNotFound);
		});
	}

	getFirstLayoutId = () => {
		return $('[name="ssb-configurator-layout"]').first().data('layout-id');
	};

	existLayout = (layoutId) => {
		return $(`input[data-layout-id="${layoutId}"]`).length > 0;
	};

	shareLinkLayout = (layoutId) => {
		layoutId = this.existLayout(layoutId) ? layoutId : this.getFirstLayoutId();
		if (layoutId) {
			this._seadevShedBuilder.setActiveLayout(layoutId);
			$(
				`#ssb-configurator-layout-option input[name="ssb-configurator-layout"][data-layout-id="${layoutId}"]`,
			).prop('checked', true);
			const layoutLabel = $(
				`#ssb-configurator-layout-option input[name="ssb-configurator-layout"][data-layout-id="${layoutId}"]`,
			).attr('data-option-value');
			const limitWidth = $(
				`#ssb-configurator-layout-option input[name="ssb-configurator-layout"][data-layout-id="${layoutId}"]`,
			).attr('data-layout-limit-width');
			const limitDepth = $(
				`#ssb-configurator-layout-option input[name="ssb-configurator-layout"][data-layout-id="${layoutId}"]`,
			).attr('data-layout-limit-depth');
			const limitHeight = $(
				`#ssb-configurator-layout-option input[name="ssb-configurator-layout"][data-layout-id="${layoutId}"]`,
			).attr('data-layout-limit-height');

			$(`#ssb-configurator-accordion-layouts .ssb-configurator-selected`).text(layoutLabel);
			$('#js-shed-data input[name="ssb-option-layout"]').val(layoutLabel);
			$('#js-shed-data input[name="ssb-option-layout"]').attr('data-key', layoutId);

			this.disableLimitSizes(limitWidth, limitDepth, limitHeight);

			const defaultLayout = $(
				`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
			);
			const { components } = this.getLayoutData(defaultLayout);
			const layoutComponents = JSON.parse(components);
			if (
				this._seadevShedBuilder._isLayoutBlock &&
				!helpers.isEmptyObject(layoutComponents)
			) {
				Object.keys(layoutComponents).forEach((key) => {
					let components = layoutComponents[key];
					components.map((item) => {
						item.is_block = -1 === interiors.indexOf(item.type);
					});
					layoutComponents[key] = components;
				});
			}
			this._seadevShedBuilder.setLayoutComponents(layoutComponents);
			this._seadevShedBuilder._isLayoutBlock =
				'1' === defaultLayout.attr('data-layout-block');
			this._seadevShedBuilder._isLayoutBlockAdding =
				'1' === defaultLayout.attr('data-layout-block-adding');
			this.updateIncludeComponents();
			this.handleShowHideButtonAddComponent();
			this.shedDetailRenderLayout();
		}
	};

	generateShedModel(dataBase64) {
		const _this = this;
		_this.handleLayoutChange(true);
		return new Promise(async (resolve) => {
			let dataNotFound = [];
			const dataString = window.atob(dataBase64);
			const data = JSON.parse(dataString);

			const {
				components,
				iComponents,
				height,
				roofColor,
				roofColorCode,
				roofType,
				sidingColor,
				sidingColorCode,
				wainsCot,
				eSidingUpgrades,
				eFinishes,
				sidingType,
				size,
				trimColor,
				shutterColor,
				roofOverhang,
				porch,
				railing,
				packages,
				others,
				externalPorch,
				levelingFee,
				loftConfig,
				layoutId,
				doorColor,
				oPosition,
				tackDoor,
				ventColor,
				roofPitch,
				legs,
				frameSpacing,
				ePackagesId,
				carportSidingData,
				jTrim,
				windowColor,
				frame,
				dormer,
				leanTo,
				railsColor,
				trimColorCode,
				shutterColorCode,
				doorColorCode,
				ventColorCode,
				windowsColorCode,
				railsColorCode,
				leantoOption,
				porchOption,
				floorMaterial,
				tackRoom,
				wallColor,
				wallColorCode,
				ceilingColor,
				ceilingColorCode,
				countertopsColor,
				countertopsColorCode,
				applianceColor,
				applianceColorCode,
				isSwapSideGable,
				interiorWallType,
				interiorCeilingType,
				insulationRoofType,
				insulationWallType,
			} = data;
			_this.shareLinkLayout(layoutId);

			$('input[name="ssb-configurator-upgrade-frame"]').prop('checked', false);

			const eSidingUpgradesData = eSidingUpgrades
				? JSON.parse(window.atob(eSidingUpgrades))
				: eFinishes
					? JSON.parse(window.atob(eFinishes))
					: {};
			if (!helpers.isEmptyObject(eSidingUpgradesData)) {
				$(
					`.ssb-configurator-options.exterior_siding_upgrades .ssb-option[data-key=${eSidingUpgradesData.key}]`,
				)
					.prop('checked', true)
					.trigger('change');

				$(
					`#exterior_siding_upgrades-material-option li[data-key="${eSidingUpgradesData.materialKey}"]`,
				).trigger('click', () => {
					$(
						`.group-exterior_siding_upgrades-color ul li[data-key="${eSidingUpgradesData.colorKey}"]`,
					).trigger('click');
				});
			}

			if (floorMaterial) {
				if ($(`#floor-material-option li[data-key="${floorMaterial}"]`).length > 0) {
					$(`#floor-material-option li[data-key="${floorMaterial}"]`).trigger('click');
				} else {
					dataNotFound.push({ type: 'Floor Material', key: floorMaterial });
				}
			}

			if (interiorWallType) {
				if (
					$(`#interior_wall-material-option li[data-key="${interiorWallType}"]`).length >
					0
				) {
					_this.triggerClickInteriorMaterial('interior_wall', interiorWallType);
				} else {
					dataNotFound.push({ type: 'Finishing Wall Material', key: interiorWallType });
				}
			}

			if (interiorCeilingType) {
				if (
					$(`#interior_ceiling-material-option li[data-key="${interiorCeilingType}"]`)
						.length > 0
				) {
					_this.triggerClickInteriorMaterial('interior_ceiling', interiorCeilingType);
				} else {
					dataNotFound.push({
						type: 'Finishing Ceiling Material',
						key: interiorCeilingType,
					});
				}
			}

			if (insulationRoofType) {
				if (
					$(`#insulation_roof-material-option li[data-key="${insulationRoofType}"]`)
						.length > 0
				) {
					_this.triggerClickInteriorMaterial('insulation_roof', insulationRoofType);
				} else {
					dataNotFound.push({
						type: 'Insulation Roof Material',
						key: insulationRoofType,
					});
				}
			}

			if (insulationWallType) {
				if (
					$(`#insulation_wall-material-option li[data-key="${insulationWallType}"]`)
						.length > 0
				) {
					_this.triggerClickInteriorMaterial('insulation_wall', insulationWallType);
				} else {
					dataNotFound.push({
						type: 'Insulation Wall Material',
						key: insulationWallType,
					});
				}
			}

			if (wallColor) {
				if ($(`.group-wall-color li[data-key="${wallColor.toLowerCase()}"]`).length) {
					$(`.group-wall-color li[data-key="${wallColor.toLowerCase()}"]`).trigger(
						'click',
					);
					if (wallColorCode) {
						$(
							`.group-wall-color ul li[data-key="${wallColor.toLowerCase()}"] .ssb-option-color-picker`,
						)
							.val(wallColorCode)
							.trigger('input');
					}
				} else {
					dataNotFound.push({ type: 'Wall Color', key: wallColor });
				}
			}

			if (ceilingColor) {
				if ($(`.group-ceiling-color li[data-key="${ceilingColor.toLowerCase()}"]`).length) {
					$(`.group-ceiling-color li[data-key="${ceilingColor.toLowerCase()}"]`).trigger(
						'click',
					);
					if (ceilingColorCode) {
						$(
							`.group-ceiling-color ul li[data-key="${ceilingColor.toLowerCase()}"] .ssb-option-color-picker`,
						)
							.val(ceilingColorCode)
							.trigger('input');
					}
				} else {
					dataNotFound.push({ type: 'Ceiling Color', key: ceilingColor });
				}
			}

			// if( ceilingColor ) {
			//     if( $( `.group-ceiling-color li[data-key="${ceilingColor.toLowerCase()}"]` ).length ) {
			//         $( `.group-ceiling-color li[data-key="${ceilingColor.toLowerCase()}"]` ).trigger( 'click' );
			//         if( ceilingColorCode ) {
			//             $( `.group-ceiling-color ul li[data-key="${ceilingColor.toLowerCase()}"] .ssb-option-color-picker` ).val( ceilingColorCode ).trigger( 'input' )
			//         }
			//     } else {
			//         dataNotFound.push( { type: 'Ceiling Color', key: ceilingColor } );
			//     }
			// }

			if (countertopsColor) {
				if (
					$(`.group-countertops-color li[data-key="${countertopsColor.toLowerCase()}"]`)
						.length
				) {
					$(
						`.group-countertops-color li[data-key="${countertopsColor.toLowerCase()}"]`,
					).trigger('click');
					if (countertopsColorCode) {
						$(
							`.group-countertops-color ul li[data-key="${countertopsColor.toLowerCase()}"] .ssb-option-color-picker`,
						)
							.val(countertopsColorCode)
							.trigger('input');
					}
				} else {
					dataNotFound.push({ type: 'Countertops Color', key: countertopsColor });
				}
			}

			if (applianceColor) {
				if (
					$(`.group-appliance-color li[data-key="${applianceColor.toLowerCase()}"]`)
						.length
				) {
					$(
						`.group-appliance-color li[data-key="${applianceColor.toLowerCase()}"]`,
					).trigger('click');
					if (applianceColorCode) {
						$(
							`.group-appliance-color ul li[data-key="${applianceColor.toLowerCase()}"] .ssb-option-color-picker`,
						)
							.val(applianceColorCode)
							.trigger('input');
					}
				} else {
					dataNotFound.push({ type: 'Appliance Panels Color', key: applianceColor });
				}
			}

			if (dormer) {
				this._seadevShedBuilder._dormerOption = dormer;
				$(`[name="ssb-configurator-upgrade-dormer-option"][data-key="${dormer}"]`).prop(
					'checked',
					true,
				);
			}

			if (
				tackRoom &&
				0 ==
					$(`[name="ssb-configurator-upgrade-tackroom"][data-key="${tackRoom.position}"]`)
						.length
			) {
				$(`input[name='ssb-configurator-upgrade-tackroom']`).prop('checked', false);
				this._seadevShedBuilder.tackroomNotFound = true;
			}

			if (tackDoor) {
				if ($('#js-enable-tack-door').length) {
					$('#js-enable-tack-door').prop('checked', true);
				} else {
					dataNotFound.push({ type: 'Tack Door', key: '' });
				}
			} else {
				$('#js-enable-tack-door').prop('checked', false);
			}

			$(`.ssb_package`)
				.prop('checked', false)
				.closest('.ssb-configurator-options')
				.find('.upgrade-quantity')
				.remove();
			if (packages) {
				const args = JSON.parse(window.atob(packages));
				let errorText = [];
				for (const e in args) {
					let base64_val = window.btoa(args[e].name);
					let baseHtml = `.ssb_package[data-value-base64="${base64_val}"]`;
					if ($(baseHtml).length) {
						let input = _this.renderInput(
							'ssb-configurator-upgrade-package',
							args[e].quantity,
						);
						let picker = $(baseHtml).data('picker');
						$(baseHtml).prop('checked', true);
						$(baseHtml).parent().show();
						$(baseHtml).parents('.ssb-configurator-group').show();
						if (picker != 1) continue;
						$(baseHtml).closest('div').append(input);
					} else {
						errorText.push(args[e].name);
					}
				}
				if (errorText.length) {
					dataNotFound.push({ type: 'Packages', key: errorText.join(', ') });
				}
			} else {
				$('.ssb_package').prop('checked', false);
			}

			this._isEnabledRailing = railing || false;
			if (
				undefined !== railing ||
				$(`input[name='ssb-configurator-upgrade-porch-railing']`).length
			) {
				const railing_key = railing ? 'with_railing' : 'no_railing';
				dataNotFound = this.updateDataNotFound(
					dataNotFound,
					railing_key,
					'Porch Railing',
					$(
						`input[name='ssb-configurator-upgrade-porch-railing'][data-key=${railing_key}]`,
					),
				);
			}

			this._isEnabledExternalPorch = externalPorch || false;
			if (undefined !== externalPorch) {
				const externalPorch_key = externalPorch ? 'enabled_porch' : 'disable_porch';
				dataNotFound = this.updateDataNotFound(
					dataNotFound,
					externalPorch_key,
					'External Porch',
					$(
						`input[name='ssb-configurator-upgrade-external-porch'][data-key=${externalPorch_key}]`,
					),
				);
			}

			const leanToKey = leanTo ? 'enabled_leanto' : 'disable_leanto';
			if (leanTo) {
				dataNotFound = this.updateDataNotFound(
					dataNotFound,
					leanToKey,
					'Leanto',
					$(`input[name=ssb-configurator-upgrade-lean-to][data-key=${leanToKey}]`),
				);
			} else {
				$(`input[name=ssb-configurator-upgrade-lean-to][data-key=${leanToKey}]`).trigger(
					'click',
				);
			}

			const porchBase64 = window.btoa(porch);
			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				porch,
				'Porch',
				$(`.ssb_porch[data-value-base64="${porchBase64}"]`),
			);
			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				roofPitch,
				'Roof Pitch',
				$(`.ssb_roof_pitch[value="${roofPitch}"]`),
			);
			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				legs,
				'Leg',
				$(`.ssb_legs_setting[value="${legs}"]`),
			);
			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				frameSpacing,
				'Frame Spacing',
				$(`.ssb_frame_spacing[value="${frameSpacing}"]`),
			);

			$(`.ssb_other`)
				.prop('checked', false)
				.closest('.ssb-configurator-options')
				.find('.upgrade-quantity')
				.remove();
			if (others) {
				const args = JSON.parse(window.atob(others));
				let errorText = [];
				for (const e in args) {
					let base64_val = window.btoa(args[e].name + '-' + args[e].group);
					let baseHtml = `.ssb_other[data-value-base64="${base64_val}"]`;
					if ($(baseHtml).length) {
						let input = _this.renderInput(
							'ssb-configurator-upgrade-other',
							args[e].quantity,
						);
						let picker = $(baseHtml).data('picker');
						$(baseHtml).prop('checked', true);
						$(baseHtml).parents('.ssb-configurator-group').show();
						if (picker != 1) continue;
						$(baseHtml).closest('div').append(input);
					} else {
						if ('Leanto' !== args[e].group) {
							errorText.push(args[e].name + '-' + args[e].group);
						}
					}
				}
				if (errorText.length) {
					dataNotFound.push({ type: 'Upgrades Options', key: errorText.join(', ') });
				}
			} else {
				$('.ssb_other').prop('checked', false);
			}

			if (sidingType) {
				if (
					$(`#siding-material-option li[data-key="${sidingType.toLowerCase()}"]`).length
				) {
					$(`#siding-material-option li[data-key="${sidingType.toLowerCase()}"]`).trigger(
						'click',
						() => {
							$(
								`.group-siding-color ul li.${sidingType}[data-key="${sidingColor}"]`,
							).trigger('click');
							$(
								`.group-trim-color ul li.${sidingType}[data-key="${trimColor}"]`,
							).trigger('click');

							if (
								!helpers.isEmptyObject(eSidingUpgradesData) &&
								eSidingUpgradesData.colorCode
							) {
								$(
									`.group-exterior_siding_upgrades-color ul li.${sidingType}[data-key="${eSidingUpgradesData.colorKey}"] .ssb-option-color-picker`,
								)
									.val(eSidingUpgradesData.colorCode)
									.trigger('input');
							}

							if (sidingColorCode) {
								$(
									`.group-siding-color ul li.${sidingType}[data-key="${sidingColor}"] .ssb-option-color-picker`,
								)
									.val(sidingColorCode)
									.trigger('input');
							}

							if (trimColorCode) {
								$(
									`.group-trim-color ul li.${sidingType}[data-key="${trimColor}"] .ssb-option-color-picker`,
								)
									.val(trimColorCode)
									.trigger('input');
							}
						},
					);
				} else {
					dataNotFound.push({ type: 'Siding Material', key: sidingType });
				}
			}

			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				sidingColor,
				'Siding Color',
				$(`.group-siding-color ul li[data-key="${sidingColor}"]`),
				false,
			);
			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				trimColor,
				'Trim Color',
				$(`.group-trim-color ul li[data-key="${trimColor}"]`),
				false,
			);

			let roofColorElement: any;
			if (roofType) {
				if ($(`.group-roof-type [data-key="${roofType.toLowerCase()}"]`).length) {
					$(`.group-roof-type [data-key="${roofType.toLowerCase()}"]`).trigger(
						'click',
						() => {
							roofColorElement = $(
								`.group-roof-color li[data-key="${roofColor}"][data-roof-type="${roofType}"]`,
							);
							roofColorElement.click();

							if (roofColorCode) {
								$(
									`.group-roof-color li[data-key="${roofColor}"][data-roof-type="${roofType}"] .ssb-option-color-picker`,
								)
									.val(roofColorCode)
									.trigger('input');
							}
						},
					);
				} else {
					dataNotFound.push({ type: 'Roof Material', key: roofType });
				}
			}

			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				roofColor,
				'Roof Color',
				roofColorElement,
				false,
			);

			const argsColor = [
				{
					key: 'shutter',
					code: shutterColorCode,
					colorKey: shutterColor,
					text: 'Shutter Color',
					element: $(`.group-shutter-color li[data-key="${shutterColor}"]`),
				},
				{
					key: 'door',
					code: doorColorCode,
					colorKey: doorColor,
					text: 'Door Color',
					element: $(`.group-door-color li[data-key="${doorColor}"]`),
				},
				{
					key: 'vent',
					code: ventColorCode,
					colorKey: ventColor,
					text: 'Vent Color',
					element: $(`.group-vent-color li[data-key="${ventColor}"]`),
				},
				{
					key: 'windows',
					code: windowsColorCode,
					colorKey: windowColor,
					text: 'Window Color',
					element: $(`.group-windows-color li[data-key="${windowColor}"]`),
				},
				{
					key: 'rails',
					code: railsColorCode,
					colorKey: railsColor,
					text: 'Post/Rails Color',
					element: $(`.group-rails-color li[data-key="${railsColor}"]`),
				},
			];

			for (let colors of argsColor) {
				let isClick = true;

				if (colors.code && colors.element.length) {
					isClick = false;
					colors.element
						.find('.ssb-option-color-picker')
						.val(colors.code)
						.trigger('input');
				}

				dataNotFound = this.updateDataNotFound(
					dataNotFound,
					colors.colorKey,
					colors.text,
					colors.element,
					isClick,
				);
			}

			if (undefined !== roofOverhang) {
				$(`.group-upgrade-roof_overhang`).show();
				const args = roofOverhang.split('||');
				if ('undefined' !== args[0]) {
					if (!args[1]) {
						args[1] = $(
							`[name="ssb-configurator-upgrade-roof_overhang"][value="${args[0]}"]`,
						).attr('data-value-base64');
					}

					if (
						$(
							`[name="ssb-configurator-upgrade-roof_overhang"][value="${args[0]}"][data-value-base64="${args[1]}"]`,
						).length
					) {
						$(
							`[name="ssb-configurator-upgrade-roof_overhang"][value="${args[0]}"][data-value-base64="${args[1]}"]`,
						).trigger('click');
						$(
							`[name="ssb-configurator-upgrade-roof_overhang"][value="${args[0]}"][data-value-base64="${args[1]}"]`,
						)
							.parent()
							.show();
					} else {
						dataNotFound.push({ type: 'Roof Overhang', key: args[0] });
					}
				}
			}

			if (loftConfig) {
				$(`input[name='ssb-configurator-upgrade-loft'][data-key="${loftConfig}"]`)
					.closest('div')
					.removeClass('hidden');
			}

			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				loftConfig,
				'Loft',
				$(`input[name='ssb-configurator-upgrade-loft'][data-key="${loftConfig}"]`),
			);

			if (ePackagesId) {
				if (
					0 >=
					$(
						`[name="ssb-configurator-electrical-packages"][data-package-id="${ePackagesId}"]`,
					).length
				) {
					dataNotFound.push({ type: 'Electrical Package', key: ePackagesId });
					_this._seadevShedBuilder._electricalPackageID = 'none';
				} else {
					$(
						`[name="ssb-configurator-electrical-packages"][data-package-id="${ePackagesId}"]`,
					).prop('checked', true);
					$(
						`[name="ssb-configurator-electrical-packages"][data-package-id="${ePackagesId}"]`,
					)
						.parent()
						.show();
					const ePackagesComponents = $(
						`[name="ssb-configurator-electrical-packages"][data-package-id="${ePackagesId}"]`,
					).attr('data-package-components');

					_this._seadevShedBuilder._electricalPackageID = ePackagesId;
					if (ePackagesComponents != undefined && ePackagesComponents != '') {
						const components = JSON.parse(ePackagesComponents);
						_this._seadevShedBuilder._defaultAllComponentInPackage = components;
						_this._seadevShedBuilder._defaultEPackageComponents = components.filter(
							(item) =>
								_this._seadevShedBuilder.isValidComponentBySizeCondition(item),
						);
					}

					_this.showHideElectricalPackagesItem(ePackagesId);
				}
			}

			if (frame) {
				if (
					$(
						`[name="ssb-configurator-upgrade-frame"][data-option-value-base64="${frame}"]`,
					).length
				) {
					$(
						`[name="ssb-configurator-upgrade-frame"][data-option-value-base64="${frame}"]`,
					).prop('checked', true);
				} else {
					dataNotFound.push({ type: 'Frame Material', key: window.atob(frame) });
				}
			}
			_this._sizeInShareLink = size;
			const tmpSizes = size.split('x');
			const widthDepth = `${tmpSizes[0]}x${tmpSizes[1]}`;

			const sizeLabel = helpers.getSizeLabel(
				$('#ssb-configurator-size-area').children(
					`option[data-size-width="${tmpSizes[0]}"][data-size-depth="${tmpSizes[1]}"]`,
				),
				height,
			);
			$(`#ssb-height .custom-select-selected`).html(sizeLabel['heightLabel']);
			$(`#ssb-height .select-items div`).removeClass('same-as-selected');
			$(`#ssb-height .select-items div[custom-select-value="${height}"]`).addClass(
				'same-as-selected',
			);

			const elementSize = $(`#ssb-configurator-size-area option[value="${widthDepth}"]`);
			const dataSizes = elementSize.attr('data-sizes');
			if (
				elementSize.length &&
				dataSizes &&
				this.hasSizeHeight(Number(height), JSON.parse(atob(dataSizes)))
			) {
				$(`#ssb-configurator-size-area`).val(widthDepth);
			} else {
				$(`#ssb-configurator-size-area`).val(null);
			}

			$(`#ssb-configurator-size-height`)
				.val(height)
				.trigger('change', async () => {
					if (isSwapSideGable) {
						if (
							$('input[name="ssb-group-upgrade-side-gable"][value="enable"]').length
						) {
							$('input[name="ssb-group-upgrade-side-gable"][value="enable"]')
								.prop('checked', true)
								.trigger('change');
						} else {
							dataNotFound.push({ type: 'Swap Layout', key: 'Side Gable' });
						}
					}

					if (levelingFee) {
						const args = JSON.parse(window.atob(levelingFee));
						const sizeElement = $('#ssb-configurator-size-area option:selected');
						let errorText = [];
						for (const e in args) {
							let base64_val = window.btoa(args[e].name);
							let input = $(
								`#foundation-options .ssb-option[data-value-base64="${base64_val}"]`,
							);
							if (input.length) {
								input.prop('checked', true);
								input.attr(
									'data-price',
									Number(sizeElement.attr(`${$(input).val()}`)),
								);
							} else {
								errorText.push(args[e].name);
							}
						}

						if (errorText.length) {
							dataNotFound.push({ type: 'Leveling Fee', key: errorText.join(', ') });
						}
					}

					if (carportSidingData && Object.keys(carportSidingData).length > 0) {
						let errorText = [];
						Object.keys(carportSidingData).forEach(function (side) {
							if (side === 'back' || side === 'front') {
								if (
									$(
										`#ssb-configurator-${side}-gable-end option[value="${carportSidingData[side].key}"]`,
									).length
								) {
									$(`#ssb-configurator-${side}-gable-end`)
										.val(carportSidingData[side].key)
										.change();
								} else {
									errorText.push(window.atob(carportSidingData[side].key));
								}
							} else {
								if (
									$(
										`#ssb-configurator-${side}-sidewall option[value="${carportSidingData[side].key}"]`,
									).length
								) {
									$(`#ssb-configurator-${side}-sidewall`)
										.val(carportSidingData[side].key)
										.change();
								} else {
									errorText.push(window.atob(carportSidingData[side].key));
								}
							}
						});

						if (errorText.length) {
							dataNotFound.push({ type: 'Sides & Ends', key: errorText.join(', ') });
						}
					}

					if (jTrim) {
						if (
							$(
								`.ssb-configurator-options.group-j-trim input[name="j_trim"][value="${jTrim}"]`,
							).length &&
							'none' !==
								$(
									`.ssb-configurator-options.group-j-trim input[name="j_trim"][value="${jTrim}"]`,
								)
									.parent()
									.css('display')
						) {
							$(
								`.ssb-configurator-options.group-j-trim input[name="j_trim"][value="${jTrim}"]`,
							)
								.prop('checked', true)
								.change();
						} else {
							dataNotFound.push({ type: 'J-Trim', key: jTrim });
						}
					}

					if (tackRoom) {
						this._seadevShedBuilder._sideWallTackRoom = tackRoom.side;
						const elementTackroom = $(
							`input[name='ssb-configurator-upgrade-tackroom'][data-key="${tackRoom.position}"]`,
						);
						if (elementTackroom.length) {
							$(`input[name='ssb-configurator-upgrade-tackroom']`).prop(
								'checked',
								false,
							);
							elementTackroom.prop('checked', true);
							const width = elementTackroom.data('width');
							const position = elementTackroom.data('position');
							const price = elementTackroom.data('price');
							const priceType = elementTackroom.data('price-type');
							const side = elementTackroom.data('side');
							const args = { width, position, price, priceType, side };
							await _this._seadevShedBuilder.animateTackroomChange(args, false);
						} else {
							dataNotFound.push({ type: 'Tack Room', key: tackRoom.position });

							if (components.door) {
								components.door = components.door.filter((d) => !d.isTackDoor);
							}
						}
					}

					let numberComponents = 0;
					if (components) {
						const componentNotFound: any = await this.renderComponent(components);
						if (componentNotFound.length) {
							numberComponents = componentNotFound.length;
							dataNotFound.push({
								type: 'Component',
								key: componentNotFound.join(', '),
							});
						}
						this.updatePrice();
					}

					let numberIComponents = 0;
					if (iComponents) {
						const componentNotFound: any = await this.renderComponent(iComponents);
						if (componentNotFound.length) {
							numberIComponents = componentNotFound.length;
							dataNotFound.push({
								type: 'Interior Component',
								key: componentNotFound.join(', '),
							});
						}
						this.updatePrice();
					}

					if (dataNotFound.length) {
						let message = '';
						const count = dataNotFound.length;
						for (let i = 0; i < count - 1; i++) {
							if ('' === dataNotFound[i].key) {
								message += `<b>${dataNotFound[i].type}</b>, `;
							} else {
								message += `<b>${dataNotFound[i].type}:</b> <i>${dataNotFound[i].key},</i> `;
							}
						}

						if ('' === dataNotFound[count - 1].type) {
							message += `<b>${dataNotFound[count - 1].type}</b> ${1 < count || 1 < numberComponents || 1 < numberIComponents ? 'are' : 'is'} not available any more. Select another option.`;
						} else {
							message += `<b>${dataNotFound[count - 1].type}:</b> <i>${dataNotFound[count - 1].key}</i> ${1 < count || 1 < numberComponents || 1 < numberIComponents ? 'are' : 'is'} not available any more. Select another option.`;
						}

						this._seadevShedBuilder.createAlert(message, count * 10000);
					}
				});

			dataNotFound = this.updateDataNotFound(
				dataNotFound,
				oPosition,
				'Opening Position',
				$(
					`input[name='ssb-configurator-upgrade-opening-position'][data-key="${oPosition}"]`,
				),
			);

			if (leantoOption) {
				$(
					`input[name=ssb-configurator-upgrade-lean-to-size-option][data-key=${leantoOption}]`,
				).trigger('click');
			}

			if (porchOption) {
				$(
					`input[name=ssb-configurator-upgrade-porch-size-option][data-key=${porchOption}]`,
				).trigger('click');
			}

			if (0 === $(`#ssb-configurator-size-height option[value="${height}"]`).length) {
				this._seadevShedBuilder.createAlert(
					`Failed to render this structure as building height (${height} ft) not found.`,
				);
				this._seadevShedBuilder._isDisableAddCart = false;
				this.handleDisableButtonAddToCart();
			}

			const wainsCotData = wainsCot ? JSON.parse(window.atob(wainsCot)) : {};
			if (!helpers.isEmptyObject(wainsCotData) && wainsCotData.hasOwnProperty('wainsType')) {
				let wainscotSides = wainsCotData.wainsSide ? wainsCotData.wainsSide : [];
				let wainscotType = 2 == wainsCotData.wainsType ? 3 : wainsCotData.wainsType;
				let wainscotElement = _this.getOptionWainscottingMatchingCondition(
					wainsCotData.material,
				);
				if (wainsCotData.wainsKey) {
					wainscotElement = $(
						`.ssb-configurator-options.wainscot .ssb-option[data-key=${wainsCotData.wainsKey}]`,
					);
				}

				let dataWainscoting = _this.getDataWaincostingFromElement(wainscotElement);
				if (2 == wainsCotData.wainsType) {
					wainscotSides = dataWainscoting.applySides;
				}

				wainscotElement.prop('checked', true);
				_this._seadevShedBuilder.setWainscotingData(dataWainscoting);
				_this.animateUpdateWainscotingOption({
					type: wainscotType,
					sides: wainscotSides,
					defaultMaterial: wainsCotData.material,
					defaultColor: wainsCotData.colorKey,
				});
				if (dataWainscoting.allowUserSelect) {
					_this.renderWainscotingSideSelect(wainscotElement);
				}
				_this.renderWainscotingSideText(wainscotSides);
				$(
					`#wainscoting-material-option li[data-key="${wainsCotData.material}"]:not(.unavailable)`,
				).trigger('click', () => {
					$(
						`.group-wainscoting-color ul li[data-key="${wainsCotData.colorKey}"]:not(.unavailable)`,
					).trigger('click');
				});
			} else {
				_this._seadevShedBuilder._wainscotingType = 1;
				$(`.ssb-configurator-options.wainscot .ssb-option[data-primary-key=1]`).prop(
					'checked',
					true,
				);
			}

			resolve(true);
		});
	}

	updateDataNotFound = (data, key, type, element, isClick = true) => {
		if (key) {
			if (element.length) {
				if (isClick) {
					element.trigger('click');
				}
			} else {
				data.push({ type, key });
			}
		}

		return data;
	};

	popupAddComponent = () => {
		const _this = this;

		$(
			'#ssb-configurator-accordion-upgrades .ssb-configurator-group, #ssb-configurator-accordion-interior .ssb-configurator-group',
		).each(function (index, el) {
			$(el)
				.find('.add-component')
				.click(async function () {
					const type = $(this).data('type');
					const title = $(this).data('title');

					if (
						_this._seadevShedBuilder._isLayoutBlockAdding &&
						-1 === interiors.indexOf(type)
					) {
						return _this._seadevShedBuilder.createAlert(NOTICES.itemNotChange);
					}

					let side = _this._seadevShedBuilder.detectFacingSideFromCamera(type);

					$('.wrap-lock-setting').hide();
					$('.upgrade-item-options').removeClass('active');
					$(`#ssb-left-position-${type}`).prop('checked', 1);

					if ('roof' === side && ('cupola' !== type || 'light' !== type)) {
						side = '';
					}

					if ('' === side || undefined === side || null === side) {
						return _this._seadevShedBuilder.createAlert(
							_this._seadevShedBuilder.NOTICES.cannotDetectSiding,
						);
					}

					if ('dormer' === type || 'skylight_window' === type) {
						if ('right' === side) {
							side = 'roof_right';
						} else {
							side = 'roof_left';
						}
					}

					if (
						_this._seadevShedBuilder.isCarport() &&
						!_this._seadevShedBuilder.isFullEnclosedWall(side)
					) {
						return _this._seadevShedBuilder.createAlert(
							_this._seadevShedBuilder.NOTICES.cannotAddComponent,
						);
					}

					if (
						(('structure_loafing_shed' === _this._seadevShedBuilder._shedType ||
							'structure_lofted_horserunin' === _this._seadevShedBuilder._shedType ||
							'structure_aframe_horserunin' === _this._seadevShedBuilder._shedType ||
							'structure_horse_shelter' === _this._seadevShedBuilder._shedType) &&
							'left' === side) ||
						('structure_chalet_genesis' === _this._seadevShedBuilder._shedType &&
							('left' === side || 'right' === side) &&
							('door' === type || 'vent' === type || 'windows' === type))
					) {
						return _this._seadevShedBuilder.createAlert(
							_this._seadevShedBuilder.NOTICES.cannotAddComponent,
						);
					}

					if ('cupola' === type || 'light' === type) {
						side = 'roof';
					}

					_this._seadevShedBuilder.rotateCameraBySide(side);

					_this._isAddNewComponent = true;
					_this._currentSide = side;
					_this._sideSelected = side;

					$('.child-option').hide();

					if ('door' === type) {
						_this.hideChildComponentNotFit('ramp', side);
					} else if ('windows' === type) {
						_this.hideChildComponentNotFit('flower_box', side);
					}

					if ('shelf' === type || 'workbench' === type) {
						const width = _this._seadevShedBuilder.getWallWidthBySide(side);
						helpers.generateComponentSizeOption(width);
					}

					_this._openingDialog = $(
						`.ssb-configurator-options.ssb-configurator-upgrade.${type}`,
					);
					_this._openingDialog
						.find('input:not(.ssb-option-1):not(.lock-setting)')
						.prop('checked', false);
					_this._openingDialog
						.find(`input#ssb-left-position-${type}`)
						.prop('checked', true);
					_this._openingDialog.find('.remove-component, .clone-component').hide();
					_this._openingDialog.find('.change-component').text('Add');
					_this._openingDialog.find('.component_size').val(2).change();

					_this._openingDialog.find('.dropdown-upgrade-select').each(function () {
						const currentDropdown = $(this);
						const elLabel = currentDropdown.find('.selected-item');
						if (currentDropdown.find('input:checked').length) {
							elLabel.text(
								currentDropdown.find('input:checked').parent().text().trim(),
							);
						} else {
							elLabel.text(
								currentDropdown.find('.dropdown-upgrade-item').eq(0).text().trim(),
							);
							if (!currentDropdown.hasClass('child-option-shutters')) {
								currentDropdown
									.find('.dropdown-upgrade-item')
									.eq(0)
									.find('input')
									.prop('checked', true);
							}
						}
					});

					if (
						('structure_alpinechalet' !== _this._seadevShedBuilder._shedType &&
							!_this._seadevShedBuilder.isFrontPorch()) ||
						(_this._seadevShedBuilder.isFrontPorch() &&
							!_this._seadevShedBuilder.isPorchModel())
					) {
						$('.wrap-popup-position').hide();
					} else {
						if (_this._seadevShedBuilder.isFrontPorch()) {
							if ('front' !== side) {
								$('.wrap-popup-position').hide();
							} else {
								$('.wrap-popup-position').show();
								$('.wrap-popup-position .ssb-position-option-dormer').hide();
							}
						} else if ('left' !== side) {
							$('.wrap-popup-position').hide();
						} else {
							$('.wrap-popup-position').show();
							$('.wrap-popup-position .ssb-position-option-porch').hide();
						}
					}

					if (_this._seadevShedBuilder.isCornerPorchLeft()) {
						if ('left' === side) {
							$('.wrap-popup-position').show();
							_this._openingDialog
								.find('.ssb-position-option-0')
								.val('left')
								.next('label')
								.html(_this.getSideLabel('left'));
							_this._openingDialog
								.find('.ssb-position-option-1')
								.val('inner_left')
								.next('label')
								.html(_this.getSideLabel('inner_left'));
						} else if ('front' === side) {
							$('.wrap-popup-position').show();
							_this._openingDialog
								.find('.ssb-position-option-0')
								.val('front')
								.next('label')
								.html(_this.getSideLabel('front'));
							_this._openingDialog
								.find('.ssb-position-option-1')
								.val('inner_front')
								.next('label')
								.html(_this.getSideLabel('inner_front'));
						}

						if ('left' === side || 'front' === side) {
							$(
								'input[name=porch-side-position-shelf]:checked, input[name=porch-side-position-workbench]:checked',
							).trigger('change');
						}
					} else if (_this._seadevShedBuilder.isDeluxeCornerLeftPorch()) {
						if ('front' === side) {
							$('.wrap-popup-position').show();
							_this._openingDialog
								.find('.ssb-position-option-0')
								.val('front')
								.prop('checked', true)
								.next('label')
								.html(_this.getSideLabel('front'));
							_this._openingDialog
								.find('.ssb-position-option-1')
								.val('inner_front')
								.next('label')
								.html(_this.getSideLabel('inner_front'))
								.parent()
								.show();
							_this._openingDialog
								.find('.ssb-position-option-2')
								.val('diagonal_right')
								.next('label')
								.html(_this.getSideLabel('diagonal_right'));
							_this._openingDialog
								.find('.ssb-position-option-3')
								.val('porch')
								.next('label')
								.html(_this.getSideLabel('porch'));
							if ('windows' === type || 'vent' === type) {
								_this._openingDialog
									.find('.ssb-position-option-3')
									.show()
									.next('label')
									.show();
							} else {
								_this._openingDialog
									.find('.ssb-position-option-3')
									.hide()
									.next('label')
									.hide();
							}
						} else if ('right' === side) {
							$('.wrap-popup-position').show();
							_this._openingDialog
								.find('.ssb-position-option-0')
								.val('right')
								.prop('checked', true)
								.next('label')
								.html(_this.getSideLabel('right'));
							if (0 === helpers.deluxePorchGetInnerRightWidth()) {
								_this._openingDialog
									.find('.ssb-position-option-1')
									.next('label')
									.parent()
									.hide();
							} else {
								_this._openingDialog
									.find('.ssb-position-option-1')
									.val('inner_right')
									.next('label')
									.html(_this.getSideLabel('inner_right'))
									.parent()
									.show();
							}
							_this._openingDialog
								.find('.ssb-position-option-2')
								.val('diagonal_right')
								.next('label')
								.html(_this.getSideLabel('diagonal_right'));
							_this._openingDialog
								.find('.ssb-position-option-3')
								.hide()
								.next('label')
								.hide();
						}

						if ('right' === side || 'front' === side) {
							$(
								'input[name=porch-side-position-shelf]:checked, input[name=porch-side-position-workbench]:checked',
							).trigger('change');
						}
					} else if (
						'structure_lakeside_bunkie_gambrel_roof' ===
							_this._seadevShedBuilder._shedType ||
						'structure_lakeside_bunkie_gable_roof' ===
							_this._seadevShedBuilder._shedType
					) {
						_this._openingDialog
							.find(`[name="dormer-position"]#ssb-left-position-${type}`)
							.val('front');

						if ('front' !== side) {
							$('.wrap-popup-position').hide();
						} else {
							$('.wrap-popup-position').show();
							$('.wrap-popup-position .ssb-position-option-dormer').hide();
						}
					} else if (
						'structure_ranch_cabin' === _this._seadevShedBuilder._shedType ||
						_this._seadevShedBuilder.isAframeSingleGable()
					) {
						if ('left' === side) {
							$('.wrap-popup-position').show();
							_this._openingDialog
								.find('.ssb-position-option-0')
								.val('left')
								.next('label')
								.html(_this.getSideLabel('left'));
							_this._openingDialog
								.find('.ssb-position-option-1')
								.val('inner_left')
								.next('label')
								.html(_this.getSideLabel('inner_left'));
						} else if ('back' === side) {
							$('.wrap-popup-position').show();
							_this._openingDialog
								.find('.ssb-position-option-0')
								.val('back')
								.next('label')
								.html(_this.getSideLabel('back'));
							_this._openingDialog
								.find('.ssb-position-option-1')
								.val('inner_back')
								.next('label')
								.html(_this.getSideLabel('inner_back'));
						}
					}

					if (
						_this._seadevShedBuilder.isMiddlePorch() ||
						_this._seadevShedBuilder.isDoubleGable()
					) {
						if ('left' === side) {
							$('.wrap-popup-position').show();

							$(
								'input[name=porch-side-position-shelf]:checked, input[name=porch-side-position-workbench]:checked',
							).trigger('change');
						}
					}

					if (_this._seadevShedBuilder.is2StoryLeanTo()) {
						if ('right' === side && _this._seadevShedBuilder.isEnableLeanTo()) {
							if (
								'door' === type ||
								!_this._seadevShedBuilder.isAllowPlaceComponentOn2ndFloor()
							) {
								side = 'lean_to_right';
								$(`.wrap-popup-position #ssb-porch-side-position-${type}-1`).prop(
									'checked',
									true,
								);
								$('.wrap-popup-position').hide();
							} else {
								_this._openingDialog
									.find('.ssb-position-option-0')
									.val('top_right')
									.next('label')
									.html(_this.getSideLabel('top_right'));
								$('.wrap-popup-position').show();
							}
						} else {
							$('.wrap-popup-position').hide();
						}
					}

					let isShowPopup = false;
					let tmpSides = [];
					let sideHidden = [];
					let firstSide = '';
					const sideElements = $(
						`.wrap-popup-position:not([style*="display: none"]) [data-popup-position="${type}"]:not([style*="display: none"])`,
					);
					if (sideElements.length) {
						sideElements.each((index, element) => {
							tmpSides.push($(element).val());
						});
					} else {
						tmpSides.push(side);
					}

					for (let i = 0; i < tmpSides.length; i++) {
						const components = _this._seadevShedBuilder.getFitComponentsByTypeAndSide(
							type,
							_this._seadevShedBuilder.getSidingType(),
							tmpSides[i],
						);
						if (components.length) {
							isShowPopup = true;
							if ('' === firstSide) {
								firstSide = tmpSides[i];
							}
						} else {
							sideHidden.push(tmpSides[i]);
						}
					}

					if (!isShowPopup) {
						return _this._seadevShedBuilder.createAlert(
							`Did not find any eligible ${type.replaceAll('_', ' ')} to add here. Common reasons are due to restriction rules for siding materials or required spacing for equipment set.`,
						);
					}

					for (let i = 0; i < sideHidden.length; i++) {
						$(
							`.wrap-popup-position:not([style*="display: none"]) [data-popup-position="${type}"][value="${sideHidden[i]}"]`,
						)
							.hide()
							.next()
							.hide();
					}

					if ('' !== firstSide) {
						side = firstSide;
						$(
							`.wrap-popup-position:not([style*="display: none"]) [data-popup-position="${type}"][value="${firstSide}"]`,
						)
							.prop('checked', true)
							.trigger('change');
					}

					_this.hideComponentNotFit(type, side);

					_this.cloneComponent('', side);

					$(_this._openingDialog).dialog({
						autoOpen: false,
						modal: true,
						title: title,
						closeText: '',
						dialogClass: 'ssb-component-dialog',
						resizable: false,
						close: function (event, ui) {
							_this.closeEditComponent();
						},
					});

					$('.upgrade-item').removeClass('block-change');
					_this._openingDialog.find('.accordion-group').removeClass('block-change');

					if (_this._openingDialog.find('.wrap-popup-position').length) {
						_this._openingDialog
							.find('.wrap-popup-position')
							.removeClass('is-show-popup');
						_this._openingDialog
							.find('.wrap-popup-position:not([style*="display: none"])')
							.addClass('is-show-popup');
						_this._openingDialog
							.find('.wrap-popup-position')
							.prependTo(_this._openingDialog.find('.accordion-component'));
					}

					_this._openingDialog.addClass('add-new-component');
					$('body').addClass('dialog-opened');
					$(_this._openingDialog).dialog('open');

					if (0 === $(_this._openingDialog).find('.accordion-component').length) {
						_this.loadComponentsByCategory(type);
					} else {
						_this.loadComponentsBySubCategory(
							$(_this._openingDialog).find(
								'.accordion-component .accordion-group.active',
							),
						);
					}
				});
		});
	};

	private addComponentDOM(
		uuid,
		side,
		type,
		name,
		key,
		ramp,
		componentSize,
		disableEdit = false,
		addClass = '',
	) {
		const _this = this;
		if (false !== ramp) {
			$(`[data-component-key="${ramp.parent}"]`).find('span.ramp').remove();
			let label = _this._isManufactureEditOrder
				? $(`[for="${name}"] input`).attr('data-option-original-value')
				: $(`[for="${name}"] input`).attr('data-option-value');
			$(`<span class="ramp"> (with a ${label})</span>`).insertAfter(
				`[data-component-key="${ramp.parent}"] .added-component-label`,
			);
		} else {
			if (
				('structure_lofted_horserunin' === this._seadevShedBuilder._shedType ||
					'structure_aframe_horserunin' === this._seadevShedBuilder._shedType ||
					'structure_horse_shelter' === this._seadevShedBuilder._shedType) &&
				this._seadevShedBuilder.getTackDoor() === name &&
				'left' === side
			) {
				return;
			}

			const components = [
				{ childType: 'flower_box', text: 'Flower box' },
				{ childType: 'shutters', text: 'Shutters' },
				{ childType: 'transom', text: 'Transom' },
			];

			const activeComponents = components
				.filter(({ childType }) =>
					this._seadevShedBuilder.isChildComponent(side, key, childType),
				)
				.map(({ text }) => text);

			type = components.some(({ childType }) => childType === type) ? 'windows' : type;
			const childrenText =
				activeComponents.length > 0
					? '<span> (with ' + activeComponents.join(', ') + ')</span>'
					: '';

			const element = $('.ssb-configurator-options.ssb-configurator-upgrade.' + type).find(
				"input[data-uuid='" + uuid + "']",
			);
			let label = _this._isManufactureEditOrder
				? element.attr('data-option-original-value')
				: element.attr('data-option-value');
			label +=
				componentSize && componentSize > 0 && 'light' !== type
					? `<span> (${componentSize} linear feet)</span>`
					: '';
			const sideLabel = this.getSideLabel(side);
			let isChangeLock = false;
			const buttonEdit = !disableEdit
				? `<button class="edit-component ${addClass}"><i class="fas fa-pen"></i></button>`
				: '';
			if ('door' === type) {
				const isAllow = $(`[data-upgrade-component-name='${name}']`).data(
					'allow-change-position',
				);
				if (isAllow) {
					const tmpComponent = _this._seadevShedBuilder.getComponentBySideAndKey(
						side,
						key,
					);
					if (tmpComponent['customLock'] && tmpComponent['defaultLock']) {
						const lockText = _this._seadevShedBuilder.getLockPositionText(
							tmpComponent['name'],
							tmpComponent['customLock'],
						);
						label += ` ${lockText}`;
						isChangeLock = true;
					}
				}
			}

			let addedItem = `<li class="added-item" data-uuid="${uuid}" data-component-name="${name}" data-component-type="${type}" data-component-side="${side}" data-component-key="${key}" data-component-size="${componentSize || 0}">
                <span class="added-component-side">${sideLabel}: </span><span class="added-component-label">${label}</span>
                ${childrenText}
                ${buttonEdit}
            </li>`;

			$(`[data-component-key="${key}"]`).remove();
			$(
				'#ssb-configurator-accordion-upgrades .ssb-configurator-group.group-upgrade-' +
					type +
					', #ssb-configurator-accordion-interior .ssb-configurator-group.group-upgrade-' +
					type,
			)
				.find('ul.added-components')
				.append(addedItem);

			if (isChangeLock) {
				const childComponents = this.getAddOn(
					key,
					this._seadevShedBuilder._walls[side]['items'],
					false,
				);
				if (childComponents.length > 0) {
					childComponents[0]['parent'] = key;
					_this.addComponentDOM(
						'uuid',
						side,
						type,
						childComponents[0]['name'],
						childComponents[0]['key'],
						childComponents[0],
						componentSize,
					);
				}
			}
		}
	}

	getRampIdFromLayoutByKey(side, key) {
		let _this = this;
		let sideComponents = _this._seadevShedBuilder._walls[side]['items'];

		for (const cKey in sideComponents) {
			let comp = sideComponents[cKey];

			if (comp.type === 'ramp' && comp.parent === key) {
				return comp.name;
			}
		}

		return 'none_ramp';
	}

	handleChildOptionsItemComponents(element) {
		const elementOptions = element.siblings('.upgrade-item-options');
		elementOptions.removeClass('show-col-1 show-col-2 show-col-3');
		$('.upgrade-item-options').removeClass('active');
		$('.dropdown-upgrade-select').removeClass('active');
		if (elementOptions) {
			element
				.parents('.ssb-configurator-upgrade')
				.find('.dropdown-upgrade-box.child-option')
				.removeClass('not-available');
			element
				.parents('.ssb-configurator-upgrade')
				.find('.dropdown-upgrade-box.child-option')
				.appendTo(elementOptions);
			const totalUpgradeBox = elementOptions.find(
				'.dropdown-upgrade-box:not([style*="display: none"])',
			).length;
			const colorUpgradeBox = elementOptions.find(
				'.dropdown-upgrade-box.full:not([style*="display: none"])',
			).length;
			const countItem = totalUpgradeBox - colorUpgradeBox;
			if (countItem > 0) {
				elementOptions.addClass('active');
				elementOptions.addClass('show-col-' + countItem);
				$(this).parents('.accordion-component').removeClass('show-more');
			} else if (colorUpgradeBox > 0) {
				elementOptions.addClass('active');
			}
			element
				.parents('.ssb-configurator-upgrade')
				.find('.dropdown-upgrade-box input:checked')
				.change();
		}
	}

	handleHideGroupComponent(element) {
		element.find('.accordion-group').addClass('hidden');
		element.find('.accordion-group').each(function () {
			const countItem = $(this).find('.upgrade-item:not([style*="display: none"])').length;
			if (countItem > 0) {
				$(this).removeClass('hidden');
			}
		});
	}

	handleAccordionGroupComponent(element, editComponent = false) {
		const currentAccordion = element.parents('.accordion-group');
		if (editComponent) {
			element
				.parents('.ssb-configurator-upgrade')
				.find('.accordion-group')
				.removeClass('active');
			element
				.parents('.ssb-configurator-upgrade')
				.find('.accordion-group')
				.removeClass('active');
			currentAccordion.addClass('active');
			element.parents('.ssb-configurator-upgrade').find('.accordion-content').hide();
			currentAccordion.find('.accordion-content').show();
		} else {
			if (currentAccordion.hasClass('active')) {
				currentAccordion.removeClass('active');
				currentAccordion.find('.accordion-content').slideUp();
			} else {
				element
					.parents('.ssb-configurator-upgrade')
					.find('.accordion-group')
					.removeClass('active');
				currentAccordion.addClass('active');
				element.parents('.ssb-configurator-upgrade').find('.accordion-content').slideUp();
				currentAccordion.find('.accordion-content').slideDown();
			}
		}
		setTimeout(function () {
			const heightBox = Number(element.parents('.ssb-configurator-upgrade').height());
			const scrollTop = Number(element.parents('.ssb-configurator-upgrade').scrollTop());
			const totalHeight = Number(element.parents('.accordion-component').height());

			if (totalHeight > heightBox && totalHeight - scrollTop > heightBox + 100) {
				element.parents('.accordion-component').addClass('show-more');
			} else {
				element.parents('.accordion-component').removeClass('show-more');
			}
		}, 500);
	}

	initSelectedOption(element, uuid, side, key, type, size) {
		element.find(`input[data-uuid="${uuid}"]`).prop('checked', true).trigger('change');
		element
			.find(`input[data-uuid="${uuid}"]`)
			.closest('.upgrade-item')
			.find('.component_size')
			.val(size)
			.change();

		let component = this._seadevShedBuilder.getComponentBySideAndKey(side, key);
		element.find('#none_ramp').trigger('click');
		element.find('#none_flower_box').trigger('click');
		element.find('#none_shutters').trigger('click');
		element.find('#none_transom').trigger('click');

		if ('door' === type) {
			if (component['customLock']) {
				element
					.find(`input[data-uuid="${uuid}"]`)
					.siblings('.upgrade-item-options')
					.find(`.wrap-lock-setting .lock-setting[value="${component['customLock']}"]`)
					.trigger('click');
			}
		}

		if ('door' === type || 'windows' === type) {
			const components = this._seadevShedBuilder._walls[side]['items'];
			const shuttersInObjects =
				'windows' === type ? this._seadevShedBuilder.getShuttersInObjectBySide(side) : {};
			const allComponents = { ...components, ...shuttersInObjects };
			for (const componentKey in allComponents) {
				const comp = allComponents[componentKey];
				if (comp.parent === key) {
					element.find(`#${comp.name}`).trigger('click');
				}
			}
		}

		element.find(`input[data-uuid="${uuid}"]`).prop('checked', true).trigger('change');
		this.handleChildOptionsItemComponents(element.find(`input[data-uuid="${uuid}"]`));
		this.handleAccordionGroupComponent(element.find(`input[data-uuid="${uuid}"]`), true);

		return element;
	}

	openEditComponent() {
		let _this = this;

		_this.closeEditComponent();

		$('ul.added-components').on('click', '.edit-component', async function () {
			// const railingIsShow  = _this._seadevShedBuilder._enabledRailing;
			$('button.remove-component, button.clone-component').show();
			$('.component-control').removeClass('not-clone');
			$('button.change-component').text('Done');
			_this._isAddNewComponent = false;
			let item = $(this).parent('li.added-item');
			let type = item.attr('data-component-type');
			let title = $(this).closest(`.added-components.${type}`).data('title');
			let name = item.attr('data-component-name');
			let key = item.attr('data-component-key');
			let side = item.attr('data-component-side');
			let size = item.attr('data-component-size');
			const uuid = item.attr('data-uuid');
			let isTackDoor = false;
			let classDialog = 'ssb-component-dialog';
			_this._sideSelected = side;
			_this._editingComponent = key;
			_this.showHideStepOutDeck(name);
			if ('shelf' === type || 'workbench' === type) {
				const width = _this._seadevShedBuilder.getWallWidthBySide(side);
				helpers.generateComponentSizeOption(width);
			}
			if (
				_this._seadevShedBuilder._isLayoutBlockAdding ||
				!_this.allowAddComponentWithQty(type, uuid, side)
			) {
				$('button.clone-component').hide();
				$('.component-control').addClass('not-clone');
			}

			$('.child-option').show();
			if ('windows' === type) {
				if (
					_this._seadevShedBuilder.isFrontPorch() ||
					_this._seadevShedBuilder.isDeluxeCornerLeftPorch()
				) {
					if ('porch' === side) {
						$('.child-option-flower_box').hide();
					}
				}
			}

			if (
				$(this).hasClass('tackdoor') ||
				(_this._seadevShedBuilder._tackDoor &&
					key === _this._seadevShedBuilder._tackDoor.key)
			) {
				classDialog += ' edit-tack-room';
				isTackDoor = true;
			}

			_this.hideComponentNotFit(type, side, isTackDoor, name, uuid, true);
			if ('door' === type) {
				_this.hideChildComponentNotFit('ramp', side, true);
			} else if ('windows' === type) {
				_this.hideChildComponentNotFit('flower_box', side, true);
			}

			_this._seadevShedBuilder.rotateCameraBySide(side);

			$('.wrap-popup-position').hide();
			$('.upgrade-item-options').removeClass('active');
			$('ul.added-components').find('.added-item').removeClass('editting');
			item.addClass('editting');
			let element = $('.ssb-configurator-options.ssb-configurator-upgrade.' + type);
			_this.cloneComponent(uuid, side);
			_this._openingDialog = _this.initSelectedOption(element, uuid, side, key, type, size);

			$(_this._openingDialog).dialog({
				autoOpen: false,
				modal: true,
				title: title,
				closeText: '',
				dialogClass: classDialog,
				resizable: false,
				close: function (event, ui) {
					_this.closeEditComponent();
				},
			});

			$('.upgrade-item').removeClass('block-change');
			_this._openingDialog.find('.accordion-group').removeClass('block-change');
			if (_this._seadevShedBuilder.isItemBlockChange(key)) {
				_this._openingDialog.find('.upgrade-item').addClass('block-change');
				_this._openingDialog
					.find(`[data-upgrade-component-name="${name}"]`)
					.parents('.upgrade-item')
					.removeClass('block-change');
				_this._openingDialog.find('.accordion-group').each(function () {
					if (0 === $(this).find('.upgrade-item:not(.block-change)').length) {
						$(this).addClass('block-change');
					}
				});
			}

			$('body').addClass('dialog-opened');
			$(_this._openingDialog).dialog('open');

			if (_this._seadevShedBuilder.isItemBlockDelete(key)) {
				_this._openingDialog.find('.remove-component').hide();
			}

			setTimeout(function () {
				const heightScroll = element
					.find(`input[data-upgrade-component-name="${name}"]`)
					.parents('.upgrade-item')
					.position().top;
				element.stop().animate(
					{
						scrollTop: heightScroll,
					},
					1000,
				);
			}, 500);

			if (0 === $(_this._openingDialog).find('.accordion-component').length) {
				_this.loadComponentsByCategory(type);
			} else {
				_this.loadComponentsBySubCategory(
					$(_this._openingDialog).find('.accordion-component .accordion-group.active'),
				);
			}
		});

		$('.wrap-popup-position input').on('change', function (e) {
			const side = $(this).val();
			const width = _this._seadevShedBuilder.getWallWidthBySide(side);
			helpers.generateComponentSizeOption(width);
		});

		$(document).on('click', '.dropdown-upgrade-box .selected-item', function () {
			const parentElement = $(this).parent();
			const scrollTop = Number($(this).parents('.ssb-configurator-upgrade').scrollTop());
			const maxHeight = Number($(this).parents('.ssb-configurator-upgrade').height());
			const positionTop = parentElement.offset().top;

			parentElement.removeClass('show-top');
			if (positionTop - scrollTop > maxHeight) {
				parentElement.addClass('show-top');
			}

			if (parentElement.hasClass('active')) {
				parentElement.removeClass('active');
			} else {
				$('.dropdown-upgrade-select').removeClass('active');
				parentElement.addClass('active');
			}
		});

		$(document).on('change', '.dropdown-upgrade-box input', function () {
			const parentElement = $(this).parents('.dropdown-upgrade-select');
			const labelText = $(this).parent().text().trim();
			parentElement.find('.selected-item').text(labelText);
			parentElement.removeClass('active');
		});

		$(document).on('change', '.upgrade-item.component-item > input', function (e) {
			_this.handleChildOptionsItemComponents($(this));

			const componentName = $(this).data('upgrade-component-name');
			const componentUUID = $(this).data('uuid') || componentName;
			if (
				_this._seadevShedBuilder.isSkylightWindow(componentName) ||
				_this._seadevShedBuilder.isMoveAlongFloor(componentUUID)
			) {
				$('.wrap-popup-position.is-show-popup').hide();
			} else {
				$('.wrap-popup-position.is-show-popup').show();
			}

			const elementOptions = $(this).siblings('.upgrade-item-options');
			elementOptions
				.find(
					'.dropdown-upgrade-box:not([style*="display: none"]) .dropdown-upgrade-item label:not([style*="display: none"]) input',
				)
				.each((index, element) => {
					const componentName = $(element).data('upgrade-component-name');
					if (
						componentName &&
						!_this._seadevShedBuilder.isShuttersInObject(componentName)
					) {
						const upgradeType = $(element).data('upgrade-component-type');
						const componentType = 'transom' === upgradeType ? 'windows' : upgradeType;
						_this.loadComponent(componentType, componentName);
					}
				});

			_this.handleComponentColorOption(e);
		});

		$(document).on('click', '.ssb-configurator-upgrade .accordion-title', function () {
			_this.handleAccordionGroupComponent($(this));
			_this.loadComponentsBySubCategory($(this).parent());
		});

		$(document).on('click', function (event) {
			var $target = $(event.target);
			if (!$target.closest('.dropdown-upgrade-select').length) {
				$('.dropdown-upgrade-select').removeClass('active');
			}
		});

		$(document).on('click', '.accordion-component .show-more-box', function () {
			const height = $(this).parents('.accordion-component').height();
			$(this).parents('.ssb-configurator-options').stop().animate(
				{
					scrollTop: height,
				},
				1000,
			);
			$(this).parents('.accordion-component').removeClass('show-more');
		});

		jQuery('.ssb-configurator-options').on('scroll', function () {
			const scrollTop = $(this).scrollTop();
			const totalHeight = $(this).find('.accordion-component').height();
			const heightBox = Number($(this).height());
			if (totalHeight > heightBox && totalHeight - scrollTop > heightBox + 100) {
				$(this).find('.accordion-component').addClass('show-more');
			} else {
				$(this).find('.accordion-component').removeClass('show-more');
			}
		});
	}

	/**
	 * Hide component not fit in the popup component
	 *
	 * @param type component type
	 * @param side front|back|left|right
	 * @returns
	 */
	hideComponentNotFit = (
		type,
		side,
		isTackDoor = false,
		currentComponentName = '',
		currentComponentUUID = '',
		isEditComponent = false,
	) => {
		const _this = this;
		let resultFitComponents = _this._seadevShedBuilder.getFitComponentsByTypeAndSide(
			type,
			_this._seadevShedBuilder.getSidingType(),
			side,
		);
		const currentUpgrades = $(`.ssb-configurator-options.ssb-configurator-upgrade.${type}`);
		const elements = currentUpgrades.find('.ssb-option');
		let currentElectricalPackage = $('[name="ssb-configurator-electrical-packages"]:checked');
		let countTotalItem = 0;
		let fitComponents = [];
		if (resultFitComponents.length > 0) {
			fitComponents = resultFitComponents.map((item) => item.uuid);
		}
		currentUpgrades.find('.notice-empty').remove();
		if (ePackageType.indexOf(type) !== -1 && currentElectricalPackage.length) {
			const componentHtml = currentElectricalPackage.attr('data-package-components');
			let componentsData = JSON.parse(componentHtml);
			fitComponents = [];
			componentsData.forEach((item) => {
				fitComponents.push(item.component);
			});
		}

		if (_this._seadevShedBuilder._isEnableTackRoom && 'door' === type && isTackDoor) {
			const listTackDoor =
				_this._seadevShedBuilder._dataSettingsTackroom['available_tackroom_door'];
			const tempFitComponent = [];
			if (listTackDoor.length > 0 && fitComponents.length > 0) {
				for (let i = 0; i < fitComponents.length; i++) {
					const indexItem = listTackDoor.indexOf(fitComponents[i]);
					if (-1 !== indexItem) {
						tempFitComponent.push(fitComponents[i]);
					}
				}
			}
			fitComponents = tempFitComponent;
		}
		elements.each((i, e) => {
			const componentUUID = $(e).data('uuid');
			if (
				-1 !== fitComponents.indexOf(componentUUID) &&
				this.allowAddComponentWithQty(type, componentUUID, side, isEditComponent)
			) {
				$(e).parent().show();
			} else {
				if (
					!this.allowAddComponentWithQty(type, componentUUID, side, isEditComponent) &&
					componentUUID === currentComponentUUID
				) {
					$(e).parent().show();
				} else {
					countTotalItem++;
					$(e).prop('checked', false).parent().hide();
				}
			}
		});

		if (countTotalItem === elements.length) {
			const sideLabel = this.getSideLabel(side);
			currentUpgrades.append(
				`<div class="notice-empty"><span class="fas fa-info-circle"></span> Max quantity is reached for ${type} on ${sideLabel}.</div>`,
			);
		}

		_this.handleHideGroupComponent(currentUpgrades);

		return fitComponents;
	};

	handleSideAndEndList = () => {
		const _this = this;
		$('.sides-ends-area').each((i, select) => {
			const height =
				$(select).hasClass('left-sidewall') &&
				'carport_lean_to_standalone' === _this._seadevShedBuilder._shedType
					? _this._seadevShedBuilder.getBuildingHeight()
					: _this._seadevShedBuilder.getWallHeight();
			const options = $(select).find('option');
			const gableSelected = $(select).find('option:selected').data('gable-end');
			if ('fully_enclosed' !== gableSelected) {
				const measurementTypeSelected = $(select)
					.find('option:selected')
					.data('measurement-types');
				if ('ft' === measurementTypeSelected) {
					const wallSelected = $(select).find('option:selected').data('wall-height');
					if (wallSelected >= height) {
						$(select).val($(select).find('option:first').val()).trigger('change');
					}
				}
			}

			options.each((index, option) => {
				$(option).prop('disabled', false);

				const gableOption = $(option).data('gable-end');
				if ('fully_enclosed' === gableOption) {
					return;
				}

				const measurementTypes = $(option).data('measurement-types');
				if ('ft' !== measurementTypes) {
					return;
				}

				const wallOption = Number($(option).data('wall-height'));
				if (wallOption >= height) {
					$(option).prop('disabled', true);
				}
			});
		});
	};

	/**
	 * Get carport siding data for Shed detail, cart, checkout....
	 *
	 * @returns Object data of siding
	 */
	getCarportSidingData = (isShareLink = false) => {
		let results = {};
		const _this = this;
		const jTrimSelected = $(
			'.ssb-configurator-options.group-j-trim input[name="j_trim"]:checked',
		);
		const jTrimValue = jTrimSelected.val();
		let jTTrimText = jTrimSelected.siblings('label').text();
		const isEnableFront = this.isEnableJTrimOptionGable('front-gable-end');
		const isEnableBack = this.isEnableJTrimOptionGable('back-gable-end');
		const isEnableLeft = this.isEnableJTrimOptionSide('left-sidewall');
		const isEnableRight = this.isEnableJTrimOptionSide('right-sidewall');
		const basePrice = _this.getBasePrice();
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();

		jQuery('.sides-ends-area').each((i, element) => {
			const side = jQuery(element).find('option:selected').attr('data-side');
			const priceRaw = jQuery(element).find('option:selected').attr('data-price');
			const priceType = jQuery(element).find('option:selected').attr('data-price-type');
			const value = Number(jQuery(element).find('option:selected').attr('data-wall-height'));
			const key = jQuery(element).find('option:selected').val();
			let display = jQuery(element).find('option:selected').text();
			const height =
				'left' === side &&
				'carport_lean_to_standalone' === _this._seadevShedBuilder._shedType
					? _this._seadevShedBuilder.getBuildingHeight()
					: _this._seadevShedBuilder.getWallHeight();
			const price = _this.calculatePriceByType(
				priceType,
				priceRaw,
				basePrice,
				baseWidth,
				baseDepth,
				false,
				(value / 100) * Math.ceil(height),
			);
			let details = '';
			let options = [];
			let hasOption = true;

			if (
				'front' === side &&
				isEnableFront &&
				('sides-ends' === jTrimValue || 'ends' === jTrimValue)
			) {
				details = display + ' - J-Trim: ' + jTTrimText;
			} else if (
				'back' === side &&
				isEnableBack &&
				('sides-ends' === jTrimValue || 'ends' === jTrimValue)
			) {
				details = display + ' - J-Trim: ' + jTTrimText;
			} else if (
				'left' === side &&
				isEnableLeft &&
				('sides-ends' === jTrimValue || 'sides' === jTrimValue)
			) {
				details = display + ' - J-Trim: ' + jTTrimText;
			} else if (
				'right' === side &&
				isEnableRight &&
				('sides-ends' === jTrimValue || 'sides' === jTrimValue)
			) {
				details = display + ' - J-Trim: ' + jTTrimText;
			} else {
				details = display;
				hasOption = false;
			}
			display = display.replace(/ {4}|[\t\n\r]/gm, '');
			details = details.replace(/ {4}|[\t\n\r]/gm, '');
			jTTrimText = jTTrimText.replace(/ {4}|[\t\n\r]/gm, '');
			if (hasOption) {
				options.push({ key: 'j_trim', value: jTrimValue, display: jTTrimText });
			}

			if (isShareLink) {
				results[side] = { key };
			} else {
				results[side] = { display, details, price, options };
			}
		});

		if (isShareLink && 0 === Object.keys(results).length) return undefined;

		return results;
	};

	closeEditComponent() {
		let _this = this;
		$('body').removeClass('dialog-opened');
		$(_this._openingDialog).removeClass('add-new-component edit-tack-room');
		$(_this._openingDialog).dialog('close');
		$('button.remove-component, button.clone-component').show();
		$('button.change-component').text('Done');
		if (_this._seadevShedBuilder._isLayoutBlockAdding) {
			$('button.clone-component').hide();
		}
	}

	cloneComponent(currentUuid, componentSide) {
		const _this = this;
		if ('diagonal_right' === componentSide) {
			$('.component-control').addClass('not-clone');
			$('button.clone-component').hide();
		}

		$('input.ssb-option').on('change', function (e) {
			const newComponentName = $(this).data('upgrade-component-name');
			const newComponentUUID = $(this).data('uuid') ?? newComponentName;
			const type = $(this).data('upgrade-type');
			_this.showHideStepOutDeck(newComponentName);
			if (
				currentUuid &&
				newComponentUUID &&
				currentUuid === newComponentUUID &&
				'diagonal_right' !== componentSide
			) {
				$('.component-control').removeClass('not-clone');
				if (
					_this._seadevShedBuilder._isLayoutBlockAdding ||
					!_this.allowAddComponentWithQty(type, newComponentUUID, componentSide)
				) {
					$('.component-control').addClass('not-clone');
					$('button.clone-component').hide();
				} else {
					$('button.clone-component').show();
				}
			} else {
				$('.component-control').addClass('not-clone');
				$('button.clone-component').hide();
			}
		});
	}

	changeComponent() {
		const _this = this;

		$(
			'.ssb-configurator-options button.change-component, .ssb-configurator-options button.clone-component',
		).on('click', function () {
			_this.handleChangeComponent($(this));
			_this.closeEditComponent();
		});
	}

	showHideStepOutDeck(componentName) {
		if (!helpers.isBackYardOfficeUtah() || undefined === componentName) return;

		const isDoubleDoor = -1 !== componentName.indexOf('_double_');

		$('.child-option-ramp .ssb-sub-option #none_ramp').prop('checked', true);

		$('.child-option-ramp .ssb-sub-option:not([for="none_ramp"])').each((i, e) => {
			$(e).hide();
			const key = $(e).attr('for');

			if (
				(isDoubleDoor && -1 !== key.indexOf('_36x84')) ||
				(!isDoubleDoor && -1 !== key.indexOf('_36x48'))
			) {
				$(e).show();
			}
		});
	}

	isValidMaxQtyComponent(componentName) {
		const _this = this;
		const maxQty = _this._seadevShedBuilder.isMaxQty(componentName);
		const components = _this._seadevShedBuilder.getComponentByName(componentName);
		const componentLabel = $(`input[data-upgrade-component-name="${componentName}"]`).attr(
			'data-option-value',
		);

		_this._seadevShedBuilder._isUpdateLayoutEPackage = true;
		if (
			'none' !== this._seadevShedBuilder._electricalPackageID &&
			components.length >= maxQty
		) {
			const msg = `The max number of <strong>${componentLabel}</strong> (Qty. ${maxQty}) has been reached. To move the item, remove some of the currently placed items.`;
			const act = [{ key: 'close', label: 'Got it' }];
			_this.createDialog(msg, act);

			return false;
		}

		return true;
	}

	async handleChangeComponent(element) {
		const _this = this;
		const action = element.attr('data-action');
		const type = element.attr('data-component-type');
		const childType = element.attr('data-child-component-type');
		const selectedComponent = $(
			`.ssb-configurator-options.ssb-configurator-upgrade.${type}`,
		).find('input.radio:checked');
		const newComponentName = $(selectedComponent).attr('data-upgrade-component-name');
		const newComponentUUID = $(selectedComponent).attr('data-uuid') ?? newComponentName;
		const newComponentSize = $(selectedComponent).attr('data-component-size');
		let addOnSelected = '';
		const lockSelected = $(selectedComponent)
			.siblings('.upgrade-item-options')
			.find('.wrap-lock-setting input.lock-setting:checked')
			.val();
		const defaultLock = $(selectedComponent).attr('data-lock-position');

		let colorInfo = {};
		const colorSelected = $(selectedComponent)
			.siblings('.upgrade-item-options')
			.find('.wrap-component-color ul li.active');
		if (colorSelected.length > 0) {
			const textureType = $(colorSelected).data('texture-type');
			const textureImage = $(colorSelected).data('texture-image');
			const textureColor = $(colorSelected).data('texture-color');
			const priceType = $(colorSelected).data('price-type');
			const itemPrice = $(colorSelected).data('price');
			const colorName = $(colorSelected).data('name');
			const colorKey = helpers.generateKey(colorName.toString());
			const endPrice = this.calculatePriceByType(
				priceType,
				itemPrice,
				this.getBasePrice(),
				helpers.getBaseWidth(),
				helpers.getBaseDepth(),
				false,
			);
			colorInfo = {
				key: colorKey,
				name: colorName,
				price: itemPrice,
				priceType,
				endPrice,
				textureType,
				textureImage,
				textureColor,
				description: '',
			};
		}

		let lockData;
		if ('door' === type && ('left' === defaultLock || 'right' === defaultLock)) {
			const customLock = lockSelected ? lockSelected : defaultLock;
			const enableHinge = $(selectedComponent).attr('data-enable-hinge');
			const lockPrice = $(selectedComponent).attr('data-lock-price');
			lockData = { defaultLock, customLock, enableHinge, lockPrice };
		}

		if ('clone' === action) {
			_this._isAddNewComponent = true;
		}

		if (_this._isAddNewComponent) {
			if (undefined === newComponentName) {
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.selectComponent,
				);
			}

			if (
				_this._seadevShedBuilder._defaultEPackageComponents &&
				-1 !== ePackageType.indexOf(type) &&
				!_this.isValidMaxQtyComponent(newComponentName)
			) {
				return;
			}

			if (
				'structure_alpinechalet' === _this._seadevShedBuilder._shedType &&
				'left' === _this._currentSide
			) {
				let dormerPosition = $(`input[name='dormer-position']:checked`).val();
				if ('dormer' === dormerPosition) {
					_this._currentSide = 'dormer';
				}
			}

			if (
				_this._seadevShedBuilder.isFrontPorch() ||
				(('structure_lakeside_bunkie_gambrel_roof' === _this._seadevShedBuilder._shedType ||
					'structure_lakeside_bunkie_gable_roof' ===
						_this._seadevShedBuilder._shedType) &&
					'front' === _this._currentSide)
			) {
				const porchPosition = $(
					`[data-popup-position="${type}"]input[name='dormer-position']:checked`,
				).val();
				if ('porch' === porchPosition) {
					_this._currentSide = 'porch';
					$('.child-option-flower_box').hide();
				}
			}

			if (_this._seadevShedBuilder.isMiddlePorch() && 'left' === _this._currentSide) {
				_this._currentSide = element
					.closest('.ssb-configurator-options')
					.find('.wrap-popup-position input:checked')
					.val();
			}

			if (
				_this._seadevShedBuilder.isCornerPorchLeft() &&
				('left' === _this._currentSide || 'front' === _this._currentSide)
			) {
				_this._currentSide = element
					.closest('.ssb-configurator-options')
					.find('.wrap-popup-position input:checked')
					.val();
			}

			if (
				_this._seadevShedBuilder.isDeluxeCornerLeftPorch() &&
				('right' === _this._currentSide || 'front' === _this._currentSide)
			) {
				_this._currentSide = element
					.closest('.ssb-configurator-options')
					.find('.wrap-popup-position input:checked')
					.val();
			}

			if (
				('structure_ranch_cabin' === _this._seadevShedBuilder._shedType ||
					_this._seadevShedBuilder.isAframeSingleGable()) &&
				('left' === _this._currentSide || 'back' === _this._currentSide)
			) {
				_this._currentSide = element
					.closest('.ssb-configurator-options')
					.find('.wrap-popup-position input:checked')
					.val();
			}

			if (
				_this._seadevShedBuilder.is2StoryLeanTo() &&
				'right' === _this._currentSide &&
				_this._seadevShedBuilder.isEnableLeanTo()
			) {
				_this._currentSide = element
					.closest('.ssb-configurator-options')
					.find('.wrap-popup-position input:checked')
					.val();
			}

			if (_this._seadevShedBuilder.isDoubleGable() && 'left' === _this._currentSide) {
				_this._currentSide = element
					.closest('.ssb-configurator-options')
					.find('.wrap-popup-position input:checked')
					.val();
			}

			if ('clone' === action) {
				let cloneItem = $(`ul.added-components.${type}`).find('.added-item.editting');
				let componentSide = cloneItem.attr('data-component-side');
				_this._currentSide = componentSide;

				if (this._seadevShedBuilder.is2StoryLeanTo()) {
					if (
						'top_front' === _this._currentSide ||
						'lean_to_front' === _this._currentSide
					) {
						_this._currentSide = 'front';
					} else if (
						'top_back' === _this._currentSide ||
						'lean_to_back' === _this._currentSide
					) {
						_this._currentSide = 'back';
					}
				}
			}

			if (_this._seadevShedBuilder.isSkylightWindow(newComponentName)) {
				if ('right' === _this._currentSide || 'roof_right' === _this._currentSide) {
					_this._currentSide = 'roof_right';
				} else {
					_this._currentSide = 'roof_left';
				}
			}

			if (_this._seadevShedBuilder.isMoveAlongFloor(newComponentUUID)) {
				_this._currentSide = 'floor';
			}

			if (
				'structure_aframe_genesis' === _this._seadevShedBuilder._shedType &&
				('left' === _this._currentSide || 'right' === _this._currentSide)
			) {
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.cannotDetectSiding,
				);
			}
			if (this.allowAddComponentWithQty(type, newComponentUUID, _this._currentSide)) {
				const isChangeComponent =
					'vent' !== type || this._seadevShedBuilder.isSkylightWindow(newComponentName);
				const params = {
					side: _this._currentSide,
					componentType: type,
					componentName: newComponentName,
					childType,
					position: null,
					isChangeComponent,
					componentSize: newComponentSize,
					lockData,
					colorInfo,
					uuid: newComponentUUID,
				};
				_this.addComponentV2(params);
				if (-1 !== layoutTypes.indexOf(type)) {
					_this._seadevShedBuilder._isUpdateLayout =
						!_this._seadevShedBuilder._isShareLink;
				}
			} else {
				const componentDisplayName = selectedComponent.val();
				const sideDisplayName = _this.getSideLabel(_this._currentSide);
				_this._seadevShedBuilder.createAlert(
					`Max quantity is reached for ${componentDisplayName} on ${sideDisplayName}.`,
				);
			}
		} else {
			let editingItem = $(`ul.added-components.${type}`).find('.added-item.editting');
			let componentName = editingItem.attr('data-component-name');
			let componentUUID = editingItem.attr('data-uuid');
			const oldBehavior = _this._seadevShedBuilder.getComponentBehavior(componentUUID);
			const newBehavior = _this._seadevShedBuilder.getComponentBehavior(newComponentUUID);
			if (oldBehavior !== newBehavior) {
				const label = helpers.getComponentLabel(newComponentName);
				return _this._seadevShedBuilder.createAlert(
					`Components can only be swapped within the same group. Select "Add New" to add the ${label} to your build.`,
				);
			}

			let componentSide = editingItem.attr('data-component-side');
			let componentType = editingItem.attr('data-component-type');
			let componentKey = editingItem.attr('data-component-key');
			let componentSize = editingItem.attr('data-component-size');
			let currentPosition =
				_this._seadevShedBuilder._walls[componentSide]['items'][componentKey]['position'];
			let currentRotation =
				_this._seadevShedBuilder._walls[componentSide]['items'][componentKey]['rotation'];
			let blockOptions =
				_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
					'blockOptions'
				];
			let currentComponent =
				_this._seadevShedBuilder._walls[componentSide]['items'][componentKey];
			let currentVertical = currentComponent.hasOwnProperty('vertical')
				? currentComponent['vertical']
				: null;
			let currentHorizontal = currentComponent.hasOwnProperty('horizontal')
				? currentComponent['horizontal']
				: null;
			const behavior = _this._seadevShedBuilder.getBehavior(newComponentName, componentType);
			if (_this._seadevShedBuilder.isHandleOffsetFloor(behavior)) {
				currentPosition.y = _this._seadevShedBuilder.getPositionYForInterior(
					behavior,
					newComponentName,
					componentUUID,
				);
			}

			const itemComponentChange = $(`input[data-upgrade-type="${type}"]:checked`).attr(
				'data-upgrade-component-name',
			);
			if (
				_this._seadevShedBuilder._defaultEPackageComponents &&
				-1 !== ePackageType.indexOf(componentType) &&
				!_this.isValidMaxQtyComponent(itemComponentChange)
			) {
				return;
			}

			if (
				componentUUID !== newComponentUUID &&
				!this.allowAddComponentWithQty(type, newComponentUUID, componentSide, true)
			) {
				const componentDisplayName = selectedComponent.val();
				const sideDisplayName = _this.getSideLabel(componentSide);
				_this._seadevShedBuilder.createAlert(
					`Max quantity is reached for ${componentDisplayName} on ${sideDisplayName}.`,
				);
				return;
			}

			if (
				componentUUID !== newComponentUUID ||
				(('shelf' === type || 'workbench' === type) && componentSize !== newComponentSize)
			) {
				const isReplace = 'door' === type;
				const isTackDoor =
					this._seadevShedBuilder._tackDoor &&
					componentKey === this._seadevShedBuilder._tackDoor.key;
				_this.removeComponentV2(componentSide, componentType, componentKey, isReplace);
				const params = {
					side: componentSide,
					componentType,
					componentName: newComponentName,
					childType,
					position: currentPosition,
					rotation: currentRotation,
					isChangeComponent: true,
					componentSize: newComponentSize,
					lockData,
					isTackDoor,
					colorInfo,
					blockOptions,
					horizontal: currentHorizontal,
					vertical: currentVertical,
					uuid: newComponentUUID,
				};
				_this.addComponentV2(params);

				if (-1 !== layoutTypes.indexOf(type)) {
					_this._seadevShedBuilder._isUpdateLayout =
						!_this._seadevShedBuilder._isShareLink;
				}
			} else if ('windows' === type) {
				_this._seadevShedBuilder.addLoadingAndStopRenderClasses('handleChangeComponent_windows');

				const typeAddOns = JSON.parse(childType);
				const parentInfo = _this._seadevShedBuilder.getComponentBySideAndKey(
					componentSide,
					componentKey,
				);
				const addOns = _this._seadevShedBuilder.getComponentChildByParentKey(
					componentKey,
					componentSide,
				);
				for (const typeAddOn of typeAddOns) {
					const addOnInfo = _this.getChildByType(addOns, typeAddOn);
					const oldAddOn = false === addOnInfo ? 'none' : addOnInfo.name;
					const element = $(`input[name='child_${typeAddOn}']:checked`);
					if ('none' === element.closest('.child-option').css('display')) {
						addOnSelected = 'none';
					} else {
						addOnSelected = element.val() as string;
					}

					//TODO @Update UUID - Component Name
					let args = {
						side: componentSide,
						componentType: typeAddOn,
						componentName: addOnSelected,
						parentKey: componentKey,
						uuid: element.data('uuid'),
					};
					
					if (oldAddOn !== addOnSelected) {
						if ('none' === addOnSelected) {
							if (addOnInfo) {
								if (this._seadevShedBuilder.isShuttersInObject(addOnInfo['name'])) {
									_this.deleteShuttersInObject(
										addOnInfo['key'],
										parentInfo['meshes'],
									);
								} else {
									await _this.removeComponentV2(
										addOnInfo['side'],
										addOnInfo['type'],
										addOnInfo['key'],
									);
								}

								_this.updatePrice();
								_this.shedDetailRenderExterior();
								$(`ul.added-components.${componentType}`)
									.find(`li[data-component-key="${componentKey}"]`)
									.remove();
								_this.addComponentDOM(
									componentUUID,
									componentSide,
									componentType,
									componentName,
									componentKey,
									false,
									newComponentSize,
								);
							}
						} else {
							if (addOnInfo) {
								if (this._seadevShedBuilder.isShuttersInObject(addOnInfo['name'])) {
									_this.deleteShuttersInObject(
										addOnInfo['key'],
										parentInfo['meshes'],
									);
									_this.updatePrice();
									_this.shedDetailRenderExterior();
								} else {
									_this.removeComponentV2(
										addOnInfo['side'],
										addOnInfo['type'],
										addOnInfo['key'],
									);
								}
							}

							if (this._seadevShedBuilder.isShuttersInObject(addOnSelected)) {
								this._seadevShedBuilder.updateShuttersInObject(
									addOnSelected,
									parentInfo['meshes'],
									componentSide,
									parentInfo['key'],
								);
							} else {
								await _this._seadevShedBuilder.addNewComponent(args);
							}
						}
					}
				}

				_this._seadevShedBuilder.removeLoadingAndStopRenderClasses('handleChangeComponent_windows');
			} else if ('door' === type) {
				_this._seadevShedBuilder.addLoadingAndStopRenderClasses('handleChangeComponent_door');

				const addOns = _this._seadevShedBuilder.getComponentChildByParentKey(
					componentKey,
					componentSide,
				);
				const typeAddOns = JSON.parse(childType);
				for (const typeAddOn of typeAddOns) {
					addOnSelected = $(`input[name='child_${typeAddOn}']:checked`).val() as string;
					const addOnInfo = _this.getChildByType(addOns, typeAddOn);
					const oldAddOn = false === addOnInfo ? 'none' : addOnInfo.name;
					if (oldAddOn !== addOnSelected) {
						if ('none' === addOnSelected) {
							if (addOnInfo) {
								await _this.removeComponentV2(
									addOnInfo['side'],
									addOnInfo['type'],
									addOnInfo['key'],
								);
								_this.updatePrice();
								_this.shedDetailRenderExterior();
								$(`ul.added-components.${componentType}`)
									.find(`li[data-component-key="${componentKey}"]`)
									.remove();
								_this.addComponentDOM(
									newComponentUUID,
									componentSide,
									componentType,
									componentName,
									componentKey,
									false,
									newComponentSize,
								);
							}
						} else {
							if (addOnInfo) {
								await _this.removeComponentV2(
									addOnInfo['side'],
									addOnInfo['type'],
									addOnInfo['key'],
								);
							}
							//TODO @Update UUID - Component Name
							const args = {
								side: componentSide,
								componentType: 'ramp',
								componentName: addOnSelected,
								parentKey: componentKey,
								uuid: addOnSelected,
							};
							await _this._seadevShedBuilder.addNewComponent(args);
						}
					}
				}

				const oldCustomLock =
					_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
						'customLock'
					];
				if (lockSelected && oldCustomLock !== lockSelected) {
					const meshes =
						_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
							'meshes'
						];
					const lockData = {
						defaultLock:
							_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
								'defaultLock'
							],
						customLock: lockSelected,
						enableHinge:
							_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
								'enableHinge'
							],
						lockPrice:
							_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
								'lockPrice'
							],
					};
					_this._seadevShedBuilder.handleHingeAndLock(lockData, meshes);
					_this._seadevShedBuilder._walls[componentSide]['items'][componentKey][
						'customLock'
					] = lockSelected;
					_this.updatePrice();
					_this.shedDetailRenderExterior();
					_this.addComponentDOM(
						newComponentUUID,
						componentSide,
						componentType,
						componentName,
						componentKey,
						false,
						newComponentSize,
					);
				}

				_this._seadevShedBuilder.removeLoadingAndStopRenderClasses('handleChangeComponent_door');
			}
		}
	}

	allowAddComponentWithQty = (componentType, componentUUID, sideAdd, isChange = false) => {
		if (!isChange && !this.isAllowAddVent(componentType)) return false;
		if (-1 === interiors.indexOf(componentType)) {
			let layoutComponents: any = this._seadevShedBuilder.getLayoutComponents();
			layoutComponents = layoutComponents[componentType];
			if (layoutComponents) {
				const componentInLayout = layoutComponents.filter(
					(item) => item.component === componentUUID && item.side === sideAdd,
				);
				let maxQty;
				if (componentInLayout.length) {
					maxQty = componentInLayout[0].max_qty;
				}

				const allComponents = this._seadevShedBuilder.getAllComponents();
				let currentQtyComponent = 0;

				for (let k in allComponents) {
					const { side, uuid } = allComponents[k];
					if (uuid === componentUUID && side === sideAdd) {
						currentQtyComponent++;
					}
				}

				if (maxQty && maxQty <= currentQtyComponent) {
					return false;
				}
			}
		}

		return true;
	};

	isAllowAddVent = (componentType) => {
		if ('vent' !== componentType) return true;
		const maxVentItem = this._seadevShedBuilder.getSettingData('max_vent_item');
		if (!maxVentItem || '' == maxVentItem) return true;
		const allComponents = this._seadevShedBuilder.getAllComponents();
		let currentQtyComponent = 0;
		for (let k in allComponents) {
			const { type } = allComponents[k];
			if ('vent' === type) {
				currentQtyComponent++;
			}
		}
		if (currentQtyComponent >= Number(maxVentItem)) {
			return false;
		}

		return true;
	};

	async removeComponentV2(side, type, key, isReplace = false) {
		let _this = this;
		const isDelete = await _this._seadevShedBuilder.deleteComponent(side, key, isReplace);
		if (isDelete) {
			$('ul.added-components.' + type)
				.find("li[data-component-key='" + key + "']")
				.remove();
			_this.shedDetailRenderExterior();
			_this.shedDetailRenderInterior();
			if (type === 'windows') {
				_this.checkShowTypeColor('shutters');
			}
			_this.checkShowTypeColor(type);
			_this._seadevShedBuilder.handleBonesScreenHouse();
			_this.updatePrice();
		}
	}

	updateIncludeComponents = () => {
        let includeItemsComponent = [ ...this._includeItemsComponent ];
        let includeComponent = [];
        let deductionComponent = [];
        let electricalPackageInclude = []
        let addOnComponent = []
        const arrAddOnsType = [ 'shutters', 'ramp', 'flower_box', 'window_transoms' ];
        let currentLayoutID = this._seadevShedBuilder.getActiveLayout();
		const currentWidth = helpers.getBaseWidth();
		const currentHeight = helpers.getBaseHeight();
		const currentDepth = helpers.getBaseDepth();
		const currentMaterial = this._seadevShedBuilder.getSidingType();
        for( let i = 0; i < includeItemsComponent.length; i++ ) {
            const { component_id, component_type, material_slug, quantity, layout_id, depth, width, height } = includeItemsComponent[i];
			if( material_slug == currentMaterial && layout_id == currentLayoutID && Number(height) === Number(currentHeight) && Number(depth) === Number(currentDepth) && Number(width) === Number(currentWidth) ) {
				if( "electrical_packages" !== component_type ) {
                    if( Number( quantity ) > 0 ) {
                        for( let j = 0; j < Number( quantity ); j++ ) {
                            if( arrAddOnsType.includes( component_type ) ) {
                                addOnComponent.push( component_id );
                            } else {
								const deduction = jQuery( `[data-upgrade-component-type="${component_type}"][data-uuid="${component_id}"]`).data('price-deduction') || 0;
                                includeComponent.push( component_id );
                                deductionComponent.push( { key: component_id, deduction: Number( deduction ), type: component_type } );
                            }
                            
                        }
                    }
                } else {
					const deduction = jQuery( `.ssb-configurator-options.electrical_packages [data-package-id="${component_id}"]`).data('deduction') || 0;
                	electricalPackageInclude.push( { key: component_id, deduction: Number( deduction ) } );
                }
			}
        }
		
        this._electricalPackageInclude = electricalPackageInclude;
        this._includeComponents = includeComponent;
        this._deductionComponents = deductionComponent;
        this._includeAddOns = addOnComponent;
    }

    getIndexElectricalPackageInclude = ( packageID ) => {
        if( 0 === this._electricalPackageInclude.length ) return -1;
        
        for( let i = 0; i < this._electricalPackageInclude.length; i++ ) {
            if( packageID == this._electricalPackageInclude[i]['key'] ) return i;
        }

        return -1;
    }

	getComponentPositionAnchorLayout = (componentType) => {
		// TODO : hardcode for component type vent => in the feture has been work all type component
		if ('vent' !== componentType)
			return {
				block_options: [],
				is_block: false,
				horizontal: null,
				vertical: null,
				side: null,
				is_place_anchor_postion: false,
			};
		const _this = this;
		let layoutComponents: any = this._seadevShedBuilder.getLayoutComponents();
		layoutComponents = layoutComponents[componentType];
		if (undefined === layoutComponents || 0 === layoutComponents.length)
			return {
				block_options: [],
				is_block: false,
				horizontal: null,
				vertical: null,
				side: null,
			};
		const horizontalOffset = this._seadevShedBuilder.getHorizontalOffset();
		const enableDistributed = parseInt(
			_this._seadevShedBuilder._canvas.getAttribute('data-horizontal-distributed'),
		);
		let allComponents: any = Object.entries(_this._seadevShedBuilder.getAllComponents()).map(
			(item) => item[1],
		);
		allComponents = allComponents.filter(
			(item) =>
				'vent' === item.type &&
				(item.isBlock || (item.blockOptions && -1 !== item.blockOptions.indexOf('move'))),
		);
		for (const component of layoutComponents) {
			let {
				side,
				type,
				horizontal_distance,
				horizontal_measured_from,
				roof_top_aligned,
				vertical_distance,
				vertical_measured_from,
				is_block,
				block_options,
			} = component;
			if (
				'vent' !== type ||
				!_this._seadevShedBuilder.isValidComponentByLayoutCondition(component) ||
				(!is_block && -1 === block_options.indexOf('move'))
			)
				continue;
			if (('windows' === type || 'door' === type) && 1 === enableDistributed) {
				horizontal_distance = component.order;
				horizontal_measured_from = 'left';
			} else {
				horizontal_distance += horizontalOffset;
			}
			let horizontal = {
				distance: horizontal_distance,
				measured_from: horizontal_measured_from,
				roof_top_aligned: roof_top_aligned,
			};
			let vertical = { distance: vertical_distance, measured_from: vertical_measured_from };
			const findIndex = allComponents.findIndex(
				(item) =>
					item.side === side &&
					item.isBlock == is_block &&
					block_options == item.blockOptions &&
					JSON.stringify(horizontal) === JSON.stringify(item.horizontal) &&
					JSON.stringify(vertical) === JSON.stringify(item.vertical),
			);
			if (-1 === findIndex) {
				return {
					block_options,
					is_block,
					horizontal,
					vertical,
					side,
					is_place_anchor_postion: true,
				};
			}
		}
		return {
			block_options: [],
			is_block: false,
			horizontal: null,
			vertical: null,
			side: null,
			is_place_anchor_postion: false,
		};
	};

	addComponentV2 = async (params) => {
		let {
			side,
			componentType,
			componentName,
			childType,
			position,
			rotation,
			isChangeComponent,
			componentSize,
			lockData,
			isTackDoor,
			colorInfo,
			blockOptions,
			horizontal,
			vertical,
			uuid,
		} = params;

		if ('' === componentType) {
			return;
		}
		let isBlock = false;
		let isPlaceAnchorPosition = false;
		if (!isChangeComponent) {
			const dataAnchor = this.getComponentPositionAnchorLayout(componentType);
			blockOptions = dataAnchor.block_options;
			isBlock = dataAnchor.is_block;
			horizontal = dataAnchor.horizontal ? dataAnchor.horizontal : horizontal;
			vertical = dataAnchor.vertical ? dataAnchor.vertical : vertical;
			side = null !== dataAnchor.side ? dataAnchor.side : side;
			isPlaceAnchorPosition = dataAnchor.is_place_anchor_postion
				? dataAnchor.is_place_anchor_postion
				: side;
			this._seadevShedBuilder.rotateCameraBySide(side);
		}
		this._seadevShedBuilder.addLoadingAndStopRenderClasses('addComponentV2');

		const addOns = '' === childType || null === childType ? [] : JSON.parse(childType);
		let childName = 'none';

		let transomMeshes = false;
		const transomKey =
			helpers.hasKeyInArray(addOns, 'transom') &&
			'windows' === componentType &&
			'none' !==
				$(`input[name='child_transom']:checked`).closest('.child-option').css('display')
				? ($(`input[name='child_transom']:checked`).val() as string)
				: 'none';
		if ('none' !== transomKey) {
			const meshes = await this._seadevShedBuilder.loadBabylonFile(transomKey, 'windows');
			if (meshes) {
				transomMeshes = meshes[0];
			}
		}

		const result = await this._seadevShedBuilder.addNewComponent({
			side,
			componentType,
			componentName,
			position,
			rotation,
			isChangeComponent,
			componentSize,
			lockData,
			isTackDoor,
			colorInfo,
			blockOptions,
			isBlock,
			horizontal,
			vertical,
			isPlaceAnchorPosition,
			uuid,
			transomMeshes,
		});
		if (false === result) {
			if (isTackDoor && isChangeComponent) {
				const oldTackDoor = this._seadevShedBuilder._tackDoor.name;
				this._seadevShedBuilder.createAlert(
					"Tackroom door don't fit the tackroom. Please consider choosing a smaller item.",
				);
				//TODO @Update UUID - Component Name
				this.addComponentV2({
					side,
					componentType,
					componentName: oldTackDoor,
					childType,
					position,
					isTackDoor,
					colorInfo,
					blockOptions,
					uuid: oldTackDoor,
				});
			}
			return this._seadevShedBuilder.removeLoadingAndStopRenderClasses('addComponentV2');
		}

		if (isTackDoor) {
			this._seadevShedBuilder._tackDoor = result;
		}

		this._seadevShedBuilder.updateWindowsPosition();

		for (const addOn of addOns) {
			const element = $(`input[name='child_${addOn}']:checked`);
			if ('none' === element.closest('.child-option').css('display')) {
				continue;
			}

			childName = element.val() as string;
			if (childName && 'none' !== childName) {
				if (this._seadevShedBuilder.isShuttersInObject(childName)) {
					this._seadevShedBuilder.updateShuttersInObject(
						childName,
						result['meshes'],
						side,
						result['key'],
					);
				} else {
					await this._seadevShedBuilder.addNewComponent({
						side,
						componentType: addOn,
						componentName: childName,
						parentKey: result['key'],
						position,
						componentSize,
						blockOptions,
						uuid: childName,
					});
				}
			}
		}

		this._seadevShedBuilder.removeLoadingAndStopRenderClasses('addComponentV2');
	};

	removeComponent() {
		let _this = this;
		$('.ssb-configurator-options button.remove-component').click(function () {
			let type = $(this).attr('data-component-type');
			if (
				'door' === type &&
				_this._seadevShedBuilder.isWindowPositionFixedEnable() &&
				_this._seadevShedBuilder.isFollowMainDoor() &&
				_this._seadevShedBuilder._doorFixedTarget.length === 1
			) {
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.doorRqdForWDWPos,
				);
			}

			let edittingItem = $('ul.added-components.' + type).find('.added-item.editting');
			let componentSide = edittingItem.attr('data-component-side');
			let componentType = edittingItem.attr('data-component-type');
			let componentKey = edittingItem.attr('data-component-key');

			if (
				'none' !== _this._seadevShedBuilder._electricalPackageID &&
				_this._seadevShedBuilder._defaultEPackageComponents &&
				-1 !== ePackageType.indexOf(type)
			) {
				const packageName = $(
					'[name="ssb-configurator-electrical-packages"]:checked',
				).val();
				if (!_this._seadevShedBuilder.validateRemoveComponentInPackageInfo(componentKey)) {
					const msg = `If you remove this item, you must place it on a different wall before you complete the building to keep the <strong>${packageName}</strong>. <br><br>Are you sure?`;
					const act = [
						{ key: 'close', label: 'Close' },
						{ key: 'remove', label: 'Remove' },
					];
					const data = { componentSide, componentType, componentKey };

					_this.closeEditComponent();
					_this.createDialog(msg, act, data);

					return;
				}

				const componentPackage = _this._seadevShedBuilder.getComponentPackageInfo();
				if (-1 !== ePackageType.indexOf(type)) {
					_this._seadevShedBuilder._isUpdateLayoutEPackage = true;
				}

				if (componentPackage.replacePackage) {
					const msg = `Do you want to remove  <strong>${packageName}</strong>?`;
					const act = [
						{ key: 'close', label: 'Close' },
						{ key: 'replace', label: 'Replace' },
					];
					const packageID = 'none';
					const components = [];
					const data = { packageID, components };
					_this.closeEditComponent();
					_this.createDialog(msg, act, data);
					return;
				}
			}

			_this.removeComponentV2(componentSide, componentType, componentKey);
			_this.closeEditComponent();

			if (-1 !== layoutTypes.indexOf(type)) {
				_this._seadevShedBuilder._isUpdateLayout = !_this._seadevShedBuilder._isShareLink;
			}
		});
	}

	cancelEditComponent() {
		let _this = this;
		$('button.cancel-edit-component').click(function () {
			let type = $(this).attr('data-component-type');
			_this.closeEditComponent();
		});
	}

	private removeUnavailableLayoutComponents(layoutComponents) {
		$('.ssb-configurator-group').each(function (index, group) {
			$(group)
				.find('.ssb-option')
				.each(function (index, option) {
					let componentType = $(option).attr('data-upgrade-component-type');
					if (componentType != '' && componentType != undefined) {
						if (
							layoutComponents[componentType] &&
							layoutComponents[componentType].length > 0
						) {
							$(option).parent('div').show();
						} else {
							$(option).parent('div').hide();
						}
					}
				});
		});
	}

	/**
	 * Filters and returns valid size configurations based on provided dimensional limits
	 * and optional zoning restrictions.
	 * 
	 * @param limitWidth - Minimum allowed width for valid sizes
	 * @param limitDepth - Minimum allowed depth for valid sizes
	 * @param limitHeight - Minimum allowed height for valid sizes
	 * @param height - Optional target height to compare against size data
	 * @returns A filtered array of valid size objects
	*/
	getValidSizes = ({
		limitDepth,
		limitHeight,
		limitWidth,
		height,
		sizes,
		idRestrictionSize,
		shouldFilterByZone
	}: {
		limitWidth: number;
		limitDepth: number;
		limitHeight: number;
		height?: number;
		sizes: any;
		idRestrictionSize: any,
		shouldFilterByZone: boolean
	}) => {
		const targetHeight = height !== undefined && height < limitHeight ? limitHeight : height;

		// Filter and flatten all size groups that meet the constraints
		const filtered = sizes.flatMap(({ width, depth, data }) =>
			data
				.filter(
					(d) =>
						d.height >= limitHeight &&
						d.height == targetHeight &&
						(!limitWidth || Number(width) >= limitWidth) &&
						(!limitDepth || Number(depth) >= limitDepth),
				)
				.map((d) => ({
					width,
					depth,
					...d,
				})),
		);

		// If restriction is active, filter by matching condition zone
		return shouldFilterByZone
			? filtered.filter((d) => d.conditionZone.includes(idRestrictionSize))
			: filtered;
	};

	disableLimitSizesByZone() {
		const _this = this;
		const currentWidth = helpers.getBaseWidth();
		const currentDepth = helpers.getBaseDepth();
		
		if (isNaN(currentWidth) || isNaN(currentDepth)) return;
		if (
			!_this._seadevShedBuilder._isUseRestrictSize ||
			!_this._seadevShedBuilder._isValidZipcode ||
			!_this._idRestrictionSize
		)
			return;
		$('.ssb-configurator-size-selects .select-items .disable-by-zone').removeClass(
			'custom-select-disabled disable-by-zone',
		);
		$(
			'.ssb-configurator-size-selects option.disable-by-zone:not(.disable-by-height , .disable-by-layout)',
		).removeAttr('disabled');
		$('.ssb-configurator-size-selects option.disable-by-zone').removeClass('disable-by-zone');

		$('#ssb-configurator-size-height')
			.find('option')
			.each((index, option) => {
				const height = Number($(option).attr('data-size-height'));
				let allowZone: any = $(option).attr('data-zone-condition');
				allowZone = allowZone.split(',');
				if (
					$(option).hasClass('disable-by-height') ||
					$(option).hasClass('disable-by-layout')
				) {
					$(`div[custom-select-value="${height}"]`).addClass('custom-select-disabled');
				}

				if (!allowZone.includes(_this._idRestrictionSize)) {
					$(option).attr('disabled', 'disabled');
					$(option).addClass('disable-by-zone');
					$(`div[custom-select-value="${height}"]`).addClass(
						'custom-select-disabled disable-by-zone',
					);
				}
			});

		const currentHeight = helpers.getBaseHeight();
		$(`#ssb-configurator-size-area`)
			.find(`option`)
			.each((index, option) => {
				let dataSizes = $(option).attr('data-sizes');
				const width = Number($(option).attr('data-size-width'));
				const depth = Number($(option).attr('data-size-depth'));
				if (
					$(option).hasClass('disable-by-height') ||
					$(option).hasClass('disable-by-layout')
				) {
					$(`div[custom-select-value="${width}x${depth}"]`).addClass(
						'custom-select-disabled',
					);
				}
				if (dataSizes) {
					dataSizes = JSON.parse(atob(dataSizes));
					if (!this.hasSizeZone(_this._idRestrictionSize, dataSizes, currentHeight)) {
						$(option).addClass('disable-by-zone').prop('disabled', true);
						$(`div[custom-select-value="${width}x${depth}"]`).addClass(
							'custom-select-disabled disable-by-zone',
						);
					}
				}
			});

		if (0 === $('#ssb-height option:not([disabled])').length) {
			_this._seadevShedBuilder._allowAddToCart = false;
			let areaHtml = _this.getCookie(_this._cookiedValidate);
			if (_this._isUseLocation) {
				areaHtml = _this._elementValidate.find(`[value=${areaHtml}]`).html();
			}
			const msg = `<b>No size found for area ${areaHtml}.</b>`;
			const act = [{ key: 'close', label: 'Close' }];
			_this.createDialog(msg, act);
		} else {
			_this._seadevShedBuilder._allowAddToCart = true;
			if ($('#ssb-configurator-size-height option:selected').hasClass('disable-by-zone')) {
				const heightSelect = $(
					'#ssb-configurator-size-height option:not([disabled]):first',
				).val();
				$('#ssb-configurator-size-height option:not([disabled]):first').prop(
					'selected',
					true,
				);
				_this._isCreateAlertChangeSize = false;
				$(`[custom-select-value="${heightSelect}"]`).trigger('click');

				this._isCreateAlertChangeSize = true;
			}

			if (null == $('#ssb-configurator-size-area').val()) {
				$('#ssb-configurator-size-area option:not([disabled]):first').prop(
					'selected',
					true,
				);
				const sizeWidth = Number(
					$('#ssb-configurator-size-area option:not([disabled]):first').attr(
						'data-size-width',
					),
				);
				const sizeDepth = Number(
					$('#ssb-configurator-size-area option:not([disabled]):first').attr(
						'data-size-depth',
					),
				);
				$(`div[custom-select-value="${sizeWidth}x${sizeDepth}"]`).trigger('click');
			}
		}
		_this.handleDisableButtonAddToCart();
	}

	private disableLimitSizes(limitWidth, limitDepth, limitHeight, oldSize?) {
		const _this = this;
		$('#ssb-configurator-size-area').find('option').removeAttr('disabled');
		$('#ssb-configurator-size-area')
			.find('option')
			.each((index, option) => {
				const width = Number($(option).attr('data-size-width'));
				const depth = Number($(option).attr('data-size-depth'));

				if (width < limitWidth || depth < limitDepth) {
					$(option).addClass('disable-by-layout').attr('disabled', 'disabled');
					$(`div[custom-select-value="${width}x${depth}"]`).addClass(
						'custom-select-disabled',
					);
				} else if ($(option).hasClass('disable-by-layout')) {
					$(option).removeClass('disable-by-layout').removeAttr('disabled');
					$(`div[custom-select-value="${width}x${depth}"]`).removeClass(
						'custom-select-disabled',
					);
				}

				if (
					'structure_lofted_horserunin' === _this._seadevShedBuilder._shedType ||
					'structure_aframe_horserunin' === _this._seadevShedBuilder._shedType
				) {
					if (depth < 10) {
						$(option)
							.addClass('disable-by-structure-lofted-horserunin')
							.attr('disabled', 'disabled');
						$(`div[custom-select-value="${width}x${depth}"]`).addClass(
							'custom-select-disabled',
						);
					} else if ($(option).hasClass('disable-by-structure-lofted-horserunin')) {
						$(option)
							.removeClass('disable-by-structure-lofted-horserunin')
							.removeAttr('disabled');
						$(`div[custom-select-value="${width}x${depth}"]`).removeClass(
							'custom-select-disabled',
						);
					}
				}
			});

		$('#ssb-configurator-size-height')
			.find('option')
			.each((index, option) => {
				const height = Number($(option).attr('data-size-height'));

				if (height < limitHeight) {
					$(option).addClass('disable-by-layout').attr('disabled', 'disabled');
					$(`div[custom-select-value="${height}"]`).addClass('custom-select-disabled');
				} else if ($(option).hasClass('disable-by-layout')) {
					$(option).removeClass('disable-by-layout').removeAttr('disabled');
					$(`div[custom-select-value="${height}"]`).removeClass('custom-select-disabled');
				}

				if (
					'structure_lofted_horserunin' === _this._seadevShedBuilder._shedType ||
					'structure_aframe_horserunin' === _this._seadevShedBuilder._shedType
				) {
					if (
						height <=
						_this._seadevShedBuilder._openingHeight +
							_this._seadevShedBuilder._trimLength
					) {
						$(option)
							.addClass('disable-by-structure-lofted-horserunin')
							.attr('disabled', 'disabled');
						$(`div[custom-select-value="${height}"]`).addClass(
							'custom-select-disabled',
						);
					} else if ($(option).hasClass('disable-by-structure-lofted-horserunin')) {
						$(option)
							.removeClass('disable-by-structure-lofted-horserunin')
							.removeAttr('disabled');
						$(`div[custom-select-value="${height}"]`).removeClass(
							'custom-select-disabled',
						);
					}
				}
			});

		_this.disableLimitSizesByZone();

		if ($('#ssb-configurator-size-area option[is-default="true"]:not([disabled])').length > 0) {
			$('#ssb-configurator-size-area option[is-default="true"]:not([disabled])').prop(
				'selected',
				true,
			);
		} else {
			$('#ssb-configurator-size-area option:not([disabled]):first').prop('selected', true);
		}
		
		if( $('#ssb-configurator-size-height option:selected:not([disabled])').length == 0 ) {
			$('#ssb-configurator-size-height option:not([disabled]):first').prop('selected', true);
		}
		

		let { width, depth, height } = { ..._this.getSizes(), ...oldSize };
		height = height < limitHeight ? limitHeight : height;

		_this._isCreateAlertChangeSize = false;
		$(`div[custom-select-value="${height}"]`).trigger('click');
		_this._isCreateAlertChangeSize = true;

		const sizeArea = $('#ssb-configurator-size-area option:selected:first');
		const dataSizes = JSON.parse(atob(sizeArea.data('sizes')));

		if (dataSizes.length > 0 && !_this.hasSizeHeight(height, dataSizes)) {
			height = dataSizes[0].height;
			$(`div[custom-select-value="${height}"]`).trigger('click');
		}

		$(`div[custom-select-value="${width}x${depth}"]`).trigger('click');
	}

	updateComponentBySidingType = async (sidingType) => {
		const components = { ...this._seadevShedBuilder.getAllComponents() };
		for (const k in components) {
			const type = components[k].type;
			if ('door' !== type && 'windows' !== type && 'vent' !== type) {
				continue;
			}

			const editComponent = $(`[data-component-key="${k}"]`);
			if (editComponent.length <= 0) {
				continue;
			}

			const componentName = editComponent.attr('data-component-name');
			const componentUUID = editComponent.attr('data-uuid');
			const side = editComponent.attr('data-component-side');
			if (this._seadevShedBuilder.ignoreHandleTackDoor(side)) {
				continue;
			}

			const resultCheck = this._seadevShedBuilder.checkAndReplaceComponent(
				sidingType,
				type,
				componentName,
				side,
				componentUUID,
			);
			const newComponentName = resultCheck.componentName;
			const newComponentUUID = resultCheck.uuid;
			if (componentUUID === newComponentUUID) {
				if ('windows' === type) {
					await this.updateShuttersBySidingType(
						sidingType,
						k,
						newComponentUUID,
						side,
						components[k]['meshes'],
					);
				}

				continue;
			}

			this._seadevShedBuilder._isUpdateLayout = true;

			const componentKey = editComponent.attr('data-component-key');
			const currentPosition =
				this._seadevShedBuilder._walls[side]['items'][componentKey]['position'];
			const vertical =
				this._seadevShedBuilder._walls[side]['items'][componentKey]['vertical'];
			const horizontal =
				this._seadevShedBuilder._walls[side]['items'][componentKey]['horizontal'];

			this.removeComponentV2(side, type, componentKey);

			if (null !== newComponentUUID) {
				const lockData = helpers.getDefaultLock(type, newComponentName);
				const colorInfo = helpers.getDefaultComponentColor(newComponentUUID);
				const blockOptions = components[k].blockOptions;
				const isBlock = components[k].isBlock;

				const args = {
					side,
					componentType: type,
					componentName: newComponentName,
					position: currentPosition,
					isChangeComponent: true,
					lockData,
					colorInfo,
					blockOptions,
					isBlock,
					vertical,
					horizontal,
					uuid: newComponentUUID,
				};
				const result = await this._seadevShedBuilder.addNewComponent(args);

				this.addFirstAddon(type, newComponentUUID, side, result);
			}
		}
	};

	private updatePrice = () => {
		const _this = this;
		let basePrice = _this.getBasePrice();
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const components = _this._seadevShedBuilder.getAllComponents();
		const shuttersInObjects = _this._seadevShedBuilder.getShuttersInObject();
		let allComponents = { ...components, ...shuttersInObjects };
		const sortKeys = Object.keys(allComponents).sort((a, b) => {
			const sizeA =
				undefined !== allComponents[a].componentSize && 0 != allComponents[a].componentSize
					? Number(allComponents[a].componentSize)
					: 1;
			const sizeB =
				undefined !== allComponents[b].componentSize && 0 != allComponents[b].componentSize
					? Number(allComponents[b].componentSize)
					: 1;

			return sizeA - sizeB;
		});
		const includePrice = _this._seadevShedBuilder.includePrice();
		const componentPackage = _this._seadevShedBuilder.getComponentPackageInfo();
		let includeAddOn = [ ..._this._includeAddOns ];
        let includeComponents = [ ..._this._includeComponents ];
		let dataPrices = [];
		const selectedLayout = jQuery(
			`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
		);

		const deductionComponents = [...this._deductionComponents];
		const packageLayout = selectedLayout.data('layout-packages');
		let packageDefaultID = '';
		let includeElectricalItem = [...componentPackage.includeElectricalItem];
		const dataSideEnd = _this.getCarportSidingData();
		const wainscoting = _this.getWainscotingData();
		const eSidingUpgrades = _this.getExteriorSidingUpgradesData();
		const copyIncludeAddOn = includeAddOn.map((key) => {
			const type = $(`[data-upgrade-component-name="${key}"]`).data('upgrade-component-type');
			return { key, type };
		});
		const indexElectricalPackageInclude = _this.getIndexElectricalPackageInclude( _this._seadevShedBuilder._electricalPackageID );
		// Custom line items
		var customData: any = [];
		var customLineTotal = 0;
		if ($('.custom-item-wrap').length) {
			$('.custom-item-wrap').each(function () {
				var encodeData: any = [];
				var tax = $(this).find('.item-col-tax input[type="checkbox"]');
				$(this)
					.find('.default-input')
					.each(function (index) {
						let itemData = $(this).val();
						encodeData.push(itemData);
					});
				encodeData.push(tax.is(':checked') ? `yes` : `no`);
				customData.push(encodeData);
				$(this)
					.find('input[type="hidden"]')
					.attr('name', window.btoa(JSON.stringify(encodeData)));
			});
			if (customData.length > 0) {
				customData.forEach((element) => {
					customLineTotal +=
						'percentage_default' === element[1]
							? _this.calculatePriceByType(
									element[1],
									element[3],
									basePrice,
									'',
									'',
									'',
									0,
								)
							: Number(element[3]) * Number(element[2]);
				});
			}
		}
		_this.shedDetailRenderCustomLineItem(customData);
		// Custom line items

		if (packageLayout.length > 0) {
			packageDefaultID = packageLayout[0].id;
		}

		for (let i = 0; i < sortKeys.length; i++) {
			const component = allComponents[sortKeys[i]];
			if (allComponents[sortKeys[i]].isHidden) {
				continue;
			}
			

			const componentInfo =
				_this._seadevShedBuilder._walls[component['side']]['items'][component['key']];
			let compPrice: any = jQuery(`[data-upgrade-component-name="${component.name}"][data-uuid="${component.uuid}"]`).data(
				'price',
			);
			let compPriceType = jQuery(`[data-upgrade-component-name="${component.name}"][data-uuid="${component.uuid}"]`).data(
				'price-type',
			);
			let compPriceDiscount = jQuery(`[data-upgrade-component-name="${component.name}"][data-uuid="${component.uuid}"]`).data(
				'price-discount',
			);

			if (component.colors && component.colors.length > 0) {
				component.colors.forEach((color) => {
					if (color.display && color.color_price && color.color_price !== 0) {
						dataPrices.push({
							name:
								component.type === 'misc_interior'
									? component.key + '-' + color.type + '-color'
									: component.key + '-color',
							key: 'color',
							type: color.color_price_type,
							price: color.color_price,
						});
					}

					if (color.upcharge && !helpers.isEmptyObject(color.upcharge)) {
						dataPrices.push({
							name: component.key + '-color-upcharge',
							key: 'color',
							price: color.upcharge.price,
							type: color.upcharge.priceType,
						});
					}
				});
			}

			if ('shelf' === component.type || 'workbench' === component.type) {
				compPriceDiscount = compPriceDiscount * component.componentSize;
			}

			if ('door' === component.type) {
				if (
					componentInfo['customLock'] &&
					componentInfo['defaultLock'] &&
					componentInfo['customLock'] !== componentInfo['defaultLock']
				) {
					dataPrices.push({
						name: componentInfo['name'] + '-lock',
						key: 'lock',
						type: 'fixed',
						price: componentInfo['lockPrice'],
					});
				}

				if (
					('structure_lofted_horserunin' === this._seadevShedBuilder._shedType ||
						'structure_aframe_horserunin' === this._seadevShedBuilder._shedType ||
						'structure_horse_shelter' === this._seadevShedBuilder._shedType) &&
					'left' === componentInfo['side'] &&
					this._seadevShedBuilder.getTackDoor() === component.name
				) {
					compPrice = _this.getPriceTackDoor(component.name);
					compPriceDiscount = compPrice;
					compPriceType = 'fixed';
				}
			}

			if( this._electricalPackageInclude.length > 0 || -1 !== indexElectricalPackageInclude ) {
				if (-1 !== ePackageType.indexOf(component.type)) {
					const indexItemPackage = includeElectricalItem.indexOf(component.name);
					if (-1 !== indexItemPackage && includeElectricalItem.length > 0) {
						includeElectricalItem.splice(indexItemPackage, 1);
						continue;
					}
				}
			} else if (
				componentPackage.hasPackage &&
				-1 !== componentPackage.componentInPackage.indexOf(sortKeys[i])
			) {
				continue;
			}

			if (
				'ramp' === component.type ||
				'flower_box' === component.type ||
				'shutters' === component.type || 
				'transom' === component.type
			) {
				const index = includeAddOn.indexOf(component.name);
				if (-1 !== index) {
					includeAddOn.splice(index, 1);
					continue;
				}
			}
			const index = includeComponents.indexOf(component['uuid']);
			if (-1 !== index) {
				if (
					!_this._seadevShedBuilder._isEnableTackRoom ||
					!_this._seadevShedBuilder._dataSettingsTackroom['include_tackroom_door']
				) {
					includeComponents.splice(index, 1);
				} else if (!componentInfo['isTackDoor']) {
					includeComponents.splice(index, 1);
				}
				continue;
			}

			if (
				_this._seadevShedBuilder._isEnableTackRoom &&
				componentInfo['isTackDoor'] &&
				_this._seadevShedBuilder._dataSettingsTackroom['include_tackroom_door']
			) {
				continue;
			}

			if ('linear_foot' === compPriceType) {
				const componentSize = $(`[data-component-key="${sortKeys[i]}"]`).attr(
					'data-component-size',
				);
				const priceElement = this.calculatePriceByType(
					compPriceType,
					compPrice,
					false,
					componentSize,
					false,
					false,
				);
				compPriceType = 'fixed';
				compPrice = priceElement;
			}

			if (
				(undefined !== compPrice &&
					'' !== compPrice &&
					undefined !== compPriceType &&
					'' !== compPriceType) ||
				(undefined !== compPriceDiscount &&
					'' !== compPriceDiscount &&
					0 !== compPriceDiscount)
			) {
				dataPrices.push({
					name: component.type,
					key: component.name,
					type: compPriceType,
					price: compPrice,
					discount: compPriceDiscount,
				});
			}
		}

		const customUpcharge = this.getCustomUpcharge();
		if (customUpcharge.length) {
			for (let i = 0; i < customUpcharge.length; i++) {
				dataPrices.push({
					name: customUpcharge[i].name,
					type: customUpcharge[i].priceType,
					price: customUpcharge[i].price,
				});
			}
		}

		let haveChargeDifferentPrice = false;
		let colorComponent = ['windows', 'vent', 'door', 'shutter', 'countertops', 'appliance'];

		$('#js-shed-data input[type="hidden"]').each((i, v) => {
			const key = $(v).attr('data-key');
			const dataType = $(v).attr('data-type');
			const dataName = $(v).attr('data-name');
			if (
				undefined !== key &&
				undefined !== dataName &&
				'color' === dataType &&
				-1 === colorComponent.indexOf(dataName)
			) {
				let price = $(`.group-${dataName}-color .active[data-key="${key}"]`).attr(
					'data-price',
				);
				let type = $(`.group-${dataName}-color .active[data-key="${key}"]`).attr(
					'data-price-type',
				);
				if ('roof' === dataName) {
					const roofType = $(`#js-shed-data [name="ssb-option-roof-type"]`).attr(
						'data-key',
					);
					price = $(
						`.group-${dataName}-color .active[data-key="${key}"][data-roof-type="${roofType}"]`,
					).attr('data-price');
					type = $(
						`.group-${dataName}-color .active[data-key="${key}"][data-roof-type="${roofType}"]`,
					).attr('data-price-type');
				}

				if ((dataName == 'siding' || dataName == 'roof') && helpers.isSmithBuilt()) {
					const sidingColor: any = $(
						`#js-shed-data [name="ssb-option-siding-color"]`,
					).val();
					const roofColor: any = $(`#js-shed-data [name="ssb-option-roof-color"]`).val();
					if (roofColor !== null && roofColor !== undefined && roofColor !== '') {
						const originalPrice = $(`.group-${dataName}-color .active[data-key="${key}"]`).attr(
							'data-original-price',
						);
						const originalType = $(`.group-${dataName}-color .active[data-key="${key}"]`).attr(
							'data-original-price-type',
						);
						price = originalPrice;
						type = originalType;
						if (sidingColor === roofColor) {
							if (sidingColor.startsWith('WG') && dataName == 'roof') {
								price = '';
							}
						} else {
							if (
								sidingColor.startsWith('WG') &&
								!roofColor.startsWith('WG') &&
								dataName == 'roof' &&
								!haveChargeDifferentPrice
							) {
								price = '5';
								type = 'percentage';
								haveChargeDifferentPrice = true;
							} else if (
								roofColor.startsWith('WG') &&
								!sidingColor.startsWith('WG') &&
								dataName == 'siding' &&
								!haveChargeDifferentPrice
							) {
								price = '5';
								type = 'percentage';
								haveChargeDifferentPrice = true;
							} else if (
								!roofColor.startsWith('WG') &&
								!sidingColor.startsWith('WG') &&
								dataName == 'siding'
							) {
								price = '5';
								type = 'percentage';
							}
						}
						$(`.group-${dataName}-color .active[data-key="${key}"]`).attr('data-price', price);
						$(`.group-${dataName}-color .active[data-key="${key}"]`).attr('data-price-type', type);
					}
				}

				if (
					'windows' === dataName &&
					$('#js-shed-data [name="ssb-option-has-windows"').val() == 'false'
				) {
					price = '';
				}

				if ('rails' === dataName && !_this.isCalculatePostRailsColor()) {
					price = '';
				}

				if (
					'ceiling' === dataName &&
					'none' ===
						$('#interior_ceiling-material-option li.active').data('material-type')
				) {
					price = '';
				}

				if (
					'wall' === dataName &&
					'none' === $('#interior_wall-material-option li.active').data('material-type')
				) {
					price = '';
				}

				if ('' !== price && undefined !== price && '' !== type && undefined !== type) {
					dataPrices.push({
						name: dataName + '-color',
						key,
						price,
						type,
					});
				}
			}
		});

		$(
			'#ssb-configurator-accordion-upgrades-new .ssb-configurator-options input:checked, #ssb-configurator-accordion-interior .ssb-configurator-options input.ssb_loft:checked, #ssb-configurator-accordion-interior .ssb-configurator-options input.ssb_frame:checked,  #ssb-configurator-accordion-interior .ssb-configurator-options input.ssb-tackroom:checked, .group-upgrade-roof_overhang input:checked, .group-upgrade-roof_pitch input:checked',
		).each((i, v) => {
			if (!$(v).hasClass('foundation-fee-option') || !this.isEnableManufacturer()) {
				const upKey = $(v).attr('data-key');
				let upPrice: any = $(v).attr('data-price');
				let upType = $(v).attr('data-price-type');
				const name = $(v).attr('name');
				const quantity = $(v).closest('div').find('.upgrade-quantity').val() || 1;
				const minPrice = $(v).attr('data-min-price');
				const maxPrice = $(v).attr('data-max-price');
				const excludeDealer: any = $(v).attr('data-exclude')
					? $(v).attr('data-exclude').split(',')
					: [];
				const excludePrice =
					excludeDealer.length && _this._lotID && excludeDealer.includes(_this._lotID);
				if ($(v).hasClass('ssb_roof_pitch')) {
					const priceCondition = $(v).attr('data-price-condition');
					const { price, priceType } = this.getRoofPitchUnitDataPrice(priceCondition);
					upPrice = price;
					upType = priceType;
				}
				if (upType === 'n_a') {
					upPrice = '(n/a)';
				} else if (upType === 'call_for_pricing') {
					upPrice = '(call_for_pricing)';
				}

				if (
					'' !== upPrice &&
					undefined !== upPrice &&
					'' !== upType &&
					undefined !== upType &&
					!excludePrice
				) {
					const excludeBuildingCost = '1' === $(v).attr('data-exclude-building-cost');
					dataPrices.push({
						name: name,
						key: upKey,
						price: upPrice,
						type: upType,
						quantity,
						excludeBuildingCost,
						minPrice,
						maxPrice,
					});
				}
			}
		});

		if (wainscoting && 1 !== this._seadevShedBuilder._wainscotingType) {
			const wainscotData = JSON.parse(window.atob(wainscoting));
			const { display } = wainscotData;

			display.forEach((data) => {
				dataPrices.push({
					key: data.key,
					name: 'wainscot-price-' + data.key,
					type: 'percentage_of_cost' === data.priceType ? data.priceType : 'fixed',
					price:
						'percentage_of_cost' === data.priceType
							? data.priceItem
							: Number(data.price),
					excludeBuildingCost: 'percentage_of_cost' === data.priceType,
				});
			});
		}

		if (eSidingUpgrades) {
			const eSidingUpgradesData = JSON.parse(window.atob(eSidingUpgrades));
			const { display } = eSidingUpgradesData;

			display.forEach((data) => {
				dataPrices.push({
					key: data.key,
					name: 'exterior-siding-upgrades-price-' + data.key,
					type: 'percentage_of_cost' === data.priceType ? data.priceType : 'fixed',
					price:
						'percentage_of_cost' === data.priceType
							? data.priceItem
							: Number(data.price),
					excludeBuildingCost: 'percentage_of_cost' === data.priceType,
				});
			});
		}

		const railingPriceTotal = _this.calculateRailingPrice();
		const railingPriceType = this._seadevShedBuilder.getSettingData('railing_price_type');
		const railingPrice = this.getRailingPrice();
		if (railingPriceTotal) {
			dataPrices.push({
				key: 'railing',
				name: 'railing',
				type: 'percentage_of_cost' === railingPriceType ? railingPriceType : 'fixed',
				price: 'percentage_of_cost' === railingPriceType ? railingPrice : railingPriceTotal,
			});
		}

		const floorMaterial = $('#floor-material-option li.active');
		if (floorMaterial.length > 0) {
			dataPrices.push({
				name: 'flooring',
				key: 'flooring',
				price: floorMaterial.data('price'),
				type: floorMaterial.data('price-type'),
			});
		}

		const arrListMaterialInterior = [
			'interior_wall',
			'interior_ceiling',
			'insulation_wall',
			'insulation_roof',
		];
		arrListMaterialInterior.forEach((item) => {
			const elementMaterial = $(`#${item}-material-option li.active`);
			if (elementMaterial.length > 0) {
				dataPrices.push({
					name: item,
					key: item,
					price: elementMaterial.data('price'),
					type: elementMaterial.data('price-type'),
				});
			}
		});

		if (
			componentPackage.hasPackage &&
			_this._seadevShedBuilder._electricalPackageID !== 'none'
		) {
			let priceElectricalPackage = Number(
				$('[name="ssb-configurator-electrical-packages"]:checked').attr('data-price'),
			);
			if( this._electricalPackageInclude.length > 0 ) {
                if( -1 !== indexElectricalPackageInclude ) {
					priceElectricalPackage = 0;
				} else {
					const priceDiscountElectricalPackage = $(
						'[name="ssb-configurator-electrical-packages"]:checked',
					).attr('data-discount');
					priceElectricalPackage =
						'' == priceDiscountElectricalPackage
							? Number(priceElectricalPackage)
							: Number(priceDiscountElectricalPackage);
				}
			}

			dataPrices.push({
				name: 'electrical_package',
				key: 'electrical_package',
				price: priceElectricalPackage,
				type: $('[name="ssb-configurator-electrical-packages"]:checked').attr(
					'data-price-type',
				),
			});
		}

		if (Object.keys(dataSideEnd).length) {
			Object.keys(dataSideEnd).forEach((key) => {
				const data = dataSideEnd[key];

				dataPrices.push({
					name: 'siding-price-' + data.key,
					key: data.key,
					price: data.price,
					type: 'fixed',
				});
			});
		}

		// basePrice = _this.calculatorPriceByType( basePriceType, basePrice, basePrice, baseWidth, baseDepth, false );

		let componentLayoutRemove = [];
		let deductionAmount = 0;
		_this._includeComponentRemove = [];
		if (includeComponents.length > 0) {
			deductionComponents.forEach((value, index) => {
				const indexInclude = includeComponents.indexOf(value['key']);
				if (indexInclude !== -1) {
					deductionAmount += Number(deductionComponents[index]['deduction']);
					componentLayoutRemove.push(value);
					_this._includeComponentRemove.push(value);
					includeComponents.splice(indexInclude, 1);
				}
			});
		}

		_this._creditItemElectrical = [];
		if( this._electricalPackageInclude.length > 0 ) {
			if (includeElectricalItem.length > 0) {
				includeElectricalItem.forEach((item) => {
					const priceItemDeduction = Number(
						$(`[data-upgrade-component-name="${item}"]`).data('price-deduction'),
					);
					deductionAmount += priceItemDeduction;
					if (priceItemDeduction > 0) {
						const creditComponentName = $(
							`[data-upgrade-component-name='${item}']`,
						).attr('data-option-value');
						const originalNameCreditComponent = $(
							`[data-upgrade-component-name='${item}']`,
						).attr('data-option-original-value');
						let elementCredit: any = {
							name: creditComponentName,
							text: creditComponentName,
							price: -priceItemDeduction,
						};

						if (_this.isEnableManufacturer()) {
							elementCredit.original_name = originalNameCreditComponent;
							elementCredit.original_text = originalNameCreditComponent;
						}

						_this._creditItemElectrical.push(elementCredit);
					}
				});
			}

			if( -1 === indexElectricalPackageInclude ) {
				for( let i = 0; i < this._electricalPackageInclude.length; i++ ) {
					const deductionPackage = Number( this._electricalPackageInclude[i].deduction );
					const packageDeductionID = this._electricalPackageInclude[i].key;
					deductionAmount       += deductionPackage;
					if( deductionPackage > 0 ) {
						const packageItemCreditName       = $( `[name="ssb-configurator-electrical-packages"][data-package-id='${packageDeductionID}']` ).val();
						const packageItemCreditOriginName = $( `[name="ssb-configurator-electrical-packages"][data-package-id='${packageDeductionID}']` ).attr( 'data-option-original-value' );
						let elementCreditPackage : any = {
							name         : packageItemCreditName,
							text         : packageItemCreditName,
							price        : -deductionPackage,
						}
						if( this.isEnableManufacturer() ) {
							elementCreditPackage.original_name = packageItemCreditOriginName;
							elementCreditPackage.original_text = packageItemCreditOriginName;
						}
						_this._creditItemElectrical.push( elementCreditPackage );
					}
				}
			}
		}

		let addOnLayoutRemove = [];
		_this._includeAddOnsRemove = [];
		if (includeAddOn.length > 0) {
			copyIncludeAddOn.forEach((value, index) => {
				const indexInclude = includeAddOn.indexOf(value['key']);
				if (indexInclude !== -1) {
					addOnLayoutRemove.push(value);
					_this._includeAddOnsRemove.push(value);
					includeAddOn.splice(indexInclude, 1);
				}
			});
		}

		let totalPrice = 0;

		if (
			(helpers.notIncludeSidingMaterialPrice() || !_this._isMaterialUpdateBasePrice) &&
			!_this.isManualPrice()
		) {
			// Quick fix base price for urbansheds
			const sidingMaterialPrice = $(
				'#ssb-configurator-accordion-materials .group-siding-type .ssb-option.active',
			).data('price');
			const sidingMaterialPriceType = $(
				'#ssb-configurator-accordion-materials .group-siding-type .ssb-option.active',
			).data('price-type');
			if (sidingMaterialPriceType && sidingMaterialPrice) {
				let materiaPrice = Number(
					_this.calculatePriceByType(
						sidingMaterialPriceType,
						sidingMaterialPrice,
						basePrice,
						baseWidth,
						baseDepth,
						false,
					),
				);
				materiaPrice = isNaN(materiaPrice) ? 0 : materiaPrice;

				dataPrices.push({
					name: 'siding',
					price: materiaPrice,
					finalPrice: materiaPrice,
				});
			}
		}
		_this._listVentsReplace = [];
		let listVentsHasReplace = [];

		dataPrices = dataPrices.sort((a, b) => {
			const priceA = Number(a.price);
			const priceB = Number(b.price);
			const discountA = undefined !== a.discount ? Number(a.discount) : 0;
			const discountB = undefined !== b.discount ? Number(b.discount) : 0;

			return priceA - priceB || discountA - discountB;
		});

		dataPrices = dataPrices.map((item) => {
			if (componentLayoutRemove.length > 0) {
				const i = helpers.findIndexObject(componentLayoutRemove, 'type', item.name);
				if (-1 !== i) {
					item.price = item.discount;
					componentLayoutRemove.splice(i, 1);
					if ('vent' === item.name) {
						listVentsHasReplace.push(item.key);
					}
				}
			}

			return item;
		});

		let layoutWindows = this._deductionComponents ? this._deductionComponents.filter( w => w.type === 'windows'  ) : [];
		dataPrices.forEach((p, index) => {
			const { type, excludeBuildingCost } = p;
			if ('percentage_of_cost' !== type && !excludeBuildingCost) {
				const data = this.getTotalDataPrices({
					p,
					componentLayoutRemove,
					layoutWindows,
					includePrice,
					listVentsHasReplace,
					addOnLayoutRemove,
					basePrice,
					baseWidth,
					baseDepth,
					dataPrices,
					index,
					total,
				});
				totalPrice += data.tpmPrice;
				dataPrices = data.dataPrices;
				layoutWindows = data.layoutWindows;
				addOnLayoutRemove = data.addOnLayoutRemove;
				listVentsHasReplace = data.listVentsHasReplace;
				componentLayoutRemove = data.componentLayoutRemove;
			}
		});

		let total =
			totalPrice +
			basePrice +
			this.getLayoutCharge() +
			this.getRoofMaterialPrice() -
			deductionAmount;

		dataPrices.push({
			name: 'sizePrice',
			price: basePrice,
			finalPrice: basePrice,
		});

		_this._totalBuildingOptionsPrice = total;

		dataPrices.forEach((p, index) => {
			const { type, excludeBuildingCost } = p;

			if ('percentage_of_cost' === type || excludeBuildingCost) {
				const data = this.getTotalDataPrices({
					p,
					componentLayoutRemove,
					layoutWindows,
					includePrice,
					listVentsHasReplace,
					addOnLayoutRemove,
					basePrice,
					baseWidth,
					baseDepth,
					dataPrices,
					index,
					total,
				});
				total += data.tpmPrice;
				dataPrices = data.dataPrices;
				layoutWindows = data.layoutWindows;
				addOnLayoutRemove = data.addOnLayoutRemove;
				listVentsHasReplace = data.listVentsHasReplace;
				componentLayoutRemove = data.componentLayoutRemove;
			}
		});

		if (wainscoting && 1 !== this._seadevShedBuilder._wainscotingType) {
			const wainsCotdata = helpers.objectFilter(
				dataPrices,
				(d) => d.key !== 'Wainscot Color',
			);
			if (wainsCotdata) {
				const wainsCotColor = wainsCotdata[Object.keys(wainsCotdata)[0]];
				if (wainsCotColor && 'percentage_of_cost' === wainsCotColor.type) {
					const price = this.calculatePriceByType(
						wainsCotColor.type,
						wainsCotColor.price,
						false,
						false,
						false,
						false,
					);
					$('#js-shed-data input[name="ssb-option-wainscoting-color-price"]').val(price);
				}
			}
		}

		_this._prices = dataPrices;

		if (_this.isEnableManufacturer()) {
			const truckload = (_this._truckloadFee * baseDepth) / 56;
			let MSRP = total + truckload + _this._logisticsFee;
			if (_this.isMultiModel()) {
				MSRP = MSRP + Math.ceil(baseDepth / 12) * baseWidth * _this._multiModuleBuildsFee;
			} else if (14 === baseWidth) {
				MSRP = MSRP + _this._wideFreightFee;
			}

			let foundationFees = 0;
			$(
				'#ssb-configurator-accordion-upgrades-new .ssb-configurator-options input.foundation-fee-option:checked',
			).each((i, v) => {
				const upPrice = $(v).attr('data-price');
				foundationFees += Number(upPrice);
			});

			const markupFee =
				((this.isExcludeFreightCharge() ? total : MSRP) * _this._markupFee) / 100;
			const discount = (MSRP * _this._discount) / 100;
			var netPrice = MSRP - discount;
			var retailPrice = MSRP + markupFee + _this._fixedAmountFee + foundationFees;
			let dealerFees = [
				{
					key: 'Markup',
					name: 'Markup',
					price: Number(markupFee + _this._fixedAmountFee).toFixed(2),
				},
			];
			retailPrice = retailPrice + customLineTotal;

			$('input[name="ssb-shed-full-price"]').val(retailPrice);
			$('input[name="ssb-model-total-price"]').val(total);
			$('input[name="ssb-model-msrp-price"]').val(MSRP);
			$('input[name="ssb-model-net-price"]').val(netPrice);
			$('input[name="ssb-option-dealer-fees"').val(window.btoa(JSON.stringify(dealerFees)));
			$('.woocommerce .summary .price .amount bdi').contents().last()[0].textContent =
				retailPrice.toLocaleString(undefined, {
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				});
			if (_this.isShowNetPrice()) {
				if (
					undefined !==
					$('.woocommerce .summary .net-price .amount bdi').contents().last()[0]
				) {
					$('.woocommerce .summary .net-price .amount bdi')
						.contents()
						.last()[0].textContent = netPrice.toLocaleString(undefined, {
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					});
				}
				if (
					undefined !==
					$('.woocommerce .summary .MSRP-price .amount bdi').contents().last()[0]
				) {
					$('.woocommerce .summary .MSRP-price .amount bdi')
						.contents()
						.last()[0].textContent = MSRP.toLocaleString(undefined, {
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					});
				}
			}
		} else {
			total = total + customLineTotal;
			$('input[name="ssb-shed-full-price"]').val(total);
			$('.woocommerce .summary .price .amount bdi').contents().last()[0].textContent =
				total.toLocaleString(undefined, {
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				});
		}

		_this.shedDetailUpdatePriceMaterialColor();
		_this.shedDetailRenderSidingAndTrim();
		_this.shedDetailRenderRoof();
		_this.shedDetailStructureRenderColor();
		_this.shedDetailRenderPorchData();
		_this.shedDetailRenderInterior();
		_this.shedDetailRenderExterior();
		_this.updateMonthlyPaymentRTO();
	};

	getManufacturerFees = () => {
		if (!this.isEnableManufacturer()) return '';
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		let results = [];
		const truckloadFee = (this._truckloadFee * baseDepth) / 56;
		const logisticsFee = this._logisticsFee;
		let multimodelFree = 0;
		let wideFreightFee = 0;

		if (this.isMultiModel()) {
			multimodelFree = Math.ceil(baseDepth / 12) * baseWidth * this._multiModuleBuildsFee;
		} else if (14 === baseWidth) {
			wideFreightFee = this._wideFreightFee;
		}
		results = [
			{ key: 'Truckload', name: 'Truckload', price: Number(truckloadFee).toFixed(2) },
			{ key: 'Logistic', name: 'Logistic', price: Number(logisticsFee).toFixed(2) },
			{ key: 'Multi-model', name: 'Multi-model', price: Number(multimodelFree).toFixed(2) },
			{ key: 'Large build', name: 'Large build', price: Number(wideFreightFee).toFixed(2) },
		];

		const jsonData = JSON.stringify(results);

		return window.btoa(jsonData);
	};

	/**
	 * Calculates and updates the total price for a given product or component based on various factors, and updates related data structures.
	 *
	 * @param {Object} args - Input parameters.
	 *
	 * @returns {Object} - Updated structures and total price.
	 */
	getTotalDataPrices = (args) => {
		let {
			p,
			componentLayoutRemove,
			layoutWindows,
			includePrice,
			listVentsHasReplace,
			addOnLayoutRemove,
			basePrice,
			baseWidth,
			baseDepth,
			dataPrices,
			index,
		} = args;
		const related = undefined !== p.related ? p.related : false;
		let priceItem = Number(p.price);
		const minPrice = p.minPrice || undefined;
		const maxPrice = p.maxPrice || undefined;

		if (p.name === 'vent' && componentLayoutRemove.length > 0) {
			if( layoutWindows.length || ( includePrice && this._isAllowChangeIncludeWindowVent ) ) {
				const indexVent = listVentsHasReplace.indexOf(p.key);
				if (-1 !== indexVent) {
					listVentsHasReplace.splice(indexVent, 1);
				} else {
					const indexItemRemove = helpers.findIndexObject(
						componentLayoutRemove,
						'type',
						'windows',
					);
					if (indexItemRemove !== -1) {
						priceItem = Number(p.discount);
						componentLayoutRemove.splice(indexItemRemove, 1);
						this._listVentsReplace.push(p.key);
						layoutWindows.splice(0, 1);
					}
				}
			}
		}

		if (addOnLayoutRemove.length > 0) {
			const i = helpers.findIndexObject(addOnLayoutRemove, 'type', p.name);
			if (i !== -1) {
				priceItem = Number(p.discount);
				addOnLayoutRemove.splice(i, 1);
			}
		}

		let tpmPrice = Number(
			this.calculatePriceByType(
				p.type,
				priceItem,
				basePrice,
				baseWidth,
				baseDepth,
				related,
				0,
				minPrice,
				maxPrice,
			),
		);

		tpmPrice = isNaN(tpmPrice) ? 0 : tpmPrice;

		if (p.quantity) {
			tpmPrice *= p.quantity;
		}

		dataPrices[index].finalPrice = tpmPrice;

		if (p.type === 'n_a') {
			dataPrices[index].finalPrice = '(n/a)';
		} else if (p.type === 'call_for_pricing') {
			dataPrices[index].finalPrice = '(call for pricing)';
		}

		return {
			componentLayoutRemove,
			layoutWindows,
			listVentsHasReplace,
			addOnLayoutRemove,
			dataPrices,
			tpmPrice,
		};
	};

	getDefaultSidingMaterial = () => {
		return $('.group-siding-type ul li.default-material').data('key');
	};

	private calculatePriceByType = (
		type,
		price,
		basePrice,
		width,
		length,
		related,
		height = 0,
		minPrice: any = undefined,
		maxPrice: any = undefined,
	) => {
		let result;
		const numPrice = Number(price);
		type = undefined === type ? type : type.trim();
		switch (type) {
			case 'percentage_default':
				const modelHeight = helpers.getBaseHeight();
				const dataSizes = $('#ssb-configurator-size-area')
					.children('option:selected')
					.attr('data-sizes');
				const material = this.isManualPrice() ? this.getDefaultSidingMaterial() : false;
				const defaultBasePrice = this.getPriceByHeight(modelHeight, dataSizes, material);
				result = (numPrice * defaultBasePrice) / 100;
				break;
			case 'percentage':
				result = (numPrice * basePrice) / 100;
				break;
			case 'percentage_height':
				result = (numPrice * height * basePrice) / 100;
				break;
			case 'square_footage':
				result = numPrice * width * length;
				break;
			case 'width_based':
			case 'linear_foot':
				result = numPrice * width;
				break;
			case 'depth_based':
				result = numPrice * length;
				break;
			case 'perimeter':
				result = numPrice * (2 * (width + length));
				break;
			case 'percentage_of_window_price':
				if (false !== related) {
					result = (numPrice * related) / 100;
				}
				result = numPrice;
				break;
			case 'roof_sqft':
				result = this.calculateRoofSQFT(numPrice);
				break;
			case 'waincosting_sqft':
				const waincostingWalls = this._seadevShedBuilder.getWaincostingWallInfor();
				result =
					0 === waincostingWalls.length
						? 0
						: this.calculateWaincostingSQFT(numPrice, waincostingWalls);
				break;
			case 'siding_sqft':
				result = this.calculateSidingSQFT(numPrice);
				break;
			case 'percentage_default_roof':
				result = this.calculatePriceByType(
					'percentage',
					price,
					this.getRoofMaterialPrice(true),
					width,
					length,
					related,
				);
				break;
			case 'percentage_extra_roof':
				result = this.calculatePriceByType(
					'percentage',
					price,
					this.getRoofMaterialPrice(),
					width,
					length,
					related,
				);
				break;
			case 'percentage_of_cost':
				result = (numPrice * this._totalBuildingOptionsPrice) / 100;
				break;
			case 'n_a':
				return '(n/a)';
			case 'call_for_pricing':
				return '(call for pricing)';
			default:
				result = numPrice;
				break;
		}

		const numericMin =
			minPrice !== '' && !isNaN(Number(minPrice)) ? Number(minPrice) : undefined;
		const numericMax =
			maxPrice !== '' && !isNaN(Number(maxPrice)) ? Number(maxPrice) : undefined;
		const numericResult = Number(result);

		if (type !== 'fixed' && type !== 'base' && !isNaN(numericResult)) {
			result = this.getPriceFromMinMaxRange(Number(result), numericMin, numericMax);
		}

		return result;
	};

	/**
	 * Get the price within the specified minimum and maximum range.
	 * @param {number} price - The calculated price.
	 * @param {number} minPrice - The minimum allowed price.
	 * @param {number} maxPrice - The maximum allowed price.
	 *
	 * @returns {number} - The price adjusted to be within the min and max range.
	 */
	private getPriceFromMinMaxRange = (
		price: number,
		minPrice?: number,
		maxPrice?: number,
	): number => {
		if (typeof minPrice === 'number') {
			price = Math.max(price, minPrice);
		}
		if (typeof maxPrice === 'number') {
			price = Math.min(price, maxPrice);
		}
		return price;
	};

	/**
	 * Calculate the price of roof square footage based on the roof shape.
	 * @param {number} numPrice - The base price per square foot.
	 *
	 * @returns {number} - The calculated roof square footage multiplied by the base price.
	 */
	calculateRoofSQFT = (numPrice) => {
		const roofShape = this._seadevShedBuilder.getRoofShape();
		const depth = this._seadevShedBuilder.isSideGable()
			? this._seadevShedBuilder.getDepth()
			: helpers.getBaseDepth();
		const width = this._seadevShedBuilder.getWidth();

		if ('gambrel' === roofShape) {
			const { lowerRafter, upperRafter } = this.getRafterData();
			if (0 >= lowerRafter && 0 >= upperRafter) {
				return numPrice;
			}

			const lowerSQFT = helpers.toFixed3(depth * lowerRafter);
			const upperSQFT = helpers.toFixed3(depth * upperRafter);
			const roofSQFT = helpers.toFixed3((lowerSQFT + upperSQFT) * 2);

			return helpers.toFixed3(roofSQFT * numPrice);
		} else if ('box_gable' === roofShape || 'open_gable' === roofShape) {
			const roofDegree = helpers.toFixed3(this._seadevShedBuilder.getRoofDegree());
			const halfWidth = width / 2;
			const rafterWidth = helpers.toFixed3(halfWidth / helpers.getCosFromDegrees(roofDegree));
			const roofSQFT = helpers.toFixed3(depth * rafterWidth * 2);

			return helpers.toFixed3(roofSQFT * numPrice);
		} else if ('flat' === roofShape) {
			const roofDegree = helpers.toFixed3(this._seadevShedBuilder.getRoofDegree());
			const rafterWidth = helpers.toFixed3(width / helpers.getCosFromDegrees(roofDegree));
			const roofSQFT = helpers.toFixed3(depth * rafterWidth);

			return helpers.toFixed3(roofSQFT * numPrice);
		} else if ('structure_quaker_silvercreek' === this._seadevShedBuilder._shedType) {
			const quakerWidth = this._seadevShedBuilder._quakerWidth;
			const remainingWidth = width - quakerWidth;
			const roofDegree = helpers.toFixed3(this._seadevShedBuilder.getRoofDegree());
			const roofHeight = helpers.toFixed3(
				quakerWidth * helpers.getTanFromDegrees(roofDegree),
			);
			const longRafter = helpers.toFixed3(
				Math.sqrt(quakerWidth * quakerWidth + roofHeight * roofHeight),
			);
			const shortRafter = helpers.toFixed3(
				Math.sqrt(remainingWidth * remainingWidth + roofHeight * roofHeight),
			);
			const roofSQFT = helpers.toFixed3(longRafter * depth + shortRafter * depth);

			return helpers.toFixed3(roofSQFT * numPrice);
		} else if ('saltbox_customize' === roofShape) {
			const area = this._seadevShedBuilder.calculateSaltboxCustomizeRoofArea();

			return area ? helpers.toFixed3(area * numPrice) : numPrice;
		}

		return numPrice;
	};

	/**
	 * Calculate the price of roof square footage based on the waincosting.
	 * @param {number} numPrice - The base price per square foot.
	 *
	 * @returns {number} - The calculated roof square footage multiplied by the base price.
	 */
	calculateWaincostingSQFT = (numPrice, waincostingWalls) => {
		let sqft = 0;
		for (let i = 0; i < waincostingWalls.length; i++) {
			sqft += this._seadevShedBuilder.calculatePolygonArea(waincostingWalls[i].bones);
		}
		return helpers.toFixed3(numPrice * sqft);
	};

	/**
	 * Calculates the price of siding square footage based on the roof shape.
	 * @param {number} numPrice - The base price per square foot.
	 *
	 * @returns {number} - The calculated siding square footage multiplied by the base price.
	 */
	calculateSidingSQFT = (numPrice) => {
		const roofShape = this._seadevShedBuilder.getRoofShape();
		const depth = this._seadevShedBuilder.isSideGable()
			? this._seadevShedBuilder.getDepth()
			: helpers.getBaseDepth();
		const width = this._seadevShedBuilder.getWidth();
		const height = helpers.getBaseHeight();
		const wallSQFT = (depth * height + width * height) * 2;

		if ('gambrel' === roofShape) {
			const { lowerRafter, upperRafter } = this.getRafterData();
			if (0 >= lowerRafter && 0 >= upperRafter) {
				return numPrice;
			}

			const lowerDegree =
				0 !== this._seadevShedBuilder._roofLowerDegree
					? this._seadevShedBuilder._roofLowerDegree
					: this._seadevShedBuilder._initRoofLowerDegree;
			const upperDegree =
				0 !== this._seadevShedBuilder._roofUpperDegree
					? this._seadevShedBuilder._roofUpperDegree
					: this._seadevShedBuilder._initRoofUpperDegree;
			const lowerTan = helpers.getTanFromDegrees(lowerDegree);
			const upperTan = helpers.getTanFromDegrees(upperDegree);
			const lowerSin = helpers.getSinFromDegrees(lowerDegree);
			const upperSin = helpers.getSinFromDegrees(upperDegree);
			const lowerHeight = lowerSin * lowerRafter;
			const lowerWidth = lowerHeight / lowerTan;
			const upperHeight = upperSin * upperRafter;
			const upperWidth = upperHeight / upperTan;
			const lowerSQFT = (lowerHeight * lowerWidth) / 2;
			const upperSQFT = (upperHeight * upperWidth) / 2;
			const remainSQFT = lowerHeight * upperWidth;
			const gableSQFT = helpers.toFixed3((lowerSQFT + upperSQFT + remainSQFT) * 4);
			const sidingSQFT = this.updateSidingSQFT(
				helpers.toFixed3(wallSQFT + gableSQFT),
				height,
			);

			return helpers.toFixed3(sidingSQFT * numPrice);
		} else if ('box_gable' === roofShape || 'open_gable' === roofShape) {
			const roofDegree = helpers.toFixed3(this._seadevShedBuilder.getRoofDegree());
			const halfWidth = width / 2;
			const roofHeight = helpers.toFixed3(halfWidth * helpers.getTanFromDegrees(roofDegree));
			const gableSQFT = helpers.toFixed3(roofHeight * halfWidth * 2);
			const sidingSQFT = this.updateSidingSQFT(
				helpers.toFixed3(wallSQFT + gableSQFT),
				height,
			);

			return helpers.toFixed3(sidingSQFT * numPrice);
		} else if ('flat' === roofShape) {
			const roofDegree = helpers.toFixed3(this._seadevShedBuilder.getRoofDegree());
			const roofHeight = helpers.toFixed3(width * helpers.getTanFromDegrees(roofDegree));
			const gableSQFT = helpers.toFixed3(roofHeight * width);
			const sidingSQFT = helpers.toFixed3(wallSQFT + gableSQFT + roofHeight * depth);

			return helpers.toFixed3(sidingSQFT * numPrice);
		} else if ('structure_quaker_silvercreek' === this._seadevShedBuilder._shedType) {
			const quakerWidth = this._seadevShedBuilder._quakerWidth;
			const roofDegree = helpers.toFixed3(this._seadevShedBuilder.getRoofDegree());
			const roofHeight = helpers.toFixed3(
				quakerWidth * helpers.getTanFromDegrees(roofDegree),
			);
			const gableSQFT = helpers.toFixed3(roofHeight * width);
			const sidingSQFT = helpers.toFixed3(wallSQFT + gableSQFT);

			return helpers.toFixed3(sidingSQFT * numPrice);
		} else if ('saltbox_customize' === roofShape) {
			const area = this._seadevShedBuilder.calculateSaltboxCustomizeSidingArea();

			return area ? helpers.toFixed3(area * numPrice) : numPrice;
		}

		return numPrice;
	};

	/**
	 * Updates the siding square footage based on the presence and type of porch.
	 * @param {number} sidingSQFT - The initial siding square footage.
	 * @param {number} height - The height of the siding.
	 *
	 * @returns {number} - The updated siding square footage.
	 */
	updateSidingSQFT = (sidingSQFT, height) => {
		if (this._seadevShedBuilder.isFrontPorch() || this._seadevShedBuilder.isSidePorch()) {
			return helpers.toFixed3(sidingSQFT - 2 * height * this._seadevShedBuilder._porchWidth);
		}

		if (this._seadevShedBuilder.isMiddlePorch()) {
			return helpers.toFixed3(sidingSQFT + 2 * height * this._seadevShedBuilder._porchWidth);
		}

		return sidingSQFT;
	};

	getRafterData = () => {
		const rafterSetting = (<any>window).shedpro.rafter_setting;
		const width = helpers.getBaseWidth();
		let lowerRafter = 0;
		let upperRafter = 0;
		for (let i = 0; i < rafterSetting.length; i++) {
			if (width === Number(rafterSetting[i]['rafter_setting_width'])) {
				lowerRafter = Number(rafterSetting[i]['lower_rafter']);
				upperRafter = Number(rafterSetting[i]['upper_rafter']);
				break;
			}
		}

		return { lowerRafter, upperRafter };
	};

	getPriceOptions = (el, type = null) => {
		const _this = this;
		const componentType = ['door', 'shutter', 'vent', 'windows', 'material'];
		if (type && -1 === componentType.indexOf(type)) return 0;

		const price = el.attr('data-price');
		const priceType = el.attr('data-price-type');

		if (priceType === 'n_a') {
			return '(n/a)';
		} else if (priceType === 'call_for_pricing') {
			return '(call for pricing)';
		}

		if (!price) return 0;

		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		let basePrice = _this.getBasePrice();
		if ('material' === type && _this._isMaterialUpdateBasePrice && 'percentage' === priceType)
			return 0;
		//     if( _this._isMaterialUpdateBasePrice && 'percentage' === priceType ) return 0;
		//     const height        = helpers.getBaseHeight();
		//     const dataSizes     = $(`#ssb-configurator-size-area`).children('option:selected').attr('data-sizes');
		//     basePrice           = _this.getPriceByHeight( height, dataSizes );
		//     const basePriceType = _this.calculatePriceByType( priceType, price, basePrice, baseWidth, baseDepth, false );
		//     return basePriceType;
		// }

		return _this.calculatePriceByType(priceType, price, basePrice, baseWidth, baseDepth, false);
	};

	getPriceByHeight = (height, dataSizes, material: any = false) => {
		const _this = this;
		if (undefined === dataSizes) {
			return 0;
		}

		if (_this._isEnabledZonePrice && _this._sizesZone.length) {
			const _sizesActive = $(`#ssb-configurator-size-area`).children('option:selected');
			const _zwidth = _sizesActive.attr('data-size-width');
			const _zdepth = _sizesActive.attr('data-size-depth');
			const itemActive = _this._sizesZone.filter(
				(item) => item.width == _zwidth && item.depth == _zdepth && item.height == height,
			);
			dataSizes = itemActive.map((item) => {
				return {
					height: item.height,
					prices: item.prices,
					name: item.name,
				};
			});
		} else {
			dataSizes = JSON.parse(atob(dataSizes));
		}

		for (let i = 0; i < dataSizes.length; i++) {
			if (false === material) {
				if (height === Number(dataSizes[i]['height']) && dataSizes[i]['prices']['price']) {
					return Number(dataSizes[i]['prices']['price']);
				}
			} else {
				if (height === Number(dataSizes[i]['height']) && dataSizes[i]['prices'][material]) {
					return Number(dataSizes[i]['prices'][material]);
				}
			}
		}

		return 0;
	};

	/**
	 * Get Base price of the model
	 *
	 * @returns {Number}
	 */
	getBasePrice = (defaultPrice: any = false) => {
		const height = helpers.getBaseHeight();
		const dataSizes = $(`#ssb-configurator-size-area`)
			.children('option:selected')
			.attr('data-sizes');
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		if (!this.isManualPrice()) {
			let basePrice = this.getPriceByHeight(height, dataSizes);
			const sidingMaterialPrice = $(
				'#ssb-configurator-accordion-materials .group-siding-type .ssb-option.active',
			).data('price');
			const sidingMaterialPriceType = $(
				'#ssb-configurator-accordion-materials .group-siding-type .ssb-option.active',
			).data('price-type');
			if (sidingMaterialPriceType && sidingMaterialPrice) {
				if (helpers.notIncludeSidingMaterialPrice() || !this._isMaterialUpdateBasePrice) {
					// Quick fix base price for urbansheds
					return basePrice;
				}

				let materiaPrice = Number(
					this.calculatePriceByType(
						sidingMaterialPriceType,
						sidingMaterialPrice,
						basePrice,
						baseWidth,
						baseDepth,
						false,
					),
				);
				materiaPrice = isNaN(materiaPrice) ? 0 : materiaPrice;
				if ('percentage' === sidingMaterialPriceType) {
					basePrice = materiaPrice;
				} else {
					basePrice += materiaPrice;
				}
			}

			return basePrice;
		}

		if (defaultPrice) {
			const defaultMaterial = $('.ssb-configurator-siding-type .default-material');
			const defaultBasePriceMaterial = this.getPriceByHeight(
				height,
				dataSizes,
				defaultMaterial.data('siding-type'),
			);
			return defaultBasePriceMaterial;
		} else {
			const material = this._seadevShedBuilder.getSidingType();
			if (material) {
				return this.getPriceByHeight(height, dataSizes, material);
			}
		}
		// const material = this._seadevShedBuilder.getSidingType();
		// if( material ) {
		//     return this.getPriceByHeight( height, dataSizes, material );
		// }

		return 0;
	};

	/**
	 * Check is using manual price
	 *
	 * @returns {boolean}
	 */
	isManualPrice = () => {
		return 'true' === this._seadevShedBuilder._canvas.getAttribute('data-set-price-manual');
	};

	customRoofOverhang = () => {
		const _this = this;
		$('input.ssb_roof_overhang').change(() => {
			_this._seadevShedBuilder.addStopRenderClasses('renderModelCanvas');
			const value: any = $('input.ssb_roof_overhang:checked').val();
			let sides = $('input.ssb_roof_overhang:checked').attr('data-sides');
			if (value && sides) {
				sides = JSON.parse(window.atob(sides));

				const name: any = $(
					`[for="ssb-configurator-upgrade-roof_overhang-${value}"]`,
				).text();
				$('#js-shed-data input[name="ssb-option-roof-overhang"]').attr('data-name', name);
				$('#js-shed-data input[name="ssb-option-roof-overhang"]').val(value);

				_this._seadevShedBuilder.updateRoofOverhang();
				_this.updatePrice();
			}
			_this._seadevShedBuilder.removeStopRenderClasses('renderModelCanvas');
		});
	};

	handleLoftChange = () => {
		const _this = this;

		$('.group-upgrade-loft .ssb_loft').on('change', function (e) {
			_this._seadevShedBuilder.addStopRenderClasses('handleLoftChange');
			const position =
				undefined !== $(this).data('position')
					? helpers.toFixed3(Number($(this).data('position')) / 12)
					: false;
			const dataLoft = _this._seadevShedBuilder.formatLoftSizeSide($(this).data('size-side'));

			_this.loftChange(dataLoft, position);
			_this._seadevShedBuilder.removeStopRenderClasses('handleLoftChange');
		});
	};

	loftChange = (dataLoft, position: any = false) => {
		this._seadevShedBuilder.handleLoft(dataLoft, position);
		this.shedDetailRenderInterior();
		this.updatePrice();
	};

	renderInput = (name, value = 1) => {
		return `<input type="number" class="upgrade-quantity" name="${name}-quantity" min="1" placeholder="Quantity" value="${value}" />`;
	};

	handleUpgradeChange = () => {
		const _this = this;
		$('.group-upgrade-package, .group-upgrade-other')
			.find('input.ssb-option:checked')
			.each((i, e) => {
				if (
					$(e).data('picker') == 1 &&
					0 == $(e).closest('div').find('.upgrade-quantity').length
				) {
					let inputName = $(e).attr('name');
					let input = _this.renderInput(inputName);
					$(e).closest('div').append(input);
				}
			});

		$('.group-upgrade-package, .group-upgrade-other').on(
			'change',
			'input.ssb-option',
			function (e) {
				let inputName = $(this).attr('name');
				let input = _this.renderInput(inputName);
				let type = $(this).hasClass('radio') ? 'radio' : 'checkbox';
				if (type === 'radio') {
					$(this).closest('.ssb-configurator-options').find('.upgrade-quantity').remove();

					if (
						$(this).data('picker') == 1 &&
						0 == $(this).closest('div').find('.upgrade-quantity').length
					) {
						$(this).closest('div').append(input);
					}
				}

				if (type === 'checkbox') {
					if ($(this).is(':checked')) {
						if (
							$(this).data('picker') == 1 &&
							0 == $(this).closest('div').find('.upgrade-quantity').length
						) {
							$(this).closest('div').append(input);
						}
					} else {
						$(this).closest('div').find('.upgrade-quantity').remove();
					}
				}
			},
		);

		$('.group-upgrade-package, .group-upgrade-other').on(
			'input',
			'.upgrade-quantity',
			function (e) {
				this.value = this.value.replace(/^0|[^0-9]/g, '');
				_this.shedDetailRenderInterior();
				_this.updatePrice();
			},
		);
	};

	/**
	 * Auto select first option
	 *
	 * @param {String} type Type of component
	 */
	selectFirstOption = (type) => {
		const options = $(`[name='${type}']`);
		for (let i = 0; i < options.length; i++) {
			const selected = $(options[i]).parent().css('display');
			if ('none' !== selected) {
				$(options[i]).prop('checked', true);
				break;
			}
		}
	};

	/**
	 * Hide or show add on based on the requirement
	 *
	 * @param {String} parentUUID Name of the parent component
	 * @param {String} requiredElement Name of the required element
	 * @param {String} elementId ID of the element to be shown or hidden
	 */
	toggleAddOn = (parentUUID, requiredElement, elementId) => {
		const isRequired = this._seadevShedBuilder.isRequiredAddon(parentUUID, requiredElement);
		$(`#${elementId}`).parent().toggle(!isRequired);
	};

	/**
	 * Handles the visibility of the add on section
	 *
	 * @param {Boolean} isShowSection If the section should be shown or not
	 * @param {String} elementName Name of the element to be shown or hidden
	 * @param {String} elementClass Class of the element to be shown or hidden
	 */
	handleSelectAddOn = (isShowSection, elementName, elementClass) => {
		if (isShowSection) {
			const elementSelected = $(`input[name='${elementName}']:checked`);
			const selectedValue = elementSelected.val() as string;
			if (selectedValue) {
				const display = elementSelected.parent().css('display');
				if ('none' === display) {
					this.selectFirstOption(elementName);
				}
			} else {
				this.selectFirstOption(elementName);
			}

			$(`.${elementClass}`).show();
		} else {
			$(`.${elementClass}`).hide();
		}
	};

	/**
	 * Toggles the visibility of the add on section
	 *
	 * @param {string[]} items List of component names to show
	 * @param {string} elementName Name of the input element
	 * @param {string} elementId ID of the element to be shown or hidden
	 *
	 * @returns {boolean} If the section should be shown or not
	 */
	toggleAddOnSection = (items, elementName, elementId) => {
		let isShowSection = false;
		$(`[name='${elementName}']:not(#${elementId})`).each((i, v) => {
			const key = $(v).data('upgrade-component-name');
			if (-1 !== items.indexOf(key)) {
				$(v).parent().show();
				isShowSection = true;
			} else {
				$(v).parent().hide();
			}
		});

		return isShowSection;
	};

	/**
	 * Check condition before show or hide shutter section when edit Windows component
	 */
	handleDisplayAddonSection = () => {
		const _this = this;

		$('input.ssb-option[data-upgrade-type="door"]').on('change', function (e) {
			const parentName = e.target.dataset.upgradeComponentName;
			const parentUUID = e.target.dataset.uuid;
			let ramp = jQuery(`input.ssb-option[data-uuid='${parentUUID}']`).data('ramp');
			ramp = ramp ? JSON.parse(atob(ramp)) : [];
			let isShowRamp = false;

			if (ramp.length) {
				_this.toggleAddOn(parentUUID, 'required-ramp', 'none_ramp');
				isShowRamp = _this.toggleAddOnSection(ramp, 'child_ramp', 'none_ramp');
			}

			_this.handleSelectAddOn(isShowRamp, 'child_ramp', 'child-option-ramp');
		});

		$(`input.ssb-option[data-upgrade-type="windows"]`).change((e) => {
			const parentUUID = e.target.dataset.uuid;
			const elParentOption = $(`input.ssb-option[data-uuid="${parentUUID}"]`);
			let windowShutters = elParentOption.data('shutters');
			let windowTransom = elParentOption.data('transom');
			windowTransom = windowTransom ? JSON.parse(atob(windowTransom)) : [];
			let isShowTransom = false;
			if (windowTransom && windowTransom.transom) {
				isShowTransom = _this.toggleAddOnSection(
					[windowTransom.transom],
					'child_transom',
					'none_transom',
				);
			}

			_this.handleSelectAddOn(isShowTransom, 'child_transom', 'child-option-transom');
			
			windowShutters = windowShutters ? JSON.parse(atob(windowShutters)) : [];
			let isShowShutters = false;

			let flowerBox = jQuery(`input.ssb-option[data-uuid="${parentUUID}"]`).data('flower_box');
			flowerBox = flowerBox ? JSON.parse(atob(flowerBox)) : [];
			let isShowFlowerBox = false;

			if (flowerBox.length) {
				_this.toggleAddOn(parentUUID, 'required-flower_box', 'none_flower_box');
				isShowFlowerBox = _this.toggleAddOnSection(
					flowerBox,
					'child_flower_box',
					'none_flower_box',
				);
			}

			_this.handleSelectAddOn(isShowFlowerBox, 'child_flower_box', 'child-option-flower_box');

			if (windowShutters.length) {
				_this.toggleAddOn(parentUUID, 'required-shutters', 'none_shutters');

				const sidingMaterial = _this._seadevShedBuilder.getSidingType();
				$(`[name='child_shutters']:not(#none_shutters)`).each((i, v) => {
					let availableMaterials = $(v).data('materials');
					availableMaterials = availableMaterials
						? JSON.parse(atob(availableMaterials))
						: [];
					const shuttersKey = $(v).data('upgrade-component-name');
					if (
						-1 !== availableMaterials.indexOf(sidingMaterial) &&
						-1 !== windowShutters.indexOf(shuttersKey)
					) {
						$(v).parent().show();
						isShowShutters = true;
					} else {
						$(v).parent().hide();
					}
				});
			}
			_this.handleSelectAddOn(isShowShutters, 'child_shutters', 'child-option-shutters');

			if ('porch' === $(`input[name='dormer-position']:checked`).val()) {
				$('.child-option-flower_box').hide();
			}

			if ('porch' === $('input[name="porch-side-position-windows"]:checked').val()) {
				$('.child-option-flower_box').hide();
			}
		});

		$('input[name="dormer-position"], input[name="porch-side-position-windows"]').change(
			(e) => {
				if ('porch' === $(e.target).val()) {
					$('.child-option-flower_box').hide();
					$('#none_flower_box').click();
				}
			},
		);
	};

	/**
	 * Check condition to disable input if porch size not satisfy the condition
	 */
	handlePorchList = () => {
		if (this._seadevShedBuilder.isFrontPorch() || this._seadevShedBuilder.isSidePorch()) {
			const porchSelectVal = Number($('input.ssb_porch:checked').data('porch-size'));

			let length = Number(
				$('.ssb-option.size-area').children('option:selected').data('size-depth'),
			);
			if (this._seadevShedBuilder.isSidePorch()) {
				length = this._seadevShedBuilder.getWidth();
			}

			if (porchSelectVal >= length) {
				$('[name="ssb-configurator-upgrade-porch"].item-0:not([disabled])').trigger(
					'click',
				);
			}

			$('.group-upgrade-porch')
				.find('input.ssb_porch')
				.each((i, v) => {
					if ($(v).data('porch-size') >= length) {
						$(v).prop('disabled', true);
						$(v).next().css('color', '#b3b1b1');
					} else {
						$(v).prop('disabled', false);
						$(v).next().css('color', '#5e6578');
					}
				});
		}

		const _this = this;
		const conditions = this._seadevShedBuilder.getSettingData('porch_restriction');
		if (conditions) {
			$('.group-upgrade-porch .ssb-configurator-options input').each(function () {
				const size = Number($(this).data('porch-size')).toString();
				if (_this.isPrevent(size, conditions, 'porch_restriction')) {
					$(this).parent().addClass('disable-by-size').hide();
				} else {
					$(this).parent().removeClass('disable-by-size').show();
				}
			});

			const currentPorch = $('.group-upgrade-porch .ssb-configurator-options input:checked');
			if (currentPorch.parent().hasClass('disable-by-size')) {
				const newPorch = $(
					'.group-upgrade-porch .ssb-configurator-options div:not(.disable-by-size) input:not([disabled]):eq(0)',
				);
				if (newPorch.length) {
					const sizeLabel = helpers.getSizeLabel();
					_this._seadevShedBuilder.createAlert(
						`Porch option change to ${newPorch.data('option-value')} because size ${sizeLabel['label']} does not have ${currentPorch.data('option-value')} option.`,
					);
					newPorch.prop('checked', true).trigger('change');
				}
			}
		}

		const porchAvailable = $(
			'.group-upgrade-porch .ssb-configurator-options div:not(.disable-by-size)',
		).length;
		if (1 >= porchAvailable) {
			$('.group-upgrade-porch').hide();
		} else {
			if (this._seadevShedBuilder.isHidePorchInfo()) {
				$('.group-upgrade-porch').hide();
			} else {
				$('.group-upgrade-porch').show();
			}
		}
	};

	/**
	 * Check condition to disable options roof pitch
	 */
	handleRoofPitchList = () => {
		const _this = this;
		const roofConditions = (<any>window).shedpro.roof_pitch_conditions;
		const width = helpers.getBaseWidth();
		const depth = helpers.getBaseDepth();
		const height = helpers.getBaseHeight();
		$('.ssb-configurator-options.roof_pitch > div').removeClass('disable-by-size').show();
		$('.ssb-configurator-options.roof_pitch input').each(function () {
			const roofPitchValue = $(this).val();
			if (_this.isPrevent(roofPitchValue, roofConditions, 'roof_pitch')) {
				$(this).parent().addClass('disable-by-size').hide();
			}
		});

		const currentRoofPitchValue = $('.ssb-configurator-options.roof_pitch input:checked').data(
			'option-value',
		);
		if (
			$('.ssb-configurator-options.roof_pitch input:checked')
				.parent()
				.hasClass('disable-by-size')
		) {
			const newRoofPitch = $(
				'.ssb-configurator-options.roof_pitch > div:not(.disable-by-size):eq(0) input',
			);
			const newRoofPitchValue = newRoofPitch.data('option-value');
			const sizeLabel = helpers.getSizeLabel();
			_this._seadevShedBuilder.createAlert(
				`Root pitch change to ${newRoofPitchValue} because size ${sizeLabel['label']} does not have ${currentRoofPitchValue} option.`,
			);
			newRoofPitch.prop('checked', true).trigger('change');
		}
	};

	isCondition = (condition) => {
		const cond = JSON.parse(window.atob(condition));
		const sizes = [
			{
				size: helpers.getBaseWidth(),
				operator: cond.condition_width.operator,
				value: cond.condition_width.value,
				max: cond.condition_width.max_value,
			},
			{
				size: helpers.getBaseDepth(),
				operator: cond.condition_depth.operator,
				value: cond.condition_depth.value,
				max: cond.condition_depth.max_value,
			},
			{
				size: helpers.getBaseHeight(),
				operator: cond.condition_height.operator,
				value: cond.condition_height.value,
				max: cond.condition_height.max_value,
			},
		];

		for (let i = 0; i < sizes.length; i++) {
			if (
				!helpers.isValidSize(
					sizes[i]['operator'],
					sizes[i]['size'],
					sizes[i]['value'],
					sizes[i]['max'],
				)
			) {
				return false;
			}
		}

		return true;
	};

	isPrevent = (value, conditions, key) => {
		if (!conditions) return false;

		for (let i = 0; i < conditions.length; i++) {
			if (!conditions[i][key]) continue;
			let roofPitchList = JSON.parse(window.atob(conditions[i][key]));

			if (!roofPitchList.includes(value)) continue;

			if (
				helpers.isValidSize(
					conditions[i].condition_width.operator,
					helpers.getBaseWidth(),
					conditions[i].condition_width.value,
					conditions[i].condition_width.max_value,
				) &&
				helpers.isValidSize(
					conditions[i].condition_height.operator,
					helpers.getBaseHeight(),
					conditions[i].condition_height.value,
					conditions[i].condition_height.max_value,
				) &&
				helpers.isValidSize(
					conditions[i].condition_depth.operator,
					helpers.getBaseDepth(),
					conditions[i].condition_depth.value,
					conditions[i].condition_depth.max_value,
				)
			) {
				return true;
			}
		}

		return false;
	};

	/**
	 * Get Porch Opening Available
	 */
	getOpeningAvailable = () => {
		let openingAvailable = this._seadevShedBuilder._canvas.getAttribute(
			'data-opening-available-on',
		);

		if (openingAvailable && 'false' !== openingAvailable) return parseFloat(openingAvailable);

		return false;
	};

	/**
	 * Get Porch Opening Available
	 */
	isRailingEnable = () => {
		const data = $('input.ssb_porch-railing:checked').data('key');
		return 'with_railing' === data ? true : false;
	};

	/**
	 * Get Railing Price
	 */
	getRailingPrice = () => {
		let railingPrice = this._seadevShedBuilder.getSettingData('railing_price');

		if (railingPrice && 'false' !== railingPrice) return parseFloat(railingPrice);

		return 0;
	};

	/**
	 * Calculate Railing Price
	 */
	calculateRailingPrice = () => {
		if (!this.isRailingEnable()) return 0;

		const railingPriceType = this._seadevShedBuilder.getSettingData('railing_price_type');
		const railingPrice = this.getRailingPrice();

		if ('linear_foot' !== railingPriceType) {
			const price = Number(
				this.calculatePriceByType(
					railingPriceType,
					railingPrice,
					this.getBasePrice(),
					helpers.getBaseWidth(),
					helpers.getBaseDepth(),
					false,
				),
			);

			return isNaN(price) ? 0 : price;
		}

		if (this._seadevShedBuilder.isCornerPorchLeft()) {
			return railingPrice * constants.cornerWidth;
		}

		if (this._seadevShedBuilder.isMiddlePorch()) {
			return railingPrice * (constants.middleWidth / 2);
		}

		if (this._seadevShedBuilder.isDeluxeCornerLeftPorch()) {
			let totalWidthRailing = 0;

			if (this._seadevShedBuilder.hasDepsToCloneLeftBalusterDeluxePorch()) {
				totalWidthRailing += constants.deluxeDepth;
			}

			if (this._seadevShedBuilder.hasDepsToCloneFrontBalusterDeluxePorch()) {
				totalWidthRailing += this._seadevShedBuilder.getWidth() / 2;
			}

			if (this._seadevShedBuilder.hasDepsToCloneRightBalusterDeluxePorch()) {
				totalWidthRailing += constants.deluxeDepth;
			}

			return totalWidthRailing * railingPrice;
		}

		const oPosition = this._seadevShedBuilder.getOpeningPosition();
		const opening = this._seadevShedBuilder.isEnableCustomOpeningSize()
			? this._seadevShedBuilder.getOpeningSize()
			: 4;

		if ('structure_ranch_cabin' === this._seadevShedBuilder._shedType) {
			let totalRailingWith = 0;
			const porchSpace =
				this._seadevShedBuilder.getDepth() - this._seadevShedBuilder._cabinWidth;
			if ('middle' === oPosition) {
				totalRailingWith = porchSpace - opening + 4;
			} else {
				totalRailingWith = porchSpace / 2 + 4;
			}

			return railingPrice * totalRailingWith;
		}

		if (
			'structure_aframe_cabin' === this._seadevShedBuilder._shedType ||
			'structure_porch_barn' === this._seadevShedBuilder._shedType
		) {
			const totalRailingWidth =
				this._seadevShedBuilder.getDepth() -
				opening +
				this._seadevShedBuilder._porchWidth * 2;
			return railingPrice * totalRailingWidth;
		}

		const porchWidth = this._seadevShedBuilder._porchWidth;
		let postDistance = this._seadevShedBuilder._postDistance;

		const totalPostDistance = oPosition == 'middle' ? postDistance * 2 : postDistance;
		let totalRailingWith =
			(this._seadevShedBuilder.isPorchFullRailing() ? totalPostDistance : 0) + porchWidth * 2;

		if (this._seadevShedBuilder.isExternalPorch()) {
			if (!this._seadevShedBuilder.isEnableExternalPorch()) {
				return 0;
			}

			if (this._seadevShedBuilder.hasOpeningSetting()) {
				totalRailingWith = totalPostDistance + porchWidth * 2;
			} else {
				const porchExternal = this._seadevShedBuilder._canvas.getAttribute(
					'data-model-porch-external',
				);
				const porchData = JSON.parse(atob(porchExternal));
				const { distance } = porchData;

				totalRailingWith = distance * 2 + porchWidth * 2;
			}
		}

		if (this._seadevShedBuilder.isAframeSingleGable()) {
			totalRailingWith =
				this._seadevShedBuilder._postDistance + constants.singleGablePorchDepth;
		}

		if (this._seadevShedBuilder.isDoubleGable()) {
			totalRailingWith = this._seadevShedBuilder._postDistance;
		}

		return porchWidth && postDistance ? railingPrice * totalRailingWith : 0;
	};

	/**
	 * Check opening available for show
	 */
	handleOpeningList = () => {
		const openingAvailable = this.getOpeningAvailable();
		if (!openingAvailable) return;

		let size = this._seadevShedBuilder.getDepth();
		if (this._seadevShedBuilder.isFrontPorch()) {
			size = this._seadevShedBuilder.getWidth();
		} else if ('structure_ranch_cabin' === this._seadevShedBuilder._shedType) {
			size = this._seadevShedBuilder.getDepth() - this._seadevShedBuilder._cabinWidth;
		}

		if (
			size < openingAvailable ||
			(this._seadevShedBuilder.isEnableCustomOpeningSize() &&
				this._seadevShedBuilder.getOpeningSize() + 2 >= size)
		) {
			$('#ssb-configurator-upgrade-opening-position-Middle')
				.prop('disabled', true)
				.next()
				.css('color', '#b3b1b1');

			if ('middle' === this._seadevShedBuilder.getOpeningPosition()) {
				$('#ssb-configurator-upgrade-opening-position-Left').trigger('click');
			}
		} else {
			$('#ssb-configurator-upgrade-opening-position-Middle')
				.prop('disabled', false)
				.next()
				.css('color', '#5e6578');
		}
	};

	/**
	 * Checks if there is a loft restriction for a given element.
	 *
	 * Iterates through all components obtained from the SeadevShedBuilder instance
	 * and checks for a loft restriction based on the provided element, component name,
	 * and side. If any component has a loft restriction, the function returns true.
	 * Otherwise, it returns false.
	 *
	 * @param {HTMLElement} element - The element to check for loft restrictions.
	 * @returns {boolean} True if there is a loft restriction for any component, false otherwise.
	 */
	checkLoftRestriction = (element) => {
		const components = this._seadevShedBuilder.getAllComponents();
		for (const k in components) {
			const { side, name } = components[k];
			const loftRestriction = this.isLoftRestriction(element, name, side);

			if (loftRestriction) {
				return true;
			}
		}

		return false;
	};

	/**
	 * Check condition to disable input if loft size not satisfy the condition
	 */
	handleLoftList = () => {
		const _this = this;
		let length = this._seadevShedBuilder.getDepth();
		let width = this._seadevShedBuilder.getWidth();

		if (!length || !width) return;

		if (this._seadevShedBuilder.isDeluxeCornerLeftPorch()) {
			length = length - 3 * constants.deluxeDepth;
		}

		$('.ssb-configurator-upgrade-new.loft')
			.find('input.ssb_loft')
			.each((i, v) => {
				const element = $(v);
				const dataLoft = _this._seadevShedBuilder.formatLoftSizeSide(
					element.data('size-side'),
				);
				const condition = element.data('condition');
				let eClass = 'disabled';
				let loftWidth = 0;
				let loftDepth = 0;
				let hideBySize = false;
				let hideByCondition = false;

				for (const key in dataLoft) {
					if (helpers.hasKeyInArray(zSide, key)) {
						loftWidth = dataLoft[key];
					} else {
						loftDepth = dataLoft[key];
					}
				}

				if (
					helpers.hasKeyInObject(dataLoft, 'front') &&
					helpers.hasKeyInObject(dataLoft, 'back')
				) {
					loftDepth = dataLoft['front'] + dataLoft['back'];
				}

				if (
					helpers.hasKeyInObject(dataLoft, 'left') &&
					helpers.hasKeyInObject(dataLoft, 'right')
				) {
					loftWidth = dataLoft['left'] + dataLoft['right'];
				}

				if (
					(helpers.hasKeyInObject(dataLoft, 'front') ||
						helpers.hasKeyInObject(dataLoft, 'back')) &&
					loftDepth >= length
				) {
					hideBySize = true;
				}

				if (
					(helpers.hasKeyInObject(dataLoft, 'left') ||
						helpers.hasKeyInObject(dataLoft, 'right')) &&
					loftWidth >= width
				) {
					hideBySize = true;
				}

				if (!_this.isCondition(condition)) {
					eClass = 'hide disabled';
					hideByCondition = true;
				}

				const hideByComponent = this.checkLoftRestriction(element);
				const isDisable = hideBySize || hideByCondition || hideByComponent;

				element.prop('disabled', isDisable);
				element.next().css('color', isDisable ? '#b3b1b1' : '#5e6578');
				if (isDisable) {
					element.closest('div').addClass(eClass);
				} else {
					element.closest('div').removeClass('hide disabled');
				}
			});

		if ($('input.ssb_loft:checked').is(':disabled')) {
			const newLoft = $(
				'.ssb-configurator-upgrade-new.loft div:not(.disabled):eq(0) input.ssb_loft',
			);
			const currentLoft = $('input.ssb_loft:checked');
			const currentLoftVal = currentLoft.data('option-value');
			const newLoftVal = newLoft.data('option-value');
			const sizeLabel = helpers.getSizeLabel();

			if (newLoft.length) {
				newLoft.trigger('click');
				if (newLoftVal !== currentLoftVal) {
					_this._seadevShedBuilder.createAlert(
						`Loft change to ${newLoftVal} option because size ${sizeLabel['label']} does not have ${currentLoftVal} option.`,
					);
				}
			} else {
				currentLoft.prop('checked', false);
				_this._seadevShedBuilder.createAlert(
					`Loft ${currentLoftVal} has been removed as it's not available in ${sizeLabel['label']}.`,
				);
				_this.loftChange({}, false);
			}
		}
	};

	/**
	 * check condition to hide frame list
	 */
	handleListFrame = () => {
		const _this = this;
		let length = this._seadevShedBuilder.getDepth();
		let width = this._seadevShedBuilder.getWidth();

		if (!length || !width) return;
		if (0 === $('input.ssb_frame:checked').length) {
			$(
				'.ssb-configurator-upgrade-new.frame div:not(.disabled):eq(0) input.ssb_frame',
			).trigger('click');
		}

		$('.ssb-configurator-upgrade-new.frame')
			.find('input.ssb_frame')
			.each((i, v) => {
				const element = $(v);
				const condition = element.data('condition');
				let eClass = 'disabled';
				let isHide = false;
				if (!_this.isCondition(condition)) {
					eClass = 'hide disabled';
					isHide = true;
				}
				element.prop('disabled', isHide);
				if (isHide) {
					element.closest('div').addClass(eClass);
				} else {
					element.closest('div').removeClass('hide disabled');
				}
			});

		if (
			$('.ssb-configurator-upgrade-new.frame input.ssb_frame').length &&
			0 === $('.ssb-configurator-upgrade-new.frame div:not(.disabled)').length
		) {
			_this._seadevShedBuilder.removeAllFrame();
		} else {
			if ($('input.ssb_frame:checked').is(':disabled')) {
				const newFrame = $(
					'.ssb-configurator-upgrade-new.frame div:not(.disabled):eq(0) input.ssb_frame',
				);
				const currentFrame = $('input.ssb_frame:checked');
				const currentFrameVal = currentFrame.data('option-value');
				const newFrameVal = newFrame.data('option-value');
				const sizeLabel = helpers.getSizeLabel();

				if (newFrame.length) {
					newFrame.trigger('click');
					_this._seadevShedBuilder.createAlert(
						`Frame change to ${newFrameVal} option because size ${sizeLabel['label']} does not have ${currentFrameVal} option.`,
					);
				} else {
					currentFrame.prop('checked', false);
					_this._seadevShedBuilder.createAlert(
						`Frame ${currentFrameVal} has been removed as it's not available in ${sizeLabel['label']}.`,
					);
				}
			}
		}
	};
	/**
	 * Handle event front end change roof pitch
	 */
	handleChangeRoofPitch = () => {
		const _this = this;

		$('input.ssb_roof_pitch').on('change', (e) => {
			const dataName = $('input.ssb_roof_pitch:checked').attr('data-option-value');
			const dataKey = $('input.ssb_roof_pitch:checked').attr('data-key');
			const dataValue = $('input.ssb_roof_pitch:checked').val() || 3;
			const roofPitch = _this._seadevShedBuilder.getRoofPitchFromRadian(dataValue);

			$('#js-shed-data input[name="ssb-option-roof-pitch"]').attr('data-name', dataName);
			$('#js-shed-data input[name="ssb-option-roof-pitch"]').attr('data-key', dataKey);
			$('#js-shed-data input[name="ssb-option-roof-pitch"]').val(dataValue);

			_this._seadevShedBuilder.setRoofDegree(roofPitch);
			_this.changeSize();
			_this._seadevShedBuilder.updateGableDormer();
			_this._seadevShedBuilder.gableDormerHandleRoofColor();
			_this.updateDormerByRoofPitch();
		});
	};

	/**
	 * Updates dormer components based on the current roof pitch.
	 */
	updateDormerByRoofPitch = () => {
		const components = { ...this._seadevShedBuilder.getAllComponents() };
		for (const k in components) {
			const type = components[k].type;
			if ('dormer' !== type) {
				continue;
			}

			const editComponent = $(`[data-component-key="${k}"]`);
			if (editComponent.length <= 0) {
				continue;
			}

			const componentName = editComponent.attr('data-component-name');
			const componentUUID = editComponent.attr('data-uuid');
			const side = editComponent.attr('data-component-side');
			const sidingType = this._seadevShedBuilder.getSidingType();
			const resultCheck = this._seadevShedBuilder.checkAndReplaceComponent(
				sidingType,
				type,
				componentName,
				side,
				componentUUID,
			);
			const newComponentName = resultCheck.componentName;
			const newComponentUUID = resultCheck.uuid;
			if (componentUUID === newComponentUUID) {
				continue;
			}

			this._seadevShedBuilder._isUpdateLayout = true;

			const componentKey = editComponent.attr('data-component-key');
			const currentPosition =
				this._seadevShedBuilder._walls[side]['items'][componentKey]['position'];
			this.removeComponentV2(side, type, componentKey);

			if (null !== newComponentUUID) {
				this._seadevShedBuilder.addNewComponent({
					side,
					componentType: type,
					componentName: newComponentName,
					position: currentPosition,
					isChangeComponent: true,
					uuid: componentUUID,
				});
			}
		}
	};

	handleChangeLegs = () => {
		const _this = this;

		$('input.ssb_legs_setting').on('change', (e) => {
			const dataKey = $('input.ssb_legs_setting:checked').attr('data-key');
			const dataValue = $('input.ssb_legs_setting:checked').val() || 'standard_legs';

			$('#js-shed-data input[name="ssb-option-legs"]').attr('data-key', dataKey);
			$('#js-shed-data input[name="ssb-option-legs"]').val(dataValue);

			_this._seadevShedBuilder.updateLegs(dataValue);
		});

		$('input.ssb_legs_setting').trigger('change');
	};

	handleChangeFrameSpacing = () => {
		const _this = this;

		$('input.ssb_frame_spacing').on('change', (e) => {
			const dataKey = $('input.ssb_frame_spacing:checked').attr('data-key');
			const dataValue = $('input.ssb_frame_spacing:checked').val();
			const legSelected = $('input.ssb_legs_setting:checked').val() || 'standard_legs';
			const spacing = Number(dataValue);

			$('#js-shed-data input[name="ssb-option-frame-spacing"]').attr('data-key', dataKey);
			$('#js-shed-data input[name="ssb-option-frame-spacing"]').val(dataValue);

			if (spacing > 0) {
				_this._seadevShedBuilder._legDistance = spacing;
			}
			_this._seadevShedBuilder.updateLegs(legSelected, true);
		});

		$('input.ssb_frame_spacing').trigger('change');
	};

	/**
	 * Handle event update porch
	 */
	handleChangePorch = () => {
		const _this = this;
		if (
			_this._seadevShedBuilder.isFrontPorch() ||
			_this._seadevShedBuilder.isSidePorch() ||
			_this._seadevShedBuilder.isMiddlePorch() ||
			_this._seadevShedBuilder.isSidePorchCabin()
		) {
			$('input.ssb_porch, input.ssb_opening-position').on('change', (e) => {
				const oldSize = this._seadevShedBuilder.getSizeGroup();
				const { width, depth, height } = _this.getSizes();
				let porchSize = $('input.ssb_porch:checked').data('porch-size');
				porchSize = undefined === porchSize ? 4 : porchSize;
				const dataKey = $('input.ssb_porch:checked').attr('data-key');
				const dataValue = $('input.ssb_porch:checked').val();

				_this._seadevShedBuilder._oldPorchWidth = _this._seadevShedBuilder._porchWidth;
				_this._seadevShedBuilder._porchWidth = porchSize;

				_this._seadevShedBuilder.setWidth(width);
				_this._seadevShedBuilder.setDepth(depth);
				_this._seadevShedBuilder.setWallHeight(height);

				const newSize = this._seadevShedBuilder.getSizeGroup();

				$('#js-shed-data input[name="ssb-option-upgrade-porch"]').attr('data-key', dataKey);
				$('#js-shed-data input[name="ssb-option-upgrade-porch"]').val(dataValue);
				if (!_this._seadevShedBuilder.isMiddlePorch())
					_this._seadevShedBuilder.updatePorch(oldSize, newSize);
				_this.handleUpdateRailing();
				if (!_this._seadevShedBuilder.isMiddlePorch()) _this.handleLoftList();

				if (this._seadevShedBuilder.isHidePorchInfo()) {
					$('#js-shed-data input[name="ssb-option-upgrade-porch"]')
						.attr('data-key', '')
						.val('');
				}
			});
		} else if (this._seadevShedBuilder.isDeluxeCornerLeftPorch()) {
			$('input.ssb_porch, input.ssb_opening-position').on('change', (e) => {
				const dataKey = $('input.ssb_porch:checked').attr('data-key');
				const dataValue = $('input.ssb_porch:checked').val();

				$('#js-shed-data input[name="ssb-option-upgrade-porch"]')
					.attr('data-key', dataKey)
					.val(dataValue);

				const newSize = this._seadevShedBuilder.getSizeGroup();
				_this._seadevShedBuilder.updatePorch(newSize, newSize);
			});
		} else if ('structure_ranch_cabin' === _this._seadevShedBuilder._shedType) {
			$('input.ssb_opening-position').on('change', (e) => {
				_this.handleUpdateRailing();
			});
		} else if (this._seadevShedBuilder.isExternalPorch()) {
			$('input.ssb_opening-position').on('change', (e) => {
				_this._seadevShedBuilder.cloneExternalPost();
				_this.handleUpdateRailing();
			});
		} else if (
			this._seadevShedBuilder.isDoubleGable() ||
			this._seadevShedBuilder.isAframeSingleGable()
		) {
			$('input.ssb_opening-position').on('change', (e) => {
				const startBone = 'b_p_l1';
				const endBone = _this._seadevShedBuilder.isAframeSingleGable()
					? 'b_p_l4'
					: 'b_p_l3';

				_this._seadevShedBuilder.clonePostAndBaluster(startBone, endBone);
				_this.handleUpdateRailing();
			});
		}
	};

	/**
	 * Handle event update Railing
	 */
	handleChangeRailing = () => {
		const isHandlePorch =
			this._seadevShedBuilder.isFrontPorch() ||
			this._seadevShedBuilder.isExternalPorch() ||
			this._seadevShedBuilder.isSidePorch() ||
			this._seadevShedBuilder.isCornerPorchLeft() ||
			this._seadevShedBuilder.isMiddlePorch() ||
			this._seadevShedBuilder.isDeluxeCornerLeftPorch() ||
			'structure_ranch_cabin' === this._seadevShedBuilder._shedType ||
			this._seadevShedBuilder.isSidePorchCabin() ||
			this._seadevShedBuilder.isAframeSingleGable() ||
			this._seadevShedBuilder.isDoubleGable();
		if (isHandlePorch) {
			this.handleUpdateRailing();

			$(document).on('change', 'input.ssb_porch-railing', (e) => {
				this.handleUpdateRailing();
				if (
					this._seadevShedBuilder.isMiddlePorch() ||
					'structure_ranch_cabin' === this._seadevShedBuilder._shedType
				) {
					if (!this._isEnabledRailing) {
						$('.group-upgrade-opening-position').hide();
					} else {
						$('.group-upgrade-opening-position').show();
					}
				}
			});
		}
	};

	/**
	 * Handle event update Railing
	 */
	handleChangeExternalPorch = () => {
		if (!this._seadevShedBuilder.isExternalPorch()) return;

		const porchExternal = this._seadevShedBuilder._canvas.getAttribute(
			'data-model-porch-external',
		);
		const porchData = JSON.parse(atob(porchExternal));
		const porchLocation = 'side' === porchData.location ? 'left' : porchData.location;
		const data = $('input.ssb_external-porch:checked').data('key');
		const status = 'enabled_porch' === data;

		this._seadevShedBuilder._externalPorchLocation = porchLocation;
		this._isEnabledExternalPorch = status;
		this._seadevShedBuilder.updateExternalPorch(status);

		$(document).on('change', 'input.ssb_external-porch', (e) => {
			const data = $('input.ssb_external-porch:checked').data('key');
			const status = 'enabled_porch' === data;

			if (!status) {
				$(
					'.group-upgrade-porch-railing, .group-upgrade-porch-size-option, .group-upgrade-opening-position',
				).hide();
			} else {
				$('.group-upgrade-porch-railing, .group-upgrade-porch-size-option').show();

				if (
					this._seadevShedBuilder.hasOpeningSetting() &&
					this._seadevShedBuilder.getOpeningSetting()
				) {
					if (
						$(
							'.group-upgrade-opening-position .opening-position div:not([style*="display: none"])',
						).length > 1
					) {
						$('.group-upgrade-opening-position').show();
					}
				}
			}

			this._isEnabledExternalPorch = status;
			this._seadevShedBuilder.updateExternalPorch(status);
			this.handleUpdateRailing();
			this.hideSizeOptionsConfigurator();
			this.updatePrice();
		});
	};

	isMultiModel = () => {
		return this._seadevShedBuilder._canvas.getAttribute('data-is-multi-model') === 'true';
	};

	/**
	 * Safely retrieves a query parameter value from the current URL
	 * @param {string} parameter - The name of the query parameter to retrieve
	 * @returns {string|null} The parameter value or null if not found
	 * @throws {Error} If URL parsing fails
	 */
	getUrlParameter = (parameter) => {
		try {
			if (!parameter) {
				return null;
			}

			const url = new URL(window.location.href);
			return url.searchParams.get(parameter?.trim());
		} catch (error) {
			console.error('Failed to parse URL:', error);
			return null;
		}
	};

	zipCodeEvent = () => {
		const _this = this;

		$('#js-zip-code-submit').on('click', async function (e) {
			e.preventDefault();
			const _el = $(this);
			let zipCodes = $('#js-zip-codes').val() as any;
			let zipCode = _this._elementValidate.val();
			let showError = true;
			let ajaxUrl = $(this).data('ajax_url');
			const modelID = $('#js-shed-data [name="ssb-model-id"]').val();
			let isGetDataZone = true;
			if ('' == zipCode || 'continue' == zipCode) {
				$('#js-zip-code-notice').show();
				return;
			}
			$(this).addClass('loading');
			const postID = _el.data('postid');
			const currentWidth = helpers.getBaseWidth();
			const currentDepth = helpers.getBaseDepth();
			const currentHeight = helpers.getBaseHeight();
			const oldSizeLabel = helpers.getSizeLabel();
			const dealerName = _this.getCookie('dealer');
			const dataPayLoad = {
				action: 'get_location_settings',
				zipCode,
				modelID,
				postID,
				dealerName,
				urlModelId: _this.getUrlParameter('model_id'),
				actionType: 'submit',
			};
			await $.ajax({
				url: ajaxUrl,
				dataType: 'JSON',
				method: 'POST',
				data: dataPayLoad,
				success: function (res) {
					if (!res.success) {
						$('#js-zip-code-submit').removeClass('loading');
						$('#js-zip-code-continue').show();
						$('#js-zip-code-notice').show();
						return;
					}
					_this.setCookie(_this._cookiedValidate, `${zipCode}`);
					_this._seadevShedBuilder._isValidZipcode = true;
					_this._idRestrictionSize = res.restriction_id;
					_this._zoneID = res.zoneID;
					_this._sizesZone = res.sizes_zone;
					showError = false;
					if (res.show_price || res.can_see_est_price) {
						$('body').addClass('show-price');
						_this._isShowPrice = true;
					}
					if (helpers.isEnableManufactureFeature()) {
						if (!res.can_use_model) {
							if (_this._seadevShedBuilder._isShareLink) {
								$('#js-model-not-allow').show();
								$('#js-zip-code-submit').removeClass('loading');
								_this.handleShowPriceChangeZipcode(false);
								isGetDataZone = false;
							} else {
								location.reload();
							}
						}
						_this._lotID = res.lot_id;
						_this._discount = Number(res.location.discount);
						_this._markupFee = Number(res.markup_fee);
						_this._logisticsFee = Number(res.location.logistics);
						_this._truckloadFee = Number(res.location.truckload_surcharge);
						_this._wideFreightFee = Number(res.location.wide_freight);
						_this._fixedAmountFee = Number(res.fixed_amount_fee);
						_this._multiModuleBuildsFee = Number(
							res.location.multi_module_builds_surcharge,
						);
					}
					_this.setCookie(_this._cookiedValidate, `${zipCode}`);
					_this.disableLimitSizesByZone();
					const newWidth = helpers.getBaseWidth();
					const newDepth = helpers.getBaseDepth();
					const newHeight = helpers.getBaseHeight();
					if (
						newWidth !== currentWidth ||
						newDepth !== currentDepth ||
						newHeight !== currentHeight
					) {
						const newSizeLabel = helpers.getSizeLabel();
						let displayArea = zipCode;
						if (_this._isUseLocation) {
							displayArea = _this._elementValidate.find(`[value=${zipCode}]`).html();
						}
						_this._seadevShedBuilder.createAlert(
							`Resize to ${newSizeLabel['label']} because area <b>${displayArea}</b> does not have size ${oldSizeLabel['label']} option.`,
						);
					}
					$('#js-zip-code-submit').removeClass('loading');
					$('#js-wrap-zip-code-popup').hide();
				},
				error: function (xhr) {
					const dataLog = {
						type : 'Submit start building',
						headers: xhr.getAllResponseHeaders(),
						...dataPayLoad
					}
					if (xhr && (xhr.status === 0 || xhr.status == 0)) {
						helpers.writeLogForGetLocationSettings(
							`AJAX get location settings failed with status 0 to ${ajaxUrl}`,
							xhr,
							dataLog
						);
					} else {
						helpers.writeLogForGetLocationSettings(`AJAX get location settings failed with error`, xhr, dataLog);
						console.error('AJAX failed with error', xhr);
					}
				}
			});

			if (showError) {
				$('#js-zip-code-submit').removeClass('loading');
				$('#js-zip-code-continue').show();
				$('#js-zip-code-notice').show();
			} else {
				_this._isShowPrice = !(
					$('body.ssb-request-a-quote-mode').length > 0 &&
					$('body.show-price').length === 0
				);
				_this.handleShowPriceChangeZipcode(true);
				_this.handleZipcodeForSimplifyCheckout();
				if (!isGetDataZone) return;
				$('#js-wrap-zip-code-popup').hide();
				_el.removeClass('loading');
			}

			// Marketing trigger: submit zipcode
			window.dispatchEvent(
				new CustomEvent('submit-zipcode', {
					detail: {
						isValid: !showError,
						value: zipCode,
					},
				}),
			);
			// Marketing trigger: submit zipcode
			_this.refreshPriceShedDetails()
		});

		$('#js-zip-code-continue').on('click', function (e) {
			e.preventDefault();
			const currentZipCode = _this.getCookie(_this._cookiedValidate);
			if (!currentZipCode) {
				_this.setCookie(_this._cookiedValidate, _this._zipCodeContinue);
			}
			$('#js-wrap-zip-code-popup').hide();
		});

		$('#js-zip-code').on('input', function () {
			$('#js-zip-code-notice').hide();
			$('#js-model-not-allow').hide();
			$('#js-zip-code-continue').removeClass('active');
		});

		$('#js-wrap-zip-code-popup .close-popup').on('click', function () {
			$('#js-wrap-zip-code-popup').hide();
		});

		$('#replace-model-expired').on('click', async function (e) {
			e.preventDefault();
			const modelId = $(this).data('model');
			const currentUrl = new URL(window.location.href);
			const href = $(
				'#ssb-configurator-accordion-style ul.ssb-configurator-options li.active',
			).data('href');
			currentUrl.searchParams.set('model_id', modelId);

			if (-1 !== href.indexOf('?')) {
				const params = href.split('?')[1].split('&');
				for (let i = 0; i < params.length; i++) {
					const paramArray = params[i].split('=');
					if (paramArray.length === 2) {
						currentUrl.searchParams.set(paramArray[0], paramArray[1]);
					}
				}
			}

			window.location.href = currentUrl.href;
		});

		$('#change-zip-code').click(function () {
			$('#js-wrap-zip-code-popup').show();
			$('#js-zip-code-notice').hide();
			$('#js-model-not-allow').hide();
			$('#js-zip-code-continue').addClass('active');
			// _this.zipCodeEvent();
		});

		$('#see-monthly-payment .see-details').click(function () {
			_this._openingDialog = $('#dialog-monthly-payment');
			const title = _this._openingDialog.attr('title-dialog');
			_this.calculate_monthly_payment();
			$(_this._openingDialog).dialog({
				autoOpen: false,
				modal: true,
				title: title,
				closeText: '',
				dialogClass: 'ssb-monthly-payment-dialog ssb-component-dialog',
				resizable: false,
				close: function (event, ui) {
					_this.closeEditComponent();
				},
			});

			$('body').addClass('dialog-opened');
			$(_this._openingDialog).dialog('open');

			const heightDialog = $('.ssb-monthly-payment-dialog').height();
			const heightTitle = $('.ssb-monthly-payment-dialog .ui-dialog-titlebar').height();
			const heightMonthBox = $(
				'#dialog-monthly-payment .custom-number-month-select',
			).height();
			$('#dialog-monthly-payment .listing-financing-terms').css(
				'max-height',
				heightDialog - heightTitle - heightMonthBox - 50,
			);
		});

		
	};

	/**
	 * function validate zipcode
	 */
	isValidateZipcodeV2 = async (zipCode: any = false) => {
		const _this = this;
		if (false === zipCode) {
			zipCode = this.getCookie(this._cookiedValidate);
		}

		if (!zipCode || this._zipCodeContinue === zipCode) {
			return false;
		}

		const ajaxUrl = $('#js-zip-code-submit').data('ajax_url');
		const postID = $('#js-zip-code-submit').data('postid');
		const modelID = $('#js-shed-data [name="ssb-model-id"]').val();
		const dealerName = _this.getCookie('dealer');
		await $.ajax({
			url: ajaxUrl,
			dataType: 'JSON',
			method: 'POST',
			data: {
				action: 'validate_zipcode_submit',
				zipCode,
				modelID,
				postID,
				dealerName,
				urlModelId: _this.getUrlParameter('model_id'),
			},
		}).done(function (res) {
			if (!res.success) {
				return false;
			}
			_this._idRestrictionSize = res.restriction_id;
			_this._zoneID = res.zoneID;
			_this._sizesZone = res.sizes_zone;
			if (helpers.isEnableManufactureFeature()) {
				_this._lotID = res.lot_id;
				_this._discount = Number(res.location.discount);
				_this._markupFee = Number(res.markup_fee);
				_this._logisticsFee = Number(res.location.logistics);
				_this._truckloadFee = Number(res.location.truckload_surcharge);
				_this._wideFreightFee = Number(res.location.wide_freight);
				_this._fixedAmountFee = Number(res.fixed_amount_fee);
				_this._multiModuleBuildsFee = Number(res.location.multi_module_builds_surcharge);
			}
		});

		return true;
	};

	/**
	 * Function check zipcode valid
	 */
	getLocationSettingsDataByZipCode = async (zipCode) => {
		const _this = this;
		let isValidZipcode = false;
		const ssb_settings = <any>window;
		const ajaxUrl = ssb_settings.ssb.ajax_url;
		const modelID = $('#js-shed-data [name="ssb-model-id"').val();
		const dealerName = this.getCookie('dealer');
		const postID = $('#js-zip-code-submit').data('postid');
		const dataPayLoad = { 
			action: 'get_location_settings', 
			zipCode, 
			modelID, 
			dealerName,
			postID,
			urlModelId: _this.getUrlParameter('model_id'),
		};
		await $.ajax({
			url: ajaxUrl,
			dataType: 'JSON',
			method: 'POST',
			data: dataPayLoad,
			success: function (res) {
				if ( res.success) {
					isValidZipcode = true;
					_this._seadevShedBuilder._isValidZipcode = isValidZipcode;
					_this._idRestrictionSize = res.restriction_id;
					_this._zoneID = res.zoneID;
					_this._sizesZone = res.sizes_zone;
					_this.disableLimitSizesByZone();
					if (helpers.isEnableManufactureFeature()) {
						_this._lotID = res.lot_id;
						_this._discount = Number(res.location.discount);
						_this._markupFee = Number(res.markup_fee);
						_this._logisticsFee = Number(res.location.logistics);
						_this._truckloadFee = Number(res.location.truckload_surcharge);
						_this._wideFreightFee = Number(res.location.wide_freight);
						_this._fixedAmountFee = Number(res.fixed_amount_fee);
						_this._multiModuleBuildsFee = Number(res.location.multi_module_builds_surcharge);
					}
				}
			},
			error: function (xhr) {
				const dataLog = {
					type : 'First Load Validate',
					headers: xhr.getAllResponseHeaders(),
					...dataPayLoad
				}
				if (xhr && (xhr.status === 0 || xhr.status == 0)) {
					helpers.writeLogForGetLocationSettings(
						`AJAX get location settings failed with status 0 to ${ajaxUrl}`,
						xhr,
						dataLog
					);
				} else {
					helpers.writeLogForGetLocationSettings(`AJAX get location settings failed with error`, xhr, dataLog);
					console.error('AJAX failed with error', xhr);
				}
			}
		});

		return isValidZipcode;
	};

	renderCustomLineItem = () => {
		const canvasCustomItems = this._seadevShedBuilder._canvas.getAttribute('custom-items');
		const customItems =
			canvasCustomItems == 'null'
				? this.getCookie(
						window.location.hostname +
							'.productID-' +
							$('.woocommerce.single .single_add_to_cart_button').val(),
					)
				: canvasCustomItems;
		if (customItems && helpers.isValidBase64(customItems)) {
			let decodeCustomData = JSON.parse(window.atob(customItems));
			let _this = this;
			$.each(decodeCustomData, function (index, value) {
				_this.addCustomizeLineItem((Math.random() + 1).toString(36).substring(7), value);
			});
			this.shedDetailRenderCustomLineItem(decodeCustomData, false);
		}
	};

	/**
	 * Handle when submiting Zip Code
	 */
	handleZipCode = async () => {
		this._seadevShedBuilder.addLoadingAndStopRenderClasses('handleZipCode');
		const _this = this;
		let localCode = _this.getCookie(_this._cookiedValidate);
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const zipCode = urlParams.get('zipcode');
		const location = urlParams.get('location');
		const dataInUrl = _this._isUseLocation ? location : zipCode;
		let isValidZipCode = false;
		if (dataInUrl) {
			const isIframe = urlParams.get('iframe');
			const isEdit = urlParams.get('edit');
			if ('true' === isIframe && 'true' === isEdit) {
				_this.setCookie(_this._cookiedValidate, `${dataInUrl}`);
				isValidZipCode = true;
			} else {
				isValidZipCode = await _this.getLocationSettingsDataByZipCode(dataInUrl);
				if( isValidZipCode ) {
					_this.setCookie(_this._cookiedValidate, `${dataInUrl}`);
				}
			}
		} else if ( false !== localCode || (_this._isUseLocation && 1 === $('#js-select-location option').length)) {
			if (_this._isUseLocation && 1 === $('#js-select-location option').length) {
				localCode = $('#js-select-location option').eq(0).val();
			}
			isValidZipCode = await _this.getLocationSettingsDataByZipCode(localCode);
			if( isValidZipCode ) {
				_this.setCookie(_this._cookiedValidate, localCode);
			} else {
				_this.setCookie(_this._cookiedValidate, '');
			}
		}

		if (this.isEnableManufacturer() || this.isEnableZonePrice()) {
			if (isValidZipCode) {
				this._seadevShedBuilder._isValidZipcode = isValidZipCode;
				this.handleShowPriceChangeZipcode(true);
			} else {
				this._isShowPrice = false;
				this.handleShowPriceChangeZipcode(false);
			}
		} else {
			this._seadevShedBuilder._isValidZipcode = true;
			this.handleShowPriceChangeZipcode(true);
		}

		this.refreshPriceShedDetails();
		if( isValidZipCode ) {
			$('#js-wrap-zip-code-popup').hide();
		} else {
			$('#js-wrap-zip-code-popup').show();
		}

		window.dispatchEvent(
			new CustomEvent('re-init-select2-popup'),
		);
		_this.handleZipcodeForSimplifyCheckout();
		
		this._seadevShedBuilder.removeLoadingAndStopRenderClasses('handleZipCode');
	};

	/**
	 * Set cookie
	 *
	 * @param {string} key      Cookie key
	 * @param {string} value    Cookie value
	 */
	setCookie = (key: string, value: string) => {
		if (this._cookiedValidate === key) {
			if (!this._isUseLocation || '' !== value) {
				this._elementValidate.val(value).change();
			}
		}
		document.cookie = `${key}=${value};path=/`;
	};

	/**
	 * Get cookie by key
	 *
	 * @param {string} key Cookie key
	 * @returns {boolean|string}
	 */
	getCookie = (key) => {
		const cookieKey = `${key}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		let cookies = decodedCookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			let cookie = cookies[i];
			while (cookie.charAt(0) == ' ') {
				cookie = cookie.substring(1);
			}

			if (cookie.indexOf(cookieKey) == 0) {
				return cookie.substring(cookieKey.length, cookie.length);
			}
		}

		const queryString = window.location.search;
		if (key === this._cookiedValidate && -1 !== queryString.search('iframe=true')) {
			return this._elementValidate.val() as any;
		}

		return false;
	};

	handleUpdateRailing = () => {
		const status = this.isRailingEnable();
		this._isEnabledRailing = status;
		this._seadevShedBuilder.updateRailing(status);
		this.shedDetailRenderExterior();
		this.shedDetailRenderInterior();
		this.shedDetailRenderPorchData();
	};

	/**Generate Additional data */
	async generateAdditional() {
		const _this = this;
		let data: Object = {};
		let prices = _this._prices;
		const components = _this.getListComponents('exterior');
		const iComponents = _this.getListComponents('interior');
		const ssb_settings = <any>window;
		const elements = _this.pushOpeningToRightElements(
			_this.getShedDetailText(components, 'exterior'),
		);
		const IElements = _this.getShedDetailText(iComponents);
		const sizeElement = $('#ssb-configurator-size-area option:selected');
		const imageSides = ['perspective', 'front', 'back', 'left', 'right'];
		let images = [];
		let image: Object = {};

		const mainSide = $('.ssb-configurator-layout .ssb-option:checked').attr(
			'data-layout-main-side',
		);
		const baseWidth = helpers.getBaseWidth();
		const baseDepth = helpers.getBaseDepth();
		const basePrice = _this.getBasePrice();
		const thumbnails: string[] = await this.captureAllThumbnails(mainSide);

		for (let i = 0; i < imageSides.length; i++) {
			image = {
				key: imageSides[i],
				value: thumbnails[i],
				display_key: imageSides[i],
				display_value: imageSides[i],
			};

			images.push(image);
		}

		let element: HTMLElement = document.getElementsByName(
			'ssb-option-2d-floor-plan',
		)[0] as HTMLElement;
		element.click();
		image = {
			key: '2D Floor Plan',
			value: $('[name="ssb-option-2d-floor-plan"]').val(),
			display_key: '2D Floor Plan',
			display_value: '2D Floor Plan',
		};
		images.push(image);
		data['product_id'] = Number($('[name="add-to-cart"]').val());
		data['sku'] = $('[name="ssb-option-product-sku"]').val();
		data['description'] = $('.product_title').text();
		data['brand_id'] = _this._seadevShedBuilder._canvas.getAttribute('data-model-brand');
		data['style_id'] = $('[name="ssb-model-style"]').val();
		data['type'] = $('[name="ssb-option-api-type"]').val();
		data['category'] = $('[name="ssb-option-api-category"]').val();
		data['owner'] = $('[name="ssb-option-owner"]').val();
		data['model_type'] = $('[name="ssb-option-model-type"]').val();
		data['size_price'] = _this.getBasePrice();
		data['layout'] = $('[data-reflect="ssb-option-layout"]').text();
		data['model_year'] = new Date().getFullYear();
		data['quantity'] = 1;
		data['total'] = data['price'] = Number($('[name="ssb-shed-full-price"]').val()).toFixed(2);
		data['msrp_price'] = Number($('[name="ssb-model-msrp-price"]').val()).toFixed(2);
		data['siding_name'] = data['price'] = $('[name="ssb-option-siding-type"]').val();
		data['component_prices'] = prices;
		data['elements'] = elements;
		data['elements_interior'] = IElements;
		data['electrical_package'] = _this.getElectricalPackageData(false);
		data['images'] = images;
		data['show_price'] = Number(ssb_settings.ssb.viewer_show_price);
		data['rto_integrate'] = Number(ssb_settings.ssb.viewer_rto_integrate);
		data['network_url'] = ssb_settings.ssb.network_url;
		data['rton_client_id'] = ssb_settings.ssb.rton_client_id;
		data['trim_color'] = $('[name="ssb-option-trim-color"]').val();
		data['vent_color'] = $('[name="ssb-option-vent-color"]').val();
		data['base_color'] = $('[name="ssb-option-siding-color"]').val();
		data['roof_overhang_label'] = $('[name="ssb-configurator-upgrade-roof_overhang"]:checked')
			.closest('div')
			.find('label')
			.text();
		data['siding_trim'] = _this.shedDetailRenderSidingAndTrim();
		data['roof'] = _this.shedDetailRenderRoof();
		data['levelingFee'] = [];
		data['door_color'] = _this.getUpgradeType(components, 'door')
			? $('[name="ssb-option-door-color"]').val()
			: '';
		data['window_color'] =
			$('[name="ssb-option-has-windows"]').val() == 'true'
				? $('[name="ssb-option-windows-color"]').val()
				: '';
		data['shutter_color'] =
			$('[name="ssb-option-has-shutter"]').val() == 'true'
				? $('[name="ssb-option-shutter-color"]').val()
				: '';

		data['wall_color'] = $('[name="ssb-option-wall-color"]').val();
		data['wall_color_price'] = $('[name="ssb-option-wall-color-price"]').val();
		data['ceiling_color'] = $('[name="ssb-option-ceiling-color"]').val();
		data['ceiling_color_price'] = $('[name="ssb-option-ceiling-color-price"]').val();

		$('#foundation-options input:checked').each((i, v) => {
			if ($(v).attr('visible') == '1') {
				data['levelingFee'].push({
					name: $(v).data('title'),
					price: Number(sizeElement.attr(`${$(v).val()}`)),
					quantity: 1,
				});
			}
		});
		data['loft'] = null;
		if (
			$(`[name="ssb-configurator-upgrade-loft"]:checked`)[0] &&
			$(`[name="ssb-configurator-upgrade-loft"]:checked`).data('option-value') != 'none'
		) {
			data['loft'] = {
				display: $(`[name="ssb-configurator-upgrade-loft"]:checked`).data('option-value'),
				price: $(`[name="ssb-option-loft"]`).attr('final-price'),
			};
		}

		// Porch
		data['porch'] = null;
		const dataColorPorch = _this.getPorchDataColor();
		$(`[name="ssb-configurator-upgrade-porch"]:checked`).each((i, v) => {
			let label = $(v).data('option-value');
			let price = $(v).data('price');
			let priceType = $(v).data('price-type');
			let oPosition = _this._seadevShedBuilder.getOpeningPosition();
			let railingPrice = _this.calculateRailingPrice();

			if (_this._isEnabledRailing) {
				label =
					label +
					' - ' +
					oPosition.charAt(0).toUpperCase() +
					oPosition.slice(1) +
					` (With Railing)`;
			} else {
				label = label + ` (No Railing)`;
			}
			let endPrice =
				_this.calculatePriceByType(
					priceType,
					price,
					basePrice,
					baseWidth,
					baseDepth,
					false,
				) + railingPrice;
			data['porch'] = {
				name: label,
				price: endPrice,
				quantity: 1,
				size: $('input.ssb_porch:checked').data('porch-size'),
				post: dataColorPorch.post,
				deck: dataColorPorch.deck,
			};
		});
		if ('' !== dataColorPorch) {
			data['porch'] = {
				post: dataColorPorch.post,
				deck: dataColorPorch.deck,
			};
		}

		if (_this._seadevShedBuilder.isExternalPorch() && _this._isEnabledExternalPorch) {
			const porchSizeData = this._seadevShedBuilder.getPorchCustomSizeData();
			const details = porchSizeData
				? `Height: ${porchSizeData.height} ft, Roof Pitch: ${porchSizeData.roof_pitch}/12`
				: '';
			const label = this.getExternalPorchLabel();
			const porchElement = $('[name="ssb-configurator-upgrade-external-porch"]');
			const price = porchElement.data('price');
			const priceType = porchElement.data('price-type');
			let endPrice = Number(
				this.calculatePriceByType(priceType, price, basePrice, baseWidth, baseDepth, false),
			);
			endPrice = isNaN(endPrice) ? 0 : endPrice;
			endPrice += _this.calculateRailingPrice();
			data['porch'] = {
				name: label,
				price: endPrice,
				quantity: 1,
				details,
				size: $('input.ssb_porch:checked').data('porch-size'),
			};
		}
		// Porch

		if (this._seadevShedBuilder.isCarport()) {
			data['carport_siding_data'] = _this.getCarportSidingData();

			if ($(`[name="ssb-configurator-upgrade-legs_setting"]:checked`).length) {
				const legsPrice = $(`[name="ssb-configurator-upgrade-legs_setting"]:checked`).data(
					'price',
				);
				const legsPriceType = $(
					`[name="ssb-configurator-upgrade-legs_setting"]:checked`,
				).data('price-type');
				data['legs'] = {
					name: $(`[name="ssb-configurator-upgrade-legs_setting"]:checked`).data(
						'option-value',
					),
					price: this.calculatePriceByType(
						legsPriceType,
						legsPrice,
						basePrice,
						baseWidth,
						baseDepth,
						false,
					),
				};
			}

			if ($(`[name="ssb-configurator-upgrade-frame_spacing"]:checked`).length) {
				const framePrice = $(
					`[name="ssb-configurator-upgrade-frame_spacing"]:checked`,
				).data('price');
				const framePriceType = $(
					`[name="ssb-configurator-upgrade-frame_spacing"]:checked`,
				).data('price-type');
				data['frame_spacing'] = {
					name: $(`[name="ssb-configurator-upgrade-frame_spacing"]:checked`).data(
						'option-value',
					),
					price: this.calculatePriceByType(
						framePriceType,
						framePrice,
						basePrice,
						baseWidth,
						baseDepth,
						false,
					),
				};
			}
		}
		if (1 == ssb_settings.ssb.viewer_enable_shedpro_rto) {
			data['ops_hub'] = await this.getOpsHubData();
		}

		await this.handleDataInputHide();
		data['hidden_field'] = [];
		$('#js-shed-data input').each((i, v) => {
			const field = $(v);
			let name = field.attr('name').split('-').join('_');
			let val;
			switch (name) {
				case 'ssb_option_roof_material_price':
					val = _this._isShowUpgradeChargeInfo ? _this.getRoofMaterialPrice() : 0;
					break;
				case 'ssb_option_upgrade_porch':
					val = _this._isEnabledExternalPorch
						? _this.getPackagesOption(
								'[name="ssb-configurator-upgrade-external-porch"]:checked',
							)
						: _this.getPackagesOption(
								'[name="ssb-configurator-upgrade-porch"]:checked',
							);
					break;
				case 'ssb_option_porch_size':
					val = $('[name="ssb-configurator-upgrade-porch"]:checked').attr(
						'data-porch-size',
					);
					break;
				case 'ssb_option_loft':
					val = _this.getPackagesOption(
						'[name="ssb-configurator-upgrade-loft"]:checked',
						true,
					);
					break;
				case 'ssb_option_roof_overhang':
					val = _this.getPackagesOption(
						'[name="ssb-configurator-upgrade-roof_overhang"]:checked',
						true,
					);
					break;
				case 'ssb_option_legs':
					val = _this.getPackagesOption(
						'[name="ssb-configurator-upgrade-legs_setting"]:checked',
					);
					break;
				case 'ssb_option_frame_spacing':
					val = _this.getPackagesOption(
						'[name="ssb-configurator-upgrade-frame_spacing"]:checked',
					);
					break;
				case 'ssb_option_components':
					val = _this.getComponentForCart(components);
					break;
				case 'ssb_option_components_interior':
					val = _this.getComponentForCart(iComponents, 'interior');
					break;
				case 'ssb_option_roof_pitch':
					val = _this.getRoofPitchData();
					break;
				case 'ssb_option_electrical_package':
					val = _this.getElectricalPackageData();
					break;
				case 'ssb_option_upgrade_package':
					val = _this.getPackagesOption(
						'[name="ssb-configurator-upgrade-package"]:checked',
						true,
					);
					break;
				case 'ssb_option_upgrade_other':
					val = helpers.mergeAndEncodeUpcharges(
						_this.getCustomUpcharge(),
						_this.getPackagesOption(
							'[data-option-key="ssb-option-upgrade-other"]:checked',
							true,
						),
					);
					break;
				case 'ssb_option_carport_siding_data':
					val = window.btoa(JSON.stringify(_this.getCarportSidingData()));
					break;
				case 'ssb_option_shed_color':
					val = _this.getShedColor();
					break;
				case 'ssb_option_wainscoting':
					val = _this.getWainscotingData();
					break;
				case 'ssb_option_exterior_siding_upgrades':
					val = _this.getExteriorSidingUpgradesData();
					break;
				case 'ssb_option_frame':
					val = _this.getFrameData();
					break;
				case 'ssb_option_floor_material':
					val = _this.getFloorMaterialData();
					break;
				case 'ssb_option_custom_line_items':
					val = _this.getDataCustomLineItems();
					break;
				case 'other_line_items':
					val = _this.getDataCustomFees(true);
					break;
				case 'ssb_option_layout_charge_price':
					val = _this.getLayoutCharge();
					break;
				case 'ssb_option_base_price':
					val = _this.getBasePrice();
					break;
				case 'ssb_option_default_base_price':
					val = _this.getBasePrice(true);
					break;
				case 'ssb_option_mfr_fees':
					val = _this.getManufacturerFees();
					break;
				case 'ssb_option_credit':
					val = window.btoa(JSON.stringify(_this.getCreditItem()));
					break;
				case 'ssb_option_finishing_interior':
					val = _this.getDataInteriorWall('finishing_interior');
					val = val.length > 0 ? window.btoa(JSON.stringify(val)) : '';
					break;
				case 'ssb_option_insulation_interior':
					val = _this.getDataInteriorWall('insulation_interior');
					val = val.length > 0 ? window.btoa(JSON.stringify(val)) : '';
					break;
				default:
					val = field.val();
			}

			if (name !== 'ssb_option_2d_floor_plan')
				data['hidden_field'].push({
					[name]: val,
				});
		});
		return data;
	}

	getOpsHubData = async () => {
		const ssb_settings = <any>window;
		const model_id = ssb_settings.ssb.model_id;
		const zipCode = this.getCookie(this._cookiedValidate);
		const { width, depth } = this.getSizes();
		const sidingType = (
			document.querySelector(
				'#js-shed-data input[name="ssb-option-siding-type"]',
			) as HTMLInputElement
		)?.value;
		try {
			const response = await fetch(ssb_settings.ssb.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'add_ops_hub_data_for_viewer',
					model_id: model_id,
					zipCode: zipCode,
					sidingType: sidingType,
					width: width.toString(),
					length: depth.toString(),
				}),
			});
			if (!response.ok) {
				throw new Error(`HTTP Error! Status: ${response.status}`);
			}
			const dataApiResponse = await response.json();
			if (dataApiResponse.success) {
				return dataApiResponse.data;
			} else {
				return {};
			}
		} catch (error) {
			console.error(error);
		} 
	}

	/**Viewer */
	handleSendFromParent = () => {
		const _this = this;
		window.addEventListener('message', async function (e) {
			// Called from the iframe
			if (typeof e === 'object' && e.data[0] === '{') {
				let data = JSON.parse(e.data);
				if (data.action === 'save') {
					window.dispatchEvent(new CustomEvent('update-accordion-status'));
					const additionalData = await _this.generateAdditional();
					const foundItem = additionalData['hidden_field'].find((item) =>
						item.hasOwnProperty('ssb_shed_url'),
					);
					const productUrl = document.querySelector('form.cart').getAttribute('action');
					const shareableLink = foundItem
						? productUrl + '?share=' + foundItem.ssb_shed_url
						: null;
					const hash = _this._base64Data;
					const message = {
						source: 'shedpro',
						message: hash,
						additionalData: additionalData,
						url: shareableLink,
						full_url: shareableLink,
					};
					window.parent.postMessage(message, '*');
				}
			}
		});
	};
	/**Viewer */

	isValidZipCode = (zipCode: any = false) => {
		const _this = this;

		if (false === zipCode) {
			zipCode = this.getCookie(this._cookiedValidate);
		}

		if (!zipCode || this._zipCodeContinue === zipCode) {
			return false;
		}

		let zipCodes = $('#js-zip-codes').val() as any;

		zipCodes = JSON.parse(zipCodes);
		for (let i = 0; i < zipCodes.length; i++) {
			let codes = JSON.parse(zipCodes[i].target_areas).map((c) => c.trim());
			if ('' !== zipCode && -1 !== codes.indexOf(zipCode)) {
				_this._discount = Number(zipCodes[i].discount);
				_this._markupFee = Number(zipCodes[i].markup_fee);
				_this._logisticsFee = Number(zipCodes[i].logistics_fee);
				_this._truckloadFee = Number(zipCodes[i].truckload_fee);
				_this._wideFreightFee = Number(zipCodes[i].wide_freight_fee);
				_this._fixedAmountFee = Number(zipCodes[i].fixed_amount_fee);
				_this._multiModuleBuildsFee = Number(zipCodes[i].multi_module_builds_fee);
				_this._seadevShedBuilder._isValidZipcode = true;

				return true;
			}
		}

		return false;
	};

	/**
	 * Check valid Zipcode 3D Standard Feature Zone Price
	 */
	isValidZipCodeZonePrice = (zipCode: any = false) => {
		const _this = this;

		if (false === zipCode) {
			zipCode = this.getCookie(this._cookiedValidate);
		}

		if (!zipCode || this._zipCodeContinue === zipCode) {
			return false;
		}

		let zipCodes = $('#js-zip-codes').val() as any;

		zipCodes = zipCodes.split('\n');

		if ('' !== zipCode && -1 !== zipCodes.indexOf(zipCode)) {
			return true;
		}

		return false;
	};

	isEnableManufacturer = () => {
		this._seadevShedBuilder._isManufacturer =
			this._seadevShedBuilder._canvas.getAttribute('data-enable-manufacturer') === 'true';

		return this._seadevShedBuilder._isManufacturer;
	};

	isEnableDealerParams = () => {
		return $('body').hasClass('enable-dealer-params');
	};

	isEnableZonePrice = () => {
		return $('body').hasClass('enable-zone-price');
	};

	isShowNetPrice = () => {
		return this._seadevShedBuilder._canvas.getAttribute('data-show-net-price') === 'true';
	};

	handleDisableButtonAddToCart() {
		if (!this._seadevShedBuilder.isEnableAddToCartButton()) {
			$(
				'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
			).prop('disabled', true);
			$(
				'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
			).addClass('is_disabled');
		} else {
			$(
				'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
			).prop('disabled', false);
			$(
				'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
			).removeClass('is_disabled');
		}
	}

	handleShowPriceChangeZipcode = (show) => {
		const _this = this;
		const zipCode = _this.getCookie(_this._cookiedValidate);
		$('#change-zip-code').find('.current-zipcode').remove();
		if (zipCode) {
			if (_this._isUseLocation) {
				if (_this._elementValidate.find(`[value=${zipCode}]`).length) {
					const location = _this._elementValidate.find(`[value=${zipCode}]`).html();
					$('#change-zip-code').append(
						`<span class="current-zipcode">(${location})</span>`,
					);
				}
			} else {
				$('#change-zip-code').append(`<span class="current-zipcode">(${zipCode})</span>`);
			}
		}
		if (show) {
			if ($('body').hasClass('show-price')) {
				$('.woocommerce .summary .wrap-title-price .price').show();
				$('.woocommerce .summary .wrap-title-price .net-price').show();
				// jQuery('.show-admin-price-wrap').show();
			} else {
				$('.woocommerce .summary .wrap-title-price .price').hide();
				$('.woocommerce .summary .wrap-title-price .net-price').hide();
			}
			$('.woocommerce .summary .wrap-title-price .notice').hide();
			// $('.woocommerce .summary .wrap-title-price .change-zip-code').hide();
			$(
				'.ssb-shed-product-single.woocommerce-page #content div.product div.summary',
			).removeClass('custom-top');
			_this.handleDisableButtonAddToCart();
		} else {
			$('.woocommerce .summary .wrap-title-price .price').hide();
			$('.woocommerce .summary .wrap-title-price .net-price').hide();
			$('.woocommerce .summary .wrap-title-price .notice').show();
			$('.woocommerce .summary .wrap-title-price .change-zip-code').show();
			$(
				'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
			).prop('disabled', true);
			$(
				'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
			).addClass('is_disabled');
			$(
				'.ssb-shed-product-single.woocommerce-page #content div.product div.summary',
			).addClass('custom-top');
		}

		window.dispatchEvent(new CustomEvent('show-price-change-zipcode'));
	};

	refreshPriceShedDetails = () => {
		this.shedDetailRenderSize();
		this.shedDetailRenderLayout();
		this.shedDetailRenderExterior();
		this.shedDetailRenderInterior();
		this.shedDetailRenderSidingAndTrim();
		this.shedDetailUpdatePriceMaterialColor();
		this.shedDetailRenderRoof();
		this.shedDetailStructureRenderColor();
		this.shedDetailRenderPorchData();
		this.updatePrice();
		this.handleShowSeeMonthlyPayment();
	}

	handleZipcodeForSimplifyCheckout() {
		if ($('.popup-billing-fields')[0]) {
			const ssb_settings = <any>window;
			let _this = this;
			let locationName = '';
			let locationID = '';
			let zipCode: any = _this._elementValidate.val()
				? _this._elementValidate.val()
				: _this.getCookie(_this._cookiedValidate);
			let checkoutZipCode = $('#billing_postcode');
			let officeName = $('#ssb_order_office_to_contact_name');
			let officeID = $('#ssb_order_office_to_contact_id');
			let locations_html: any = $('#popup-locations').val();
			let locations: any = JSON.parse(locations_html);
			if (!_this._isUseLocation && zipCode && 'continue' !== zipCode) {
				checkoutZipCode.val(zipCode);
			}
			// if ( officeName[0] && officeID[0] && ssb_settings.ssb.dealer_in_param == false && zipCode ) {
			if ((officeName[0] || officeID[0]) && zipCode && 'object' === typeof locations) {
				let foundZipCode = false;
				for (let i = 0; i < locations.length; i++) {
					if (!_this._isUseLocation) {
						if (locations[i].target !== null) {
							locations[i].target.forEach((item) => {
								if (item.replaceAll(/\s/g, '') === zipCode.replaceAll(/\s/g, '')) {
									locationName = locations[i].location;
									locationID = locations[i].id;
									foundZipCode = true;
								}
							});
							if (foundZipCode) break;
						}
					} else if (locations[i].id == zipCode) {
						locationName = locations[i].location;
						locationID = locations[i].id;
					}
				}
				officeName.val(locationName);
				officeID.val(locationID);
				if (officeID.hasClass('select')) {
					window.dispatchEvent(
						new CustomEvent('re-init-select2', { detail: locationID }),
					);
				}
			}
		}
	}

	handleShowSeeMonthlyPayment() {
		const _this = this;
		if ($('#js-zip-code-submit').hasClass('zone-price') || _this.isEnableManufacturer()) {
			if (_this._seadevShedBuilder._isValidZipcode) {
				$('#see-monthly-payment').show();
			}
		} else {
			$('#see-monthly-payment').show();
		}
		let event = new CustomEvent('calculate-height');
		window.dispatchEvent(event);
	}
	calculate_monthly_payment() {
		const _this = this;
		const element = $('.select-items-month .item.selected-item');
		const type = element.attr('type');
		const financing = element.attr('custom-value');
		const total_price = Number($('[name="ssb-shed-full-price"]').val());
		$('.listing-financing-terms .financing').hide();
		$(`.listing-financing-terms .financing[data-partner="${financing}"] tr`).each(
			function (index, item) {
				const divisor = Number($(item).attr('data-value'));
				let price = '';
				if (type === 'divisor') {
					price = helpers.renderPrice(total_price / divisor);
				} else {
					price = helpers.renderPrice(total_price * divisor);
				}
				$(item)
					.find('.price-month')
					.text(price + '/month');
			},
		);
		$(`.listing-financing-terms .financing[data-partner="${financing}"]`).show();
	}

	updateMonthlyPaymentRTO() {
		const _this = this;
		let value = 0;
		let count = 0;
		const total_price = Number($('[name="ssb-shed-full-price"]').val());
		$('.listing-financing-terms .financing').hide();
		$('.select-items-month .item').each(function (i, e) {
			const type = $(e).attr('type');
			const financing = $(e).attr('custom-value');
			$(`.listing-financing-terms .financing[data-partner="${financing}"] tr`).each(
				function (index, item) {
					const divisor = Number($(item).attr('data-value'));
					let price = 0;
					if (type === 'divisor') {
						price = total_price / divisor;
					} else {
						price = total_price * divisor;
					}

					if (count == 0) {
						value = price;
					} else {
						value = price < value ? price : value;
					}
					count++;
				},
			);
		});

		$('#see-monthly-payment #amount-monthly-payment').text(helpers.renderPrice(value));
	}

	handleFoundation = () => {
		const _this = this;
		$('#foundation-options input').change((e) => {
			const sizeElement = $('#ssb-configurator-size-area option:selected');
			const isLevelingFee = $(e.target).data('leveling-fee');
			const leveling_fee = $('#leveling_fee');
			const isDefaultChecked = leveling_fee.data('checked');

			if (isLevelingFee) {
				if ($('#gravel_pad').is(':checked')) {
					leveling_fee.prop('checked', false);
					leveling_fee.prop('disabled', true);
				} else {
					leveling_fee.prop('disabled', false);
					if (isDefaultChecked) {
						leveling_fee.prop('disabled', true);
						leveling_fee.prop('checked', true);
					}
				}
			} else if ($(e.target).is(':checked')) {
				$(e.target).attr('data-price', Number(sizeElement.attr(`${$(e.target).val()}`)));
			} else {
				$(e.target).attr('data-price', 0);
			}

			let foundation = [];
			$('#foundation-options input:checked').each((idx, elm) => {
				const visible = $(elm).attr('visible') == '1';
				$(elm).attr('data-price', Number(sizeElement.attr(`${$(elm).val()}`)));
				foundation.push({
					name: $(elm).data('title'),
					price: Number(sizeElement.attr(`${$(elm).val()}`)),
					quantity: 1,
					visible,
				});
			});

			$('#js-shed-data input[name="ssb-foundation-fee"]').val(
				window.btoa(JSON.stringify(foundation)),
			);

			_this.updatePrice();
			_this.shedDetailRenderInterior();
		});

		$(document).ready(function () {
			$('#foundation-options input').trigger('change');
		});
	};

	async renderModelCanvas() {
		this._seadevShedBuilder.addLoadingAndStopRenderClasses('renderModelCanvas');
		let geoData = this._shareLinkData
			? JSON.parse(window.atob(this._shareLinkData)).geoData
			: null;
		let geoDataCookie = this.getCookie(this._cookiedValidate);
		if (this._shareLinkId) {
			$('#js-wrap-zip-code-popup').hide();
			const data = await this.getSharebleLinkDataById(this._shareLinkId);
			if (data) {
				this._shareLinkData = data.base64Data || null;
				geoData = JSON.parse(window.atob(this._shareLinkData)).geoData;
			}
		}

		const results = await this._seadevShedBuilder.initModel();
		this._seadevShedBuilder.handleHideInnerObject();
		for (let i = 0; i < results.length; i++) {
			if (!results[i]) {
				return;
			}
		}

		this.loadSidingForCache();
		this.handleChangeExternalPorch();
		this.handleSidingMaterialChange();
		this.handleAddOnSidingMaterialChange('wainscoting');
		this.handleAddOnSidingMaterialChange('accent_gable');
		this.handleAddOnSidingMaterialChange('exterior_siding_upgrades');
		this.handleRoofMaterialChange();
		this.handleFloorMaterialChange();
		this.handleMaterialInteriorChange('interior_wall');
		this.handleMaterialInteriorChange('interior_ceiling');
		this.handleMaterialInteriorChange('insulation_wall');
		this.handleMaterialInteriorChange('insulation_roof');
		this.handleColorChange('group-siding-color', 'ssb-option-siding-color');
		this.handleColorChange('group-trim-color', 'ssb-option-trim-color');
		this.handleColorChange('group-roof-color', 'ssb-option-roof-color');
		this.handleColorChange('group-shutter-color', 'ssb-option-shutter-color');
		this.handleColorChange('group-door-color', 'ssb-option-door-color');
		this.handleColorChange('group-vent-color', 'ssb-option-vent-color');
		this.handleColorChange('group-windows-color', 'ssb-option-windows-color');
		this.handleColorChange('group-wainscoting-color', 'ssb-option-wainscoting-color');
		this.handleColorChange('group-accent_gable-color', 'ssb-option-accent_gable-color');
		this.handleColorChange(
			'group-exterior_siding_upgrades-color',
			'ssb-option-exterior_siding_upgrades-color',
		);
		this.handleColorChange('group-rails-color', 'ssb-option-rails-color');
		this.handleColorChange('group-countertops-color', 'ssb-option-countertops-color');
		this.handleColorChange('group-wall-color', 'ssb-option-wall-color');
		this.handleColorChange('group-ceiling-color', 'ssb-option-ceiling-color');
		this.handleColorChange('group-appliance-color', 'ssb-option-appliance-color');
		this.handleChangeFrame();
		this.initLayout();
		this.handleActiveDefaultWainscoting();

		var queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const zipCode = urlParams.get('zipcode');
		const location = urlParams.get('location');
		if (!zipCode && !location) {
			if (geoData) {
				this.setCookie(this._cookiedValidate, `${geoData}`);
				this.handleGeoData(geoData);
			}
			if (!geoData && !geoDataCookie) {
				$('#js-wrap-zip-code-popup').show();
			}
		}

		this._seadevShedBuilder.removeLoadingAndStopRenderClasses('renderModelCanvas');
	}

	async initLayout() {
		if (this._shareLinkData) {
			this._seadevShedBuilder._isShareLink = true;
			const isGenerateShedModel = await this.generateShedModel(this._shareLinkData);
			if (isGenerateShedModel && this._seadevShedBuilder.isEnableAddToCartButton()) {
				$(
					'.woocommerce.single .single_add_to_cart_button, .woocommerce.single .group-button, .ssb-mobile-button-request-a-quote',
				).prop('disabled', false);
				// jQuery('.show-admin-price-wrap').show();
			}
		} else {
			this.handleLayoutChange(false);

			const { width, depth, height } = this.getSizes();

			this._seadevShedBuilder.setWidth(width);
			this._seadevShedBuilder.setDepth(depth);
			this._seadevShedBuilder.setWallHeight(height);
		}
	}

	updateLayout = (
		layoutId,
		layoutLabel,
		limitWidth,
		limitDepth,
		limitHeight,
		components,
		packages: any = '',
	) => {
		const oldSize = this.getSizes();
		this._seadevShedBuilder.addLoadingAndStopRenderClasses('updateLayout');
		this._isChangeLayout = true;
		this._seadevShedBuilder._isUpdateLayout = this._seadevShedBuilder._isShareLink;
		this._seadevShedBuilder._doorFixedTarget = [];
		$('#js-shed-data input[name="ssb-option-layout"]').val(layoutLabel);
		$('#js-shed-data input[name="ssb-option-layout"]').attr('data-key', layoutId);
		$(`#ssb-configurator-accordion-layouts .ssb-configurator-selected`).text(layoutLabel);
		this._seadevShedBuilder.handleUpdateTackRoom();
		this._seadevShedBuilder.updateCameraPosition();
		this._seadevShedBuilder.setLayoutComponents({});
		this.disableLimitSizes(limitWidth, limitDepth, limitHeight, oldSize);
		this._seadevShedBuilder.animateElectricalPackageChange('none', []);
		this.shedDetailRenderLayout(layoutLabel);
		this.removeUnavailableLayoutComponents(JSON.parse(components));
		jQuery('[name="ssb-configurator-electrical-packages"][data-package-id="none"]')
			.prop('checked', true)
			.trigger('change');
		if ($('.group-upgrade-electrical_packages')[0]) {
			$('.wrap-electric').hide();
		} else {
			$('.wrap-electric').show();
		}
		this._seadevShedBuilder.animateLayoutChange(layoutId, components).then(async (data) => {
			if (packages !== '') {
				packages.forEach((element) => {
					$(
						`[name="ssb-configurator-electrical-packages"][data-package-id="${element.id}"]`,
					)
						.prop('checked', true)
						.trigger('change');
				});
			}
			this.updatePrice();
			$(`#ssb-configurator-layout-option input[name='ssb-configurator-layout']`).prop(
				'disabled',
				false,
			);

			this._seadevShedBuilder.removeLoadingAndStopRenderClasses('updateLayout');
		});
	};

	handleLayoutChange = (isShareLink) => {
		this._currentLayoutID = $(`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`).attr('data-layout-id');

		const _this = this;
		if (!isShareLink) {
			const defaultLayout = $(
				`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
			);
			const {
				layoutId,
				layoutLabel,
				limitWidth,
				limitDepth,
				limitHeight,
				components,
				packages,
			} = _this.getLayoutData(defaultLayout);
			$(`#ssb-configurator-layout-option input[name='ssb-configurator-layout']`).prop(
				'disabled',
				true,
			);
			_this._seadevShedBuilder._isLayoutBlock =
				'1' === defaultLayout.attr('data-layout-block');
			_this._seadevShedBuilder._isLayoutBlockAdding =
				'1' === defaultLayout.attr('data-layout-block-adding');
			_this.updateLayout(
				layoutId,
				layoutLabel,
				limitWidth,
				limitDepth,
				limitHeight,
				components,
				packages,
			);
			_this.handleShowHideButtonAddComponent();
		}

		//Show popup when click to change layout
		$(`#ssb-configurator-layout-option input[name='ssb-configurator-layout']`).change((e) => {
			// Get the current base dimensions of the model
			const height = helpers.getBaseHeight();
			const width = helpers.getBaseWidth();
			const depth = helpers.getBaseDepth();

			// Get the layout data based on the current selected target (e.g., a layout option clicked by the user)
			const layoutData = _this.getLayoutData($(e.currentTarget));
			const { limitWidth, limitDepth, limitHeight } = layoutData;

			// Get the list of sizes from model settings
			const sizes = this._seadevShedBuilder.getSettingData('sizes', 'model');

			// Get restricted size IDs
			const idRestrictionSize = this._seadevShedBuilder.getSettingData(
				'idRestrictionSize',
				'model',
			);

			// Determine if size filtering should consider zone restrictions
			const shouldFilterByZone =
				this._seadevShedBuilder._isUseRestrictSize &&
				this._seadevShedBuilder._isValidZipcode &&
				idRestrictionSize;

			// Prepare data for filtering valid sizes
			const validSizesData = {
				limitWidth,
				limitDepth,
				limitHeight,
				height,
				sizes,
				shouldFilterByZone,
				idRestrictionSize,
			};

			// Filter valid sizes based on limits, height, and zoning restrictions & 
			const validSizes = this.getValidSizes(validSizesData);

			// Check current size will fit into target layout or not.
			let isValid = false;
			for (let i = 0; i < validSizes.length; i++) {
				const size = validSizes[i];

				if (size.width == width && size.depth == depth && size.height == height) {
					isValid = true;
				}
			}

			// Define the actions available in the confirmation dialog & the message
			const act = [
				{ key: 'layout-cancel', label: 'Cancel' },
				{ key: 'layout-proceed', label: 'Proceed' },
			];
			const oldSizeLabel = helpers.getSizeLabel(
				$('.ssb-option.size-area').children('option:selected'),
				this._seadevShedBuilder._wallHeight,
			);
			const newSizeLabel = helpers.getSizeLabel(
				$('#ssb-configurator-size-area').children(
					`option[data-size-width="${validSizes[0].width}"][data-size-depth="${validSizes[0].depth}"]`,
				),
				validSizes[0].height,
			);
			const validMessage = `Components maybe changed upon layout switching. Proceed?`;
			const inValidMessage = `Size <strong>${oldSizeLabel['label']}</strong> is not available in the new layout. Switching layout will resize the building to the nearest size <strong>${newSizeLabel['label']}</strong>. Proceed?`;
			const msg = isValid ? validMessage : inValidMessage;

			// Show confirmation dialog to user
			_this.createDialog(msg, act, layoutData);
		});

		$(document).on('click', '.action-layout-proceed', e => {
			_this.removeDialog();
			const data = $(e.currentTarget).attr('data');
			const dataObj = JSON.parse(window.atob(data));
			const {
				layoutId,
				layoutLabel,
				limitWidth,
				limitDepth,
				limitHeight,
				components,
				packages, 
			} = dataObj;

			_this._currentLayoutID = layoutId;

			$(`#ssb-configurator-layout-option input[name='ssb-configurator-layout']`).prop(
				'disabled',
				true,
			);
			_this._seadevShedBuilder._isLayoutBlock =
				'1' === $(e.currentTarget).attr('data-layout-block');
			_this._seadevShedBuilder._isLayoutBlockAdding =
				'1' === $(e.currentTarget).attr('data-layout-block-adding');
			_this.updateLayout(
				layoutId,
				layoutLabel,
				limitWidth,
				limitDepth,
				limitHeight,
				components,
				packages,
			);
			_this.handleShowHideButtonAddComponent();
		})

		$(document).on('click', '.action-layout-cancel', () => {
			$(`[data-layout-id=${this._currentLayoutID}]`).prop('checked', true);
			_this.removeDialog();
		});		
	};

	handleShowHideButtonAddComponent = () => {
		const buttonAdd = $('.ssb-configurator-panel.exterior .add-component');
		if (this._seadevShedBuilder._isLayoutBlockAdding) {
			buttonAdd.hide();
		} else {
			buttonAdd.show();
		}
	};

	handleChangeSidesEnds = () => {
		const _this = this;

		_this.handleJTrimShowHide();

		$(document).on('change', '.sides-ends-area', function (e) {
			const value = Number($(this).find(':selected').attr('data-wall-height'));
			const side = $(this).find(':selected').attr('data-side');
			const gableEnd = $(this).find(':selected').attr('data-gable-end');
			const measurementTypes = $(this).find(':selected').attr('data-measurement-types');
			if (!_this._seadevShedBuilder.isFullEnclosedWall(side)) {
				_this._seadevShedBuilder.deleteAllComponentsBySide(side);
			}

			_this.carportUpdateSidingInfo();
			_this.handleJTrimShowHide();
			_this._seadevShedBuilder.cloneSidingForCarport(side, value, gableEnd, measurementTypes);
			_this.shedDetailRenderSidingAndTrim();
			const jTrimData = $('.group-j-trim .radio:checked').val();
			_this._seadevShedBuilder.handleJTrimChange(jTrimData);
			_this.updatePrice();
			_this.shedDetailRenderExterior();
		});

		$(document).on('change', '.group-j-trim .radio', function (e) {
			const data = $(this).val();
			_this._seadevShedBuilder.handleJTrimChange(data);
			_this.shedDetailRenderSidingAndTrim();
		});
	};

	isEnableJTrim = () => {
		return $('#js-enable-j-trim').data('is-enable-j-trim') == '1';
	};

	isEnableJTrimOptionGable = (classSide) => {
		let isEnable = false;
		const wallHeight = this._seadevShedBuilder.getWallHeight();
		const gableOption = $(`.${classSide}`).find('option:selected').data('gable-end');
		if (
			'fully_enclosed' === gableOption ||
			'left_side_gable' === gableOption ||
			'right_side_gable' === gableOption
		) {
			isEnable = true;
		} else if (
			'extended_top_gable' === gableOption ||
			'left_side' === gableOption ||
			'right_side' === gableOption
		) {
			const wallOption = Number(
				$(`.${classSide}`).find('option:selected').data('wall-height'),
			);
			const measurementTypes = $(`.${classSide}`)
				.find('option:selected')
				.data('measurement-types');
			if ('ft' === measurementTypes && wallOption < wallHeight && 0 !== wallOption) {
				isEnable = true;
			} else if ('percent' === measurementTypes && wallOption < 100 && 0 !== wallOption) {
				isEnable = true;
			}
		}

		return isEnable;
	};

	isEnableJTrimOptionSide = (classSide) => {
		let isEnable = false;
		const wallHeight =
			'left-sidewall' === classSide &&
			'carport_lean_to_standalone' === this._seadevShedBuilder._shedType
				? this._seadevShedBuilder.getBuildingHeight()
				: this._seadevShedBuilder.getWallHeight();
		const wallOption = Number($(`.${classSide}`).find('option:selected').data('wall-height'));
		const measurementTypes = $(`.${classSide}`)
			.find('option:selected')
			.data('measurement-types');
		if ('ft' === measurementTypes && wallOption < wallHeight && 0 !== wallOption) {
			isEnable = true;
		} else if ('percent' === measurementTypes && wallOption < 100 && 0 !== wallOption) {
			isEnable = true;
		}

		return isEnable;
	};

	handleJTrimShowHide() {
		if (!this.isEnableJTrim()) {
			return;
		}

		let show = [];
		const j_trim = $('.group-j-trim .radio:checked').val();
		const isEnableFront = this.isEnableJTrimOptionGable('front-gable-end');
		const isEnableBack = this.isEnableJTrimOptionGable('back-gable-end');
		const isEnableLeft = this.isEnableJTrimOptionSide('left-sidewall');
		const isEnableRight = this.isEnableJTrimOptionSide('right-sidewall');

		if ((isEnableFront || isEnableBack) && (isEnableLeft || isEnableRight)) {
			show = ['none', 'sides-ends', 'sides', 'ends'];
		} else if (isEnableLeft || isEnableRight) {
			show = ['none', 'sides'];
		} else if (isEnableFront || isEnableBack) {
			show = ['none', 'ends'];
		}

		if (show.length > 0) {
			if (-1 === show.indexOf(j_trim)) {
				$('#ssb-configurator-upgrade-j_trim-none').prop('checked', true);
				this._seadevShedBuilder.handleJTrimChange('none');
			}

			$('.group-j-trim').show();
			$('.group-j-trim .wrap-item').hide();

			show.forEach((k) => {
				$(`.group-j-trim .wrap-${k}`).show();
			});
		} else {
			$('#ssb-configurator-upgrade-j_trim-none').prop('checked', true);
			this._seadevShedBuilder.handleJTrimChange('none');
			$('.group-j-trim').hide();
		}
	}

	handleElectricalPackageChange = () => {
		const _this = this;

		if ($('.group-upgrade-electrical_packages')[0]) {
			$('.wrap-electric').hide();
		} else {
			$('.wrap-electric').show();
		}

		$(document).on('click', '.action-close', () => {
			const packageID = _this._seadevShedBuilder._electricalPackageID;
			$(`[data-package-id=${packageID}]`).prop('checked', true);
			_this.removeDialog();
		});

		$(document).on('click', '.action-replace', (e) => {
			let data = $(e.currentTarget).attr('data');
			let dataObj = JSON.parse(window.atob(data));
			const { packageID, components } = dataObj;

			_this.addComponentElectricalPackage(packageID, components);
			_this.removeDialog();

			if (packageID == 'none') {
				_this._seadevShedBuilder._electricalPackageID = 'none';
				jQuery('[name="ssb-configurator-electrical-packages"][data-package-id="none"]')
					.prop('checked', true)
					.trigger('change');
				_this._seadevShedBuilder._defaultEPackageComponents = [];
				_this.updatePrice();
			}
		});

		$(document).on('click', '.action-remove', (e) => {
			let data = $(e.currentTarget).attr('data');
			let dataObj = JSON.parse(window.atob(data));
			const { componentSide, componentType, componentKey } = dataObj;
			_this.removeComponentV2(componentSide, componentType, componentKey);
			_this.removeDialog();
		});

		$(document).on('click', '.popup-electrical-package-item', (e) => {
			const _this = this;
			let cElement = '';
			const currentPackage = $(e.currentTarget)
				.closest('div')
				.find('[name="ssb-configurator-electrical-packages"]');
			const componentHtml = currentPackage.attr('data-package-components');
			const packageName = _this._isManufactureEditOrder
				? currentPackage.attr('data-option-original-value')
				: currentPackage.val();
			let componentsData = JSON.parse(componentHtml);
			componentsData = componentsData.filter((item) =>
				this._seadevShedBuilder.isValidComponentBySizeCondition(item),
			);
			const components = [];
			for (const component of componentsData) {
				let qty = components[component.component] ? components[component.component].qty : 1;
				if (components.hasOwnProperty(component.component)) qty++;

				component.qty = qty;
				components[component.component] = component;
			}

			for (const key in components) {
				const component = components[key];
				const element = $(`input[data-upgrade-component-name="${component.component}"]`);
				let label = _this._isManufactureEditOrder
					? element.attr('data-option-original-value')
					: element.attr('data-option-value');
				cElement += `<li>${label} (Qty. ${component.qty})</li>`;
			}

			const act = [{ key: 'close', label: 'Close' }];
			const msg = `
                <h5>${packageName}</h5>
                <p>Includes the following items:</p>
                <ul>${cElement}</ul>
            `;

			_this.createDialog(msg, act);

			return false;
		});

		$(
			'.ssb-configurator-options.electrical_packages input[name="ssb-configurator-electrical-packages"]',
		).on('change', (e) => {
			const oldPackageID = _this._seadevShedBuilder._electricalPackageID;
			const oldPackageName = $(`[data-package-id=${oldPackageID}]`).val();

			const packageID = $(e.currentTarget).attr('data-package-id');
			const packageName = $(e.currentTarget).val();
			const components = $(e.currentTarget).attr('data-package-components');
			if ('none' !== oldPackageID && oldPackageID !== packageID) {
				const msg =
					'none' === packageID
						? `Do you want to remove <strong>${oldPackageName}</strong>?`
						: `Do you want to replace the <strong>${oldPackageName}</strong> with <strong>${packageName}</strong>?`;
				const act = [
					{ key: 'close', label: 'Close' },
					{ key: 'replace', label: 'none' === packageID ? 'Remove' : 'Replace' },
				];
				const data = { packageID, components };
				_this.createDialog(msg, act, data);
			} else {
				_this.addComponentElectricalPackage(packageID, components);
			}
		});
	};

	addComponentElectricalPackage = (packageID, components) => {
		this._seadevShedBuilder.addLoadingAndStopRenderClasses('addComponentElectricalPackage');
		$(`.ssb_electrical_packages`).prop('disabled', true);

		this._seadevShedBuilder
			.animateElectricalPackageChange(packageID, components)
			.then((data) => {
				this.updatePrice();
				$(`.ssb_electrical_packages`).prop('disabled', false);
				this.showHideElectricalPackagesItem(packageID);
				this._seadevShedBuilder.removeLoadingAndStopRenderClasses('addComponentElectricalPackage');
			});
	};

	showHideElectricalPackagesItem = (packageID) => {
		if ('none' === packageID) {
			$('.wrap-electric').hide();
		} else {
			$('.wrap-electric').show();

			ePackageType.forEach((key) => {
				$(`.group-upgrade-${key}`).hide();
			});

			for (const component of this._seadevShedBuilder.getDefaultPackageComponents()) {
				if (component.max_qty !== 0) {
					$(`.group-upgrade-${component.type}`).show();
				} else {
					$(`.group-upgrade-${component.type}`).hide();
				}
			}
		}
	};

	getLayoutData = (element) => {
		const layoutId = element.attr('data-layout-id');
		const layoutLabel = element.attr('data-option-value');
		const limitWidth = element.attr('data-layout-limit-width');
		const limitDepth = element.attr('data-layout-limit-depth');
		const limitHeight = element.attr('data-layout-limit-height');
		const packages = JSON.parse(element.attr('data-layout-packages'));
		const tmpComponents = JSON.parse(element.attr('data-layout-components'));

		Object.keys(tmpComponents).forEach((side) => {
			let components = [];
			tmpComponents[side].map((item) => {
				item.colorInfo = helpers.getDefaultComponentColor(item.uuid);
				components.push(item);
			});

			tmpComponents[side] = components;
		});

		const components = JSON.stringify(tmpComponents);
		return { layoutId, layoutLabel, limitWidth, limitDepth, limitHeight, components, packages };
	};

	setInitColor = (groupClass, optionName) => {
		let defaultColor = $(`.${groupClass}`).find('.ssb-option:not(.unavailable):eq(0)');

		if ($(`.${groupClass}`).find('.ssb-option.default:not(.unavailable)').length) {
			$(`.${groupClass}`).find('.ssb-option.default:not(.unavailable)').addClass('active');
			defaultColor = $(`.${groupClass}`).find('.ssb-option.default:not(.unavailable)');
		} else {
			$(`.${groupClass}`).find('.ssb-option:not(.unavailable):eq(0)').addClass('active');
		}

		this.handleTextureChange(defaultColor, optionName);
		this.handleHideGroupColor(groupClass);
	};

	handleHideGroupColor = (groupClass) => {
		if (
			$(`.${groupClass}`).find(
				'.ssb-option:not(.unavailable)[data-texture-type="color_picker"]',
			).length ||
			$(`.${groupClass}`).find('.ssb-option:not(.unavailable)').length > 1
		) {
			$(`.${groupClass}`).show();
		} else {
			$(`.${groupClass}`).hide();
		}

		if( 'group-ceiling-color' === groupClass || 'group-wall-color' === groupClass ) {
			const type = 'group-ceiling-color' === groupClass ? 'interior_ceiling' : 'interior_wall';
			const material = jQuery(`#${type}-material-option li.active`).attr( 'data-material-type' ) || 'none';
			this.handleHideGroupInteriorColorFinishing(type, material);
		}
	};

	/**
	 * Handles the visibility of material option groups based on their availability.
	 *
	 * @param {string} groupClass - The class name of the group whose visibility is being handled.
	 *
	 */
	handleHideGroupMaterial = (groupClass) => {
		if ($(`.${groupClass}`).find('.ssb-option:not(.unavailable)').length > 1) {
			$(`.${groupClass}`).show();
		} else {
			$(`.${groupClass}`).hide();
		}
	};

	handleColorChange = (groupClass, optionName) => {
		const ignoreInitColor = [
			'group-siding-color',
			'group-trim-color',
			'group-wainscoting-color',
			'group-accent_gable-color',
			'group-exterior_siding_upgrades-color',
		];
		if (-1 === ignoreInitColor.indexOf(groupClass)) {
			this.setInitColor(groupClass, optionName);
		}

		$(`.${groupClass} ul li`).click((e) => {
			if ('color_picker' === $(e.currentTarget).attr('data-texture-type')) return;

			$(`.${groupClass} ul li`).removeClass('active');
			$(e.currentTarget).addClass('active');

			this.handleTextureChange($(e.currentTarget), optionName);

			const textureType = $(e.currentTarget).attr('data-texture-type');
			const textureImage = $(e.currentTarget).attr('data-texture-image');
			const textureColor = $(e.currentTarget).attr('data-texture-color');

			if ('group-siding-color' === groupClass) {
				this._seadevShedBuilder.updateLeftWallColor(
					$(e.currentTarget).attr('data-texture-color'),
				);
				this._seadevShedBuilder.updateWallColor(
					textureType,
					textureImage,
					textureColor,
					'siding',
				);
				this._seadevShedBuilder.updateLoafingInteriorColor();
			}

			if ('group-wainscoting-color' === groupClass) {
				this._seadevShedBuilder.updateDrawMaterialColor(
					textureType,
					textureImage,
					textureColor,
					'wainscoting',
				);
			}

			if ('group-accent_gable-color' === groupClass) {
				this._seadevShedBuilder.updateDrawMaterialColor(
					textureType,
					textureImage,
					textureColor,
					'accent_gable',
				);
			}

			if ('group-exterior_siding_upgrades-color' === groupClass) {
				this._seadevShedBuilder.updateDrawMaterialColor(
					textureType,
					textureImage,
					textureColor,
					'exterior_siding_upgrades',
				);
			}

			if (
				'group-wall-color' === groupClass &&
				'none' !== $('#interior_wall-material-option li.active').data('material-type')
			) {
				this._seadevShedBuilder.updateDrawMaterialColor(
					textureType,
					textureImage,
					textureColor,
					'interior_wall',
				);
			}

			if (
				'group-ceiling-color' === groupClass &&
				'none' !== $('#interior_ceiling-material-option li.active').data('material-type')
			) {
				this._seadevShedBuilder.updateDrawMaterialColor(
					textureType,
					textureImage,
					textureColor,
					'interior_ceiling',
				);
			}
		});

		let timeoutId;
		$(`.${groupClass} .ssb-option-color-picker`).on('input', (e) => {
			clearTimeout(timeoutId);

			const textureColor = $(e.currentTarget).val().toString();

			$(`.${groupClass} ul li`).removeClass('active');
			$(e.currentTarget)
				.next('.ssb-option-swatch')
				.css({
					'background-color': textureColor,
					color: this.getReflectColor(textureColor),
				});
			$(e.currentTarget)
				.closest('li')
				.attr('data-texture-color', textureColor)
				.addClass('active');

			timeoutId = setTimeout(() => {
				this.handleTextureChange($(e.currentTarget).closest('li'), optionName);

				if ('group-siding-color' === groupClass) {
					this._seadevShedBuilder.updateLeftWallColor(textureColor);
					this._seadevShedBuilder.updateWallColor(
						'color_picker',
						'',
						textureColor,
						'siding',
					);
					this._seadevShedBuilder.updateLoafingInteriorColor();
				}

				if ('group-wainscoting-color' === groupClass) {
					this._seadevShedBuilder.updateDrawMaterialColor(
						'color_picker',
						'',
						textureColor,
						'wainscoting',
					);
				}

				if ('group-accent_gable-color' === groupClass) {
					this._seadevShedBuilder.updateDrawMaterialColor(
						'color_picker',
						'',
						textureColor,
						'accent_gable',
					);
				}

				if ('group-exterior_siding_upgrades-color' === groupClass) {
					this._seadevShedBuilder.updateDrawMaterialColor(
						'color_picker',
						'',
						textureColor,
						'exterior_siding_upgrades',
					);
				}

				if (
					'group-wall-color' === groupClass &&
					'none' !== $('#interior_wall-material-option li.active').data('material-type')
				) {
					this._seadevShedBuilder.updateDrawMaterialColor(
						'color_picker',
						'',
						textureColor,
						'interior_wall',
					);
				}

				if (
					'group-ceiling-color' === groupClass &&
					'none' !==
						$('#interior_ceiling-material-option li.active').data('material-type')
				) {
					this._seadevShedBuilder.updateDrawMaterialColor(
						'color_picker',
						'',
						textureColor,
						'interior_ceiling',
					);
				}
			}, 200);
		});
		this.handleHideGroupColor(groupClass);
	};

	getReflectColor = (backgroundColor) => {
		backgroundColor = backgroundColor.replace('#', '');
		const r = parseInt(backgroundColor.substr(0, 2), 16);
		const g = parseInt(backgroundColor.substr(2, 2), 16);
		const b = parseInt(backgroundColor.substr(4, 2), 16);
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
		return luminance > 0.5 ? '#000000' : '#FFFFFF';
	};

	handleRoofMaterialChange = () => {
		const _this = this;
		const roofType = $('#roof-material-option li.default-material').attr('data-roof-type');

		_this.updateRoofMaterialChange(roofType);

		$('#roof-material-option li').click((e, callback) => {
			$('#roof-material-option li').removeClass('active');
			$(e.currentTarget).addClass('active');

			const roofType = $(e.currentTarget).attr('data-roof-type');

			_this.updateRoofMaterialChange(roofType);

			if ('function' === typeof callback) {
				callback();
			}
		});
	};

	updateRoofMaterialChange = (roofType) => {
		this._seadevShedBuilder.animateRoofTypeChange(roofType);
		$('.group-roof-color')
			.find(`li.ssb-option:not([data-roof-type="${roofType}"])`)
			.hide()
			.addClass('unavailable');
		$('.group-roof-color')
			.find(`li.ssb-option[data-roof-type="${roofType}"]`)
			.show()
			.removeClass('unavailable');

		const label = $(`#roof-material-option li[data-key="${roofType}"] .ssb-option-name`).attr(
			'data-option-value',
		);
		$('#js-shed-data input[name="ssb-option-roof-type"]').val(label);
		$('#js-shed-data input[name="ssb-option-roof-type"]').attr('data-key', roofType);

		$('.group-roof-color li').removeClass('active');
		let defaultRoofColor = $('.group-roof-color').find('.ssb-option:not(.unavailable):eq(0)');

		if ($('.group-roof-color').find('.ssb-option.default:not(.unavailable)').length) {
			$('.group-roof-color').find('.ssb-option.default:not(.unavailable)').addClass('active');
			defaultRoofColor = $('.group-roof-color').find('.ssb-option.default:not(.unavailable)');
		} else {
			$('.group-roof-color').find('.ssb-option:not(.unavailable):eq(0)').addClass('active');
		}

		this.handleListUpgrades('roof');
		this.handleHideGroupColor('group-roof-color');
		this.handleTextureChange(defaultRoofColor, 'ssb-option-roof-color');
		this.shedDetailRenderRoof();
		this.shedDetailRenderExterior();
		this.shedDetailRenderInterior();
		this.updatePrice();
	};

	handleMaterialInteriorChange = (type) => {
		const _this = this;
		_this.updateMaterialInteriorChange(type);
		const material =
			$(`#${type}-material-option li.active`).attr('data-material-type') || 'none';
		if( type === 'interior_wall' || type === 'interior_ceiling') {
			const groupClass = type === 'interior_wall' ? 'group-wall-color' : 'group-ceiling-color';
			_this.handleHideGroupInteriorColorFinishing(groupClass, material);
		}
		
		$(`#${type}-material-option li`).click((e, callback) => {
			const prevMaterial =
				$(`#${type}-material-option li.active`).attr('data-material-type') || 'none';
			const newMaterial = $(e.currentTarget).attr('data-material-type') || 'none';

			if( type === 'interior_wall' || type === 'interior_ceiling') {
				const groupClass = type === 'interior_wall' ? 'group-wall-color' : 'group-ceiling-color';
				_this.handleHideGroupInteriorColorFinishing(groupClass, newMaterial);
			}

			$(`#${type}-material-option li`).removeClass('active');
			$(e.currentTarget).addClass('active');
			if (
				prevMaterial !== newMaterial &&
				(prevMaterial === 'none' || newMaterial === 'none')
			) {
				if (prevMaterial === 'none' || newMaterial === 'none') {
					_this._seadevShedBuilder.drawInteriorlWallCeiling();
					_this._seadevShedBuilder.blurMeshes();
				}
			}
			_this.updateMaterialInteriorChange(type);
			if ('function' === typeof callback) {
				callback();
			}
		});
	};

	triggerClickInteriorMaterial = (group, materialType) => {
		const groupElement = $(`#${group}-material-option`);
		groupElement.find('li').removeClass('active');
		const elementActive = groupElement.find(`li[data-key="${materialType}"]`);
		elementActive.addClass('active');
		elementActive.trigger('click');
	}

	handleHideGroupInteriorColorFinishing = (groupClass, materialType) => {
		if (materialType === 'none') {
			$(`.ssb-configurator-group.${groupClass}`).hide();
		} else {
			$(`.ssb-configurator-group.${groupClass}`).show();
		}
	}

	updateMaterialInteriorChange = (groupType) => {
		const element = $(`#${groupType}-material-option li.active`);
		const materialType = element.data('material-type');
		let isUseSelectColor = (groupType === 'interior_wall' || groupType === 'interior_ceiling') && element.data( 'material-type' ) !== 'none';
		if (this.isUpdateMaterialDataInteriorWall(groupType)) {
			const type =
				'interior_wall' === groupType || 'insulation_wall' === groupType
					? 'interior_wall'
					: 'interior_ceiling';
			const { defaultDiffuse, defaultBump, defaultSpecular, uScale, vScale, specularPower } =
				this.getMaterialDataInterior(groupType, materialType, element);
			const data = {
				material: type,
				isUseSelectColor,
				diffuseTexture: defaultDiffuse,
				bumpTexture: defaultBump,
				specularTexture: defaultSpecular,
				specularPower,
				uScale,
				vScale,
			};
			this._seadevShedBuilder.animateMaterialInteriorChange(data);
		}

		const inputKey = groupType.replace('_', '-');
		const materialKey = element.data('key');
		const materialLabel = element.data('label');
		$(`#js-shed-data input[name="ssb-option-${inputKey}-material-type"]`).attr(
			'data-key',
			materialKey,
		);
		$(`#js-shed-data input[name="ssb-option-${inputKey}-material-type"]`).attr(
			'data-name',
			materialLabel,
		);
		this.updatePrice();
	};

	/**
	 * Check condition change material
	 * @param type
	 * @returns
	 */
	isUpdateMaterialDataInteriorWall = (type) => {
		if ('insulation_roof' === type) {
			return (
				0 == $('#interior_ceiling-material-option li').length ||
				'none' === $('#interior_ceiling-material-option li.active').data('material-type')
			);
		}

		if ('insulation_wall' === type) {
			return (
				0 == $('#interior_wall-material-option li').length ||
				'none' === $('#interior_wall-material-option li.active').data('material-type')
			);
		}

		return true;
	};

	/**
	 * Check use backside material to apply interior wall
	 * @param type
	 * @returns
	 */
	isUseBackSideMaterial = () => {
		const elementMaterialInteriorWall = jQuery('#interior_wall-material-option li.active');
		const elementMaterialInsulationWall = jQuery('#insulation_wall-material-option li.active');

		if (0 === elementMaterialInteriorWall.length && 0 === elementMaterialInsulationWall.length)
			return true;

		if (
			0 === elementMaterialInteriorWall.length &&
			'none' === elementMaterialInsulationWall.data('material-type')
		)
			return true;

		if (
			0 === elementMaterialInsulationWall.length &&
			'none' === elementMaterialInteriorWall.data('material-type')
		)
			return true;

		if (
			'none' === elementMaterialInteriorWall.data('material-type') &&
			'none' === elementMaterialInsulationWall.data('material-type')
		)
			return true;

		return false;
	};

	/**
	 * Retrieves material data for interior elements based on group type and material type.
	 *
	 * @param {string} groupType - The type of the group (e.g., 'interior_ceiling', 'interior_wall').
	 * @param {string} materialType - The selected material type (e.g., 'wood', 'none').
	 * @param {object} element - The DOM element associated with the material selection.
	 * @returns {object} An object containing material data (diffuse, bump, specular, etc.).
	 */
	getMaterialDataInterior = (groupType, materialType, element) => {
		switch (groupType) {
			case 'interior_ceiling':
				if (materialType !== 'none') {
					return this._seadevShedBuilder.getSidingMaterialData(element);
				}
				const activeWallMaterial = $('#insulation_roof-material-option li.active');
				const hasWallMaterial =
					$('#insulation_roof-material-option li').length &&
					'none' !== activeWallMaterial.data('material-type');
				if (hasWallMaterial) {
					return this._seadevShedBuilder.getSidingMaterialData(activeWallMaterial);
				}
				return {
					defaultDiffuse: '',
					defaultBump: '',
					defaultSpecular: '',
					specularPower: '',
					uScale: 1,
					vScale: 1,
				};
			case 'interior_wall':
			case 'insulation_wall':
				const {
					diffuseTexture,
					bumpTexture,
					specularTexture,
					uScale,
					vScale,
					specularPower,
				} = this._seadevShedBuilder.getSidingInnerMaterialData();
				return {
					defaultDiffuse: diffuseTexture,
					defaultBump: bumpTexture,
					defaultSpecular: specularTexture,
					uScale,
					vScale,
					specularPower,
				};
			default:
				return this._seadevShedBuilder.getSidingMaterialData(element);
		}
	};

	private handleTextureChange(option, optionName) {
		let materialName = option.attr('data-material');
		if (
			'' === materialName &&
			'ssb-option-ceiling-color' !== optionName &&
			'ssb-option-wall-color' !== optionName
		) {
			return;
		}

		if ('ssb-option-roof-color' === optionName) {
			materialName += '|' + this._seadevShedBuilder._roofMaterial.join('|');
		}

		const textureType = option.attr('data-texture-type');
		const textureImage = option.attr('data-texture-image');
		const textureColor = option.attr('data-texture-color');
		const typeColor = option.attr('data-color-type');
		const dataKey = option.attr('data-key');
		const dataColor = 'image' === textureType ? textureImage : textureColor;
		const dataValue = helpers.formatColorName(
			option.find('.ssb-option-name').attr('data-option-value'),
			textureType,
			textureColor,
		);

		$(`#js-shed-data input[name="${optionName}"]`).val(dataValue);
		$(`#js-shed-data input[name="${optionName}"]`).attr('data-key', dataKey);
		$(`#js-shed-data input[name="${optionName}"]`).attr('data-color', dataColor);
		$(`#js-shed-data input[name="${optionName}"]`).attr('data-color-type', textureType);

		this.carportUpdateSidingInfo();

		const priceOption = this.getPriceOptions(option);
		const optionPirce = optionName + '-price';
		$(`#js-shed-data input[name="${optionPirce}"]`).val(priceOption);

		const typeComponent = ['door', 'windows', 'vent', 'shutter', 'countertops', 'appliance'];
		if (-1 !== typeComponent.indexOf(typeColor)) {
			this._seadevShedBuilder.updateColorComponent(typeColor);
		}
		this._seadevShedBuilder.animateTextureChange(
			materialName,
			textureType,
			textureImage,
			textureColor,
		);
		this.shedDetailRenderSize();
		this.shedDetailRenderLayout();
		this.shedDetailRenderSidingAndTrim();
		this.shedDetailRenderRoof();
		this.shedDetailStructureRenderColor();
		this.shedDetailRenderPorchData();
		this.shedDetailRenderExterior();
		this.shedDetailRenderInterior();
		this.updatePrice();
	}

	handleAddOnSidingMaterialChange = async (key: string) => {
		const _this = this;
		const defaultMaterial = $(`#${key}-material-option li.active`);
		const {
			sidingType,
			defaultDiffuse,
			defaultBump,
			defaultSpecular,
			uScale,
			vScale,
			specularPower,
		} = _this._seadevShedBuilder.getSidingMaterialData(defaultMaterial);

		$(`.group-${key}-color`)
			.find(`.ssb-option:not(.${sidingType})`)
			.hide()
			.addClass('unavailable');
		$(`.group-${key}-color`)
			.find(`.ssb-option.${sidingType}`)
			.show()
			.removeClass('unavailable');

		$(`.ssb-configurator-color.${key} li`).removeClass('active');
		if ('wainscoting' !== key) {
			_this.setInitColor(`group-${key}-color`, `ssb-option-${key}-color`);
		}

		_this.handleHideGroupMaterial(`group-${key}-type`);

		_this._seadevShedBuilder.setCustomUVScale(`${key}_uscale`, uScale);
		_this._seadevShedBuilder.setCustomUVScale(`${key}_vscale`, vScale);
		_this._seadevShedBuilder.animateAddonSidingTypeChange(
			key,
			defaultDiffuse,
			defaultBump,
			defaultSpecular,
			specularPower,
		);

		$(`#${key}-material-option`).on('click', 'li', async (e, callback) => {
			$(`#${key}-material-option li`).removeClass('active');
			$(e.currentTarget).addClass('active');

			const {
				sidingType,
				defaultDiffuse,
				defaultBump,
				defaultSpecular,
				uScale,
				vScale,
				specularPower,
			} = _this._seadevShedBuilder.getSidingMaterialData($(e.currentTarget));

			$(`.group-${key}-color`)
				.find(`.ssb-option:not(.${sidingType})`)
				.hide()
				.addClass('unavailable');
			$(`.group-${key}-color`)
				.find(`.ssb-option.${sidingType}`)
				.show()
				.removeClass('unavailable');

			$(`.ssb-configurator-color.${key} li`).removeClass('active');
			_this.setInitColor(`group-${key}-color`, `ssb-option-${key}-color`);
			_this.handleHideGroupMaterial(`group-${key}-type`);

			_this._seadevShedBuilder.setCustomUVScale(`${key}_uscale`, uScale);
			_this._seadevShedBuilder.setCustomUVScale(`${key}_vscale`, vScale);
			_this._seadevShedBuilder.animateAddonSidingTypeChange(
				key,
				defaultDiffuse,
				defaultBump,
				defaultSpecular,
				specularPower,
			);

			if ('function' === typeof callback) {
				callback();
			}
		});
	};

	/**
	 * Handle floor material change from front end select
	 */
	handleFloorMaterialChange = () => {
		this.autoHideFloorMaterialConfigurator();

		const activeMaterial = $('#floor-material-option li.active');
		const activeMaterialData = this._seadevShedBuilder.getFloorMaterialData(activeMaterial);

		this.updateFloorMaterialChange(activeMaterialData);

		$('#floor-material-option li').click((e) => {
			$('#floor-material-option li').removeClass('active');
			$(e.currentTarget).addClass('active');

			const activeMaterialData = this._seadevShedBuilder.getFloorMaterialData(
				$(e.currentTarget),
			);

			this.updateFloorMaterialChange(activeMaterialData);
		});
	};

	/**
	 * Update floor material configurator to change active selection
	 *
	 * @param {Object} materialData Data to update
	 */
	updateFloorMaterialChange = (materialData) => {
		const _this = this;

		return new Promise(async (resolve) => {
			if ('default' === materialData?.floorType) {
				_this._seadevShedBuilder.showFloorMesh(false);
			}
			_this._seadevShedBuilder.showFloorMesh();

			const label =
				$(
					`#floor-material-option li[data-key="${materialData?.floorType}"] .ssb-option-name`,
				).attr('data-option-value-base64') || '';
			$('#js-shed-data input[name="ssb-option-floor-type"]').val(atob(label));
			$('#js-shed-data input[name="ssb-option-floor-type"]').attr(
				'data-key',
				materialData?.floorType,
			);

			_this._seadevShedBuilder.animateFloorTypeChange(materialData).then((data) => {
				_this.handleListUpgrades('floor');
				_this.updatePrice();
				resolve(true);
			});
		});
	};

	/**
	 * Auto hide floor configurator if less than 2 options
	 */
	autoHideFloorMaterialConfigurator() {
		$('.ssb-configurator-group.group-floor-type').each(function (index, group) {
			let options = $(group).find('.ssb-option.display-thumbnail').length;
			if (options < 2) {
				$(group).hide();
			}
		});
	}

	handleSidingMaterialChange = async () => {
		const _this = this;
		const defaultMaterial = $('#siding-material-option li.default-material');
		const {
			sidingType,
			defaultDiffuse,
			defaultBump,
			defaultSpecular,
			uScale,
			vScale,
			specularPower,
		} = _this._seadevShedBuilder.getSidingMaterialData(defaultMaterial);

		this.updateSidingMaterialChange(
			sidingType,
			uScale,
			vScale,
			defaultDiffuse,
			defaultBump,
			defaultSpecular,
			specularPower,
			true,
		);
		_this.handleListInsulationWall();

		$('#siding-material-option li').click(async (e, callback) => {
			_this._seadevShedBuilder.addStopRenderClasses('handleSidingMaterialChange');
			$('#siding-material-option li').removeClass('active');
			$(e.currentTarget).addClass('active');

			const {
				sidingType,
				defaultDiffuse,
				defaultBump,
				defaultSpecular,
				uScale,
				vScale,
				specularPower,
			} = _this._seadevShedBuilder.getSidingMaterialData($(e.currentTarget));

			_this._seadevShedBuilder.setSidingType(sidingType);

			await this._seadevShedBuilder.handleLayoutComponent();
			if (!this._seadevShedBuilder._isUpdateLayout) {
				this._seadevShedBuilder.distributeComponentEqually();
			}
			this._seadevShedBuilder.updateWindowsPosition();
			this._seadevShedBuilder.isValidAllComponents();

			_this.handleListWainscoting();
			_this.handleListInsulationWall();
			_this.handleWainscotingUIStatus();
			await _this.updateSidingMaterialChange(
				sidingType,
				uScale,
				vScale,
				defaultDiffuse,
				defaultBump,
				defaultSpecular,
				specularPower,
				false,
			);

			if ('function' === typeof callback) {
				callback();
			}

			_this._seadevShedBuilder.removeStopRenderClasses('handleSidingMaterialChange');
		});
	};

	updateSidingMaterialChange = async (
		sidingType,
		uScale,
		vScale,
		defaultDiffuse,
		defaultBump,
		defaultSpecular,
		specularPower,
		isFirstLoad,
	) => {
		const _this = this;

		return new Promise(async (resolve) => {
			_this._seadevShedBuilder.setSidingType(sidingType);

			_this._seadevShedBuilder._sidingUscale = uScale;
			_this._seadevShedBuilder._sidingVscale = vScale;

			const label =
				$(`#siding-material-option li[data-key="${sidingType}"] .ssb-option-name`).attr(
					'data-option-value-base64',
				) || '';
			$('#js-shed-data input[name="ssb-option-siding-type"]').val(atob(label));
			$('#js-shed-data input[name="ssb-option-siding-type"]').attr('data-key', sidingType);

			_this.carportUpdateSidingInfo();

			const elMateial = $(`#siding-material-option li[data-key="${sidingType}"]`);
			let priceMaterial = 0;
			if (_this.isManualPrice()) {
				const height = helpers.getBaseHeight();
				const dataSizes = $(`#ssb-configurator-size-area`)
					.children('option:selected')
					.attr('data-sizes');
				const basePrice = _this.getPriceByHeight(
					height,
					dataSizes,
					elMateial.data('siding-type'),
				);
				const defaultMaterial = $('.ssb-configurator-siding-type .default-material');
				const defaultBasePriceMaterial = _this.getPriceByHeight(
					height,
					dataSizes,
					defaultMaterial.data('siding-type'),
				);
				priceMaterial = basePrice - defaultBasePriceMaterial;
			} else {
				priceMaterial = !_this._isMaterialUpdateBasePrice
					? _this.getPriceOptions(elMateial, 'material')
					: 0;
			}

			$('#js-shed-data input[name="ssb-option-siding-type-price"]').val(priceMaterial);

			_this.updateElementBySidingType(sidingType);

			$('.ssb-configurator-color.siding li').removeClass('active');
			$('.ssb-configurator-color.trim li').removeClass('active');
			$('.ssb-configurator-color.siding')
				.find('.ssb-option:not(.unavailable):eq(0)')
				.addClass('active');
			const sidingColor = $('.ssb-configurator-color.siding')
				.find('.ssb-option:not(.unavailable):eq(0)')
				.attr('data-texture-color');

			_this.setInitColor('group-siding-color', 'ssb-option-siding-color');
			_this.setInitColor('group-trim-color', 'ssb-option-trim-color');

			const { diffuseTexture, bumpTexture, specularTexture } =
				await _this._seadevShedBuilder.getTextureFile(
					sidingType,
					defaultDiffuse,
					defaultBump,
					defaultSpecular,
					specularPower,
				);

			if (!isFirstLoad) {
				_this.updateComponentBySidingType(sidingType);
			}

			_this._seadevShedBuilder
				.animateSidingTypeChange(
					sidingType,
					sidingColor,
					diffuseTexture,
					bumpTexture,
					specularTexture,
					specularPower,
				)
				.then((data) => {
					_this.updateIncludeComponents();
					_this.handleListUpgrades('siding');
					_this.shedDetailRenderExterior();
					_this.shedDetailRenderInterior();
					_this.shedDetailRenderSize();
					_this.shedDetailRenderLayout();
					_this.shedDetailRenderSidingAndTrim();
					_this.shedDetailUpdatePriceMaterialColor();
					_this.shedDetailRenderRoof();
					_this.shedDetailStructureRenderColor();
					_this.shedDetailRenderPorchData();
					_this.updatePrice();
					resolve(true);
				});

			if (this._seadevShedBuilder._isDrawInteriorSiding && this.isUseBackSideMaterial()) {
				const innerData = this._seadevShedBuilder.getSidingInnerMaterialData();
				const data = {
					material: 'interior_wall',
					materialType: 'back_side',
					color: innerData.color,
					diffuseTexture: innerData.diffuseTexture,
					bumpTexture: innerData.bumpTexture,
					specularTexture: innerData.specularTexture,
					specularPower: innerData.specularPower,
				};
				this._seadevShedBuilder.animateMaterialInteriorChange(data);
			}
		});
	};

	updateElementBySidingType = (sidingType) => {
		$('.group-siding-color')
			.find(`.ssb-option:not(.${sidingType})`)
			.hide()
			.addClass('unavailable');
		$('.group-siding-color')
			.find(`.ssb-option.${sidingType}`)
			.show()
			.removeClass('unavailable');

		$('.group-trim-color')
			.find(`.ssb-option:not(.${sidingType})`)
			.hide()
			.addClass('unavailable');
		$('.group-trim-color').find(`.ssb-option.${sidingType}`).show().removeClass('unavailable');

		$('.ssb-configurator-upgrade.door')
			.find(`.ssb-option:not(.${sidingType})`)
			.prop('disabled', true);
		$('.ssb-configurator-upgrade.door')
			.find(`.ssb-option.${sidingType}`)
			.prop('disabled', false);

		$('.ssb-configurator-upgrade.door').find(`.ssb-option:not(.${sidingType})`).parent().hide();
		$('.ssb-configurator-upgrade.door').find(`.ssb-option.${sidingType}`).parent().show();

		$('.ssb-configurator-upgrade.windows')
			.find(`.ssb-option:not(.${sidingType})`)
			.prop('disabled', true);
		$('.ssb-configurator-upgrade.windows')
			.find(`.ssb-option.${sidingType}`)
			.prop('disabled', false);

		$('.ssb-configurator-upgrade.windows')
			.find(`.ssb-option:not(.${sidingType})`)
			.parent()
			.hide();
		$('.ssb-configurator-upgrade.windows').find(`.ssb-option.${sidingType}`).parent().show();
	};

	/**
	 * Handle show hide item other upgrade
	 * @param type
	 */
	handleListUpgrades = (type) => {
		const _this = this;
		const itemsRemove = [];
		const groupSingleOld = [];
		$('.ssb-configurator-options.other input.ssb-option').each((i, v) => {
			const element = $(v);
			let isHide = false;
			let eClass = 'disabled';
			const dataCondition = element.data('condition');
			const parentElement = element.closest('div');
			const isItemRequired = '1' == element.data('required');
			let isValid = true;
			if (dataCondition) {
				const conditions = JSON.parse(window.atob(dataCondition));
				if ('size' === type && !helpers.isValidConditionUpgrades(conditions)) {
					isValid = false;
				} else if (
					'siding' === type &&
					!helpers.isValidMaterial('siding', conditions['siding_material'])
				) {
					isValid = false;
				} else if (
					'roof' === type &&
					!helpers.isValidMaterial('roof', conditions['roof_material'])
				) {
					isValid = false;
				} else if (
					'floor' === type &&
					!helpers.isValidMaterial('floor', conditions['floor_material'])
				) {
					isValid = false;
				}
				if (!isValid) {
					eClass = `hide disabled  disable-by-${type}`;
					isHide = true;
				}
			}

			if (isHide) {
				if (element.is(':checked')) {
					const itemName = element.attr('data-option-value');
					const groupName = element.attr('origin-group-name');
					const qty = element.siblings('.upgrade-quantity').length
						? element.siblings('.upgrade-quantity').val()
						: 1;
					if (!isItemRequired) {
						groupSingleOld.push({ group: groupName, item: itemName, qty });
						itemsRemove.push(itemName);
					}
				}
				parentElement.find('.upgrade-quantity').remove();
				parentElement.addClass(eClass);
				element.prop('checked', false);
			} else {
				parentElement.removeClass(`disable-by-${type}`);
				if (
					!parentElement.hasClass('disable-by-size') &&
					!parentElement.hasClass('disable-by-siding') &&
					!parentElement.hasClass('disable-by-floor') &&
					!parentElement.hasClass('disable-by-roof')
				) {
					parentElement.removeClass('hide disabled');
				}

				if (isItemRequired && !parentElement.hasClass('disabled')) {
					element.prop('checked', true);
				}
			}
		});

		$('.group-upgrade-other').each(function () {
			const otherGroup = $(this);
			const isSingleChoices = otherGroup.find('.ssb-configurator-upgrade-new.single').length;
			if (0 === otherGroup.find('.wrap-item:not(.disabled)').length) {
				otherGroup.hide();
			} else {
				otherGroup.show();
				const groupName = otherGroup.find('input').attr('origin-group-name');
				if (isSingleChoices) {
					const findIndex = helpers.findIndexObject(groupSingleOld, 'group', groupName);
					let indexItemRemove = -1;
					if (-1 !== findIndex) {
						indexItemRemove = itemsRemove.indexOf(groupSingleOld[findIndex].item);
					}
					let newItemChecked =
						-1 !== findIndex
							? otherGroup.find(
									`.ssb-configurator-upgrade-new div:not(.disabled) input[data-value-custom="${helpers.removeSpecialCharacters(window.btoa(groupSingleOld[findIndex].item))}"]`,
								)
							: null;
					if (0 === otherGroup.find('input:checked').length) {
						if (!newItemChecked || 0 === newItemChecked.length) {
							newItemChecked = otherGroup.find(
								'.single div:not(.disabled):eq(0) input',
							);
						}
						const newItemName = newItemChecked.attr('data-option-value');
						newItemChecked.prop('checked', true);

						if (
							1 == newItemChecked.data('picker') &&
							0 === newItemChecked.closest('div').find('.upgrade-quantity').length
						) {
							const inputName = newItemChecked.attr('name');
							const input = _this.renderInput(inputName);
							newItemChecked.closest('div').append(input);
						}
						if (-1 !== findIndex) {
							if (groupSingleOld[findIndex].item !== newItemName) {
								_this._seadevShedBuilder.createAlert(
									`${groupSingleOld[findIndex].item} has been changed to ${newItemName}.`,
								);
							} else if (findIndex > -1 && 1 == newItemChecked.data('picker')) {
								newItemChecked
									.siblings('.upgrade-quantity')
									.val(groupSingleOld[findIndex].qty);
							}
							if (indexItemRemove > -1) {
								itemsRemove.splice(indexItemRemove, 1);
							}
						}
					}
				} else {
					const groupItemRemove = groupSingleOld.filter(
						(item) => item.group === groupName,
					);
					if (groupItemRemove.length) {
						for (const itemRemove of groupItemRemove) {
							const indexItemRemove = itemsRemove.indexOf(itemRemove.item);
							let newItemChecked = otherGroup.find(
								`.ssb-configurator-upgrade-new div:not(.disabled) input[data-value-custom='${helpers.removeSpecialCharacters(window.btoa(itemRemove.item))}']`,
							);
							if (newItemChecked && newItemChecked.length) {
								newItemChecked.prop('checked', true);
								if (
									1 == newItemChecked.data('picker') &&
									0 ===
										newItemChecked.closest('div').find('.upgrade-quantity')
											.length
								) {
									const inputName = newItemChecked.attr('name');
									const input = _this.renderInput(inputName);
									newItemChecked.closest('div').append(input);
									newItemChecked
										.siblings('.upgrade-quantity')
										.val(itemRemove.qty);
								}
								itemsRemove.splice(indexItemRemove, 1);
							}
						}
					}
				}
			}
		});

		itemsRemove.forEach((item) => {
			_this._seadevShedBuilder.createAlert(`${item} has been removed as it's not available.`);
		});
	};

	handleSizeChange = () => {
		const _this = this;
		$('#ssb-configurator-size-area').change((e, callback) => {
			_this.changeSize();

			if ('function' === typeof callback) {
				callback();
			}
		});
		$('#ssb-configurator-size-height').change((e, callback) => {
			_this.disableSizeByHeight(Number($(e.currentTarget).val()));
			_this.disableLimitSizesByZone();
			_this.changeSize();

			if ('function' === typeof callback) {
				callback();
			}
		});
	};

	getSizes = () => {
		const width = helpers.getBaseWidth();
		const depth = helpers.getBaseDepth();
		const height = helpers.getBaseHeight();
		let name = 'N/A';
		let sizes = $(`#ssb-configurator-size-area`).children('option:selected').data('sizes');
		if (!sizes) return { width, depth, height, name };
		sizes = JSON.parse(atob(sizes));
		name = sizes.length > 0 ? sizes[0].name : '';
		return { width, depth, height, name };
	};

	changeSize = () => {
		const oldSize = this._seadevShedBuilder.getSizeGroup();
		const { width, depth, height } = this.getSizes();

		if (this._seadevShedBuilder.isFrontPorch() || this._seadevShedBuilder.isSidePorch()) {
			let porchSize = $('input.ssb_porch:checked').data('porch-size');
			porchSize = undefined === porchSize ? 4 : porchSize;
			this._seadevShedBuilder._oldPorchWidth = this._seadevShedBuilder._porchWidth;
			this._seadevShedBuilder._porchWidth = porchSize;
		}

		this._seadevShedBuilder.setWidth(width);
		this._seadevShedBuilder.setDepth(depth);
		this._seadevShedBuilder.setWallHeight(height);

		const newSize = this._seadevShedBuilder.getSizeGroup();

		this.updateOpeningPosition();

		this._isChangeLayout = false;
		this.initSize(oldSize, newSize);
	};

	initSize = (oldSize, newSize) => {
		const _this = this;
		_this._seadevShedBuilder
			.animateSizeChange(oldSize, newSize, _this._isChangeLayout)
			.then((data) => {
				_this.updateIncludeComponents();
				_this.handleSideAndEndList();
				_this.handlePorchList();
				_this.handleOpeningList();
				_this.handleLoftList();
				_this.handleChangeRailing();
				_this.handleFoundation();
				_this.handleJTrimShowHide();
				_this.handleRoofPitchList();
				_this.handleListFrame();
				_this.handleRestrictSwapSideGable();
				const jTrimData = $('.group-j-trim .radio:checked').val();
				_this._seadevShedBuilder.handleJTrimChange(jTrimData);

				$('input.ssb_roof_overhang').trigger('change');
				$('[name="ssb-configurator-upgrade-loft"]:checked').trigger('change');

				const heightDisplay = $('#ssb-configurator-height').css('display');

				let width = this._seadevShedBuilder._width;
				let depth = this._seadevShedBuilder._depth;
				let height = this._seadevShedBuilder._wallHeight;
				if (this._seadevShedBuilder.isSideGable()) {
					width = this._seadevShedBuilder._depth;
					depth = this._seadevShedBuilder._width;
				}

				if (
					this._seadevShedBuilder.isExcludePorchMeasurement() &&
					this._seadevShedBuilder.isSidePorch()
				) {
					if (this._seadevShedBuilder.isSideGable()) {
						depth -= this._seadevShedBuilder._porchWidth;
					} else {
						width -= this._seadevShedBuilder._porchWidth;
					}
				}

				let tmpFrontPorchWidth = 0;
				if (this._seadevShedBuilder.isFrontPorch()) {
					tmpFrontPorchWidth = this._seadevShedBuilder._porchWidth;
				}

				const sizeLabel = helpers.getSizeLabel();

				$('#text-size-canvas').text(`Current Size: ${sizeLabel['label']}`);
				$('#js-shed-data input[name="ssb-option-size"]').val(
					`${width}x${depth + tmpFrontPorchWidth}x${height}`,
				);
				$('#js-shed-data input[name="ssb-option-size"]').attr(
					'data-key',
					`${width}x${depth + tmpFrontPorchWidth}x${height}`,
				);
				$('#js-shed-data input[name="ssb-option-size-height"]').val(`${height}`);
				$('#js-shed-data input[name="ssb-option-size-height"]').attr(
					'data-key',
					`${height}`,
				);
				$(`#ssb-configurator-accordion-sizes .ssb-configurator-selected`).text(
					`${sizeLabel['label']}`,
				);
				$('#js-shed-data input[name="ssb-option-size-height"]').val(`${height}`);
				$('#js-shed-data input[name="ssb-sizes-display"]').val(
					window.btoa(JSON.stringify(sizeLabel['label'])),
				);
				_this.updateIncludeComponents();
				this.handleListUpgrades('size');
				_this.shedDetailRenderSize();
				_this.shedDetailRenderExterior();
				_this.shedDetailRenderInterior();
				_this.updatePrice();

				_this.handleListWainscoting();
				_this.handleWainscotingUIStatus();
				_this.shedDetailUpdatePriceMaterialColor();
				_this.shedDetailRenderSidingAndTrim();
				_this.shedDetailRenderRoof();
				_this.shedDetailStructureRenderColor();
				_this.shedDetailRenderPorchData();
			});
	};

	disableSizeByHeight = (height) => {
		$(`#ssb-configurator-size-area`)
			.find(`option`)
			.each((index, option) => {
				if (
					$(option).hasClass('disable-by-height') &&
					!$(option).hasClass('disable-by-layout')
				) {
					$(option).removeClass('disable-by-height').prop('disabled', false);
				}
			});

		$(`#ssb-configurator-size-area`)
			.find(`option`)
			.each((index, option) => {
				let dataSizes = $(option).attr('data-sizes');
				if (dataSizes) {
					dataSizes = JSON.parse(atob(dataSizes));
					if (!this.hasSizeHeight(height, dataSizes)) {
						$(option).addClass('disable-by-height').prop('disabled', true);
					}
				}
			});

		const currentWidth = helpers.getBaseWidth();
		const currentDepth = helpers.getBaseDepth();
		let { width, depth, label } = this.getSizeByHeight(height);
		if (width !== currentWidth || depth !== currentDepth) {
			if (isNaN(width) && isNaN(depth)) {
				this._seadevShedBuilder.createAlert(
					`Failed to render this structure as building WxLxH (${this._sizeInShareLink}) not found.`,
				);
				this._seadevShedBuilder._isDisableAddCart = false;
				this.handleDisableButtonAddToCart();
			} else {
				if (this._isCreateAlertChangeSize) {
					const oldSizeLabel = helpers.getSizeLabel(
						$('.ssb-option.size-area').children('option:selected'),
						this._seadevShedBuilder._wallHeight,
					);
					const newSizeLabel = helpers.getSizeLabel(
						$('#ssb-configurator-size-area').children(
							`option[data-size-width="${width}"][data-size-depth="${depth}"]`,
						),
						height,
					);
					const heightLabel = newSizeLabel['heightLabel'];
					const currentLabel = oldSizeLabel['widthDepthLabel'];
					this._seadevShedBuilder.createAlert(
						`Resize to ${label} because shed ${heightLabel} ft tall does not have ${currentLabel} option.`,
					);
				}
			}

			// Marketing trigger: Change width x length, Change height (event name: change-select-option)
			window.dispatchEvent(
				new CustomEvent('change-select-option', {
					detail: {
						isChange: true,
						isTrusted: false,
						event: 'change_width_length',
						value: `${width} x ${depth}`,
					},
				}),
			);
		}

		$(`#ssb-configurator-size-area`)
			.find(`option`)
			.each((index, option) => {
				const width = Number($(option).attr('data-size-width'));
				const depth = Number($(option).attr('data-size-depth'));

				if ($(option).attr('disabled')) {
					$(
						`#ssb-sizes .select-items div[custom-select-value="${width}x${depth}"]`,
					).addClass('custom-select-disabled');
				} else {
					$(
						`#ssb-sizes .select-items div[custom-select-value="${width}x${depth}"]`,
					).removeClass('custom-select-disabled');
				}
			});

		$(`#ssb-sizes .select-items div`).removeClass('same-as-selected');
		$(`#ssb-sizes .select-items div[custom-select-value="${width}x${depth}"]`).addClass(
			'same-as-selected',
		);
		$(`#ssb-sizes .custom-select-selected`).html(label);
		$('#ssb-configurator-size-area')
			.children(`option[data-size-width="${width}"][data-size-depth="${depth}"]`)
			.prop('selected', true);
	};

	hasSizeHeight = (height, dataSizes) => {
		for (let i = 0; i < dataSizes.length; i++) {
			if (height === Number(dataSizes[i]['height'])) {
				return true;
			}
		}

		return false;
	};

	hasSizeZone = (zoneID, dataSizes, height) => {
		for (let i = 0; i < dataSizes.length; i++) {
			let zoneAllow: any = [];
			if (height != dataSizes[i]['height']) continue;
			Object.keys(dataSizes[i]['conditionZone']).forEach(function (key) {
				zoneAllow.push(dataSizes[i]['conditionZone'][key]);
			});
			if (!zoneAllow.includes(zoneID)) {
				return false;
			}
		}

		return true;
	};

	getSizeByHeight = (height) => {
		const currentWidth = helpers.getBaseWidth();
		const currentDepth = helpers.getBaseDepth();
		const sizeLabel = helpers.getSizeLabel(
			$('.ssb-option.size-area').children('option:selected'),
			height,
		);
		let result = {
			width: currentWidth,
			depth: currentDepth,
			label: sizeLabel['widthDepthLabel'],
		};
		let isReturn = false;
		let sizes = [];

		$(`#ssb-configurator-size-area`)
			.find(`option:not([disabled])`)
			.each((index, option) => {
				const dataSizes = $(option).attr('data-sizes');
				if (dataSizes && this.hasSizeHeight(height, JSON.parse(atob(dataSizes)))) {
					const width = Number($(option).attr('data-size-width'));
					const depth = Number($(option).attr('data-size-depth'));
					const sizeLabel = helpers.getSizeLabel($(option), height);

					sizes.push({ width, depth, label: sizeLabel['widthDepthLabel'] });

					if (currentWidth === width && currentDepth === depth) {
						isReturn = true;
						return false;
					}
				}
			});

		if (isReturn) {
			return result;
		}

		sizes.push({ width: currentWidth, depth: currentDepth });
		sizes.sort((a, b) => a.width - b.width || a.depth - b.depth);

		for (let i = 0; i < sizes.length; i++) {
			if (currentWidth === sizes[i].width && currentDepth === sizes[i].depth) {
				if (sizes[i + 1]) {
					return sizes[i + 1];
				}

				if (sizes[i - 1]) {
					return sizes[i - 1];
				}
			}
		}

		return result;
	};

	handleUpgradePackageUpdate = () => {
		const _this = this;
		let upgradeClasses = [];
		$(`#ssb-configurator-accordion-upgrades-new .ssb-configurator-group`).each(
			(index, group) => {
				const upgradeClass = `.${$(group).attr('class').replace(' ', '.')}`;
				upgradeClasses.push(upgradeClass);
			},
		);

		$(upgradeClasses.join(', ')).on('change', 'input.ssb-option', (e) => {
			_this.shedDetailRenderInterior();
			_this.shedDetailRenderExterior();
			_this.updatePrice();
		});
	};

	handleChangeComponentSize = () => {
		$(document).on('change', '.component_size', (e) => {
			const size = $(e.target).find('option:selected').attr('value');
			$(e.target)
				.closest('.upgrade-item')
				.find('.ssb-option')
				.attr('data-component-size', size);
		});
	};

	handleChangeTackDoor = () => {
		const _this = this;
		$('#js-enable-tack-door').change(() => {
			_this._seadevShedBuilder.drawLeftWall();
		});

		$(document).on('change', '.ssb-configurator-options .ssb-tackroom', async function () {
			_this._seadevShedBuilder.addStopRenderClasses('handleChangeTackDoor');
			const width = $(this).data('width');
			const position = $(this).data('position');
			const price = $(this).data('price');
			const priceType = $(this).data('price-type');
			const side = $(this).data('side');
			const args = { width, position, price, priceType, side };
			await _this._seadevShedBuilder.animateTackroomChange(args, true, true);
			_this.updatePrice();
			_this.shedDetailRenderExterior();
			_this._seadevShedBuilder.removeStopRenderClasses('handleChangeTackDoor');
		});
	};

	getOpeningComponents = (numberComponents) => {
		const _this = this;
		let results = [];
		const depth = this._seadevShedBuilder.getDepth();
		const height = this._seadevShedBuilder.getWallHeight();

		this._seadevShedBuilder._openingList.forEach((opening) => {
			let distanceLeft = 0;
			let distanceRight = 0;
			if (0 === opening.z) {
				distanceLeft = distanceRight = +(depth / 2).toFixed(3);
			} else if (opening.z > 0) {
				distanceLeft = +(depth / 2 - Math.abs(opening.z)).toFixed(3);
				distanceRight = +(depth / 2 + Math.abs(opening.z)).toFixed(3);
			} else {
				distanceLeft = +(depth / 2 + Math.abs(opening.z)).toFixed(3);
				distanceRight = +(depth / 2 - Math.abs(opening.z)).toFixed(3);
			}

			const tmpDistanceLeft = helpers.convertUnit(distanceLeft);
			const tmpDistanceRight = helpers.convertUnit(distanceRight);

			const distanceBottom = +(
				(this._seadevShedBuilder._openingHeight +
					this._seadevShedBuilder._openingTopHeight) /
				2
			).toFixed(3);
			const distanceTop = +(height - distanceBottom).toFixed(3);

			const tmpDistanceBottom = helpers.convertUnit(distanceBottom);
			const tmpDistanceTop = helpers.convertUnit(distanceTop);

			const openingElement = this._isShowPositionComponent
				? `Opening (Top: ${tmpDistanceTop}, Bottom: ${tmpDistanceBottom}, Left: ${tmpDistanceLeft}, Right: ${tmpDistanceRight})`
				: `Opening`;

			numberComponents += 1;

			results.push({
				key: 'opening',
				left: distanceLeft,
				name: 'Opening',
				options: [],
				order: numberComponents,
				position: [tmpDistanceTop, tmpDistanceBottom, tmpDistanceLeft, tmpDistanceRight],
				price: '',
				right: distanceRight,
				side: 'left',
				text: openingElement,
				type: 'door',
				width: _this._seadevShedBuilder._openingWidth,
			});
		});

		return results;
	};

	getOpeningElement = (numberComponents) => {
		let elements = '';
		const opening = this.getOpeningComponents(numberComponents);

		for (let i = 0; i < opening.length; i++) {
			elements += `<li>
                    <div class="item">
                        <p class="left type-door">${opening[i].text}</p>
                    </div>
                </li>`;
		}

		return elements;
	};

	pushOpeningToRightElements = (elements) => {
		let rightComponents = 0;
		if (elements.hasOwnProperty('right') && Array.isArray(elements['right'])) {
			rightComponents = elements['right'].length;
		}

		const opening = this.getOpeningComponents(rightComponents);
		for (let i = 0; i < opening.length; i++) {
			if (elements.hasOwnProperty('right')) {
				elements['right'].push(opening[i]);
			} else {
				elements['right'] = [opening[i]];
			}
		}

		return elements;
	};

	/* Custom select option: Copy from w3school: https://www.w3schools.com/howto/howto_custom_select.asp */
	customSelectOption = () => {
		const _this = this;
		var x, i, j, l, ll, selElmnt, a, b, c;
		x = document.getElementsByClassName('ssb-custom-select');

		l = x.length;
		for (i = 0; i < l; i++) {
			selElmnt = x[i].getElementsByTagName('select')[0];
			ll = selElmnt.length;
			a = document.createElement('DIV');

			a.setAttribute('class', 'custom-select-selected');
			a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML.trim();
			x[i].appendChild(a);
			b = document.createElement('DIV');
			b.setAttribute('class', 'select-items select-hide');

			let searchInput = document.createElement('input');
			searchInput.type = 'text';
			searchInput.className = `search-option`;
			searchInput.placeholder = `Search`;
			searchInput.addEventListener('input', helpers.handleSearchCustomSelect);
			b.appendChild(searchInput);

			for (j = 0; j < ll; j++) {
				c = document.createElement('DIV');
				var selected = selElmnt.options[j].getAttribute('selected');
				var disabled = selElmnt.options[j].getAttribute('disabled');
				if ('selected' === selected) {
					c.classList.add('same-as-selected');
				}
				if ('disabled' === disabled) {
					c.classList.add('custom-select-disabled');
				}

				c.innerHTML = selElmnt.options[j].innerHTML.trim();
				c.setAttribute('custom-select-value', selElmnt.options[j].value.trim());
				c.addEventListener('click', function (e) {
					// Marketing trigger: Change width x length, Change height (event name: change-select-option)
					window.dispatchEvent(
						new CustomEvent('change-select-option', {
							detail: {
								isTrusted: e.isTrusted,
								isChange: !jQuery(e.target).hasClass('same-as-selected'),
								event: jQuery(e.target).parent().parent().data('type'),
								value: e.target.innerHTML,
							},
						}),
					);
					// Marketing trigger: Change width x length, Change height (event name: change-select-option)

					const classList = $(e.target).attr('class');
					if (classList && -1 !== classList.indexOf('custom-select-disabled')) {
						return;
					}

					var y, i, k, s, h, sl, yl;
					s = this.parentNode.parentNode.getElementsByTagName('select')[0];
					sl = s.length;
					h = this.parentNode.previousSibling;

					for (i = 0; i < sl; i++) {
						if (s.options[i].innerHTML.trim() == this.innerHTML.trim()) {
							$('#' + s.id)
								.val(s.options[i].value)
								.trigger('change');

							s.selectedIndex = i;
							h.innerHTML = this.innerHTML.trim();

							y = this.parentNode.getElementsByClassName('same-as-selected');
							yl = y.length;

							for (k = 0; k < yl; k++) {
								y[k].classList.remove('same-as-selected');
							}

							this.classList.add('same-as-selected');
							break;
						}
					}

					h.click();
				});

				b.appendChild(c);
			}

			x[i].appendChild(b);

			a.addEventListener('click', function (e) {
				e.stopPropagation();
				_this.closeAllSelect(this);
				this.nextSibling.classList.toggle('select-hide');
				this.classList.toggle('select-arrow-active');
				$(searchInput)
					.trigger('focus')
					.val('')
					.parent()
					.children()
					.removeClass('hide-custom-option');
			});
		}
	};

	eventCloseAllSelect = () => {
		const _this = this;
		document.addEventListener('click', function (e) {
			if (!e.isTrusted) {
				return;
			}

			const classList = $(e.target).attr('class');
			if (classList) {
				if (
					-1 === classList.indexOf('custom-select-disabled') &&
					-1 === classList.indexOf('search-option')
				) {
					_this.closeAllSelect(this);
				}
			} else {
				_this.closeAllSelect(this);
			}
		});
	};

	closeAllSelect = (elmnt) => {
		let x,
			y,
			i,
			xl,
			yl,
			arrNo = [];
		x = document.getElementsByClassName('select-items');
		y = document.getElementsByClassName('custom-select-selected');
		xl = x.length;
		yl = y.length;
		for (i = 0; i < yl; i++) {
			if (elmnt == y[i]) {
				arrNo.push(i);
			} else {
				y[i].classList.remove('select-arrow-active');
			}
		}

		for (i = 0; i < xl; i++) {
			if (arrNo.indexOf(i)) {
				x[i].classList.add('select-hide');
			}
		}
	};

	hideDoorAndWindowsOption = () => {
		if ('structure_monitorbarns_helmuth' === this._seadevShedBuilder._shedType) {
			$('.ssb-configurator-group.group-upgrade-door').hide();
			$('.ssb-configurator-group.group-upgrade-windows').hide();
			$('.ssb-configurator-group.group-upgrade-vent').hide();
			$('.ssb-configurator-group.group-upgrade-dormer').hide();
		}
	};

	getLayoutCharge = () => {
		const selectedLayout = $(
			`#ssb-configurator-layout-option input[name='ssb-configurator-layout']:checked`,
		);
		let chargeSetting = selectedLayout.attr('data-layout-charge');
		chargeSetting = JSON.parse(chargeSetting);
		const wallWidth = this._seadevShedBuilder.getDepth();
		for (let i = 0; i < chargeSetting.length; i++) {
			let sizes = chargeSetting[i]['condition'];
			let materials = chargeSetting[i]['charge_siding_material'];
			if ('' !== materials) {
				materials = window.atob(materials);
				materials = JSON.parse(materials);
			} else {
				materials = [];
			}

			if (
				helpers.isValidSize(sizes['operator'], wallWidth, sizes['value'], sizes['max']) &&
				this._seadevShedBuilder.isValidSidingMaterialCondition(materials)
			) {
				return Number(chargeSetting[i]['price']);
			}
		}

		return 0;
	};

	/**
	 * Get price for roof material
	 *
	 * @returns {Number} Price of roof material
	 */
	getRoofMaterialPrice = (isDefault = false) => {
		let roofType = this._seadevShedBuilder.getRoofType();
		if (isDefault) {
			roofType = $('#roof-material-option li.default-material').data('roof-type');
		}
		const height = helpers.getBaseHeight();
		let dataSizes = $(`#ssb-configurator-size-area`)
			.children('option:selected')
			.attr('data-sizes');
		if (!dataSizes) return 0;
		dataSizes = JSON.parse(atob(dataSizes));

		for (let i = 0; i < dataSizes.length; i++) {
			if (height === Number(dataSizes[i]['height']) && dataSizes[i]['roofPrices'][roofType]) {
				return Number(dataSizes[i]['roofPrices'][roofType]);
			}
		}

		return 0;
	};

	handleChangeSideOnPopup = () => {
		const _this = this;
		$(`.wrap-popup-position .upgrade-item input`).on('change', (e) => {
			const side = $(e.currentTarget).val();
			const type = $(e.currentTarget).data('popup-position');
			const childType = 'door' === type ? 'ramp' : 'windows' === type ? 'flower_box' : false;
			_this._sideSelected = side;
			_this.hideComponentNotFit(type, side);
			if (childType) {
				_this.hideChildComponentNotFit(childType, side, true);
			}
		});

		$(`input.ssb-option[data-upgrade-type="door"]`).on('change', (e) => {
			_this.hideChildComponentNotFit('ramp', _this._sideSelected, true);
			_this.handleHingeOption(e);
		});

		$(`input.ssb-option[data-upgrade-type="windows"]`).on('change', (e) => {
			_this.hideChildComponentNotFit('flower_box', _this._sideSelected, true);
		});
	};

	hideChildComponentNotFit = (type, side, isShow = false) => {
		const _this = this;
		const validComponents = [];

		$(`.child-option-${type} [name="child_${type}"]`).each((i, e) => {
			const componentName = $(e).data('upgrade-component-name');
			const uuid = $(e).data('uuid') ?? componentName;
			if (componentName) {
				if (_this._seadevShedBuilder.isAllowAddComponent({ side, uuid, componentName })) {
					validComponents.push(componentName);
					$(e).parent().show();
				} else {
					$(e).prop('checked', false).parent().hide();
				}
			}
		});

		if (0 === validComponents.length) {
			$(`.child-option-${type}`).hide();
		} else if (isShow) {
			$(`.child-option-${type}`).show();
		}
	};

	getSideLabel = (key) => {
		const sidesData = this._seadevShedBuilder.getSettingData('sides_data');

		switch (key) {
			case 'left':
				return helpers.getSideLabel(key, 'Right');
			case 'top_left':
				return helpers.getSideLabel(key, 'Top Right');
			case 'right':
				return helpers.getSideLabel(key, 'Left');
			case 'top_right':
				return helpers.getSideLabel(key, 'Top Left');
			case 'inner_left':
				return helpers.getSideLabel(key, 'Inner Right');
			case 'inner_right':
				return helpers.getSideLabel(key, 'Inner Left');
			case 'diagonal_right':
				return helpers.getSideLabel(key, 'Diagonal Left');
			case 'left_front':
				return helpers.getSideLabel(key, 'Right Front');
			case 'left_back':
				return helpers.getSideLabel(key, 'Right Back');
			default:
				return helpers.getSideLabel(key, sidesData[key]);
		}
	};

	/**
	 * Check condition to add carport to cart
	 *
	 * @returns {Boolean}
	 */
	allowAddCarportToCart = () => {
		if (!this._seadevShedBuilder.isCarport()) return true;

		const sides = ['front', 'back', 'left', 'right'];
		for (let i = 0; i < sides.length; i++) {
			if (!this._seadevShedBuilder.isFullEnclosedWall(sides[i])) return true;
		}

		return false;
	};

	/**
	 * Update siding info for carport
	 */
	carportUpdateSidingInfo = () => {
		if (!this._seadevShedBuilder.isCarport()) return;

		if (!this.carportShowWallInfo()) {
			$('#js-shed-data input[name="ssb-option-siding-type"]').val('');
			$('#js-shed-data input[name="ssb-option-siding-color"]').val('');
		} else {
			const sidingTypeKey = this._seadevShedBuilder.getSidingType();
			const sidingTypeLabel =
				$(`#siding-material-option li[data-key="${sidingTypeKey}"] .ssb-option-name`).attr(
					'data-option-value-base64',
				) || '';
			if ('' !== sidingTypeLabel)
				$('#js-shed-data input[name="ssb-option-siding-type"]').val(atob(sidingTypeLabel));

			const sidingColorKey = $('#js-shed-data input[name="ssb-option-siding-color"]').attr(
				'data-key',
			);
			const sidingColorLabel = $(
				`.group-siding-color .ssb-configurator-color li[data-key="${sidingColorKey}"] .ssb-option-name`,
			).text();
			$('#js-shed-data input[name="ssb-option-siding-color"]').val(sidingColorLabel);
		}
	};

	/**
	 * Check condition to show wall info for carport
	 *
	 * @returns {Boolean}
	 */
	carportShowWallInfo = () => {
		if (!this._seadevShedBuilder.isCarport()) return true;

		const sides = ['front', 'back', 'left', 'right'];
		for (let i = 0; i < sides.length; i++) {
			if (this.hasWall(sides[i])) return true;
		}

		return false;
	};

	/**
	 * Check exist wall for carport
	 *
	 * @param {String} side front|back|left|right
	 * @returns {Boolean}
	 */
	hasWall = (side) => {
		if ('front' === side || 'back' === side) {
			const gableOption = jQuery(`.${side}-gable-end`)
				.find('option:selected')
				.data('gable-end');
			if ('extended_top_gable' !== gableOption) return true;

			return Number($(`.${side}-gable-end`).find('option:selected').data('wall-height')) > 0;
		} else if ('left' === side || 'right' === side) {
			return Number($(`.${side}-sidewall`).find('option:selected').data('wall-height')) > 0;
		}

		return false;
	};

	/**
	 * Show|Hide the Hinge options
	 *
	 * @param {Object} e event when radio button change
	 */
	handleHingeOption = (e) => {
		$('.wrap-lock-setting').hide();

		const lockPosition = $(e.currentTarget).data('lock-position');
		const allowChangePosition = $(e.currentTarget).data('allow-change-position');
		if (('left' === lockPosition || 'right' === lockPosition) && allowChangePosition) {
			$(e.currentTarget).siblings('.upgrade-item-options').find('.wrap-lock-setting').show();
		}
	};

	/**
	 * Handles component color option event
	 * Set active color follow selected color, default color
	 *
	 * @param {Object} e event
	 */
	handleComponentColorOption = (e) => {
		$('.wrap-component-color').hide();
		const currentElement = $(e.currentTarget);
		const currentComponentName = currentElement.data('upgrade-component-name');
		const currentComponentType = currentElement.data('upgrade-component-type');
		const currentComponentUUID = currentElement.data('uuid');
		let isShowSection = false;
		const colorElements = currentElement
			.siblings('.upgrade-item-options')
			.find('.wrap-component-color ul li');
		const editingComponent = this._seadevShedBuilder.getComponentByKey(this._editingComponent);
		let activeColor: any = false;
		if (!this._isAddNewComponent && currentComponentUUID === editingComponent.uuid) {
			const currentColor = editingComponent['colors'].find(
				(color) => color.type === currentComponentType,
			);
			if (currentColor) {
				activeColor = helpers.generateKey(currentColor.display.toString());
			}
		} else {
			const defaultColor = helpers.getDefaultComponentColor(currentComponentUUID);
			if (!helpers.isEmptyObject(defaultColor)) {
				activeColor = defaultColor['key'];
			}
		}

		colorElements.each((i, element) => {
			$(element).removeClass('active');
			let components = $(element).data('components');
			if (components) {
				components = JSON.parse(window.atob(components));
				if (helpers.hasKeyInArray(components, currentComponentUUID)) {
					$(element).show();
					isShowSection = true;
					if (false !== activeColor && activeColor == $(element).data('key')) {
						$(element).addClass('active');
						$(element)
							.closest('.wrap-component-color')
							.find('span.color-name')
							.html($(element).data('name'));
					}
				} else {
					$(element).hide();
				}
			} else {
				$(element).hide();
			}
		});

		if (
			currentElement
				.siblings('.upgrade-item-options')
				.find('.wrap-component-color ul li.active').length === 0
		) {
			currentElement
				.siblings('.upgrade-item-options')
				.find('span.color-name')
				.html('Default');
		}

		if (isShowSection) {
			currentElement
				.siblings('.upgrade-item-options')
				.addClass('active')
				.find('.wrap-component-color')
				.show();
		} else {
			currentElement.siblings('.upgrade-item-options').find('.wrap-component-color').hide();
			let hasChildrenOptions = false;
			currentElement
				.siblings('.upgrade-item-options')
				.find('.add-on')
				.each((i, element) => {
					if ('none' !== $(element).css('display')) {
						hasChildrenOptions = true;
					}
				});

			if (!hasChildrenOptions) {
				currentElement.siblings('.upgrade-item-options').removeClass('active');
			}
		}
	};

	/**
	 * Add custom line items
	 */
	customizeLineItems = () => {
		const _this = this;
		let adminBar = $('#wpadminbar')[0] ? $('#wpadminbar').outerHeight() : 0;
		let menuBar = $('nav.navbar').outerHeight();
		let customLineHeader = $('.custom-line-items-header').outerHeight();
		let customLineFooter = $('.custom-line-items-footer').outerHeight();
		let topLine = $('.custom-line-items-top-line');
		let height = adminBar + menuBar + customLineHeader + customLineFooter;
		let itemColWidth =
			topLine.find('.item-col-action').outerHeight() +
			topLine.find('.item-col-price-type').outerHeight() +
			topLine.find('.item-col-qty').outerHeight() +
			topLine.find('.item-col-price').outerHeight() +
			topLine.find('.item-col-tax').outerHeight();
		$('.custom-line-items-body').css('height', 'calc(100svh - ' + height + 'px)');
		$('.item-col-name').css('width', 'calc(100% - ' + itemColWidth + 'px)');

		// Add item
		$(document).on('click', '.custom-line-items-add-new', function () {
			let key = (Math.random() + 1).toString(36).substring(7);
			_this.addCustomizeLineItem(key, null);
		});

		// Remove item
		$(document).on('click', '.custom-item-wrap .remove-action', function () {
			$(this)
				.closest('.custom-item-wrap')
				.hide('slow', function () {
					$(this).closest('.custom-item-wrap').remove();
				});
		});

		// Open panel
		$(document).on('click', '.ssb-add-custom-line-items, #custom-line-items', function () {
			$('.custom-line-items-inner').addClass('active');
			$('.ssb-shed-product-single #content div.product div.summary').addClass(
				'opening-sidebar',
			);
			if ($(window).width() < 1025) {
				$('.summary-wrapper').removeClass('active');
			}
		});

		// Close panel
		$(document).on('click', '.close-custom-line-item', function () {
			$('.custom-line-items-inner').removeClass('active');
			$('.ssb-shed-product-single #content div.product div.summary').removeClass(
				'opening-sidebar',
			);
			if ($(window).width() < 1025) {
				$('.summary-wrapper').addClass('active');
			}
		});

		// Change price type
		$(document).on('change', 'select[id*="custom-item-price-type"]', function () {
			let value = $(this).val();
			// let labelText    = ( value === 'percentage' ) ? 'Percent (%)' : 'Price ($)';
			let disableQty = value === 'percentage' ? true : false;
			let quanityInput = $(this)
				.closest('.custom-item-wrap')
				.find('input[id*="custom-item-quantity"]');
			// let quanityLabel = $( this ).closest( '.custom-item-wrap' ).find( 'label[for*="custom-item-quantity"]' );
			// $( this ).closest( '.custom-item-wrap' ).find( 'label[for*="custom-item-price"]' ).html( labelText );
			if (disableQty) {
				quanityInput.prop('disabled', true);
				// quanityLabel.addClass( 'disabled' );
			} else {
				quanityInput.prop('disabled', false);
				// quanityLabel.removeClass( 'disabled' );
			}
		});

		// Changing price
		$(document).on('change', '.item-col-price .default-input', function () {
			let value = Number($(this).val());
			if (value < 0) {
				$(this)
					.closest('.custom-item-wrap')
					.find('.item-col-tax input')
					.prop('checked', true)
					.change();
				$(this).closest('.custom-item-wrap').find('.item-col-tax').addClass('disabled');
			} else {
				$(this).closest('.custom-item-wrap').find('.item-col-tax').removeClass('disabled');
			}
		});

		// Change textarea height
		$(document).on('keyup', ' .item-col-name textarea', function () {
			let textHeight = $(this).prop('scrollHeight');
			if (textHeight > 45) {
				$(this).height('65px');
			}
			_this.validateCustomizeLineItem();
		});

		// clear all items
		$(document).on('click', '.custom-line-items-clear-all', function () {
			if (
				confirm(
					'This action will remove all custom line items for this structure. Are you sure?',
				)
			) {
				$('.custom-item-wrap')
					.each(function (i, elm) {
						$(elm).remove();
					})
					.promise()
					.done(function () {
						$('.save-custom-line-items').click();
					});
			}
		});

		// Update data
		$(document).on('click', '.save-custom-line-items', function (e) {
			e.preventDefault();
			if (_this.preventUpdatePriceCustomizeLineItem()) {
				return _this._seadevShedBuilder.createAlert(
					_this._seadevShedBuilder.NOTICES.cannotNull,
				);
			}
			_this.updatePrice();
			_this._seadevShedBuilder.createAlert(
				_this._seadevShedBuilder.NOTICES.shedDetailsUpdated,
			);
			if ($(window).width() < 1025) {
				$('.custom-line-items-inner').removeClass('active');
				$('.ssb-shed-product-single #content div.product div.summary').removeClass(
					'opening-sidebar',
				);
				$('.summary-wrapper').addClass('active');
			}
			// let form       = $( '.custom-line-item-form' );
			// let datastring = form.serialize();
			// _this.customizeLineItemSave( datastring );
		});

		// Disable breakline
		$(document).on('keyup', '.default-input', function (e) {
			// Enter was pressed without shift key
			if (e.key === 'Enter' && !e.shiftKey) {
				// prevent default behavior
				e.preventDefault();
			}
		});
	};

	/**
	 * Validate Name
	 */
	validateCustomizeLineItem = () => {
		$('.custom-line-items-body')
			.find('.item-col-name .default-input')
			.each(function () {
				let itemData = String($(this).val());
				if (itemData.trim() === '') {
					$('.custom-line-items-inner').addClass('active');
					$('.ssb-shed-product-single #content div.product div.summary').addClass(
						'opening-sidebar',
					);
					if ($(window).width() < 1025) {
						$('.summary-wrapper').removeClass('active');
					}
					$(this).closest('.custom-item-wrap').addClass('warning');
				} else {
					$(this).closest('.custom-item-wrap').removeClass('warning');
				}
			});
	};

	/**
	 * Prevent update price
	 */
	preventUpdatePriceCustomizeLineItem = () => {
		var emptyField = false;
		if ($('.custom-line-items-body')[0]) {
			$('.custom-line-items-body')
				.find('.custom-item-wrap')
				.each(function () {
					let itemData = String($(this).find('.item-col-name .default-input').val());
					if (itemData.trim() === '') {
						emptyField = true;
					}
				});
		}
		return emptyField;
	};

	addCustomizeLineItem = (i, cookieItem = null) => {
		const _this = this;
		let item = _this.customizeLineItemHTML(i, cookieItem);
		if (cookieItem) {
			$('.custom-line-items-body').append(item);
		} else {
			$('.custom-line-items-body').prepend(item);
		}
		// $( ".item-col-price .default-input" ).maskMoney( { allowNegative: true } );
		$('.custom-line-items-body').animate(
			{
				scrollTop: 0,
			},
			300,
		);
		$('.custom-line-items-body tr:first-child .item-col-name .default-input').trigger('focus');
	};

	customizeLineItemHTML = (i, cookieItem = null) => {
		const _this = this;
		let item =
			'<tr class="custom-item-wrap ' + (cookieItem && !cookieItem[0] ? 'warning' : '') + '">';
		item += '<input type="hidden" value="' + window.btoa(JSON.stringify(cookieItem)) + '">';
		item +=
			'<td class="remove-item item-col-action"><div class="remove-action" title="Remove this item"></div></td>';
		item += '<td class="item-col-name">';
		item +=
			'<textarea rows="1" class="default-input form-control" id="custom-item-name-' +
			i +
			'">' +
			(cookieItem ? cookieItem[0] : '') +
			'</textarea>';
		item += '</td>';
		item += '<td class="item-col-price-type">';
		item += '<select class="default-input form-control" id="custom-item-price-type-' + i + '">';
		item +=
			'<option value="fixed" ' +
			(cookieItem && cookieItem[1] === 'fixed' ? 'selected' : '') +
			'>Fixed Price</option>';
		item +=
			'<option value="percentage_default" ' +
			(cookieItem && 'percentage_default' === cookieItem[1] ? 'selected' : '') +
			'>% of Base Price</option>';
		item += '</select>';
		item += '</td>';
		item += '<td class="item-col-qty">';
		item +=
			'<input ' +
			(cookieItem && 'percentage_default' === cookieItem[1] ? 'disabled' : '') +
			' class="default-input form-control" type="number" min="1" step="1" id="custom-item-quantity-' +
			i +
			'" oninput="this.value = !!this.value && Math.abs( this.value ) >= 0 ? Math.abs( this.value ) : null" value="' +
			(cookieItem ? cookieItem[2] : '1') +
			'">';
		item += '</td>';
		item += '<td class="item-col-price">';
		item +=
			'<input class="default-input form-control" type="number" step="0.01" id="custom-item-price-' +
			i +
			'" value="' +
			(cookieItem ? cookieItem[3] : '') +
			'">';
		item += '</td>';
		if (_this._enableTax === 'yes') {
			item +=
				'<td class="item-col-tax ' +
				(cookieItem && Number(cookieItem[3]) < 0 ? 'disabled' : '') +
				'">';
			item +=
				'<label class="switch" for="custom-item-tax-' +
				i +
				'"><input value="yes" ' +
				(cookieItem && (cookieItem[4] === 'yes' || Number(cookieItem[3]) < 0)
					? 'checked'
					: '') +
				' type="checkbox" id="custom-item-tax-' +
				i +
				'"><div class="slider round"></div></label>';
			item += '</td>';
			item += '</tr>';
		}

		return item;
	};

	customizeLineItemSave = (data) => {
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'custom_line_items_calculate_price',
				data: data,
			},
			beforeSend: function () {},
			success: function (response) {},
		});
		return false;
	};

	shedDetailRenderCustomLineItem(items, isReturn = false, returnData = []) {
		const _this = this;
		const basePrice = _this.getBasePrice();
		let fullElement = '';
		let html = '';
		let pid = $('.woocommerce.single .single_add_to_cart_button').val();
		let cookieKey = window.location.hostname + '.productID-' + pid;
		let encodeData = window.btoa(JSON.stringify(items));
		let hasData = false;
		let searchParams = new URLSearchParams(window.location.search);
		let countText = '';
		let buttonText = '';
		$('.woocommerce.single input[name="ssb-option-custom-line-items-source"]').val(encodeData);
		if (_this._canCustomLineItems && !searchParams.has('data')) {
			_this.setCookie(cookieKey, encodeData);
		}
		if (items.length > 0) {
			fullElement += '<ul>';
			items.forEach((element) => {
				let customLinePrice =
					'percentage_default' === element[1]
						? _this.calculatePriceByType(
								element[1],
								element[3],
								basePrice,
								'',
								'',
								'',
								0,
							)
						: Number(element[3]) * Number(element[2]);
				let taxable = _this._enableTax === 'yes' ? ' (taxable)' : '';
				let itemName =
					element[0] +
					(element[4] === 'yes' && customLinePrice > 0 ? taxable : '') +
					(element[1] === 'fixed' && element[2] > 1 ? ' x ' + element[2] : '');
				hasData = itemName ? true : hasData;
				itemName = itemName.trim();
				if (itemName) {
					fullElement += '<li><div class="item"><p class="left">' + itemName + '</p>';
					fullElement += _this._isShowPrice
						? helpers.getPriceElement(customLinePrice, _this._isShowPrice)
						: '';
					fullElement += '</div></li>';
					returnData.push([itemName, customLinePrice, element[4]]);
				}
			});

			fullElement += '</ul>';
			html = `
                <div class="wrap-content content">
                    <h5 class="ssb-configurator-group-name">Other Line Items</h5>
                    ${fullElement}
                </div>
            `;

			countText =
				'(incl. ' +
				items.length +
				' custom line ' +
				(1 == items.length ? 'item' : 'items') +
				')';
			buttonText = '&nbsp;(' + items.length + ')';
		}

		if (isReturn) {
			return returnData;
		}
		$('#js-custom-line-items-content').html(hasData ? html : '');
		$('#custom-line-items').html(countText);
		$('.ssb-add-custom-line-items span').html(buttonText);
	}

	/**
	 * Delete component shutters in object - shutters attached direct in the window
	 *
	 * @param {string}  key Shutters key
	 * @param {Array}   parentMeshes Mehses of parent component
	 */
	deleteShuttersInObject = (key, parentMeshes) => {
		this._seadevShedBuilder.removeShuttersInObject(key);
		this._seadevShedBuilder.disableShuttersInComponent(parentMeshes);
	};

	/**
	 * Filter components by type
	 *
	 * @param {Object} components Components list
	 * @param {String} type Component type
	 *
	 * @returns {Object}
	 */
	filterComponentByType = (components, type) => {
		let results = {};
		for (let k in components) {
			const componentType = components[k].type;
			if (componentType === type) {
				results[k] = components[k];
			}
		}

		return results;
	};

	/**
	 * Get list shutters - include shutters component and shutters in object
	 *
	 * @returns {Object}
	 */
	getShutters = () => {
		const shuttersInObjects = this._seadevShedBuilder.getShuttersInObject();
		const shuttersComponents = this.filterComponentByType(
			this._seadevShedBuilder.getAllComponents(),
			'shutters',
		);

		return { ...shuttersComponents, ...shuttersInObjects };
	};

	/**
	 *
	 * Update shutters when changing the siding material
	 *
	 * @param {String}  sidingMaterial Material of siding
	 * @param {String}  windowKey Key of component window
	 * @param {String}  windowUUID Name of window
	 * @param {String}  side Side to place component
	 * @param {Array}   meshes List meshes of window
	 */
	updateShuttersBySidingType = (sidingMaterial, windowKey, windowUUID, side, meshes) => {
		return new Promise(async (resolve) => {
			const childComponents = this._seadevShedBuilder.getComponentChildByParentKey(
				windowKey,
				side,
			);
			const shutters = this.getChildByType(childComponents, 'shutters');
			if (shutters) {
				if (
					!this._seadevShedBuilder.isValidShutters(
						sidingMaterial,
						shutters['name'],
						windowUUID,
					)
				) {
					if (this._seadevShedBuilder.isShuttersInObject(shutters['name'])) {
						this.deleteShuttersInObject(shutters['key'], meshes);
					} else {
						await this.removeComponentV2(side, 'shutters', shutters['key']);
					}

					const shuttersName = this._seadevShedBuilder.getFirstShutters(
						sidingMaterial,
						windowUUID,
					);
					if (shuttersName) {
						this._seadevShedBuilder.replaceComponentNotice(
							shutters['name'],
							shuttersName,
							[NOTICES.sidingMaterial],
						);
						await this._seadevShedBuilder.addNewShutters(
							shuttersName,
							meshes,
							side,
							windowKey,
						);
					} else {
						this._seadevShedBuilder.removeComponentNotice(shutters['name'], [
							NOTICES.sidingMaterial,
						]);
					}
				}
			} else if (this._seadevShedBuilder.isRequiredAddon(windowUUID, 'required-shutters')) {
				const shuttersName = this._seadevShedBuilder.getFirstShutters(
					sidingMaterial,
					windowUUID,
				);
				if (shuttersName) {
					await this._seadevShedBuilder.addNewShutters(
						shuttersName,
						meshes,
						side,
						windowKey,
					);
				}
			}

			resolve(true);
		});
	};

	/**
	 * Get first component child by child type
	 *
	 * @param {Array}   components Component list
	 * @param {String}  type Child component type
	 *
	 * @returns {Object|Boolean}
	 */
	getChildByType = (components, type) => {
		for (let i = 0; i < components.length; i++) {
			if (components[i].type === type) {
				return components[i];
			}
		}

		return false;
	};

	/**
	 * Get data for the selected frame from the configurator.
	 *
	 * @returns {string} - Base64-encoded JSON string containing frame data.
	 */
	getFrameData = () => {
		const selectedFrame = $(`input[name="ssb-configurator-upgrade-frame"]:checked`);

		if (selectedFrame.length) {
			const name = selectedFrame.val();
			const distance = selectedFrame.data('distance');
			const material_key = selectedFrame.data('file');
			const material_name = selectedFrame.data('material-name');
			const group = 'Studs';
			let price = selectedFrame.data('price');
			const priceType = selectedFrame.data('price-type');
			const basePrice = this.getBasePrice();
			const baseWidth = helpers.getBaseWidth();
			const baseDepth = helpers.getBaseDepth();
			price = this.calculatePriceByType(
				priceType,
				price,
				basePrice,
				baseWidth,
				baseDepth,
				false,
			);

			return window.btoa(
				JSON.stringify([{ name, price, distance, group, material_key, material_name }]),
			);
		}

		return window.btoa(JSON.stringify([]));
	};

	/**
	 * Handle change event for the frame selection in the configurator.
	 */
	handleChangeFrame = () => {
		const _this = this;
		$('input[name="ssb-configurator-upgrade-frame"]').on('change', function (e) {
			const file = $(e.currentTarget).data('file');
			const distributionRules = JSON.parse(
				window.atob($(e.currentTarget).data('distribution-rules')),
			);
			if ('in-model' === file) {
				_this._seadevShedBuilder.cloneFrameInModelObject(distributionRules);
			} else {
				_this._seadevShedBuilder.cloneFrameComponent(file, distributionRules, true);
			}
			_this.shedDetailRenderInterior();
			_this.updatePrice();
		});
	};

	/**
	 * Handle update event for the frame in the configurator.
	 * This function updates the frame and price when triggered, but only if it is not a shared link.
	 */
	handleUpdateFrame = () => {
		const selected = $(`input[name="ssb-configurator-upgrade-frame"]:checked`);
		if (0 === selected.length) return;
		const file = selected.data('file');
		const distributionRules = JSON.parse(window.atob(selected.data('distribution-rules')));

		if ('in-model' === file) {
			this._seadevShedBuilder.cloneFrameInModelObject(distributionRules);
		} else {
			if (file) {
				this._seadevShedBuilder.cloneFrameComponent(file, distributionRules, false);
				this.updatePrice();
			}
		}
	};

	handleShowHideTackRoomGroup = () => {
		if (!this._seadevShedBuilder._isAllowEnableTackRoom) return;
		const depth = this._seadevShedBuilder.getDepth();
		const dataTackRoomSettings = this._seadevShedBuilder._dataSettingsTackroom;
		if (
			'' !== dataTackRoomSettings['tackroom_available_length'] &&
			depth < dataTackRoomSettings['tackroom_available_length']
		) {
			$('.group-upgrade-tackroom').hide();
			const sizeLabel = helpers.getSizeLabel();
			this._seadevShedBuilder.createAlert(
				`Tackroom has been removed as it's not available in ${sizeLabel['label']}.`,
			);
		} else {
			$('.group-upgrade-tackroom').show();
		}
	};

	isExcludeFreightCharge = () => {
		return this._seadevShedBuilder._canvas.getAttribute('is-exclude-freight-charge') === 'true';
	};

	getColorPickerCode = (type) => {
		return 'color_picker' ===
			$(`#js-shed-data input[name="ssb-option-${type}-color"]`).attr('data-color-type')
			? $(`#js-shed-data input[name="ssb-option-${type}-color"]`).attr('data-color')
			: undefined;
	};

	/**
	 * Adds the first required addon for windows, such as shutters or flower boxes, based on the type and name.
	 *
	 * @param {string} type - The type of the addon. The function only processes if the type is 'windows'.
	 * @param {string} uuid - The name of the addon to check if it is required.
	 * @param {string} side - The side where the addon will be added.
	 * @param {Object} result - An object containing the meshes and key used in the addition of new components.
	 */
	addFirstAddon = async (type, uuid, side, result) => {
		if ('windows' !== type) {
			return;
		}

		if (this._seadevShedBuilder.isRequiredAddon(uuid, 'required-shutters')) {
			const sidingType = this._seadevShedBuilder.getSidingType();
			const shuttersName = this._seadevShedBuilder.getFirstShutters(sidingType, uuid);
			if (shuttersName) {
				await this._seadevShedBuilder.addNewShutters(
					shuttersName,
					result['meshes'],
					side,
					result['key'],
				);
			}
		}

		if (this._seadevShedBuilder.isRequiredAddon(uuid, 'required-flower_box')) {
			const flowerBoxName = this._seadevShedBuilder.getFirstAddOn(uuid, 'flower_box');

			//TODO @Update UUID - Component Name
			if (flowerBoxName) {
				await this._seadevShedBuilder.addNewComponent({
					side,
					componentType: 'flower_box',
					componentName: flowerBoxName,
					parentKey: result['key'],
					uuid: flowerBoxName,
				});
			}
		}
	};

	/**
	 * Loads a component of a specified type and name by fetching its associated .babylon file
	 * and its textures.
	 *
	 * @param {string} type - The type of the component (e.g., 'window', 'door').
	 * @param {string} name - The name of the component.
	 * @returns {Promise<void>} A promise that resolves when the component and its textures have been loaded.
	 */
	loadComponent = async (type, name) => {
		const componentDir = `${this._seadevShedBuilder._componentDir}${type}/${name}/`;
		const response = await this.fileGetContents(`${componentDir}${name}.babylon`);
		if (response && response['materials'] && response['materials'].length > 0) {
			for (let i = 0; i < response['materials'].length; i++) {
				this.fetchTexture(componentDir, response['materials'][i]['bumpTexture']);
				this.fetchTexture(componentDir, response['materials'][i]['diffuseTexture']);
				this.fetchTexture(componentDir, response['materials'][i]['specularTexture']);
				this.fetchTexture(componentDir, response['materials'][i]['emissiveTexture']);
				this.fetchTexture(componentDir, response['materials'][i]['opacityTexture']);
				this.fetchTexture(componentDir, response['materials'][i]['reflectionTexture']);
			}
		}
	};

	/**
	 * Loads components for a specified subcategory based on the given element.
	 * The function searches for components within the element that are not hidden
	 * and loads each component by calling `this.loadComponent`.
	 *
	 * @param {jQuery} element - The jQuery object representing the subcategory element.
	 */
	loadComponentsBySubCategory = (element) => {
		if (0 === element.length) {
			return;
		}

		const category = element.data('category');
		element
			.find(`.accordion-content .component-item:not([style*="display: none"]) .ssb-option`)
			.each((index, element) => {
				const componentName = $(element).data('upgrade-component-name');
				if (componentName) {
					this.loadComponent(category, componentName);
				}
			});
	};

	/**
	 * Loads components for a specified category by iterating over all visible components
	 * within the category and calling `this.loadComponent` for each one.
	 *
	 * @param {string} category - The category of components to load.
	 */
	loadComponentsByCategory = (category) => {
		const _this = this;
		$(`.ssb-configurator-upgrade.${category}`)
			.find(`.component-item:not([style*="display: none"]) .ssb-option`)
			.each((index, element) => {
				const componentName = $(element).data('upgrade-component-name');
				if (componentName) {
					_this.loadComponent(category, componentName);
				}
			});
	};

	/**
	 * Fetches the content of a file from the given URL and returns it as JSON.
	 *
	 * @param {string} url - The URL of the file to fetch.
	 * @return {Promise<Object|boolean>} A Promise that resolves to the JSON content of the file
	 *                                   if the file was successfully fetched, or false otherwise.
	 */
	fileGetContents = async (url) => {
		try {
			const response = await fetch(url);
			if (response.ok) {
				return await response.json();
			}

			return false;
		} catch (error) {
			return false;
		}
	};

	/**
	 * Fetches a texture from the specified directory and logs any errors.
	 *
	 * @param string $componentDir The directory where the texture is located.
	 * @param array $texture An array containing the texture information.
	 *                       The array should have a 'name' key with the name of the texture file.
	 */
	fetchTexture = async (componentDir, texture) => {
		if (texture && '' !== texture['name']) {
			try {
				fetch(`${componentDir}${texture['name']}`);
			} catch (error) {}
		}
	};

	/**
	 * Handles the change event of the "Wall Ceiling Finishing" radio group.
	 *
	 * When the "Enable" option is selected, it creates a hole in the wall inner 3D model.
	 * When the "Disable" option is selected, it removes the inner 3D model.
	 */
	handleChangeWallFinish = () => {
		const _this = this;
		$(document).on('change', '[name="ssb-group-wall_ceiling_finishing"]', function (e) {
			if ('enable' === $('[name="ssb-group-wall_ceiling_finishing"]:checked').val()) {
				_this._seadevShedBuilder.createWallFinish();
			} else {
				_this._seadevShedBuilder.removeWallFinish();
			}
		});
	};

	/**
	 * Handles the change event of the "Swap Side Gable" radio group.
	 *
	 * When the "Enable" option is selected, it swaps the left and right sides of the shed.
	 * When the "Disable" option is selected, it reverts the sides.
	 */
	handleChangeSideGable = () => {
		const _this = this;
		$(document).on('change', '[name="ssb-group-upgrade-side-gable"]', function (e) {
			const fromLeftToRight = 'enable' === $(this).val();
			const sides = fromLeftToRight ? convertSides : revertSides;

			const { width, depth, height } = _this.getSizes();

			_this._seadevShedBuilder.setWidth(width);
			_this._seadevShedBuilder.setDepth(depth);
			_this._seadevShedBuilder.setWallHeight(height);

			_this._seadevShedBuilder.handleSwapSide(sides, fromLeftToRight);
			_this.shedDetailRenderInterior();
		});
	};

	/**
	 * Gets the label of the external porch component.
	 *
	 * @return {string} The label of the external porch component.
	 */
	getExternalPorchLabel = () => {
		const porchSizeData = this._seadevShedBuilder.getPorchCustomSizeData();
		const porchLable = porchSizeData ? porchSizeData.custom_name : 'Porch';
		const railLabel = this._isEnabledRailing ? '(With Railing)' : '(No Railing)';
		const oPosition = this._seadevShedBuilder.getOpeningPosition();
		const openingLabel = this._seadevShedBuilder.hasOpeningSetting()
			? `- ${oPosition.charAt(0).toUpperCase()}${oPosition.slice(1)}`
			: '';

		return `${porchLable} ${openingLabel} ${railLabel}`;
	};

	/**
	 * Updates the opening position based on the opening setting.
	 */
	updateOpeningPosition = () => {
		if (!this._seadevShedBuilder.hasOpeningSetting()) {
			return;
		}

		const openingSetting = this._seadevShedBuilder.getOpeningSetting();
		if (undefined === openingSetting) {
			$('[name=ssb-configurator-upgrade-opening-position]').prop('checked', false);
			return $('.group-upgrade-opening-position').hide();
		}

		const defaultOpening = openingSetting['default_opening_position'];
		const openingOptions = openingSetting['opening_option'];
		const values = openingOptions.map((option) => option['value']);

		let numberOpening = 0;
		$('[name=ssb-configurator-upgrade-opening-position]').each((index, element) => {
			$(element).parent().show();
			const openingValue = $(element).val().toString().toLowerCase();
			if (!helpers.hasKeyInArray(values, openingValue)) {
				$(element).prop('checked', false).parent().hide();
			} else {
				numberOpening++;
				if (defaultOpening === openingValue) {
					$(element).prop('checked', true);
				}
			}
		});

		if (numberOpening > 1) {
			$('.group-upgrade-opening-position').show();
		} else {
			$('.group-upgrade-opening-position').hide();
		}
	};

	/**
	 * Updates the color price and details in the component and shed data.
	 *
	 * @param {string} side - The side of the component.
	 * @param {string} key - The key of the component.
	 * @param {string} componentType - The type of the component.
	 * @param {string} componentUUID - The name of the component.
	 * @param {string} textureType - The type of the texture.
	 * @param {jQuery} currentElement - The current element clicked.
	 */
	updateColorPrice = (
		side: string,
		key: string,
		componentType: string,
		componentUUID: string,
		textureType: string,
		currentElement: JQuery
	) => {
		const colorName = $(currentElement).data('name');
		const color_price = $(currentElement).data('price');
		const color_price_type = $(currentElement).data('price-type');
		const texture =
			'color' === textureType
				? $(currentElement).data('texture-color')
				: $(currentElement).data('texture-image');
		const colors = {
			type: componentType,
			type_display: colorLabels[componentType] ? colorLabels[componentType] : '',
			display: colorName,
			color_price,
			color_price_type,
			texture_type: textureType,
			texture,
			description: '',
		};

		let hasUpdateWall = false;
		for (
			let i = 0;
			i < this._seadevShedBuilder._walls[side]['items'][key]['colors'].length;
			i++
		) {
			if (
				this._seadevShedBuilder._walls[side]['items'][key]['colors'][i]['type'] ===
				componentType
			) {
				this._seadevShedBuilder._walls[side]['items'][key]['colors'][i] = colors;
				hasUpdateWall = true;
			}
		}

		if (!hasUpdateWall) {
			this._seadevShedBuilder._walls[side]['items'][key]['colors'][0] = colors;
		}

		let hasUpdateAllComponent = false;
		for (let i = 0; i < this._seadevShedBuilder._allComponents[key]['colors'].length; i++) {
			if (
				this._seadevShedBuilder._allComponents[key]['colors'][i]['type'] === componentType
			) {
				this._seadevShedBuilder._allComponents[key]['colors'][i] = colors;
				hasUpdateAllComponent = true;
			}
		}

		if (!hasUpdateAllComponent) {
			this._seadevShedBuilder._allComponents[key]['colors'][0] = colors;
		}

		this.shedDetailRenderExterior();
		this.updatePrice();
	};

	/**
	 * Initializes the event handler for changing the component color.
	 * When a color is clicked, updates the component's color and associated price.
	 */
	handleChangeComponentColor = () => {
		const _this = this;
		const groupClass = 'wrap-component-color';
		$(document).on('click', `.${groupClass} ul li`, function (e) {
			const currentElement = e.currentTarget;
			$(`.${groupClass} ul li`).removeClass('active');
			$(currentElement).addClass('active');
			$(currentElement)
				.closest('.wrap-component-color')
				.find('span.color-name')
				.html($(currentElement).data('name'));

			const editingComponent = _this._seadevShedBuilder.getComponentByKey(
				_this._editingComponent,
			);
			if (!editingComponent) {
				return;
			}

			const componentUUID = $(currentElement)
				.closest('.upgrade-item')
				.find('input.ssb-option')
				.data('uuid');
			if (editingComponent.uuid !== componentUUID) {
				return;
			}

			const textureType = $(currentElement).attr('data-texture-type');
			const textureImage = $(currentElement).attr('data-texture-image');
			const textureColor = $(currentElement).attr('data-texture-color');
			const componentType = $(currentElement)
				.closest('.upgrade-item')
				.find('input.ssb-option')
				.data('upgrade-component-type');
			if (
				_this._seadevShedBuilder.updateComponentColor(
					componentType,
					textureType,
					textureImage,
					textureColor,
					editingComponent.meshes,
				)
			) {
				_this.updateColorPrice(
					_this._sideSelected,
					_this._editingComponent,
					componentType,
					componentUUID,
					textureType,
					currentElement,
				);
			}
		});
	};

	/**
	 * Handles the restriction logic for swapping side gables.
	 *
	 * This function enables or disables side gable options based on the current settings and restrictions.
	 * It also ensures that the selected side gable is set to the default if restrictions apply.
	 */
	handleRestrictSwapSideGable = () => {
		// If swapping side is not allowed, exit early.
		if (!helpers.isAllowSwapSide()) {
			return;
		}

		// If the current size does not prevent swap side gable, enable all options and exit this function.
		if (!this.isPreventSwapSideGable()) {
			// Enable all side gable options.
			$('.group-upgrade-upgrade-side-gable input').each((index, element) => {
				$(element).prop('disabled', false);
				$(element).next('label').css('opacity', '1');
			});

			// Remove the warning message.
			$('.group-upgrade-upgrade-side-gable .swap-layout-warning').remove();

			return;
		}

		// Get the default and currently selected side gable values.
		const defaultSideGable = $('[name="ssb-group-upgrade-side-gable"].default').val();
		const selectedSideGable = $('[name="ssb-group-upgrade-side-gable"]:checked').val();

		// If the selected side gable is not the default, set it to the default and trigger change.
		if (defaultSideGable !== selectedSideGable) {
			$(`[name="ssb-group-upgrade-side-gable"][value="${defaultSideGable}"]`)
				.prop('checked', true)
				.trigger('change');
		}

		// Disable all side gable options.
		$('.group-upgrade-upgrade-side-gable input').each((index, element) => {
			$(element).prop('disabled', true);
			$(element).next('label').css('opacity', '0.5');
		});

		// Add the warning message.
		$('.group-upgrade-upgrade-side-gable .swap-layout-warning').remove();
		$('.group-upgrade-upgrade-side-gable .ssb-configurator-group-name').after(
			helpers.addWarningMessage('swap-layout-warning', NOTICES.featureNotSupport),
		);
	};

	/**
	 * Check if the current size is in the list of sizes that do not allow swap side gable.
	 *
	 * @return {boolean} True if the size does not allow swap side gable, false otherwise.
	 */
	isPreventSwapSideGable = (): boolean => {
		const sideGableRestriction =
			this._seadevShedBuilder.getSettingData('side_gable_restriction');

		// Iterate through the list of restrictions and check if the current size matches any of the conditions.
		for (let i = 0; i < sideGableRestriction.length; i++) {
			const conditionEncode = window.btoa(JSON.stringify(sideGableRestriction[i]));
			if (this.isCondition(conditionEncode)) {
				// If the condition is true, return true to indicate that the size does not allow swap side gable.
				return true;
			}
		}

		// If no condition is true, return false to indicate that the size allows swap side gable.
		return false;
	};

	/**
	 * Get the side gable data.
	 *
	 * @return {object} The side gable data, or empty object if no side gable is selected.
	 */
	getSideGableData = (): object => {
		const element = $(
			'.group-upgrade-upgrade-side-gable [name="ssb-group-upgrade-side-gable"]:checked',
		);
		const group = element
			.parents('.group-upgrade-upgrade-side-gable')
			.find('.ssb-configurator-group-name')
			.text();
		const name = element.next('label').text();

		// If the name is not empty, return the side gable data.
		if (name) {
			if (this.isEnableManufacturer()) {
				// Include the original group and original name if the manufacturer is enabled.
				return {
					name,
					price: 0,
					quantity: 1,
					group,
					original_group: group,
					original_name: name,
				};
			} else {
				// Return the side gable data without the original group and original name.
				return { name, price: 0, quantity: 1, group };
			}
		}

		// If the name is empty, return an empty object.
		return {};
	};

	/**
	 * Checks if there is a loft restriction by component.
	 *
	 * @returns {boolean} True if there is a loft restriction by component. False otherwise.
	 */
	isLoftRestrictionByComponent = () => {
		const loftRestriction = this._seadevShedBuilder.getSettingData('loft_restriction');

		if (loftRestriction.length > 0) {
			return true;
		}

		return false;
	};

	/**
	 * Checks if a component is restricted in a loft based on the component category and side.
	 *
	 * @param {JQuery<HTMLElement>} loftElementOption - The loft size option element.
	 * @param {string} componentName - The name of the component.
	 * @param {string} side - The side of the loft.
	 *
	 * @returns {boolean} True if the component is restricted, false otherwise.
	 */
	isLoftRestriction = (
		loftElementOption: JQuery<HTMLElement>,
		componentName: string,
		side: string,
	) => {
		const preventData = this._seadevShedBuilder.getSettingData('loft_restriction');
		const categories = this._seadevShedBuilder.getComponentCategory(componentName);
		let loftSide = [];

		if (loftElementOption.length > 0) {
			loftSide = Object.keys(
				this._seadevShedBuilder.formatLoftSizeSide(loftElementOption.data('size-side')),
			);
		}

		if (!helpers.hasKeyInArray(loftSide, side)) {
			return false;
		}

		for (let i = 0; i < preventData.length; i++) {
			const {
				prevent_by: preventBy,
				prevent_items: encodedPreventItems,
				prevent_category: preventCategory,
			} = preventData[i];
			const preventItems =
				encodedPreventItems === '' ? [] : JSON.parse(atob(encodedPreventItems));

			if ('subcategory' === preventBy) {
				if (
					false !== categories &&
					categories.category === preventCategory &&
					helpers.hasKeyInArray(preventItems, categories.sub_category)
				) {
					return true;
				}
			} else if (
				'component' === preventBy &&
				helpers.hasKeyInArray(preventItems, componentName)
			) {
				return true;
			}
		}

		return false;
	};

	/**
	 * Evaluate the conditions of a payment factor.
	 *
	 * This function will take a list of payment items and evaluate the conditions of each item.
	 * The conditions are evaluated by comparing the colors of the base factor with the colors of the compare factor.
	 *
	 * @param {Object[]} items - The list of payment items.
	 * @param {string} separateParam - The parameter to separate the colors by.
	 * @param {string} paymentFactor - The payment factor to evaluate.
	 *
	 * @returns {Object} An object with the results of the condition evaluation.
	 * - allConditionResults: an array of booleans indicating whether each condition was matched.
	 * - factorsSatisfyCondition: an array of factor keys that satisfy the condition.
	 * - factorsNotSatisfyCondition: an array of factor keys that do not satisfy the condition.
	 */
	evaluateFactorConditions = (items, separateParam, paymentFactor) => {
		let allConditionResults = [];
		let factorsSatisfyCondition = [];
		let factorsNotSatisfyCondition = [];
		const conditionList = helpers.getConditionList(items);
		for (let i = 0; i < conditionList.length; i++) {
			const { baseFactor, operator, compareFactor } = conditionList[i];
			const baseColors = this.getColorNamesByFactor(baseFactor, separateParam, paymentFactor);
			const compareColors = this.getColorNamesByFactor(
				compareFactor,
				separateParam,
				paymentFactor,
			);
			if (baseColors.length && compareColors.length) {
				let factors = baseColors;
				let comparison = compareColors;
				if (compareColors.find((color) => color.isFactor)) {
					factors = compareColors;
					comparison = baseColors;
				}

				let conditionMatched = false;
				for (let j = 0; j < factors.length; j++) {
					const base = factors[j];
					let factorMatched = false;
					for (let k = 0; k < comparison.length; k++) {
						const compare = comparison[k];
						const isMatch =
							(operator === 'equal' && base.name?.trim() === compare.name?.trim()) ||
							(operator === 'not_equal' &&
								base.name?.trim() !== compare.name?.trim());
						if (isMatch) {
							factorMatched = true;
							conditionMatched = true;
						}
					}

					if (factorMatched) {
						if (base.isFactor) factorsSatisfyCondition.push(base.key);
					} else {
						if (base.isFactor) factorsNotSatisfyCondition.push(base.key);
					}
				}

				allConditionResults.push(conditionMatched);
			}
		}

		return { allConditionResults, factorsSatisfyCondition, factorsNotSatisfyCondition };
	};

	/**
	 * Calculates the price of a custom upcharge based on its payment type and condition.
	 *
	 * @param {{ priceType: string, price: number, paymentType: string, name: string, description: string, factorsSatisfyCondition: string[], factorsNotSatisfyCondition: string[] }} options - The options for calculating the price of the custom upcharge.
	 * - priceType: The type of price. Can be 'fixed', 'per_sqft', or 'per_linear_ft'.
	 * - price: The price of the custom upcharge.
	 * - paymentType: The type of payment. Can be 'one_time' or 'quantity'.
	 * - name: The name of the custom upcharge.
	 * - description: The description of the custom upcharge.
	 * - factorsSatisfyCondition: An array of factor keys that satisfy the condition.
	 * - factorsNotSatisfyCondition: An array of factor keys that do not satisfy the condition.
	 *
	 * @returns {Object[]} An array of objects with the calculated price and quantity.
	 */
	calculateCustomUpchargePrice = ({
		priceType,
		price,
		paymentType,
		name,
		description,
		factorsSatisfyCondition,
		factorsNotSatisfyCondition,
	}) => {
		let results = [];
		const endPrice = this.calculatePriceByType(
			priceType,
			price,
			this.getBasePrice(),
			helpers.getBaseWidth(),
			helpers.getBaseDepth(),
			false,
		);
		if ('one_time' === paymentType) {
			// If the payment type is one_time, add the price to the results with a quantity of 1.
			results.push({
				group: 'Custom Upcharge',
				name,
				quantity: 1,
				description,
				price: endPrice,
				priceType: 'fixed',
			});
		} else if ('quantity' === paymentType) {
			// If the payment type is quantity, add the price to the results with a quantity equal to the number of factors that satisfy the condition.
			const factorItems = helpers
				.removeDuplicates(factorsSatisfyCondition)
				.filter((item) => !factorsNotSatisfyCondition.includes(item));
			if (factorItems.length) {
				results.push({
					group: 'Custom Upcharge',
					name,
					quantity: 1,
					description,
					price: endPrice * factorItems.length,
					priceType: 'fixed',
				});
			}
		}

		return results;
	};

	/**
	 * Returns an array of objects with the name and key of the colors of a given factor.
	 *
	 * @param {string} factor - The factor to get the color names for.
	 * @param {string} separateParam - The parameter to separate the colors by.
	 * @param {string} paymentFactor - The payment factor to compare the component key to.
	 *
	 * @returns {Object[]} An array of objects with the following properties:
	 * - name: The name of the color.
	 * - key: The key of the color.
	 * - isFactor: A boolean indicating whether the color is a factor.
	 */
	getColorNamesByFactor = (factor, separateParam, paymentFactor) => {
		let colorNames = [];
		const baseFactorArray = factor.split(separateParam);
		if (baseFactorArray.length === 2) {
			colorNames = this.getColorDisplaysBySubCategory(baseFactorArray[1]);
			if (paymentFactor === baseFactorArray[1]) {
				// If the payment factor matches the sub category, set the isFactor property to true.
				colorNames = colorNames.map((colorName) => {
					colorName.isFactor = true;
					return colorName;
				});
			}
		} else {
			colorNames = this.getColorName(factor);
			const componentInfo = helpers.getComponentInfoByColorType(factor);
			if (componentInfo && componentInfo['key'] === paymentFactor) {
				// If the payment factor matches the component key, set the isFactor property to true.
				colorNames = colorNames.map((colorName) => {
					colorName.isFactor = true;
					return colorName;
				});
			}
		}

		return colorNames;
	};

	/**
	 * Returns an array of objects with the name and key of the colors of a given component sub category.
	 *
	 * @param {string} componentSubCat - The sub category of the components to get the colors for.
	 *
	 * @returns {Object[]} An array of objects with the following properties:
	 * - key: The key of the component.
	 * - name: The name of the color.
	 */
	getColorDisplaysBySubCategory = (componentSubCat) => {
		const displays = [];
		const components = Object.values(this._seadevShedBuilder._allComponents);

		// Loop through all components and filter out the components with the given sub category.
		// Then loop through the colors of each component and add an object with the key and name of the color to the displays array.
		for (const component of components) {
			const categories = this._seadevShedBuilder.getComponentCategory(component['name']);
			if (
				categories &&
				categories.sub_category === componentSubCat &&
				Array.isArray(component['colors'])
			) {
				for (const color of component['colors']) {
					displays.push({ key: component['key'], name: color.display });
				}
			}
		}

		return displays;
	};

	/**
	 * Returns an array of objects with the name and key of the colors of the wainscoting.
	 *
	 * @returns {Object[]} An array of objects with the following properties:
	 * - key: The key of the component.
	 * - name: The name of the color.
	 */
	getWainscotingColorDisplays = () => {
		if (
			1 === this._seadevShedBuilder._wainscotingType ||
			(3 === this._seadevShedBuilder._wainscotingType &&
				0 === this._seadevShedBuilder._wainscotingSide.length)
		) {
			return [];
		}

		return this.getColorNameByType('wainscoting');
	};

	/**
	 * Returns an array of objects with the name and key of the colors of the finishing for the given group class and type.
	 *
	 * @param {string} groupClass - The class of the group to get the colors for.
	 * @param {string} type - The type of the colors to get (e.g. 'wallFinishing', 'ceilingFinishing').
	 *
	 * @returns {Object[]} An array of objects with the following properties:
	 * - key: The key of the component.
	 * - name: The name of the color.
	 */
	getFinishingColorDisplays = (groupClass, type) => {
		const wallFinishingMatType = $(`.${groupClass} ul li.active`).data('material-type');
		if ('none' === wallFinishingMatType) {
			return [];
		}

		return this.getColorNameByType(type);
	};

	/**
	 * Returns an array of objects with the name and key of the colors of a given factor.
	 *
	 * @param {string} factor - The factor to get the colors for.
	 *
	 * @returns {Object[]} An array of objects with the following properties:
	 * - key: The key of the component.
	 * - name: The name of the color.
	 */
	getColorName = (factor) => {
		switch (factor) {
			case 'siding_color':
				return this.getColorNameByType('siding');
			case 'trim_color':
				return this.getColorNameByType('trim');
			case 'roof_color':
				return this.getColorNameByType('roof');
			case 'post_rails_color':
				return this.getColorNameByType('rails');

			case 'wainscoting_color':
				return this.getWainscotingColorDisplays();
			case 'wall_finishing_color':
				return this.getFinishingColorDisplays('group-interior_wall-type', 'wall');
			case 'ceiling_finishing_color':
				return this.getFinishingColorDisplays('group-interior_ceiling-type', 'ceiling');

			case 'door_color':
				return helpers.getColorDisplaysByComponentType(
					'door',
					this._seadevShedBuilder._allComponents,
				);
			case 'vent_color':
				return helpers.getColorDisplaysByComponentType(
					'vent',
					this._seadevShedBuilder._allComponents,
				);
			case 'windows_color':
				return helpers.getColorDisplaysByComponentType(
					'windows',
					this._seadevShedBuilder._allComponents,
				);

			case 'appliance_panels_color':
				return helpers.getColorDisplaysByColorType(
					'appliance',
					this._seadevShedBuilder._allComponents,
				);
			case 'countertops_color':
				return helpers.getColorDisplaysByColorType(
					'countertops',
					this._seadevShedBuilder._allComponents,
				);

			case 'shutters_color':
				return helpers.getAllShutterColorDisplays(
					this._seadevShedBuilder._allComponents,
					this._seadevShedBuilder.getShuttersInObject(),
				);
		}

		return [];
	};

	/**
	 * Retrieves the display name of a color by its type.
	 *
	 * This function fetches the color information for a given color type and returns an array
	 * containing an object with the color type as the key and the color's display name.
	 * If no color information is found for the given type, it returns an empty array.
	 *
	 * @param {string} colorType - The type of the color to retrieve.
	 * @returns {Object[]} An array containing an object with the key and display name of the color.
	 */
	getColorNameByType = (colorType) => {
		const colorInfo = this._seadevShedBuilder.getColorInfo(colorType);
		const { type, code, name } = colorInfo;
		if (type && code && name) {
			return [{ key: colorType, name: helpers.formatColorName(name, type, code) }];
		}

		return [];
	};

	/**
	 * Retrieves the custom upcharges from the shed builder's settings.
	 *
	 * @returns {Object[]} An array of objects containing the custom upcharge information.
	 */
	getCustomUpcharge = () => {
		const separateParam = '___';
		let upchargeItems = [];
		const customUpcharges = this._seadevShedBuilder.getSettingData('custom_upcharge');

		// Loop through all the custom upcharges.
		for (let i = 0; i < customUpcharges.length; i++) {
			const {
				label: name,
				description,
				condition,
				items,
				priceType,
				price,
				paymentType,
				paymentFactor,
			} = customUpcharges[i];

			// If the condition is an "and" condition, evaluate it.
			if ('and' === condition) {
				const { allConditionResults, factorsSatisfyCondition, factorsNotSatisfyCondition } =
					this.evaluateFactorConditions(items, separateParam, paymentFactor);

				// If all the conditions are satisfied, calculate the custom upcharge price.
				if (
					allConditionResults.length &&
					undefined === allConditionResults.find((result) => result === false)
				) {
					upchargeItems = upchargeItems.concat(
						this.calculateCustomUpchargePrice({
							priceType,
							price,
							paymentType,
							name,
							description,
							factorsSatisfyCondition,
							factorsNotSatisfyCondition,
						}),
					);
				}
			}
		}

		return upchargeItems;
	};

	/**
	 * Handles geo location data by updating UI elements and triggering validation.
	 *
	 * @param {string} geoData - The geographic location data (zip code or location ID)
	 */
	handleGeoData = (geoData: string): void => {
		// Only proceed if geoData exists
		if (!geoData) {
			return;
		}
		// Get UI elements
		const elements = {
			location: $('#js-select-location'),
			zipCode: $('#js-zip-code'),
			submit: $('#js-zip-code-submit'),
			popup: $('.zip-code-popup'),
		};

		// Handle location select if it exists
		if (elements.location.length) {
			const selectedOption = elements.location.find(`option[value=${geoData}]`);
			const selectedText = selectedOption.text();

			elements.location.val(geoData).trigger('change');
			elements.popup
				.find('.select2-selection__rendered')
				.text(selectedText)
				.attr('title', selectedText);
		}

		// Handle zip code input if it exists
		if (elements.zipCode.length) {
			elements.zipCode.val(geoData).trigger('change');
		}

		// Trigger form submission
		elements.submit.trigger('click');
	};

	/**
	 * Captures all thumbnails (front, back, left, right, and the current side) and returns them as an array of promises.
	 *
	 * @param {string} side - The side of the shed to capture thumbnail for.
	 * @returns {Promise<string[]>} An array of promises that resolves to the file names of the thumbnails.
	 */
	captureAllThumbnails = async (side: string): Promise<string[]> => {
		const imageMain = await this._seadevShedBuilder.captureCartThumbnailV2(side);
		const imageFront = await this._seadevShedBuilder.captureCartThumbnailV2('front');
		const imageBack = await this._seadevShedBuilder.captureCartThumbnailV2('back');
		const imageLeft = await this._seadevShedBuilder.captureCartThumbnailV2('left');
		const imageRight = await this._seadevShedBuilder.captureCartThumbnailV2('right');

		return [imageMain, imageFront, imageBack, imageLeft, imageRight];
	};
}

window.addEventListener('DOMContentLoaded', () => {
	new SeadevShedBuilderScripts();
});
